/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouter = __webpack_require__(17);
	
	var _CoreLayout = __webpack_require__(101);
	
	var _CoreLayout2 = _interopRequireDefault(_CoreLayout);
	
	__webpack_require__(120);
	
	__webpack_require__(121);
	
	var _store = __webpack_require__(117);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (false) {
	    module.hot.accept();
	}
	
	// import configureStore from './store/configureStore'
	
	// import Root from 'containers/Root'
	
	
	if (false) {
	    // Add a polyfill for Element.animate so that the React render visualizer
	    // plugin will work okay in all browsers (namely, Firefox)
	    require('web-animations-js');
	}
	
	// window.React = React
	
	var rootEl = document.getElementById("root");
	
	var render = function render() {
	    // const Root = require("containers/Root").default
	    _reactDom2.default.render(_react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _store2.default },
	        _react2.default.createElement(
	            _reactRouter.Router,
	            { history: _store.history },
	            _react2.default.createElement(_reactRouter.Route, { path: '/', component: _CoreLayout2.default })
	        )
	    ), rootEl);
	};
	// <IndexRedirect to="/de" />
	// <Route path="/de">
	//   <IndexRedirect to="/de/1" />
	//   <Route path="/:lang/:step(/:postalCode)" component={App}>
	//     <IndexRoute component={Regions} />
	//     <Route path="*" component={NotFound} />
	//   </Route>
	// </Route>
	// <Route path="/:lang(/:step(/:postalCode))" component={App}>
	//   <IndexRoute component={Regions} />
	//   <Route path="*" component={NotFound} />
	// </Route>
	
	
	if (false) {
	    // Support hot reloading of components
	    // and display an overlay for runtime errors
	    var renderApp = render;
	    var renderError = function renderError(error) {
	        var RedBox = require('redbox-react');
	        _reactDom2.default.render(_react2.default.createElement(RedBox, { error: error }), rootEl);
	    };
	
	    render = function render() {
	        try {
	            renderApp();
	        } catch (error) {
	            renderError(error);
	        }
	    };
	
	    module.hot.accept('./components/CoreLayout', function () {
	        setTimeout(render);
	    });
	}
	// prevent pinch-to-zoom
	document.addEventListener('touchmove', function (event) {
	    event = event.originalEvent || event;
	    if (event.scale != 1) {
	        event.preventDefault();
	    }
	}, false);
	// prevent double-tap-to-zoom
	var lastTouchEnd = 0;
	document.addEventListener('touchend', function (event) {
	    var now = new Date().getTime();
	    if (now - lastTouchEnd <= 300) {
	        event.preventDefault();
	    }
	    lastTouchEnd = now;
	}, false);
	
	render();

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(6);

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = vendor_0e74e3b91b7f55dd9a1a;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(219);

/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(202);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.radiogreen = exports.palebanana = exports.purewhite = exports.midblue = exports.skin = exports.orange = exports.red = exports.yellow = exports.cdblue = exports.lightblue = exports.tileY2lat = exports.tileX2lng = exports.lat2tileY = exports.lng2tileX = exports.__ = exports.getLanguage = exports.getAngle = exports.getDistance = exports.earthRadiusKm = undefined;
	
	var _lodash = __webpack_require__(214);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Cesium = __webpack_require__(29);
	
	var _Cesium2 = _interopRequireDefault(_Cesium);
	
	var _de = __webpack_require__(96);
	
	var _de2 = _interopRequireDefault(_de);
	
	var _en = __webpack_require__(97);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _it = __webpack_require__(98);
	
	var _it2 = _interopRequireDefault(_it);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var earthRadiusKm = exports.earthRadiusKm = 6371; // Radius of the earth in km
	
	// distance helper
	var getDistance = exports.getDistance = function getDistance(lon1, lat1, lon2, lat2) {
	  var R = earthRadiusKm;
	  var dLat = _Cesium2.default.Math.toRadians(lat2 - lat1);
	  var dLon = _Cesium2.default.Math.toRadians(lon2 - lon1);
	  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(_Cesium2.default.Math.toRadians(lat1)) * Math.cos(_Cesium2.default.Math.toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
	  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  var d = R * c; // Distance in km
	  return d;
	};
	
	// angle helper
	var getAngle = exports.getAngle = function getAngle(A, B, C) {
	  var AB = Math.sqrt(Math.pow(B.x - A.x, 2) + Math.pow(B.y - A.y, 2));
	  var BC = Math.sqrt(Math.pow(B.x - C.x, 2) + Math.pow(B.y - C.y, 2));
	  var AC = Math.sqrt(Math.pow(C.x - A.x, 2) + Math.pow(C.y - A.y, 2));
	  return Math.acos((BC * BC + AB * AB - AC * AC) / (2 * BC * AB));
	};
	
	var getLanguage = exports.getLanguage = function getLanguage() {
	  var language = window.navigator.languages[0] || window.navigator.userLanguage;
	
	  return language ? language.split('-')[0].toLowerCase() : 'de';
	};
	
	var __ = exports.__ = function __(key) {
	  var dict = void 0;
	  switch (getLanguage()) {
	
	    case 'de':
	      dict = _de2.default;
	      break;
	
	    case 'it':
	      dict = _it2.default;
	      break;
	
	    case 'en':
	    default:
	      dict = _en2.default;
	      break;
	  }
	
	  return _lodash2.default.has(dict, key) && _lodash2.default.get(dict, key) != '' ? _lodash2.default.get(dict, key) : _lodash2.default.get(_en2.default, key);
	};
	
	var lng2tileX = exports.lng2tileX = function lng2tileX(lng) {
	  var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	
	  return Math.floor((lng + 180) / 360 * Math.pow(2, zoom));
	};
	
	var lat2tileY = exports.lat2tileY = function lat2tileY(lat) {
	  var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	
	  return Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom));
	};
	
	var tileX2lng = exports.tileX2lng = function tileX2lng(x) {
	  var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	
	  return x / Math.pow(2, zoom) * 360 - 180;
	};
	
	var tileY2lat = exports.tileY2lat = function tileY2lat(y) {
	  var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	
	  var n = Math.PI - 2 * Math.PI * y / Math.pow(2, zoom);
	  return 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)));
	};
	
	// dot color testing
	var lightblue = exports.lightblue = {
	  fill: new _Cesium2.default.Color(215 / 255, 238 / 255, 251 / 255, 1.0),
	  outline: new _Cesium2.default.Color(215 / 255, 238 / 255, 251 / 255, 0.15)
	};
	
	var cdblue = exports.cdblue = {
	  fill: new _Cesium2.default.Color(76 / 255, 207 / 255, 239 / 255, 1.0),
	  outline: new _Cesium2.default.Color(76 / 255, 207 / 255, 239 / 255, 0.15)
	};
	
	var yellow = exports.yellow = {
	  fill: new _Cesium2.default.Color(249 / 255, 203 / 255, 71 / 255, 1.0),
	  outline: new _Cesium2.default.Color(249 / 255, 203 / 255, 71 / 255, 0.15)
	};
	
	var red = exports.red = {
	  fill: new _Cesium2.default.Color(219 / 255, 68 / 255, 55 / 255, 1.0),
	  outline: new _Cesium2.default.Color(219 / 255, 68 / 255, 55 / 255, 0.15)
	};
	
	var orange = exports.orange = {
	  fill: new _Cesium2.default.Color(239 / 255, 154 / 255, 76 / 255, 1.0),
	  outline: new _Cesium2.default.Color(239 / 255, 154 / 255, 76 / 255, 0.15)
	};
	
	var skin = exports.skin = {
	  fill: new _Cesium2.default.Color(241 / 255, 171 / 255, 137 / 255, 1.0),
	  outline: new _Cesium2.default.Color(241 / 255, 171 / 255, 137 / 255, 0.15)
	};
	
	var midblue = exports.midblue = {
	  fill: new _Cesium2.default.Color(149 / 255, 224 / 255, 242 / 255, 1.0),
	  outline: new _Cesium2.default.Color(149 / 255, 224 / 255, 242 / 255, 0.15)
	};
	
	var purewhite = exports.purewhite = {
	  fill: new _Cesium2.default.Color(255 / 255, 255 / 255, 255 / 255, 1.0),
	  outline: new _Cesium2.default.Color(255 / 255, 255 / 255, 255 / 255, 0.15)
	};
	
	var palebanana = exports.palebanana = {
	  fill: new _Cesium2.default.Color(249 / 255, 227 / 255, 151 / 255, 1.0),
	  outline: new _Cesium2.default.Color(249 / 255, 227 / 255, 151 / 255, 0.2)
	};
	
	var radiogreen = exports.radiogreen = {
	  fill: new _Cesium2.default.Color(0 / 255, 255 / 255, 116 / 255, 1.0),
	  outline: new _Cesium2.default.Color(0 / 255, 255 / 255, 116 / 255, 0.2)
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(151),
	    getValue = __webpack_require__(175);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(7);
	
	var _Actions = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    arrayOf = _react.PropTypes.arrayOf,
	    oneOfType = _react.PropTypes.oneOfType,
	    element = _react.PropTypes.element,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(8);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(51);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(12);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(242);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(86);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(238);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(253);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(239);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(240);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(88);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(241);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(52);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(251);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(93);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(244);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(245);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(249);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(90);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(190);

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(208);

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(186),
	    listCacheDelete = __webpack_require__(187),
	    listCacheGet = __webpack_require__(188),
	    listCacheHas = __webpack_require__(189),
	    listCacheSet = __webpack_require__(190);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(14);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(184);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(10);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(46),
	    isLength = __webpack_require__(78);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _props2 = __webpack_require__(48);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEEK_ON_PLAY_EXPIRY = 5000;
	
	var Base = function (_Component) {
	  _inherits(Base, _Component);
	
	  function Base() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Base);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Base.__proto__ || Object.getPrototypeOf(Base)).call.apply(_ref, [this].concat(args))), _this), _this.isReady = false, _this.startOnPlay = true, _this.durationOnPlay = false, _this.seekOnPlay = null, _this.onPlay = function () {
	      var _this$props = _this.props,
	          volume = _this$props.volume,
	          onStart = _this$props.onStart,
	          onPlay = _this$props.onPlay,
	          onDuration = _this$props.onDuration,
	          playbackRate = _this$props.playbackRate;
	
	      if (_this.startOnPlay) {
	        _this.setPlaybackRate(playbackRate);
	        _this.setVolume(volume);
	        onStart();
	        _this.startOnPlay = false;
	      }
	      onPlay();
	      if (_this.seekOnPlay) {
	        _this.seekTo(_this.seekOnPlay);
	        _this.seekOnPlay = null;
	      }
	      if (_this.durationOnPlay) {
	        onDuration(_this.getDuration());
	        _this.durationOnPlay = false;
	      }
	    }, _this.onReady = function () {
	      var _this$props2 = _this.props,
	          onReady = _this$props2.onReady,
	          playing = _this$props2.playing,
	          onDuration = _this$props2.onDuration;
	
	      _this.isReady = true;
	      onReady();
	      if (playing || _this.preloading) {
	        _this.preloading = false;
	        if (_this.loadOnReady) {
	          _this.load(_this.loadOnReady);
	          _this.loadOnReady = null;
	        } else {
	          _this.play();
	        }
	      }
	      var duration = _this.getDuration();
	      if (duration) {
	        onDuration(duration);
	      } else {
	        _this.durationOnPlay = true;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Base, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var url = this.props.url;
	
	      this.mounted = true;
	      if (url) {
	        this.load(url);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	      this.mounted = false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          url = _props.url,
	          playing = _props.playing,
	          volume = _props.volume,
	          playbackRate = _props.playbackRate;
	      // Invoke player methods based on incoming props
	
	      if (url !== nextProps.url && nextProps.url) {
	        this.seekOnPlay = null;
	        this.startOnPlay = true;
	        this.load(nextProps.url);
	      } else if (url && !nextProps.url) {
	        this.stop();
	        clearTimeout(this.updateTimeout);
	      } else if (!playing && nextProps.playing) {
	        this.play();
	      } else if (playing && !nextProps.playing) {
	        this.pause();
	      } else if (volume !== nextProps.volume) {
	        this.setVolume(nextProps.volume);
	      } else if (playbackRate !== nextProps.playbackRate) {
	        this.setPlaybackRate(nextProps.playbackRate);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url;
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      var _this2 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && fraction !== 0) {
	        this.seekOnPlay = fraction;
	        setTimeout(function () {
	          _this2.seekOnPlay = null;
	        }, SEEK_ON_PLAY_EXPIRY);
	      }
	    }
	  }]);
	
	  return Base;
	}(_react.Component);
	
	Base.propTypes = _props2.propTypes;
	Base.defaultProps = _props2.defaultProps;
	exports['default'] = Base;
	module.exports = exports['default'];

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Base2 = __webpack_require__(27);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
	
	var FilePlayer = function (_Base) {
	  _inherits(FilePlayer, _Base);
	
	  function FilePlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilePlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FilePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          playsinline = _props.playsinline,
	          onPause = _props.onPause,
	          onEnded = _props.onEnded,
	          onError = _props.onError;
	
	      this.player.addEventListener('canplay', this.onReady);
	      this.player.addEventListener('play', this.onPlay);
	      this.player.addEventListener('pause', function () {
	        if (_this2.mounted) {
	          onPause();
	        }
	      });
	      this.player.addEventListener('ended', onEnded);
	      this.player.addEventListener('error', onError);
	      if (playsinline) {
	        this.player.setAttribute('playsinline', '');
	        this.player.setAttribute('webkit-playsinline', '');
	      }
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props2 = this.props,
	          onPause = _props2.onPause,
	          onEnded = _props2.onEnded,
	          onError = _props2.onError;
	
	      this.player.removeEventListener('canplay', this.onReady);
	      this.player.removeEventListener('play', this.onPlay);
	      this.player.removeEventListener('pause', onPause);
	      this.player.removeEventListener('ended', onEnded);
	      this.player.removeEventListener('error', onError);
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      this.player.src = url;
	      if (this.props.playing) {
	        this.player.load();
	      }
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.player.removeAttribute('src');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, fraction);
	      this.player.currentTime = this.getDuration() * fraction;
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.player.playbackRate = rate;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady) return null;
	      return this.player.currentTime / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || this.player.buffered.length === 0) return null;
	      return this.player.buffered.end(0) / this.getDuration();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          url = _props3.url,
	          loop = _props3.loop,
	          controls = _props3.controls,
	          fileConfig = _props3.fileConfig;
	
	      var Media = AUDIO_EXTENSIONS.test(url) ? 'audio' : 'video';
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement(Media, _extends({
	        ref: this.ref,
	        style: style,
	        preload: 'auto',
	        controls: controls,
	        loop: loop
	      }, fileConfig.attributes));
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return true;
	    }
	  }]);
	
	  return FilePlayer;
	}(_Base3['default']);
	
	FilePlayer.displayName = 'FilePlayer';
	exports['default'] = FilePlayer;
	module.exports = exports['default'];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(277))(1);

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(165);

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(200);

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(211);

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SET_CAMERA_IS_FLYING = exports.SET_SHOW_FORM = exports.SET_MODE = exports.SET_SELECTED_OBJECT = exports.SET_VIEWPORT = exports.SET_CENTER_HEIGHT = exports.SET_BOUNDS = exports.ZOOM_INCREMENT = exports.ZOOM_DECREMENT = exports.UNSET_SELECTED_ENTITY = exports.UNSET_ENTITY_IS_LOADING = exports.SET_ENTITY_IS_LOADING = exports.AWARD_FAILURE = exports.AWARD_SUCCESS = exports.AWARD_REQUEST = exports.AWARDS_FAILURE = exports.AWARDS_SUCCESS = exports.AWARDS_REQUEST = exports.AMBASSADOR_FAILURE = exports.AMBASSADOR_SUCCESS = exports.AMBASSADOR_REQUEST = exports.AMBASSADORS_FAILURE = exports.AMBASSADORS_SUCCESS = exports.AMBASSADORS_REQUEST = exports.VIDEO_FAILURE = exports.VIDEO_SUCCESS = exports.VIDEO_REQUEST = exports.VIDEOS_FAILURE = exports.VIDEOS_SUCCESS = exports.VIDEOS_REQUEST = exports.BATTERY_FAILURE = exports.BATTERY_SUCCESS = exports.BATTERY_REQUEST = exports.BATTERIES_FAILURE = exports.BATTERIES_SUCCESS = exports.BATTERIES_REQUEST = undefined;
	exports.loadBatteriesByBounds = loadBatteriesByBounds;
	exports.loadBattery = loadBattery;
	exports.loadVideosByBounds = loadVideosByBounds;
	exports.loadVideo = loadVideo;
	exports.loadAmbassadorsByBounds = loadAmbassadorsByBounds;
	exports.loadAmbassador = loadAmbassador;
	exports.loadAwardsByBounds = loadAwardsByBounds;
	exports.loadAward = loadAward;
	exports.setEntityIsLoading = setEntityIsLoading;
	exports.unsetEntityIsLoading = unsetEntityIsLoading;
	exports.unsetSelectedEntity = unsetSelectedEntity;
	exports.zoomIncrement = zoomIncrement;
	exports.zoomDecrement = zoomDecrement;
	exports.setBounds = setBounds;
	exports.setCenterHeight = setCenterHeight;
	exports.setViewport = setViewport;
	exports.setSelectedObject = setSelectedObject;
	exports.setMode = setMode;
	exports.setShowForm = setShowForm;
	exports.setCameraIsFlying = setCameraIsFlying;
	
	var _api = __webpack_require__(56);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	  Action Creators
	
	  These fire events which the reducer will handle
	  We will later call these functions from inside our component
	
	  Later these functions get bound to 'dispatch' fires the actual event
	  Right now they just return an object
	
	  It's a code convention to use all capitals and snake case for the event names
	  We use const to store the name of the event so it is immutable
	
	*/
	var BATTERIES_REQUEST = exports.BATTERIES_REQUEST = 'BATTERIES_REQUEST';
	var BATTERIES_SUCCESS = exports.BATTERIES_SUCCESS = 'BATTERIES_SUCCESS';
	var BATTERIES_FAILURE = exports.BATTERIES_FAILURE = 'BATTERIES_FAILURE';
	
	function fetchBatteriesByBounds() {
	  var fromLat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -90;
	  var fromLon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -180;
	  var toLat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
	  var toLon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180;
	  var per = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  return _defineProperty({}, _api.CALL_API, {
	    types: [BATTERIES_REQUEST, BATTERIES_SUCCESS, BATTERIES_FAILURE],
	    endpoint: 'batteries?searchwindow=' + fromLat + ',' + fromLon + '|' + toLat + ',' + toLon + '&per=' + per + '&page=' + page,
	    schema: _api.Schemas.BATTERY_ARRAY
	  });
	}
	
	function loadBatteriesByBounds() {
	  var fromLat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -90;
	  var fromLon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -180;
	  var toLat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
	  var toLon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180;
	  var per = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  return function (dispatch, getState) {
	    return dispatch(fetchBatteriesByBounds(fromLat, fromLon, toLat, toLon, per, page)).then(function (response) {
	      // load all pages
	      if (per === response.response.result.length) {
	        return dispatch(loadBatteriesByBounds(fromLat, fromLon, toLat, toLon, per, ++page));
	      } else {
	        return response;
	      }
	    });
	  };
	}
	
	var BATTERY_REQUEST = exports.BATTERY_REQUEST = 'BATTERY_REQUEST';
	var BATTERY_SUCCESS = exports.BATTERY_SUCCESS = 'BATTERY_SUCCESS';
	var BATTERY_FAILURE = exports.BATTERY_FAILURE = 'BATTERY_FAILURE';
	
	function fetchBattery(id) {
	  return _defineProperty({}, _api.CALL_API, {
	    types: [BATTERY_REQUEST, BATTERY_SUCCESS, BATTERY_FAILURE],
	    endpoint: 'batteries/' + id,
	    schema: _api.Schemas.BATTERY
	  });
	}
	
	function loadBattery(id) {
	  return function (dispatch, getState) {
	    return dispatch(fetchBattery(id));
	  };
	}
	
	var VIDEOS_REQUEST = exports.VIDEOS_REQUEST = 'VIDEOS_REQUEST';
	var VIDEOS_SUCCESS = exports.VIDEOS_SUCCESS = 'VIDEOS_SUCCESS';
	var VIDEOS_FAILURE = exports.VIDEOS_FAILURE = 'VIDEOS_FAILURE';
	
	function fetchVideosByBounds() {
	  var fromLat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -90;
	  var fromLon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -180;
	  var toLat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
	  var toLon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180;
	  var per = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  return _defineProperty({}, _api.CALL_API, {
	    types: [VIDEOS_REQUEST, VIDEOS_SUCCESS, VIDEOS_FAILURE],
	    endpoint: 'videos?searchwindow=' + fromLat + ',' + fromLon + '|' + toLat + ',' + toLon + '&per=' + per + '&page=' + page,
	    schema: _api.Schemas.VIDEO_ARRAY
	  });
	}
	
	function loadVideosByBounds() {
	  var fromLat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -90;
	  var fromLon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -180;
	  var toLat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
	  var toLon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180;
	  var per = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  return function (dispatch, getState) {
	    return dispatch(fetchVideosByBounds(fromLat, fromLon, toLat, toLon, per, page));
	  };
	}
	
	var VIDEO_REQUEST = exports.VIDEO_REQUEST = 'VIDEO_REQUEST';
	var VIDEO_SUCCESS = exports.VIDEO_SUCCESS = 'VIDEO_SUCCESS';
	var VIDEO_FAILURE = exports.VIDEO_FAILURE = 'VIDEO_FAILURE';
	
	function fetchVideo(id) {
	  return _defineProperty({}, _api.CALL_API, {
	    types: [VIDEO_REQUEST, VIDEO_SUCCESS, VIDEO_FAILURE],
	    endpoint: 'videos/' + id,
	    schema: _api.Schemas.VIDEO
	  });
	}
	
	function loadVideo(id) {
	  return function (dispatch, getState) {
	    return dispatch(fetchVideo(id));
	  };
	}
	
	var AMBASSADORS_REQUEST = exports.AMBASSADORS_REQUEST = 'AMBASSADORS_REQUEST';
	var AMBASSADORS_SUCCESS = exports.AMBASSADORS_SUCCESS = 'AMBASSADORS_SUCCESS';
	var AMBASSADORS_FAILURE = exports.AMBASSADORS_FAILURE = 'AMBASSADORS_FAILURE';
	
	function fetchAmbassadorsByBounds() {
	  var fromLat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -90;
	  var fromLon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -180;
	  var toLat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
	  var toLon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180;
	  var per = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 500;
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  return _defineProperty({}, _api.CALL_API, {
	    types: [AMBASSADORS_REQUEST, AMBASSADORS_SUCCESS, AMBASSADORS_FAILURE],
	    endpoint: 'ambassadors?searchwindow=' + fromLat + ',' + fromLon + '|' + toLat + ',' + toLon + '&per=' + per + '&page=' + page,
	    schema: _api.Schemas.AMBASSADOR_ARRAY
	  });
	}
	
	function loadAmbassadorsByBounds() {
	  var fromLat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -90;
	  var fromLon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -180;
	  var toLat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
	  var toLon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180;
	  var per = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 500;
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  return function (dispatch, getState) {
	    return dispatch(fetchAmbassadorsByBounds(fromLat, fromLon, toLat, toLon, per, page));
	  };
	}
	
	var AMBASSADOR_REQUEST = exports.AMBASSADOR_REQUEST = 'AMBASSADOR_REQUEST';
	var AMBASSADOR_SUCCESS = exports.AMBASSADOR_SUCCESS = 'AMBASSADOR_SUCCESS';
	var AMBASSADOR_FAILURE = exports.AMBASSADOR_FAILURE = 'AMBASSADOR_FAILURE';
	
	function fetchAmbassador(id) {
	  return _defineProperty({}, _api.CALL_API, {
	    types: [AMBASSADOR_REQUEST, AMBASSADOR_SUCCESS, AMBASSADOR_FAILURE],
	    endpoint: 'ambassadors/' + id,
	    schema: _api.Schemas.AMBASSADOR
	  });
	}
	
	function loadAmbassador(id) {
	  return function (dispatch, getState) {
	    return dispatch(fetchAmbassador(id));
	  };
	}
	
	var AWARDS_REQUEST = exports.AWARDS_REQUEST = 'AWARDS_REQUEST';
	var AWARDS_SUCCESS = exports.AWARDS_SUCCESS = 'AWARDS_SUCCESS';
	var AWARDS_FAILURE = exports.AWARDS_FAILURE = 'AWARDS_FAILURE';
	
	function fetchAwardsByBounds() {
	  var fromLat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -90;
	  var fromLon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -180;
	  var toLat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
	  var toLon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180;
	  var per = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  return _defineProperty({}, _api.CALL_API, {
	    types: [AWARDS_REQUEST, AWARDS_SUCCESS, AWARDS_FAILURE],
	    endpoint: 'awards?searchwindow=' + fromLat + ',' + fromLon + '|' + toLat + ',' + toLon + '&per=' + per + '&page=' + page,
	    schema: _api.Schemas.AWARD_ARRAY
	  });
	}
	
	function loadAwardsByBounds() {
	  var fromLat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -90;
	  var fromLon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -180;
	  var toLat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
	  var toLon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180;
	  var per = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  return function (dispatch, getState) {
	    return dispatch(fetchAwardsByBounds(fromLat, fromLon, toLat, toLon, per, page));
	  };
	}
	
	var AWARD_REQUEST = exports.AWARD_REQUEST = 'AWARD_REQUEST';
	var AWARD_SUCCESS = exports.AWARD_SUCCESS = 'AWARD_SUCCESS';
	var AWARD_FAILURE = exports.AWARD_FAILURE = 'AWARD_FAILURE';
	
	function fetchAward(id) {
	  return _defineProperty({}, _api.CALL_API, {
	    types: [AWARD_REQUEST, AWARD_SUCCESS, AWARD_FAILURE],
	    endpoint: 'awards/' + id,
	    schema: _api.Schemas.AWARD
	  });
	}
	
	function loadAward(id) {
	  return function (dispatch, getState) {
	    return dispatch(fetchAward(id));
	  };
	}
	
	var SET_ENTITY_IS_LOADING = exports.SET_ENTITY_IS_LOADING = 'SET_ENTITY_IS_LOADING';
	
	function setEntityIsLoading(entityType) {
	  return {
	    type: SET_ENTITY_IS_LOADING,
	    entityType: entityType
	  };
	}
	
	var UNSET_ENTITY_IS_LOADING = exports.UNSET_ENTITY_IS_LOADING = 'UNSET_ENTITY_IS_LOADING';
	
	function unsetEntityIsLoading() {
	  return {
	    type: UNSET_ENTITY_IS_LOADING
	  };
	}
	
	var UNSET_SELECTED_ENTITY = exports.UNSET_SELECTED_ENTITY = 'UNSET_SELECTED_ENTITY';
	
	function unsetSelectedEntity() {
	  return {
	    type: UNSET_SELECTED_ENTITY
	  };
	}
	
	var ZOOM_DECREMENT = exports.ZOOM_DECREMENT = 'ZOOM_DECREMENT';
	
	function zoomIncrement() {
	  return {
	    type: ZOOM_INCREMENT
	  };
	}
	
	var ZOOM_INCREMENT = exports.ZOOM_INCREMENT = 'ZOOM_INCREMENT';
	
	function zoomDecrement() {
	  return {
	    type: ZOOM_DECREMENT
	  };
	}
	
	var SET_BOUNDS = exports.SET_BOUNDS = 'SET_BOUNDS';
	
	function setBounds(bounds) {
	  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return {
	    type: SET_BOUNDS,
	    bounds: bounds,
	    duration: duration
	  };
	}
	
	var SET_CENTER_HEIGHT = exports.SET_CENTER_HEIGHT = 'SET_CENTER_HEIGHT';
	
	function setCenterHeight(center, height) {
	  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  return {
	    type: SET_CENTER_HEIGHT,
	    center: center,
	    height: height,
	    duration: duration
	  };
	}
	
	var SET_VIEWPORT = exports.SET_VIEWPORT = 'SET_VIEWPORT';
	
	function setViewport(bounds, center, height, magnitude) {
	  return {
	    type: SET_VIEWPORT,
	    bounds: bounds,
	    center: center,
	    height: height,
	    magnitude: magnitude
	  };
	}
	
	var SET_SELECTED_OBJECT = exports.SET_SELECTED_OBJECT = 'SET_SELECTED_OBJECT';
	
	function setSelectedObject(selectedObject) {
	  return {
	    type: SET_SELECTED_OBJECT,
	    selectedObject: selectedObject
	  };
	}
	
	var SET_MODE = exports.SET_MODE = 'SET_MODE';
	
	function setMode(mode) {
	  return {
	    type: SET_MODE,
	    mode: mode
	  };
	}
	
	var SET_SHOW_FORM = exports.SET_SHOW_FORM = 'SET_SHOW_FORM';
	
	function setShowForm(showForm) {
	  return {
	    type: SET_SHOW_FORM,
	    showForm: showForm
	  };
	}
	
	var SET_CAMERA_IS_FLYING = exports.SET_CAMERA_IS_FLYING = 'SET_CAMERA_IS_FLYING';
	
	function setCameraIsFlying(cameraIsFlying) {
	  return {
	    type: SET_CAMERA_IS_FLYING,
	    cameraIsFlying: cameraIsFlying
	  };
	}

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var urlQuery = new URLSearchParams(location.search);
	var paramMode = 'live';
	if (urlQuery.get('mode') == 'live' || urlQuery.get('mode') == 'stories' || urlQuery.get('mode') == 'ambassadors') {
	  paramMode = urlQuery.get('mode');
	}
	
	var initialStateMap = {
	  targetBounds: null,
	  targetCenter: null,
	  targetHeight: null,
	  targetDuration: null,
	
	  currentBounds: { west: -180, south: -90, east: 180, north: 90 },
	  currentCenter: null,
	  currentHeight: null,
	  currentMagnitude: null,
	
	  zoom: 0,
	  mode: paramMode,
	  showForm: false,
	  cameraIsFlying: false
	};
	
	exports.default = initialStateMap;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAwards = exports.getAmbassadors = exports.getVideos = exports.getSelectedEntity = exports.getBatteriesByTiles = exports.getBatteriesNetByBounds = exports.getBatteriesNet = exports.getWeightBounds = exports.getBatteriesByBounds = exports.getBatteries = undefined;
	
	var _reselect = __webpack_require__(276);
	
	var _Cesium = __webpack_require__(29);
	
	var _Cesium2 = _interopRequireDefault(_Cesium);
	
	var _d3Voronoi = __webpack_require__(118);
	
	var _helpers = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getMode = function getMode(state) {
	  return state.map.mode;
	};
	
	var getBounds = function getBounds(state) {
	  return state.map.currentBounds;
	};
	
	var getBoundsRound = (0, _reselect.createSelector)([getBounds], function (bounds) {
	
	  if (!bounds) {
	    return {
	      west: -180,
	      east: 180,
	      north: 90,
	      south: -90
	    };
	  }
	
	  return {
	    west: Math.max(-180, Math.floor(bounds.west) - .5),
	    east: Math.min(180, Math.ceil(bounds.east) + .5),
	    north: Math.min(90, Math.ceil(bounds.north) + .5),
	    south: Math.max(-90, Math.floor(bounds.south) - .5)
	  };
	});
	
	var getMagnitude = function getMagnitude(state) {
	  return state.map.currentMagnitude;
	};
	
	var batteryEntities = function batteryEntities(state) {
	  return state.entities.batteries;
	};
	
	var getBatteries = exports.getBatteries = (0, _reselect.createSelector)([batteryEntities, getMode], function (batteryEntities, mode) {
	
	  if (mode !== 'live') {
	    return {};
	  }
	
	  // console.log("getBatteries",Object.keys(batteryEntities).length)
	
	  var batteries = {};
	  var batteryIds = {};
	  var batteryIndex = 0;
	  // load all initial api battery pages first
	  if (!batteryEntities || window.api__batteriesCurrentPage < window.api__batteriesTotalPages) {
	    return {};
	  }
	  // console.log("batteries",Object.keys(batteryEntities).length)
	  return batteryEntities;
	
	  // let locations = {}
	  // let len = Object.keys(batteryEntities).length
	  // let keys = Object.keys(batteryEntities)
	
	  // for (let i=0; i<len; i++) {
	  //   if (batteries.length <= batteryIndex) {
	  //     return
	  //   }
	
	  //   let battery = batteryEntities[keys[batteryIndex]]
	
	  //   if ( ! battery) {
	  //     // console.log("no location")
	  //     batteryIndex++
	  //     continue
	  //   }
	
	  //   if (batteryIds[battery.id] === true) {
	  //     // console.log("id exists",battery.id)
	  //     batteryIndex++
	  //     continue
	  //   }
	
	  //   let location = battery.lng+'|'+battery.lat
	  //   // console.log(locations.indexOf(location))
	  //   if (locations[location] && locations[location] >= 1) {
	  //     // console.log("location already exists",location)
	  //     // batteryIndex++
	  //     // continue
	  //     locations[location] += 1
	  //     battery = spreadLatLng(battery, locations[location])
	  //   } else {
	  //     locations[location] = 1
	  //   }
	
	  //   // batteries[battery.id] = spreadLatLng(battery)
	  //   batteries[battery.id] = battery
	  //   // if (battery.lat === -33.7927 || battery.lng === 151.242 || [12240, 32668, 34220].indexOf(battery.id) >= 0) {
	  //   //   console.log(battery)
	  //   // }
	  //   if (batteries[battery.id].hasOwnProperty('battery')) {
	  //     // console.log(battery)
	  //     delete batteries[battery.id]['battery']
	  //   }
	  //   batteryIds[battery.id] = true
	
	  //   batteryIndex++
	  // }
	  // return batteries
	});
	
	var getBatteriesByBounds = exports.getBatteriesByBounds = (0, _reselect.createSelector)([getBatteries, getBoundsRound], function (batteries, bounds) {
	  // console.log(bounds)
	
	  var batteriesByBounds = Object.keys(batteries).reduce(function (acc, batteryId, index) {
	    var battery = batteries[batteryId];
	    if (battery.lng >= bounds.west && battery.lng <= bounds.east && battery.lat >= bounds.south && battery.lat <= bounds.north) {
	      acc[batteryId] = battery;
	    }
	    return acc;
	  }, {});
	
	  // console.log('batteriesByBounds', Object.keys(batteriesByBounds).length)
	
	  return batteriesByBounds;
	});
	
	var getWeightBounds = exports.getWeightBounds = (0, _reselect.createSelector)([getBatteriesByBounds], function (batteries) {
	
	  var w = null;
	  var s = null;
	  var e = null;
	  var n = null;
	
	  var batteriesWithWeight = Object.keys(batteries).reduce(function (acc, batteryId, index) {
	    var battery = batteries[batteryId];
	    if (battery.weight && battery.weight > 1) {
	      acc[batteryId] = battery;
	
	      if (!w || battery.lng < w) {
	        w = Math.floor(battery.lng);
	      }
	      if (!s || battery.lat < s) {
	        s = Math.floor(battery.lat);
	      }
	      if (!e || battery.lng > e) {
	        e = Math.ceil(battery.lng);
	      }
	      if (!n || battery.lat > n) {
	        n = Math.ceil(battery.lat);
	      }
	    }
	    return acc;
	  }, {});
	
	  var deltaLat = n - s;
	  var deltaLng = e - w;
	  // console.log(deltaLat,deltaLng)
	  if (Object.keys(batteriesWithWeight).length > 0 && deltaLat <= 5 && deltaLng <= 5) {
	    return new _Cesium2.default.Rectangle(w, s, e, n);
	  }
	  return null;
	});
	
	var getBatteriesNet = exports.getBatteriesNet = (0, _reselect.createSelector)([getBatteriesByBounds, getBoundsRound], function (batteries, bounds) {
	
	  switch (true) {
	    case bounds.north - bounds.south > 5:
	    case bounds.east - bounds.west > 5:
	      return [];
	  }
	
	  var R = _helpers.earthRadiusKm;
	  var v = (0, _d3Voronoi.voronoi)();
	  var edges = [];
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(batteries)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      edges.push([batteries[key].lat, batteries[key].lng]);
	    }
	
	    // console.log("edges", edges.length)
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  var links = v.links(edges);
	  // console.log("links", links.length)
	  // return links
	
	  var shortLinks = [];
	  // console.log('voronoi',links.length)
	  for (var l = 0; l < links.length; l++) {
	    var link = links[l];
	    var length = (0, _helpers.getDistance)(link.source[1], link.source[0], link.target[1], link.target[0]);
	    if (length <= 100) {
	      link.length = length;
	      shortLinks.push(link);
	    }
	  }
	  // console.log("short links",shortLinks.length)
	  shortLinks.sort(function (a, b) {
	    if (a.length < b.length) {
	      return -1;
	    }
	    if (a.length > b.length) {
	      return 1;
	    }
	    // a must be equal to b
	    return 0;
	  });
	  // console.log('sorted links')
	  // console.log("shortLinks",shortLinks.length)
	  return shortLinks;
	});
	
	var getBatteriesNetByBounds = exports.getBatteriesNetByBounds = (0, _reselect.createSelector)([getBatteriesNet, getBoundsRound, getMagnitude], function (links, bounds, magnitude) {
	  // console.log("getBatteriesNetByBounds", links.length)
	
	  // let linksByBounds = []
	  // if (Math.abs(magnitude-earthRadiusKm) > 50) {
	  //   return linksByBounds
	  // }
	  // let deltaLat = bounds.east-bounds.west
	  // let deltaLng = bounds.north-bounds.south
	  // // console.log(deltaLat,deltaLng)
	  // if (deltaLat > 1 || deltaLng > 1) {
	  //   return linksByBounds
	  // }
	
	  // for (let l=0; l<links.length; l++) {
	  //   let link = links[l]
	  //   switch (true) {
	  //     // source is in bounds
	  //     case link.source[1] > bounds.west && link.source[1] < bounds.east && link.source[0] > bounds.south && link.source[0] < bounds.north :
	  //       linksByBounds.push(link)
	  //       break
	
	  //     // target is in bounds
	  //     case link.target[1] > bounds.west && link.target[1] < bounds.east && link.target[0] > bounds.south && link.target[0] < bounds.north :
	  //       linksByBounds.push(link)
	  //       break
	  //   }
	  // }
	
	  var batteriesNet = [];
	  var positions = {};
	  // for (let link of linksByBounds) {
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = links[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var link = _step2.value;
	
	
	      var sourceKey = link.source[0] + ',' + link.source[1];
	      if (positions[sourceKey] === undefined) {
	        positions[sourceKey] = [];
	      }
	
	      var skip = false;
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = Object.keys(positions[sourceKey])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var vKey = _step3.value;
	
	          var v = positions[sourceKey][vKey];
	          var deg = _Cesium2.default.Math.toDegrees((0, _helpers.getAngle)({ x: v[0], y: v[1] }, { x: link.source[0], y: link.source[1] }, { x: link.target[0], y: link.target[1] }));
	          // if (isNaN(deg)) { console.log({v,link}) }
	          if (deg < 45) {
	            skip = true;
	            continue;
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      if (skip) {
	        // console.log("skip")
	        continue;
	      }
	
	      var targetKey = link.target[0] + ',' + link.target[1];
	      if (positions[targetKey] === undefined) {
	        positions[targetKey] = [];
	      }
	
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = Object.keys(positions[targetKey])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var _vKey = _step4.value;
	
	          var _v = positions[targetKey][_vKey];
	          var _deg = _Cesium2.default.Math.toDegrees((0, _helpers.getAngle)({ x: _v[0], y: _v[1] }, { x: link.target[0], y: link.target[1] }, { x: link.source[0], y: link.source[1] }));
	          // if (isNaN(deg)) { console.log({v,link}) }
	          if (_deg < 45) {
	            skip = true;
	            continue;
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      if (skip) {
	        // console.log("skip")
	        continue;
	      }
	
	      positions[sourceKey].push(link.target);
	      positions[targetKey].push(link.source);
	
	      batteriesNet.push(link);
	    }
	    // console.log('sort out')
	
	
	    // console.log("getBatteriesNetByBounds",batteriesNet.length)
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return batteriesNet;
	});
	
	var getBatteriesByTiles = exports.getBatteriesByTiles = (0, _reselect.createSelector)([getBatteries], function (batteries) {
	  var batteriesByTiles = {};
	
	  for (var id in batteries) {
	
	    var battery = batteries[id];
	
	    var tileX = (0, _helpers.lng2tileX)(battery.lng);
	    var tileY = (0, _helpers.lat2tileY)(battery.lat);
	    var tileKey = '_' + tileX + '_' + tileY;
	    // console.log(tileKey)
	    if (typeof batteriesByTiles[tileKey] == "undefined") {
	      var tile = { batteries: [battery] };
	      batteriesByTiles[tileKey] = tile;
	    } else {
	      batteriesByTiles[tileKey].batteries.push(battery);
	    }
	  }
	  // console.log(batteriesByTiles)
	  // console.log("COMPLETE getBatteriesByTiles",Object.keys(batteriesByTiles).length)
	  // console.log(batteriesByTiles)
	  return batteriesByTiles;
	});
	
	var selectedEntity = function selectedEntity(state) {
	  return state.entities.selected;
	};
	
	var getSelectedEntity = exports.getSelectedEntity = (0, _reselect.createSelector)([selectedEntity], function (selectedEntity) {
	  return spreadLatLng(selectedEntity);
	});
	
	var videoEntities = function videoEntities(state) {
	  return state.entities.videos;
	};
	
	var getVideos = exports.getVideos = (0, _reselect.createSelector)([videoEntities, getMode], function (videoEntities, mode) {
	  if (mode !== 'stories') {
	    return {};
	  }
	
	  var videos = {};
	  var _iteratorNormalCompletion5 = true;
	  var _didIteratorError5 = false;
	  var _iteratorError5 = undefined;
	
	  try {
	    for (var _iterator5 = Object.keys(videoEntities)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	      var key = _step5.value;
	
	      var video = videoEntities[key];
	      videos[video.id] = spreadLatLng(video);
	    }
	  } catch (err) {
	    _didIteratorError5 = true;
	    _iteratorError5 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion5 && _iterator5.return) {
	        _iterator5.return();
	      }
	    } finally {
	      if (_didIteratorError5) {
	        throw _iteratorError5;
	      }
	    }
	  }
	
	  return videos;
	});
	
	var ambassadorEntities = function ambassadorEntities(state) {
	  return state.entities.ambassadors;
	};
	
	var getAmbassadors = exports.getAmbassadors = (0, _reselect.createSelector)([ambassadorEntities, getMode], function (ambassadorEntities, mode) {
	  if (mode !== 'ambassadors') {
	    return {};
	  }
	
	  var ambassadors = {};
	  var _iteratorNormalCompletion6 = true;
	  var _didIteratorError6 = false;
	  var _iteratorError6 = undefined;
	
	  try {
	    for (var _iterator6 = Object.keys(ambassadorEntities)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	      var key = _step6.value;
	
	      var ambassador = ambassadorEntities[key];
	      ambassadors[ambassador.id] = spreadLatLng(ambassador, 0, 0);
	    }
	  } catch (err) {
	    _didIteratorError6 = true;
	    _iteratorError6 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion6 && _iterator6.return) {
	        _iterator6.return();
	      }
	    } finally {
	      if (_didIteratorError6) {
	        throw _iteratorError6;
	      }
	    }
	  }
	
	  return ambassadors;
	});
	
	var awardEntities = function awardEntities(state) {
	  return state.entities.awards;
	};
	
	var getAwards = exports.getAwards = (0, _reselect.createSelector)([awardEntities], function (awardEntities) {
	  var awards = {};
	  var _iteratorNormalCompletion7 = true;
	  var _didIteratorError7 = false;
	  var _iteratorError7 = undefined;
	
	  try {
	    for (var _iterator7 = Object.keys(awardEntities)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	      var key = _step7.value;
	
	      var award = awardEntities[key];
	      awards[award.id] = spreadLatLng(award);
	    }
	  } catch (err) {
	    _didIteratorError7 = true;
	    _iteratorError7 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion7 && _iterator7.return) {
	        _iterator7.return();
	      }
	    } finally {
	      if (_didIteratorError7) {
	        throw _iteratorError7;
	      }
	    }
	  }
	
	  return awards;
	});
	
	var spreadLatLng = function spreadLatLng(object) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var multiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	
	  var r = 100000;
	
	  if (object && object.lat && object.lng) {
	
	    var latRemainder = object.lat * r % Math.floor(object.lat * r);
	    var lngRemainder = object.lng * r % Math.floor(object.lng * r);
	
	    if (latRemainder == 0 || lngRemainder == 0) {
	      var lat = object.lat;
	      var lng = object.lng;
	
	      var angle = Math.sqrt(offset) * 887; // object.id
	
	      var x = angle * Math.cos(angle);
	      var y = angle * Math.sin(angle);
	
	      lat += y / 1000000 * multiplier;
	      lng += x / 1000000 * multiplier;
	
	      object.lat = lat; // +offset
	      object.lng = lng; // +offset
	    }
	  }
	
	  return object;
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(11);
	
	var _DOMUtils = __webpack_require__(21);
	
	var _DOMStateStorage = __webpack_require__(57);
	
	var _PathUtils = __webpack_require__(7);
	
	var _ExecutionEnvironment = __webpack_require__(37);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(123);
	
	var _PathUtils = __webpack_require__(7);
	
	var _runTransitionHook = __webpack_require__(39);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(20);
	
	var _LocationUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(10),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(72);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 42 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(147),
	    isObjectLike = __webpack_require__(19);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(5),
	    stubFalse = __webpack_require__(218);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)(module)))

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(31),
	    isObject = __webpack_require__(4);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(152),
	    baseUnary = __webpack_require__(159),
	    nodeUtil = __webpack_require__(199);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultProps = exports.propTypes = undefined;
	
	var _propTypes = __webpack_require__(225);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var string = _propTypes2['default'].string,
	    bool = _propTypes2['default'].bool,
	    number = _propTypes2['default'].number,
	    oneOfType = _propTypes2['default'].oneOfType,
	    shape = _propTypes2['default'].shape,
	    object = _propTypes2['default'].object,
	    func = _propTypes2['default'].func;
	var propTypes = exports.propTypes = {
	  url: string,
	  playing: bool,
	  loop: bool,
	  controls: bool,
	  volume: number,
	  playbackRate: number,
	  width: oneOfType([string, number]),
	  height: oneOfType([string, number]),
	  hidden: bool,
	  className: string,
	  style: object,
	  progressFrequency: number,
	  playsinline: bool,
	  soundcloudConfig: shape({
	    clientId: string,
	    showArtwork: bool
	  }),
	  youtubeConfig: shape({
	    playerVars: object,
	    preload: bool
	  }),
	  vimeoConfig: shape({
	    iframeParams: object,
	    preload: bool
	  }),
	  vidmeConfig: shape({
	    format: string
	  }),
	  fileConfig: shape({
	    attributes: object
	  }),
	  onReady: func,
	  onStart: func,
	  onPlay: func,
	  onPause: func,
	  onBuffer: func,
	  onEnded: func,
	  onError: func,
	  onDuration: func,
	  onProgress: func
	};
	
	var defaultProps = exports.defaultProps = {
	  playing: false,
	  loop: false,
	  controls: false,
	  volume: 0.8,
	  playbackRate: 1,
	  width: 640,
	  height: 360,
	  hidden: false,
	  progressFrequency: 1000,
	  playsinline: false,
	  soundcloudConfig: {
	    clientId: 'e8b6f84fbcad14c301ca1355cae1dea2',
	    showArtwork: true
	  },
	  youtubeConfig: {
	    playerVars: {},
	    preload: false
	  },
	  vimeoConfig: {
	    iframeParams: {},
	    preload: false
	  },
	  vidmeConfig: {
	    format: null
	  },
	  fileConfig: {
	    attributes: {}
	  },
	  onReady: function onReady() {},
	  onStart: function onStart() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onProgress: function onProgress() {}
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  eventIndex: _react.PropTypes.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getRouteParams = __webpack_require__(248);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(50);
	
	var _RouteUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    array = _React$PropTypes.array,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(197);

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logoWhite = __webpack_require__(268);
	
	var _logoWhite2 = _interopRequireDefault(_logoWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logo = function (_React$Component) {
	  _inherits(Logo, _React$Component);
	
	  function Logo(props) {
	    _classCallCheck(this, Logo);
	
	    return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).call(this, props));
	  }
	
	  _createClass(Logo, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        { className: 'Logo', ref: 'logo', href: 'https://sonnen.de/', target: '_blank' },
	        _react2.default.createElement('img', { className: 'Logo-image', src: 'data:image/svg+xml;base64,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' })
	      );
	    }
	  }]);
	
	  return Logo;
	}(_react2.default.Component);
	
	exports.default = Logo;

/***/ },
/* 55 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialStateEntities = {
	  batteries: {},
	  batteryLocations: {},
	  videos: {},
	  ambassadors: {},
	  awards: {},
	  selected: null
	};
	
	exports.default = initialStateEntities;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CALL_API = exports.Schemas = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _normalizr = __webpack_require__(223);
	
	var _humps = __webpack_require__(129);
	
	__webpack_require__(60);
	
	// import { oauthParams } from 'Oauth'
	
	// let API_ROOT = (process.env.NODE_ENV === 'production') 
	//   ? 'https://core-api.sonnenbatterie.de/'
	//   : 'http://localhost:3000/'
	var API_ROOT = 'https://core-api.sonnenbatterie.de/sonnen_community/';
	
	// 'https://realdaten.sonnenbatterie.de/'
	
	// Fetches an API response and normalizes the result JSON according to schema.
	// This makes every API response have the same shape, regardless of how nested it was.
	function callApi(endpoint, schema) {
	  var fullUrl = endpoint.indexOf(API_ROOT) === -1 ? API_ROOT + endpoint : endpoint;
	
	  return fetch(fullUrl, {
	    headers: {
	      'Accept': 'application/vnd.sonnenbatterie.api.core.v3+json'
	    }
	  }).then(function (response) {
	    return response.json().then(function (json) {
	      return { json: json, response: response };
	    });
	  }).then(function (_ref) {
	    var json = _ref.json,
	        response = _ref.response;
	
	
	    // quickfix to remove root element
	    if (json.result && typeof json.result !== 'undefined') {
	      json = json.result;
	    } else if (json.results && typeof json.results !== 'undefined') {
	      // global workaround (because meta paging is not stored)
	      // todo: replace api middleware with axios
	      window['api__' + schema._itemSchema._key + 'CurrentPage'] = json.current_page;
	      window['api__' + schema._itemSchema._key + 'TotalPages'] = json.total_pages;
	      json = json.results;
	    } else if (json.status == 'ZERO_RESULTS') {
	      json = [];
	    }
	    // console.log(json.length)
	
	    if (!response.ok) {
	      return Promise.reject(json);
	    }
	
	    var camelizedJson = (0, _humps.camelizeKeys)(json);
	
	    return Object.assign({}, (0, _normalizr.normalize)(camelizedJson, schema));
	  });
	}
	
	// We use this Normalizr schemas to transform API responses from a nested form
	// to a flat form where repos and users are placed in `entities`, and nested
	// JSON objects are replaced with their IDs. This is very convenient for
	// consumption by reducers, because we can easily build a normalized tree
	// and keep it updated as we fetch more data.
	
	// Read more about Normalizr: https://github.com/gaearon/normalizr
	
	var energyMapSchema = new _normalizr.Schema('energy_maps', {
	  idAttribute: 'id'
	});
	var placesSchema = new _normalizr.Schema('places', {
	  idAttribute: 'id'
	});
	var batteriesSchema = new _normalizr.Schema('batteries', {
	  idAttribute: 'id'
	});
	var videosSchema = new _normalizr.Schema('videos', {
	  idAttribute: 'id'
	});
	var ambassadorsSchema = new _normalizr.Schema('ambassadors', {
	  idAttribute: 'id'
	});
	var awardsSchema = new _normalizr.Schema('awards', {
	  idAttribute: 'id'
	});
	
	// Schemas for Github API responses.
	var Schemas = exports.Schemas = {
	  ENERGY_MAP: energyMapSchema,
	  ENERGY_MAP_ARRAY: (0, _normalizr.arrayOf)(energyMapSchema),
	  PLACE: placesSchema,
	  PLACE_ARRAY: (0, _normalizr.arrayOf)(placesSchema),
	  BATTERY: batteriesSchema,
	  BATTERY_ARRAY: (0, _normalizr.arrayOf)(batteriesSchema),
	  VIDEO: videosSchema,
	  VIDEO_ARRAY: (0, _normalizr.arrayOf)(videosSchema),
	  AMBASSADOR: ambassadorsSchema,
	  AMBASSADOR_ARRAY: (0, _normalizr.arrayOf)(ambassadorsSchema),
	  AWARD: awardsSchema,
	  AWARD_ARRAY: (0, _normalizr.arrayOf)(awardsSchema)
	};
	
	// Action key that carries API call info interpreted by this Redux middleware.
	var CALL_API = exports.CALL_API = Symbol('Call API');
	
	// A Redux middleware that interprets actions with CALL_API info specified.
	// Performs the call and promises when such actions are dispatched.
	
	exports.default = function (store) {
	  return function (next) {
	    return function (action) {
	      var callAPI = action[CALL_API];
	      if (typeof callAPI === 'undefined') {
	        return next(action);
	      }
	
	      var endpoint = callAPI.endpoint;
	      var schema = callAPI.schema,
	          types = callAPI.types;
	
	
	      if (typeof endpoint === 'function') {
	        endpoint = endpoint(store.getState());
	      }
	
	      if (typeof endpoint !== 'string') {
	        throw new Error('Specify a string endpoint URL.');
	      }
	      if (!schema) {
	        throw new Error('Specify one of the exported Schemas.');
	      }
	      if (!Array.isArray(types) || types.length !== 3) {
	        throw new Error('Expected an array of three action types.');
	      }
	      if (!types.every(function (type) {
	        return typeof type === 'string';
	      })) {
	        throw new Error('Expected action types to be strings.');
	      }
	
	      function actionWith(data) {
	        var finalAction = Object.assign({}, action, data);
	        delete finalAction[CALL_API];
	        return finalAction;
	      }
	
	      var _types = _slicedToArray(types, 3),
	          requestType = _types[0],
	          successType = _types[1],
	          failureType = _types[2];
	
	      next(actionWith({ type: requestType }));
	
	      return callApi(endpoint, schema).then(function (response) {
	        return next(actionWith({
	          response: response,
	          type: successType,
	          isFetching: false
	        }));
	      }, function (error) {
	        return next(actionWith({
	          type: failureType,
	          error: error.message || 'Something bad happened',
	          isFetching: false
	        }));
	      });
	    };
	  };
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(39);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(81);
	
	var _runTransitionHook = __webpack_require__(39);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(11);
	
	var _PathUtils = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(130);
	module.exports = self.fetch.bind(self);


/***/ },
/* 61 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(191),
	    mapCacheDelete = __webpack_require__(192),
	    mapCacheGet = __webpack_require__(193),
	    mapCacheHas = __webpack_require__(194),
	    mapCacheSet = __webpack_require__(195);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(10),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(62),
	    setCacheAdd = __webpack_require__(201),
	    setCacheHas = __webpack_require__(202);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(22),
	    stackClear = __webpack_require__(205),
	    stackDelete = __webpack_require__(206),
	    stackGet = __webpack_require__(207),
	    stackHas = __webpack_require__(208),
	    stackSet = __webpack_require__(209);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(5);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(158),
	    isArguments = __webpack_require__(44),
	    isArray = __webpack_require__(15),
	    isBuffer = __webpack_require__(45),
	    isIndex = __webpack_require__(74),
	    isTypedArray = __webpack_require__(47);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 68 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(41),
	    eq = __webpack_require__(14);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(76),
	    overRest = __webpack_require__(200),
	    setToString = __webpack_require__(203);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 71 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(10);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(64),
	    arraySome = __webpack_require__(139),
	    cacheHas = __webpack_require__(71);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 74 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 75 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(26),
	    isObjectLike = __webpack_require__(19);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 78 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(67),
	    baseKeysIn = __webpack_require__(154),
	    isArrayLike = __webpack_require__(26);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isObject = __webpack_require__(4);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnionSchema = function () {
	  function UnionSchema(itemSchema, options) {
	    _classCallCheck(this, UnionSchema);
	
	    if (!(0, _isObject2.default)(itemSchema)) {
	      throw new Error('UnionSchema requires item schema to be an object.');
	    }
	
	    if (!options || !options.schemaAttribute) {
	      throw new Error('UnionSchema requires schemaAttribute option.');
	    }
	
	    this._itemSchema = itemSchema;
	
	    var schemaAttribute = options.schemaAttribute;
	    this._getSchema = typeof schemaAttribute === 'function' ? schemaAttribute : function (x) {
	      return x[schemaAttribute];
	    };
	  }
	
	  _createClass(UnionSchema, [{
	    key: 'getItemSchema',
	    value: function getItemSchema() {
	      return this._itemSchema;
	    }
	  }, {
	    key: 'getSchemaKey',
	    value: function getSchemaKey(item) {
	      return this._getSchema(item);
	    }
	  }]);
	
	  return UnionSchema;
	}();
	
	exports.default = UnionSchema;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(254);
	var objectAssign = __webpack_require__(228);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
	
					key = key.replace(/\[\]$/, '');
	
					if (!result || accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props3 = __webpack_require__(48);
	
	var _YouTube = __webpack_require__(234);
	
	var _YouTube2 = _interopRequireDefault(_YouTube);
	
	var _SoundCloud = __webpack_require__(229);
	
	var _SoundCloud2 = _interopRequireDefault(_SoundCloud);
	
	var _Vimeo = __webpack_require__(232);
	
	var _Vimeo2 = _interopRequireDefault(_Vimeo);
	
	var _FilePlayer = __webpack_require__(28);
	
	var _FilePlayer2 = _interopRequireDefault(_FilePlayer);
	
	var _Streamable = __webpack_require__(230);
	
	var _Streamable2 = _interopRequireDefault(_Streamable);
	
	var _Vidme = __webpack_require__(231);
	
	var _Vidme2 = _interopRequireDefault(_Vidme);
	
	var _Wistia = __webpack_require__(233);
	
	var _Wistia2 = _interopRequireDefault(_Wistia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactPlayer = function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  function ReactPlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.seekTo = function (fraction) {
	      if (_this.player) {
	        _this.player.seekTo(fraction);
	      }
	    }, _this.getDuration = function () {
	      if (!_this.player) return null;
	      return _this.player.getDuration();
	    }, _this.getCurrentTime = function () {
	      if (!_this.player) return null;
	      var duration = _this.player.getDuration();
	      var fractionPlayed = _this.player.getFractionPlayed();
	      if (duration === null || fractionPlayed === null) {
	        return null;
	      }
	      return fractionPlayed * duration;
	    }, _this.progress = function () {
	      if (_this.props.url && _this.player) {
	        var loaded = _this.player.getFractionLoaded() || 0;
	        var played = _this.player.getFractionPlayed() || 0;
	        var duration = _this.player.getDuration();
	        var progress = {};
	        if (loaded !== _this.prevLoaded) {
	          progress.loaded = loaded;
	          if (duration) {
	            progress.loadedSeconds = progress.loaded * duration;
	          }
	        }
	        if (played !== _this.prevPlayed) {
	          progress.played = played;
	          if (duration) {
	            progress.playedSeconds = progress.played * duration;
	          }
	        }
	        if (progress.loaded || progress.played) {
	          _this.props.onProgress(progress);
	        }
	        _this.prevLoaded = loaded;
	        _this.prevPlayed = played;
	      }
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
	    }, _this.ref = function (player) {
	      _this.player = player;
	    }, _this.renderPlayer = function (Player) {
	      var active = Player.canPlay(_this.props.url);
	
	      var _this$props = _this.props,
	          youtubeConfig = _this$props.youtubeConfig,
	          soundcloudConfig = _this$props.soundcloudConfig,
	          vimeoConfig = _this$props.vimeoConfig,
	          vidmeConfig = _this$props.vidmeConfig,
	          fileConfig = _this$props.fileConfig,
	          activeProps = _objectWithoutProperties(_this$props, ['youtubeConfig', 'soundcloudConfig', 'vimeoConfig', 'vidmeConfig', 'fileConfig']);
	
	      var props = active ? _extends({}, activeProps, { ref: _this.ref }) : {};
	      return _react2['default'].createElement(Player, _extends({
	        key: Player.displayName,
	        youtubeConfig: youtubeConfig,
	        soundcloudConfig: soundcloudConfig,
	        vimeoConfig: vimeoConfig,
	        vidmeConfig: vidmeConfig,
	        fileConfig: fileConfig
	      }, props));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.progress();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.volume !== nextProps.volume || this.props.playbackRate !== nextProps.playbackRate || this.props.height !== nextProps.height || this.props.width !== nextProps.width || this.props.hidden !== nextProps.hidden;
	    }
	  }, {
	    key: 'renderPlayers',
	    value: function renderPlayers() {
	      // Build array of players to render based on URL and preload config
	      var _props = this.props,
	          url = _props.url,
	          youtubeConfig = _props.youtubeConfig,
	          vimeoConfig = _props.vimeoConfig;
	
	      var players = [];
	      if (_YouTube2['default'].canPlay(url)) {
	        players.push(_YouTube2['default']);
	      } else if (_SoundCloud2['default'].canPlay(url)) {
	        players.push(_SoundCloud2['default']);
	      } else if (_Vimeo2['default'].canPlay(url)) {
	        players.push(_Vimeo2['default']);
	      } else if (_Streamable2['default'].canPlay(url)) {
	        players.push(_Streamable2['default']);
	      } else if (_Vidme2['default'].canPlay(url)) {
	        players.push(_Vidme2['default']);
	      } else if (_Wistia2['default'].canPlay(url)) {
	        players.push(_Wistia2['default']);
	      } else if (url) {
	        // Fall back to FilePlayer if nothing else can play the URL
	        players.push(_FilePlayer2['default']);
	      }
	      // Render additional players if preload config is set
	      if (!_YouTube2['default'].canPlay(url) && youtubeConfig.preload) {
	        players.push(_YouTube2['default']);
	      }
	      if (!_Vimeo2['default'].canPlay(url) && vimeoConfig.preload) {
	        players.push(_Vimeo2['default']);
	      }
	      return players.map(this.renderPlayer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          style = _props2.style,
	          width = _props2.width,
	          height = _props2.height,
	          className = _props2.className,
	          hidden = _props2.hidden;
	
	      var players = this.renderPlayers();
	      return _react2['default'].createElement(
	        'div',
	        { style: _extends({}, style, { width: width, height: height }), className: className, hidden: hidden },
	        players
	      );
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	ReactPlayer.displayName = 'ReactPlayer';
	ReactPlayer.propTypes = _props3.propTypes;
	ReactPlayer.defaultProps = _props3.defaultProps;
	exports['default'] = ReactPlayer;
	module.exports = exports['default'];

/***/ },
/* 83 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(85);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(83);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(237);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(236);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 85 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(51);
	
	var _ContextUtils = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    bool = _React$PropTypes.bool,
	    object = _React$PropTypes.object,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func,
	    oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object, func]),
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 87 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(8);
	
	var _PatternUtils = __webpack_require__(12);
	
	var _InternalPropTypes = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 89 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(59);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(58);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(128);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(93);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(246);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(243);
	
	var _isActive2 = __webpack_require__(250);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(247);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(252);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(59);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(58);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(201);

/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";module.exports={"type":"Topology","arcs":[[[122103,52046],[96,186],[94,182],[101,195],[121,235],[114,221],[94,181],[0,93],[0,200],[0,137],[0,379],[0,232],[0,221],[0,228]],[[122103,52046],[-160,-196],[-180,-222],[-189,-233],[-122,-150],[-194,-238],[-160,-198],[-166,-216],[-150,-196],[-194,-271],[-126,-176],[-198,-275],[-124,-173],[-19,-10],[-177,13],[-173,13],[-221,16],[-25,0],[-64,-17],[-39,-15],[-159,-47],[-29,-12],[-132,-74],[-135,-88],[-71,-67],[-55,-97],[-23,-69],[-25,-31],[-42,-26],[-282,-66],[-81,-9],[-132,-52],[-71,-88],[-20,-44]],[[113230,71188],[66,70],[1,57],[114,135],[-1,13],[-31,35]],[[114073,72167],[-43,5],[-53,40],[-10,35],[-16,12],[-38,5],[-71,18],[-83,-61],[-35,-101],[-7,-47],[-28,-99],[10,-61],[4,-79],[8,-65],[-8,-38],[-16,-21],[5,-15],[14,-5],[46,17],[47,-17],[46,-34],[4,-21],[-33,-13],[-76,-51],[-55,-58],[-14,-54],[-36,-116],[5,-23],[18,-14],[125,12],[113,47],[85,49],[27,-3]],[[113787,72735],[74,6],[56,-10],[66,-3],[53,36],[25,108],[30,17],[16,-25]],[[114226,72447],[9,39],[36,66],[36,72],[-20,40],[-7,34],[-2,41],[25,38],[-12,47],[-19,47],[-14,24],[0,43],[9,33],[12,51]],[[113074,74369],[-25,-7],[-40,23],[-24,7],[-23,-22],[-25,-15],[-23,-7],[-20,-2],[-33,-16],[-39,4],[-57,13],[-33,-32],[-7,4],[-5,80],[-21,32],[-26,18],[-38,-7],[-50,2],[-37,14],[-73,-23],[-59,-24],[-43,-24],[-32,2],[-56,21],[-41,25],[-5,21]],[[141370,74724],[8,-10],[26,-19],[28,-10],[33,19],[41,15],[22,-8],[3,-26],[-25,-117],[2,-46],[41,-96],[53,-155],[51,-146],[29,-96],[29,-39],[122,-40],[100,-32],[60,-54],[66,-52],[46,-32],[22,-40],[4,-37],[-4,-25],[-25,-32],[-115,-83],[-14,-27],[-3,-35],[22,-103],[14,-65],[4,-131],[8,-124],[41,-57],[33,-37]],[[140885,74406],[-11,-40],[-20,-58],[-70,-44],[-70,-31],[-17,-19],[-5,-25],[-34,-50],[-66,-42],[-55,4],[-34,13],[-184,-73],[-85,2],[-66,-48],[-49,-43],[-99,-47],[-67,0],[-99,28],[-122,53],[-49,31],[-45,-2],[-107,8],[-106,26],[-126,31],[-62,14],[-127,27],[-83,-36],[-75,-33],[-62,-23],[-50,-103],[-21,-36],[-25,-52],[-11,-36],[10,-44],[74,-30],[31,-43],[4,-37],[-26,-38],[-23,-31],[1,-26],[11,-27],[18,-20],[105,-13],[63,0],[24,-11],[3,-36],[-23,-49],[-89,-40],[-50,-41],[-16,-56],[1,-44],[17,-29],[43,-34],[39,-38],[12,-31],[-4,-43],[-16,-59],[-44,-68],[-36,-49],[-3,-17],[9,-26],[29,-38],[50,-56],[62,-46],[40,-12],[13,-11],[12,-53],[5,-55],[-16,-42]],[[150308,68344],[52,0],[72,-11],[55,-14],[44,1],[80,64],[36,3],[42,12],[18,12],[13,-9],[46,-8],[48,3],[42,18],[43,28],[76,57],[15,33],[0,30],[-14,20],[-15,10],[6,26],[32,44],[116,67],[99,82],[55,62],[25,74],[31,81],[29,32],[71,21],[196,29],[62,33],[92,61],[46,47],[25,39],[3,42],[61,14],[53,69],[64,70],[113,59],[100,79],[35,-12],[37,-38],[19,-41],[4,-21],[128,-26],[20,4],[94,-37],[87,-45],[48,-12],[23,2],[20,14],[24,39],[24,29],[15,12],[-1,45],[126,89],[113,63],[97,47],[28,-19],[32,-36],[43,-89],[26,-22],[66,12],[12,-10],[-10,-32],[-45,-40],[-58,-36],[-38,-29],[12,-98],[-2,-34],[16,-11],[119,97],[58,20],[20,-24],[6,-52],[47,-107],[20,-54],[-119,-130],[-44,-67],[1,-23],[-2,-23],[-31,-34],[2,-13],[25,-21],[30,-16],[14,1],[25,31],[113,44],[33,-8],[79,-68],[37,-4],[96,-20],[61,25],[45,-23],[93,-86],[22,-15]],[[113317,49262],[167,210],[155,193],[133,167],[119,149]],[[174048,77303],[-23,-13],[-39,-69],[-36,-88],[-35,-48],[-41,-26],[-43,-16],[-87,-6],[-78,6],[-25,9],[-107,-5],[-30,-7],[-154,7],[-81,-7],[-51,-17],[-52,-36],[-45,-53],[-40,-58],[-80,-104],[-57,-51],[0,-74],[-1,-22],[-20,-16]],[[85493,68259],[-87,0],[2,-35],[19,-69],[7,-58],[-9,-36],[-9,-46],[4,-43],[14,-48],[13,-49],[0,-33],[-26,-25],[-61,-14],[-73,-11],[-53,0],[-80,8],[-50,-2],[-44,0],[-39,-8],[-48,-31],[-53,-49],[-67,-66],[-40,-41],[-53,-9],[-53,0],[-53,33],[-33,17],[-22,-2],[-36,-23],[-43,-16],[-40,0],[-67,33],[-80,49],[-47,25],[-67,8],[-66,16],[-47,-8],[-60,0],[-80,-33],[-67,-24],[-73,-25],[-84,-23],[21,-74],[28,-40],[0,-50],[-13,-42],[-40,-41],[-46,-52],[-27,-41],[-26,-58],[-20,-33],[-35,-54],[-30,-67],[-10,-42],[-12,-48],[-24,-15],[-81,-13],[-52,-17],[-45,-16],[-17,-28],[-3,-5],[-12,-58],[0,-41],[-13,-33],[-20,-82],[-26,-75],[-19,-99],[-19,-82],[-26,-132],[-26,-123],[-32,-116],[-26,-74],[-20,-42],[-45,-49],[-39,-33],[-45,-42],[-51,-41],[-71,-49],[-59,-42],[-24,-18],[-28,-23],[-45,-57],[-38,-83],[-26,-66],[-45,-107],[-33,-58],[-19,-32],[-52,-33],[-58,-25],[-65,-33],[-51,-33],[-71,-33],[-45,-33],[-33,-49],[-26,-58],[-32,-83],[-26,-90],[-13,-58],[-39,-199],[-13,-115],[-12,-74],[-20,-91],[-13,-140],[0,-115],[-13,-66],[-6,-50],[-32,-57],[-26,-41],[-45,-58],[-39,-33],[-13,-33],[-39,-41],[-39,-67],[-32,-41],[6,-33],[7,-58],[-20,-58],[-19,-66],[-52,-82],[-58,-41],[-84,-8],[-116,0],[-90,8],[-110,0],[-97,16],[-91,17],[-109,8],[-78,0],[-97,-16],[-252,0],[-97,-9],[-142,-33],[-34,-8]],[[114312,49261],[-48,68],[-54,87],[-4,118],[15,128],[13,42],[-7,42],[2,58],[-30,54],[-179,62],[-29,-5],[-30,-23],[-34,-16],[-24,15],[-15,23],[0,38],[3,29]],[[10494,85443],[115,-41],[110,-40],[121,-38],[126,-39],[112,-35],[135,-30],[70,-5],[98,26],[121,68],[38,57],[-16,47],[-32,73],[-7,26],[-6,50],[15,39],[128,65],[6,18],[-16,29],[-99,80],[-84,62]],[[150308,68344],[-2,34],[8,101],[-23,23],[-73,25],[-81,33],[-39,35],[-22,12],[-31,-6],[-49,-37],[-46,-43],[-37,-4],[-38,21],[-36,26],[-123,37],[-56,6],[-98,-6],[-81,7],[-12,12],[0,20],[12,41],[7,40],[-10,22],[-82,28],[-75,20],[-80,8],[-54,-14],[-52,-32],[-43,-56],[-63,-24],[-75,-42],[-36,-39],[-55,-84],[-80,-103],[-72,-101],[-38,-98],[-49,-61],[-51,-45],[-36,-122]],[[106355,87937],[5,6],[-3,70],[25,15],[38,11],[55,-4],[47,-11],[56,-32],[18,5],[96,61],[99,91],[28,52],[25,24],[86,13],[75,5],[48,-1],[117,9],[69,10],[60,16],[130,6],[202,-11],[133,0],[90,-9],[221,-48],[82,-9],[38,-25],[73,-10],[134,-26],[116,-13],[78,5],[44,-7],[83,-114],[17,-14],[33,-2],[68,10],[96,-4],[57,-24],[-8,-68],[15,-10],[26,4],[31,38],[26,40],[19,12],[98,-27],[45,5],[42,30],[25,5],[70,-21],[86,-15],[69,-1],[43,-17],[32,-71],[27,-14],[27,-5],[40,64],[36,24],[51,18],[32,8],[23,23],[31,21],[26,2],[22,-8],[25,-30],[36,-69],[45,-70],[30,-25],[80,21],[54,22],[99,4],[131,15],[100,20],[62,-3],[38,-22],[58,-43],[16,-61],[75,-42],[61,-8],[21,44],[36,31],[-13,42],[-6,53],[-27,50],[-18,53],[33,77],[36,67],[18,36],[57,67],[58,48],[87,76],[64,26],[58,-12],[32,-10],[82,45],[147,3],[123,-6]],[[114279,73022],[-19,-14],[-34,-38],[-34,-30],[-70,-48],[-15,-28]],[[114279,73022],[29,27],[8,29],[26,28],[36,23],[8,19],[-5,11],[-36,20],[-19,37],[17,54],[11,16],[21,26],[48,39],[37,7],[32,0],[54,-3],[42,-7],[11,10],[-1,13],[-52,32],[-3,26],[13,27],[37,44],[43,31],[23,6],[50,64],[32,72],[-52,174],[-31,28],[-51,24],[-31,3],[-2,12],[40,44],[29,38],[-32,37],[-56,17],[-21,-38],[-73,-3],[-113,0]],[[113510,35548],[23,5],[16,-9],[10,-14],[1,-24],[-7,-24],[-17,-18],[-23,-7],[-14,15],[3,44],[8,32]],[[142927,80244],[16,15],[17,23],[-3,32],[-32,103],[-17,98],[-11,88],[2,33],[24,57],[31,52],[112,48],[74,15],[4,31],[-61,20],[-43,32],[-8,18],[2,20],[10,19],[76,35],[71,35],[87,-21],[17,13],[5,36],[-19,35],[-17,57],[-40,30],[-2,35],[25,61],[-34,114],[-37,99],[-63,171],[-42,49],[-23,79],[-26,41],[2,61],[4,43],[-6,85],[-12,92],[12,94],[23,62],[-6,23],[12,18],[35,6],[17,25],[-17,26],[-61,20],[-68,31],[-82,-3],[-85,-6],[-42,23],[-36,30],[-3,19],[51,50],[71,51],[109,23],[120,34],[61,24],[81,18],[94,7],[48,-5],[120,33],[191,64],[172,53],[58,32],[44,-32],[20,-70],[50,-36],[50,-18],[29,1],[86,27],[93,20],[36,-11],[48,-35],[53,-32],[27,1],[25,25],[24,50],[16,63],[3,67],[-9,42],[-19,15],[-85,24],[-80,39],[-10,37],[2,25],[21,63],[53,116],[53,160],[28,126],[89,188],[69,196],[113,282],[19,56],[11,89],[6,36],[39,20],[66,-19],[162,-64],[123,-54],[52,-19],[77,-19],[118,-22],[69,6],[60,14],[80,1],[125,-17],[38,-1],[48,-2],[35,-27],[17,-62],[26,-28],[46,11],[100,54],[63,43],[80,62],[78,9],[84,13],[29,31],[31,72],[51,55],[9,69],[-19,49],[-35,79],[1,54],[-17,155],[-23,139],[23,112],[42,126],[16,38],[26,51],[37,60],[52,19],[146,13],[135,26],[70,26],[71,15],[43,20],[74,88],[35,51],[26,134],[-19,65],[16,58],[35,33],[50,34],[34,6],[71,10],[118,-3],[60,-17]],[[106277,89934],[48,-16],[113,-7],[90,20],[46,2],[41,-6],[62,11],[57,5],[29,-25],[52,-23],[104,33],[92,39],[95,-4],[14,19],[23,100],[29,21],[114,-10],[42,18],[44,49],[67,31],[56,0],[59,34],[29,-23],[14,-41],[-20,-33],[9,-13],[40,-16],[70,1],[44,13],[10,19],[0,34],[-11,32],[-29,27],[-55,14],[-39,1],[-6,17],[13,38],[34,68],[42,63],[25,23],[5,22],[-5,37],[-1,68],[38,95],[50,71],[68,23],[83,12],[53,34],[27,39],[10,33],[12,28],[27,13],[200,-8],[30,61],[17,17],[39,18],[26,22],[-10,16],[-51,11],[-120,10],[-24,20],[8,24],[32,63],[30,81],[16,63],[2,37]],[[56620,17625],[-18,4],[-42,22],[-36,27],[-8,18],[-4,27],[5,101],[-1,272],[13,51],[18,33],[57,48],[55,69],[62,87],[57,70],[-20,47],[-48,45],[-85,36],[-82,65],[-72,82],[-34,86],[-31,93],[-29,73],[-10,34],[-29,14],[-45,37],[-29,35],[-41,20],[-75,22],[-77,38],[-97,91],[-69,101],[-35,66],[-37,47],[-199,78],[-90,92],[-36,-29],[-53,29],[-52,44],[-16,34],[-22,35],[-21,41],[-13,38],[-54,68],[-70,73],[-30,20],[-15,-6],[-15,-28],[-10,-27],[-26,-18],[-33,-33],[-33,-41],[-42,-27],[-51,-9],[-34,1],[-7,16],[-2,56],[13,128],[-30,49],[-39,52],[-46,71],[-149,149],[-203,215],[-72,66],[-68,5],[-61,-8],[-57,-28],[-43,-100],[-18,-15],[-109,2],[-109,17],[-37,60]],[[166494,86540],[-61,-115],[-121,-230],[-102,-194],[-55,-110],[-39,-83],[-41,-80],[-6,-47],[-47,-77],[-86,-92],[-18,-101],[3,-90],[-7,-81],[-95,-51],[-74,-45],[21,-154],[38,-58],[62,-62],[65,-50],[56,-43],[61,21],[53,64],[101,57],[55,1],[40,-13],[87,-4],[90,21],[70,4],[91,-13],[32,-14],[76,-25],[83,-55],[57,-60],[42,-12],[21,19],[46,54],[65,53],[79,85],[59,66],[46,10],[90,-1],[41,16],[68,9],[59,-25],[168,-13],[44,-33],[80,-100],[44,-53],[78,-27],[47,-18],[42,-15],[42,-26],[9,-31],[17,-47],[26,-28],[47,-27],[36,-16],[11,-35],[11,-17],[33,-24],[97,-103],[47,-28],[72,-59],[30,-50],[2,-52],[18,-39],[48,-60],[23,-40],[-9,-55],[7,-48],[-18,-50],[-77,-37],[-27,-18],[-56,-2],[-94,19],[-92,-11],[-110,21],[-86,44],[-46,35],[-73,21],[-35,-11],[-43,-45],[-48,8],[-44,-8],[-114,9],[-62,12],[-98,-32],[-55,-10],[-104,-39],[-63,-67],[-47,-16],[-45,3],[-33,25],[-47,29],[-71,-1],[-21,-13],[-8,-27],[-23,-84],[0,-37],[-15,-24],[-42,-8],[-73,2],[-114,6],[-78,21],[-46,-9],[-64,-45],[-45,-7],[-36,-20],[-30,-66],[-46,-42],[-57,-51],[-60,-110],[-33,-63],[10,-34],[8,-41],[-28,-47],[-57,-43],[-45,-8],[-68,-42],[-94,-75],[-70,-63],[-91,-16],[-65,-16],[-143,-20],[-36,-5],[-157,-9],[-117,34],[-61,-6],[-54,-19],[-28,-21],[-9,-40],[-10,-36],[-44,-57],[-89,-76],[-74,-50],[-56,-65],[-32,-24],[-65,-25],[-34,-13],[-81,-58],[-64,-51],[-43,-15],[-51,14],[-34,4],[-100,20],[-67,2],[-95,13],[-222,61],[-71,28],[-63,77],[-56,39],[-77,4],[-116,0],[-52,15],[-87,-15],[-95,-77],[-45,-59],[-39,-59],[-48,-127],[-21,-85],[-16,-48],[-51,-76],[-5,-43],[17,-37],[37,-42],[22,-66],[53,-70],[53,-54],[98,-88],[29,-46],[33,-53],[7,-51],[-6,-34],[-36,-26],[-69,-13],[-33,-35],[-51,-48],[-61,-55],[-28,-3],[-34,-15],[-171,-68],[-64,-20],[-52,-22],[-60,-70],[-48,-52],[-59,-68],[-26,-31],[-52,-69],[-69,-78],[-38,-42],[-21,-25],[-19,-33],[-72,-26],[-59,-27],[-90,-41],[-129,-44],[-103,-44],[-67,-35],[-98,-45],[-67,-15],[-134,2],[-167,-12],[-121,-8],[-91,11],[-137,6],[-105,9],[-70,-17],[-166,-18],[-37,-4],[-295,-42],[-130,-23],[-119,-11],[-88,-16],[-50,-21],[-74,-30],[-39,-13],[-130,-58],[-290,-121],[-195,-98],[-32,-17],[-131,-69],[-76,-27],[-52,-62],[-42,-39],[-45,-17],[-78,40],[-56,-2],[-178,14],[0,180],[-125,-25],[-199,-41],[-185,-37],[-169,86],[-130,66],[-113,58],[-172,37],[-150,34],[-270,54],[-119,48],[-60,63],[-107,143],[-35,28],[-52,19],[-54,13],[-118,-1],[-143,11],[-206,30],[-164,24],[-280,45],[-66,5],[-146,-39],[-187,-51],[-337,40],[-149,18],[-302,38],[-342,43],[-332,44],[-241,-24],[-134,-14],[-155,-19],[-21,21],[-7,85],[-27,65],[-85,71],[-57,68],[-108,91],[-35,57],[-11,89],[-100,231],[-62,156],[-16,32],[-26,51],[-36,27],[-74,16],[-20,27],[0,54],[12,75],[15,55],[-11,13],[-194,-15],[-119,36],[-99,39],[-141,101],[-84,38],[-106,104],[-156,25],[-58,40],[-73,89],[-64,57],[-91,36],[-143,32],[-245,30],[-82,13],[-135,-20],[-101,-2],[-162,22],[-92,27],[-115,1],[-74,0],[-99,6],[-48,18],[-45,22],[-83,-6],[-58,22],[-55,41],[-56,19],[-63,-1],[-25,-18],[-24,1],[-15,55],[-59,89],[-8,40],[-36,46],[-21,42],[6,57],[25,112],[56,102],[36,26],[23,30],[46,52],[28,42],[-4,57],[-31,60],[-24,77],[5,44],[34,52],[40,117],[-3,30],[-16,25],[-4,53],[-8,73],[-48,111],[-27,58],[-45,26],[-54,15],[-47,80],[-58,93],[-37,59],[-13,36],[-6,66],[-27,79],[-29,43],[-21,33],[-11,48],[-11,18],[-79,21],[-57,36],[-24,48],[-8,38],[-17,23],[-44,7],[-31,-35],[-52,-17],[-34,3],[-34,21],[-21,22],[-35,25],[-50,78],[-53,21],[-97,-4],[-86,-36],[-52,6],[-44,12],[-49,39],[-35,32],[-51,11],[-101,56],[-69,41],[-6,80],[-32,56],[-66,15],[-68,57],[-98,30],[-61,24],[-54,14],[-8,22],[3,18],[25,31],[26,28],[6,27],[-21,23],[-55,25],[-72,22],[-14,36],[-43,38],[8,30],[33,22],[35,17],[8,28],[-25,27],[-12,40],[6,29],[-7,39]],[[100029,85668],[-29,41],[-55,50],[-88,68],[-70,-3],[-25,18],[-11,25],[-29,43],[-33,31],[-39,11],[-57,39],[-75,84],[-69,58],[-67,-1],[-42,30],[-43,40],[-32,39],[-49,93],[-36,54],[-28,33],[-32,27],[-11,22],[38,50],[14,25],[17,19],[10,20],[-1,15],[-35,49],[-47,36],[-70,36],[-44,45],[-17,42],[-4,23],[-31,31],[-24,45],[0,28],[6,7],[23,0],[26,-18],[36,-36],[30,-52],[18,20],[34,55],[61,63],[62,36],[56,3],[46,10],[38,18],[67,-7],[48,-13],[15,8],[20,33],[12,28],[107,17],[36,55],[21,-1],[23,9],[23,20],[22,9],[17,-10],[23,-7],[23,13],[35,62],[19,10],[94,10],[127,37],[65,33],[63,18],[68,31],[108,31],[5,13],[-50,32],[-17,20],[-11,20],[18,23],[23,7],[31,-10],[91,-13],[24,-13],[9,-32],[23,-30],[19,-4],[-7,-48],[29,-19],[42,-15],[28,3],[20,20],[8,13]],[[108776,92893],[-17,-2],[-90,11],[-99,33],[-44,25],[-42,0],[-52,-17],[-186,-47],[-45,11],[-106,46],[-54,51],[-119,102],[-10,24],[-16,19],[-127,25],[-47,37],[-39,6],[-58,18],[-149,80],[-37,7],[-9,-13],[2,-19],[-9,-11],[-19,1],[-35,29],[-41,26],[-129,-49],[-47,-13],[-41,-3],[-205,-64],[-62,-34],[-26,4]],[[108776,92893],[76,-3],[27,-13],[17,-65],[87,-51],[80,-42],[21,-19],[6,-38],[-5,-44],[-10,-23],[-34,-26],[-29,-66],[-4,-63],[-47,-110],[11,-2],[97,20],[28,-11],[21,-24],[7,-69],[32,-31],[32,-48],[10,-37],[62,-45],[5,-29],[38,-102],[14,-59],[7,-45],[-19,-58],[-16,-39]],[[104701,91691],[174,97],[219,104],[50,10],[201,62],[27,5],[182,-12],[143,-15],[120,2],[66,16],[60,-13],[49,-47],[49,6],[49,30],[270,-28],[60,1],[69,-4],[126,-28],[73,-26],[160,15],[68,1],[36,10],[110,71],[48,12],[43,12],[40,-11],[27,-59],[81,-104],[89,-18],[245,-40],[50,-20],[137,-92],[83,-44],[52,-36],[81,-70],[46,-51],[77,-38],[92,-26],[33,-4]],[[104427,102384],[-84,-3],[-242,-10],[107,-71],[35,-29],[7,-42],[-18,-78],[-51,-67],[-60,-54],[-116,-54],[176,-53],[-119,-72],[-56,-28],[-64,5],[-116,25],[-279,60],[-134,23],[-119,6],[-63,0],[-253,51],[-49,-6],[-91,-22],[-10,-50],[6,-124],[13,-96],[-33,-56],[-33,-37],[-102,-102],[-227,69],[-155,46],[-100,-61],[-250,-111],[-128,-220],[-7,-8],[-76,-55],[-97,-26],[-73,-13],[-43,-65],[100,-94],[51,-50],[48,-80],[-9,-50],[-11,-32],[-107,-65],[-229,-171],[-211,-179],[-87,-51],[39,-152],[-70,-44],[-143,-51],[-73,-19],[-79,-11],[-242,-20],[43,-163],[16,-72],[0,-43],[-25,-41],[-30,-80],[-45,-284],[-35,-31],[-47,-77],[-154,-185],[-123,-123],[-177,-178],[144,-56],[132,-41],[27,-63],[18,-105],[-4,-71],[-50,-65],[-39,-45],[-28,-22],[-187,22],[-240,28],[-62,0],[-139,-20],[-126,-42],[-67,-35],[-17,-14],[-84,-80],[-149,-142],[-82,-62],[24,-85],[-137,-166],[89,-167],[4,-5],[48,-68],[-50,-43],[-21,-24],[7,-77],[13,-86],[-12,-51],[-4,-56],[122,-252],[-2,-60],[-6,-38],[-37,-157],[-51,-211],[88,-56],[126,-66],[71,-26],[104,-79],[80,-77],[-11,-51],[-23,-57],[-34,-39],[-31,-54],[-14,-40],[-15,-11],[-139,-4],[-74,-15],[-38,-17],[13,-91],[84,-167],[70,-119],[23,-79],[-23,-79],[-24,-41],[-1,-54],[-18,-109],[-55,-55],[-71,-60],[-79,-45],[-63,-13],[-54,-5],[-36,-23],[-33,-67],[-30,-70],[-100,-86],[3,-31],[38,-102],[35,-117],[-30,-109],[-25,-114],[-45,-77],[-64,-27],[-47,13],[-54,105],[-30,43],[-28,11],[-40,2],[-60,-13],[-19,-55],[-36,-52],[-94,-10]],[[104427,102384],[35,27],[138,2],[114,-25],[25,11],[15,22],[-48,87],[8,22],[50,28],[80,22],[126,3],[85,-3],[18,-3],[128,-96],[110,-93],[58,-40],[143,-113],[53,-65],[18,-47],[58,0],[201,-20],[168,-18],[47,-26],[116,5],[90,24],[158,30],[42,37],[53,39],[92,-6],[102,-31],[114,-41],[103,-19],[137,-29],[64,-39],[90,-11],[94,39],[56,103],[49,47],[70,33],[80,15],[61,6],[46,26],[66,59],[12,71],[-12,128],[12,42],[53,69],[72,183],[33,53],[39,32],[54,19],[98,56],[141,109],[38,10],[100,5],[126,-4],[112,-19],[13,1],[50,10],[92,35],[158,67],[101,19],[91,-3],[102,-74],[143,-82],[92,-41],[251,-75],[221,-49],[124,-164],[-61,-65],[-31,-23],[-107,-65],[-116,-91],[-9,-48],[39,-48],[47,-32]],[[158574,54037],[27,9],[30,34],[33,43],[81,6],[81,-2],[22,12],[33,46],[54,59],[40,33],[10,26],[-17,62],[-9,64],[16,21],[73,-12],[81,-30],[19,-13],[47,78],[12,10],[31,0],[80,14],[78,21],[37,-4],[36,-52],[27,-52],[15,-4],[40,22],[34,-28],[70,-45],[42,-1],[-21,104],[24,75],[-5,20],[-40,35],[-134,137],[-23,40],[3,65],[-4,94],[-12,60],[2,35],[8,27],[25,11],[24,4],[19,24],[32,63],[63,-6],[88,-35],[65,-22],[38,4],[9,9],[-1,34],[4,143],[-2,30],[55,14],[85,3],[45,8],[41,60],[107,21],[78,81],[70,84],[34,22],[44,15],[33,-3],[40,-48],[34,29],[39,57],[21,55],[11,90],[-8,136],[-20,108],[-20,80],[-4,80],[46,161],[38,175],[-7,69],[-42,110],[-43,133],[-47,146],[-18,22],[-12,40],[-8,48],[19,150],[3,50],[54,68],[29,78],[27,86],[-10,45]],[[46191,31015],[11,-94],[88,-126],[29,-141],[20,-18],[122,-71],[2,-16],[-18,-27],[-18,-34],[13,-48],[22,-66],[7,-61],[14,-63],[13,-97],[8,-87],[31,-129],[6,-80],[1,-48],[24,-47],[47,-57],[64,-56],[51,-67],[39,-44],[47,-37],[36,-34],[14,-23],[5,-19],[-16,-17],[-57,-88],[-80,-132],[2,-17],[76,-95],[12,-38],[-1,-53],[-25,-64],[-82,-21],[-19,-17],[-2,-21],[19,-27],[-3,-63],[30,-70],[-16,-24],[-30,-32],[-1,-32],[10,-35],[32,-28],[127,-98],[10,-14],[-2,-10],[-49,-65],[-5,-41],[1,-66],[7,-43],[16,-18],[63,-20],[79,-150],[75,-141],[-1,-121],[8,-141],[48,-111],[7,-89],[16,-101],[57,-61],[22,-121],[6,-64],[-3,-43],[44,-132],[5,-113],[-10,-81],[0,-45],[6,-32],[39,-29],[16,-18],[57,-8],[82,-2],[141,30],[108,28]],[[46191,31015],[-48,-56],[-64,-63],[-78,-13],[-30,-32],[7,-67],[25,-95],[0,-74],[-24,-85],[-56,-93],[-86,-64],[-80,-34],[-64,0],[-62,-7],[-26,-10]],[[95202,86234],[3,49],[19,72],[19,37],[24,31],[26,21],[6,38],[-4,37],[-30,5],[-75,27],[-45,29],[-33,35],[-43,49],[-18,49],[-1,50],[5,22]],[[92735,87590],[7,-39],[25,-51],[17,-27],[-14,-36],[11,-30],[47,-53],[58,-50],[52,-32],[15,3],[38,10],[65,32],[55,11],[31,-25],[17,-15],[34,-56],[10,-59],[15,-50],[28,-20],[104,-6],[76,-18],[21,-17],[26,-109],[14,-16],[19,13],[19,18],[26,3],[45,-7],[59,-2],[61,-12],[84,-62],[-3,-20],[-16,-36],[-6,-28],[15,-12],[22,-29],[-6,-34],[-21,-24],[-9,-20],[0,-13],[8,-10],[17,-10],[125,-12],[114,12],[72,35],[12,37],[20,41],[43,35],[30,11],[27,-14],[-46,-145],[33,-37],[5,-56],[12,-49],[41,1],[49,-9],[35,-18],[41,-29],[59,-26],[41,-10],[15,-22],[33,-25],[53,-54],[47,-36],[22,0],[44,14],[65,9],[51,-1]],[[95055,86785],[-4,2],[-14,26],[-22,-1],[-50,11],[-71,-70],[-32,-58],[-19,-42],[-28,-34],[-6,-37],[3,-15],[-9,-19],[-1,-21],[41,-41],[10,-22],[50,-72],[-16,-26],[-12,-29],[-14,-20],[-17,-13]],[[121102,79998],[-12,11],[-93,46],[-35,24],[-34,2],[-72,14],[-61,22],[-28,29],[-42,32],[-77,41],[-57,38],[-3,24],[35,101],[25,97],[-14,19],[-32,17],[-60,14],[-142,-4],[-87,97],[-31,22],[-57,16],[-83,30],[-47,21],[-13,-8],[-52,-107],[-51,77],[-31,21],[-43,11],[-46,0],[-114,-37],[-84,-41],[-62,-31],[-64,-17],[-30,-24],[-85,4],[-43,18],[-14,19],[8,34],[29,37],[2,21],[-10,16],[-103,50],[-43,30],[-135,43],[-167,76],[-58,50],[-5,35],[-66,34],[-84,30],[-64,-9],[-61,-3],[-95,57],[-90,3],[-102,-17],[-22,-7],[-25,-7],[-303,24],[-77,47],[-67,47],[-177,34],[-92,36],[-90,51],[-100,45],[-83,-18],[-114,25],[-124,22],[-43,-14],[-39,-56],[-29,-53]],[[104649,79139],[-4,18],[-16,26],[-41,12],[-84,-10],[-20,19],[-35,110],[-26,17],[-31,37],[-51,120],[-1,52],[4,46],[-29,107],[18,27],[26,17],[0,43],[-7,66],[31,128],[8,9]],[[104391,79983],[10,37],[-4,78],[-34,131],[-24,43],[-50,42],[-39,28],[-69,25],[-35,72],[-54,81],[-25,19]],[[117923,79690],[43,-17],[81,-21],[50,-26],[29,-7],[66,53],[98,-2],[86,-6],[45,-9],[54,-18],[66,-11],[27,25],[39,73],[14,10],[11,6],[49,6],[46,-6],[22,-12],[22,-59],[55,-21],[97,-94],[59,-38],[15,-16],[-20,-19],[8,-23],[34,-31],[48,-11],[51,4],[28,-11],[20,-18],[5,-24],[-1,-16]],[[156450,63237],[38,-37],[-14,-95],[19,-19],[10,-34],[-6,-53],[9,-45],[15,-22],[21,-11],[105,39],[64,3],[27,-26],[24,-15],[31,-13],[23,-16],[15,5],[36,40],[11,7],[1,19],[-25,35],[-26,30],[0,66],[13,115],[2,59],[-2,142],[-5,40],[-23,46],[-63,89],[-17,54],[-10,54],[1,34],[-16,39],[-9,36],[29,19],[33,42],[17,64],[16,47],[24,20],[20,8],[14,-5],[52,-84],[67,42],[51,0],[44,-22],[23,-27]],[[138678,77984],[54,11],[69,22],[32,36],[23,38],[4,23],[-20,89],[-28,40],[-3,30],[14,24],[18,41],[35,83],[34,53],[19,13],[42,13],[101,14],[110,37],[130,112],[43,31],[57,16],[40,-1],[7,14],[-26,69],[7,25],[15,19],[20,9],[90,-36],[69,4],[83,21],[181,122],[23,-2],[18,-17],[22,-73],[25,-154],[13,-20],[126,-2],[86,57],[37,13],[61,-9],[32,26],[34,18],[39,-64],[50,31],[54,49],[26,51],[37,55],[29,70],[11,65],[14,31],[31,32],[74,135],[54,35],[51,12],[127,-23],[65,3],[193,-18],[89,26],[62,26],[91,-4],[108,20],[144,170],[1,36],[9,38],[52,38],[65,35],[129,83],[262,131],[94,53],[39,-2],[97,33],[169,64],[48,80],[45,16],[198,14],[12,9],[7,14],[-11,58],[-13,49]],[[119170,79351],[34,7],[99,1],[96,12],[75,23],[108,19],[45,18],[52,8],[159,-19],[59,15],[179,2],[4,8],[-24,23],[0,9],[107,15],[16,11]],[[142927,80244],[-89,93],[-97,91],[-76,21],[-132,15],[-70,1],[-40,21],[-39,53],[-47,47],[-60,51],[-24,77],[-25,13],[-43,-10],[-72,3],[-41,7],[-61,13],[-96,31],[-76,30],[-96,5],[-56,-6],[-172,-5],[-143,31],[-116,6],[-71,-2],[-34,4],[-59,-1],[-86,7],[-115,48],[-45,3],[-28,-2],[-192,-35],[-89,-9],[-188,4],[-185,4],[-59,8],[-33,-4],[-70,-85],[-30,-13],[-174,19],[-206,55],[-148,61],[-126,65],[-167,101],[-100,51],[-15,-29],[-26,-10],[-39,-4],[-88,5],[-41,-51],[-108,-37],[-69,-33],[-36,-37],[-69,-248],[-18,-90],[46,-152],[-53,9],[-61,39],[-22,30],[-59,19],[-217,28],[-41,35],[-25,29],[-56,18],[-80,15],[-172,65],[-74,3],[-223,51],[-36,-1],[-17,-2],[-87,-33],[-56,-10],[-59,13],[-107,-40],[-58,-55],[-47,-67],[-46,-42],[-13,-63],[-33,-33],[-38,-65],[0,-38],[35,-37]],[[54609,47053],[-28,-12],[-24,-17],[-34,13],[-48,-7],[-49,-18],[-46,-9],[-85,29],[-27,4],[-17,12],[-36,57],[-17,7],[-46,-27],[-55,-18],[-27,3],[-32,-19],[-30,-26],[-57,-111],[-29,-39],[-31,-18],[-63,0],[-67,-4],[-50,-27],[-48,-14],[-23,-1],[-8,-61],[-11,-29],[-15,-16],[-36,-5],[-33,2],[-20,26],[-37,12],[-33,10],[-21,14],[-17,-4],[-15,-25],[-11,-22],[-10,-40],[-50,-13],[-21,-22],[12,-75],[-6,-30],[-10,-22],[-60,-5],[-52,2],[-29,-28],[-37,-32],[-22,-6],[-27,2],[-35,37],[-33,46],[-85,32],[-85,27],[-55,73],[-13,36],[-26,16],[-66,86],[-37,56],[-39,15],[-45,23],[2,41],[-3,39],[-20,15],[-27,11],[-10,22],[3,51],[5,131],[-7,126],[-61,43],[-26,30],[-46,186],[-22,84],[-1,62],[15,185],[18,81],[47,161],[27,54],[1,41],[-3,52],[-13,104],[79,65],[34,27],[6,44],[42,55],[19,53],[16,41],[-5,22],[-18,13],[-22,39],[-46,113],[-17,23],[-14,32],[8,50],[18,54],[-3,23],[-27,30],[-57,48],[-47,4],[-36,18],[-54,2],[-42,5],[-25,19],[5,30],[11,23],[36,57],[24,61],[3,59],[7,78],[11,68],[6,77],[-57,50],[-18,42],[-23,37],[-26,0],[-39,15],[-60,-48],[-48,9],[-32,-18],[-76,3],[-48,24],[-59,-16]],[[96526,90888],[45,-21],[51,-96],[34,-32],[49,-10],[121,-2],[30,-4],[182,-43],[45,-30],[56,-1],[101,28],[76,12],[29,-17],[42,-7],[9,0]],[[97253,70381],[77,43],[110,50],[57,37],[24,31],[82,128],[43,71],[58,96],[26,68],[0,62],[-8,76],[-46,180],[-37,176],[29,67],[23,33],[51,82],[20,16],[110,26],[44,55],[33,69],[9,36],[48,38],[57,37],[35,49],[116,76],[105,70],[123,73],[95,56],[20,49],[-2,43],[-51,97],[0,114],[3,96],[5,56],[23,157],[1,22]],[[120179,79503],[14,-37],[40,-42],[44,-17],[23,-22],[1,-18],[-77,-21],[-5,-10],[5,-11],[23,-5],[108,-52],[62,-1],[32,-16],[16,-31],[52,-42],[41,-41],[2,-14],[-7,-21],[-115,-81],[-15,-27],[-2,-30],[51,-87],[74,-95],[108,-72],[148,-79],[1,-49],[-23,-57],[-20,-40],[-9,-26],[-18,-11],[-148,2],[-22,-9],[-9,-12],[-1,-9],[53,-18],[82,-62],[48,-60],[50,-26],[55,-48],[45,-44],[69,-58],[77,19],[103,-52],[5,-34],[-7,-32],[-65,-34],[-8,-14],[0,-11],[9,-17],[38,-28],[45,-41],[50,-62],[-22,-18],[-47,-3],[-37,8],[-13,-13],[1,-20],[48,-47],[9,-34],[-2,-60],[2,-74]],[[120029,78194],[63,13],[107,38],[29,-19],[31,-38],[15,-33],[3,-61],[13,-10],[51,21],[24,-25],[39,-29],[69,-30],[100,46],[49,12],[41,-1],[22,-14],[8,-48],[-8,-58],[-12,-32],[21,-24],[82,-56],[34,-31],[-17,-55],[61,-132],[20,-52],[24,-63]],[[104182,83476],[25,20],[147,28],[68,-28],[31,10],[30,23],[16,18],[3,19],[15,23],[49,11],[131,-14],[53,33],[20,18],[12,40],[14,32],[47,17],[-1,30],[-7,31],[27,71],[16,30],[27,10],[32,23],[56,46],[-13,41],[11,30],[58,73],[44,70],[-1,35],[7,31],[39,34],[41,44],[54,137],[20,23],[35,26],[27,26],[3,90],[24,27],[48,29],[47,47],[39,55],[30,26],[39,7],[42,22],[48,8],[46,-11],[30,6],[44,27],[113,102],[16,20]],[[136950,78635],[21,13],[67,14],[136,13],[46,-10],[53,-27],[40,-27],[39,1],[32,5],[14,-7],[10,-24],[17,-22],[51,29],[47,39],[37,5],[35,15],[10,25],[26,42],[77,81],[40,13],[26,0],[1,-13],[12,-12],[67,-18],[21,21],[11,29],[-24,47],[0,19],[9,18],[12,11],[107,-44],[24,1],[48,24],[45,44],[16,35],[219,111],[16,21],[-3,15],[-92,26],[-41,-15],[-39,0],[-23,16],[-111,7],[-25,11],[-74,81],[-51,31],[-40,20],[-45,-3],[-53,-21],[-17,9],[-4,34],[0,43],[-11,45],[-31,11],[-41,-18],[-60,18],[-52,7],[-13,96],[-21,41],[-22,43],[-22,12],[-37,21],[-2,51],[-8,14],[-13,7],[-18,-6],[-23,-25],[12,-56],[-9,-56],[-13,-28],[-26,-21],[-30,0],[-51,28],[-8,-170],[-10,-10],[-61,24],[-48,-11],[-73,11],[-55,28],[-41,8],[-66,23],[-50,31],[-31,114],[-30,41],[-28,9],[-112,-40],[-41,31],[-76,39],[-58,14],[-16,21],[3,26],[177,127],[70,87],[44,37],[62,24],[49,15],[25,80],[10,9],[34,6],[79,33],[127,70],[2,19],[-12,17],[-54,36],[-61,28],[-36,-15],[-21,-14]],[[103271,86282],[68,-11],[13,-41],[7,-43],[117,3],[65,92],[34,11],[54,32],[36,28],[24,-17],[36,-59],[38,-48],[21,-19],[3,-14],[21,-9],[43,-5],[28,-15],[9,-44],[0,-40],[-13,-29],[-7,-25],[30,-10],[43,10],[30,14],[92,-33],[32,74],[36,37],[47,18],[43,23],[39,16],[27,-1],[12,7],[33,-2],[39,-7],[53,8],[73,-18],[45,-34],[45,-11],[51,2],[34,19],[51,64],[37,-1],[57,10],[81,0],[187,-14],[47,-25],[115,-31],[50,-37],[22,-44],[12,-30],[118,-46],[174,-60],[43,-7]],[[86439,90884],[-102,-53],[-16,-20],[-29,-81],[-3,-23],[-33,-43],[-31,-47],[-36,-18],[-54,-15],[-31,-14],[-39,7],[-49,-1],[-24,-16],[1,-13],[15,-14],[43,-22],[47,-19],[-5,-18],[-25,-19],[-162,-49],[-49,-29],[-16,-19],[17,-33],[129,-97],[22,-10],[19,-57],[114,-23],[47,-36],[40,-8],[87,3],[35,-13],[20,10],[11,18],[74,48],[24,21],[-15,29],[-15,23],[44,44],[54,43],[27,-1],[47,-27],[38,-37],[5,-29],[7,-21],[36,-44],[23,-16],[63,-9],[15,-17],[-12,-65],[10,-22],[65,-1],[70,5],[24,-2],[26,13],[38,15],[56,-5]],[[103271,86282],[-2,24],[-14,60],[-138,119],[-16,50],[5,19],[-9,32],[-30,19],[-109,22],[-27,-13],[-26,14],[-39,28],[-69,23],[-7,12],[-25,20],[-13,3],[-9,-12],[-20,-18],[-71,-22],[-28,9],[-25,19],[-29,42],[-43,36],[-35,13],[-20,19],[-4,15],[77,30],[17,30],[-10,56],[-11,7],[-31,-19],[-65,-16],[-59,-8],[-31,0],[-170,102],[-110,31],[-65,9],[-7,-10],[29,-57],[51,-71],[-3,-19],[-60,-28],[-35,-13],[-41,-24],[-34,-34],[-30,-16],[-26,4],[-27,17],[-71,104],[-89,80],[-10,18],[-28,4],[-39,18],[-13,24],[20,26],[27,23],[47,15],[15,13],[9,21],[17,26],[-4,10],[-34,29],[-51,29],[-139,-21],[-38,-16],[-22,20],[-16,29],[-36,5],[-48,26],[-57,26],[-56,8],[-116,37],[-45,2],[-26,12],[-27,28],[-23,31],[-12,63],[-86,28],[-85,18],[-6,-10],[3,-62],[-4,-34],[-56,-21],[-56,-2]],[[136950,78635],[2,-15],[-9,-27],[-135,-47],[-61,-39],[-13,-70],[-16,-20],[-27,-16],[-27,-4],[-41,82],[-47,17],[-68,29],[-131,56],[-67,24],[-131,-36],[-151,-51],[-24,-30],[-16,-33],[1,-24],[11,-34],[-7,-25],[-29,-8],[-43,31],[-37,17],[-19,-42],[-22,-74],[-10,-55],[33,-78],[11,-117],[61,7],[46,-1],[88,35],[44,1],[68,-15],[119,-3],[94,6],[22,-3],[23,22],[24,-7],[23,-27],[95,32],[71,5],[43,-10],[26,-9],[46,-77],[35,-48],[43,-15],[132,14],[39,67],[35,17],[54,5],[46,13],[35,28],[49,24],[43,4],[21,-17],[10,-24],[-8,-30],[-2,-32],[28,-21],[82,-5],[38,-20],[2,-37],[-6,-59],[34,-23],[18,-2],[120,62],[33,1],[27,-34],[41,-41],[53,-44],[13,6],[24,48],[45,52],[86,17],[47,17],[50,7],[150,-21],[50,-3],[103,4],[81,10],[66,32],[33,25],[53,14],[68,-2],[37,-7]],[[104026,78199],[14,1],[24,-10],[46,-31],[49,-6],[27,20],[15,19],[10,31],[4,36],[8,12],[38,-4],[12,8],[-1,33],[-24,40],[-21,50],[0,23],[17,10],[29,21],[16,27],[31,13],[46,3],[51,11],[33,29],[5,28],[21,78],[13,39],[22,34],[12,47],[23,45],[49,18],[44,22],[34,57],[19,49],[0,29],[-28,49],[-21,48],[6,61]],[[112555,33895],[-34,59],[-29,-15],[-40,-42],[-21,-11],[-11,1],[-7,11],[-9,27],[-31,77],[-34,54],[-36,22],[-30,25],[13,24],[14,18],[-6,18],[-17,26],[-64,38],[-1,16],[57,34],[36,39],[24,38],[31,82],[25,82],[19,27],[7,54],[-5,62],[13,78],[6,74],[-19,29],[-16,50],[19,85],[30,58],[143,61],[100,55],[21,24],[34,47],[19,46],[-14,14],[-78,1],[-19,18],[-57,161],[31,185],[3,73],[-1,90],[-10,66],[-25,27],[-15,36],[4,96],[23,12],[50,127],[22,76],[-26,60],[-30,85],[-13,55],[-7,18],[20,34],[34,32],[37,9],[40,16],[126,158],[1,31],[-22,53],[-47,81],[-11,33],[-5,96],[-19,29],[-69,65],[-53,68],[17,69],[9,76],[-26,42],[-39,43],[-25,63],[-11,47],[-30,18],[-29,1],[-20,-29],[-23,2],[-27,10],[-9,41],[-1,44],[-19,30],[-18,41],[-2,22]],[[105403,85370],[7,135],[98,96],[25,49],[36,106],[28,50],[33,41],[26,39],[10,34]],[[83668,51147],[34,37],[51,118],[70,114],[66,67],[52,70],[55,53],[79,62],[120,163],[29,19],[19,113],[30,144],[35,45],[82,27],[20,25],[29,101],[18,118],[2,26]],[[105873,54456],[46,-102],[22,-36],[188,-243],[37,-57],[93,-176],[57,-119],[65,-171],[7,-93],[-9,-79],[-13,-226],[-17,-65],[-83,-121],[-3,-55],[17,-45],[25,-19],[15,-23],[-9,-105],[30,-41],[62,-27],[156,-19],[82,-15],[95,-32],[17,-37],[-27,-121],[19,-76],[53,-64],[55,-27],[52,-16],[181,-39],[75,-45],[100,-142],[125,-130],[30,-69],[-6,-62],[-37,-76],[6,-31],[57,-76],[66,-77],[120,-86],[208,-136],[96,-90],[32,-69],[54,-74],[74,-68],[50,-53],[-34,-148],[10,-49],[18,-42],[44,-59],[17,-75],[43,-94],[52,-42],[85,-16],[46,-44],[94,-74],[91,-65],[39,-44],[24,-40],[21,-46],[10,-47],[3,-100],[15,-125],[49,-85],[46,-63]],[[108809,49665],[23,-58],[34,-59],[111,-100],[36,-56],[27,-62],[17,-48],[35,-39],[49,-25],[41,-29],[25,-44],[38,-45],[74,-61],[35,-2],[41,-8],[37,-16],[39,4],[62,40],[75,68],[56,41],[137,-14],[77,-34],[60,-48],[48,3],[103,88],[55,93],[53,20],[81,-40],[66,-87],[59,-127],[41,-49],[56,-75],[113,-161],[145,-81],[57,-40],[19,-40],[10,-53],[4,-57],[18,-24],[39,8],[34,8],[37,-16],[26,-42],[12,-33],[14,-35]],[[118836,54522],[82,161],[71,141],[56,111]],[[118836,54522],[-51,-1],[-39,9],[-27,28],[-56,29],[-63,2],[-60,-28],[-101,-34],[-92,-11],[-73,-19],[-62,-23],[-55,12],[-47,21],[-11,171],[-11,185],[1,145],[17,80],[15,32],[86,110],[30,45],[99,183],[85,157],[64,117]],[[110101,41782],[1,-39],[-24,-142],[-27,-138],[-2,-52],[13,-69],[50,-159],[36,-116],[18,-70],[25,-81],[33,-125],[9,-59],[-7,-44],[-68,-156],[-7,-49],[17,-122],[22,-117],[32,-66],[77,-184],[57,-61],[106,-92],[93,-92],[36,-48],[33,-54],[65,-137],[40,-111],[20,-100],[51,-138],[48,-127],[61,-156],[43,-110],[20,-74]],[[118485,55732],[19,23],[27,22],[19,-6],[123,-113],[22,3],[41,35],[37,121],[26,44],[12,-1],[79,34],[71,38]],[[100029,85668],[18,-6],[53,-26],[42,-29],[39,-74],[90,-20],[115,-2],[41,33],[38,8],[42,-11],[88,-11],[10,60],[52,62],[23,22],[65,-2],[16,46],[16,129],[14,14],[47,-2],[47,-24],[14,-19],[25,2],[34,13],[38,8],[59,-14],[127,-58],[66,-22],[41,4],[39,0],[150,-91],[105,-13],[95,0],[31,27],[41,24],[42,-4],[37,-12],[73,-39],[33,-10],[44,-6],[33,-9],[29,-68],[16,-18]],[[118472,76054],[63,16],[116,100],[68,93],[21,8],[61,-31],[44,-8],[101,35],[60,-18],[50,-24],[28,-1],[135,-58],[34,-7],[70,-7],[103,-3],[67,37],[48,37],[33,-1],[32,-9],[27,-15],[23,-28],[11,-39],[-5,-124],[11,-33],[18,-24],[23,-4],[29,27],[49,39],[61,43],[45,40],[26,14],[41,-2],[39,-6],[23,-19]],[[101501,84098],[103,90],[51,25],[60,-5],[19,9],[5,13],[10,29],[5,27],[5,26],[-6,15],[-29,4],[-14,64],[15,24],[15,17],[-18,78],[5,26],[47,5],[38,16],[32,19],[8,24],[26,49],[-24,60],[-134,39],[-7,15],[31,17],[34,24],[19,19],[26,3],[36,-10],[65,-43],[25,-6],[24,12],[25,3],[72,-2],[60,10],[-13,47],[0,33],[-10,27],[6,30],[24,23],[8,52],[37,35]],[[95640,83325],[22,-18],[47,-19],[129,26],[80,27],[56,27],[35,-5],[126,-41],[42,21],[91,56],[13,30],[72,90],[1,22],[-29,56],[9,13],[88,58],[43,51],[47,34],[33,1],[9,-12],[4,-24],[-3,-98],[13,-31],[69,-71],[50,-40],[114,-28],[5,-13],[-31,-54],[69,-64],[12,-47],[32,-26],[46,13],[14,25],[-17,43],[-13,45],[2,27],[13,30],[31,42],[86,96],[30,56],[6,86],[0,69],[29,17],[61,-12],[19,1],[8,-42],[26,-68],[31,-35],[33,-8],[38,-1],[96,42],[63,18],[35,-5],[21,-28],[45,-74],[25,-9],[31,9],[11,12],[-10,29],[-13,62],[-18,47],[-23,23],[-5,29],[15,52],[17,44],[32,12],[38,6],[49,-47],[59,-15],[44,3],[7,27],[-2,30],[-27,38],[6,57],[30,108]],[[97857,84100],[1,28],[-26,54],[-42,16],[-109,-101],[-30,-8],[-89,27],[-77,44],[-8,31],[-13,26],[-64,25],[-81,16],[-26,0]],[[120027,76082],[1,11],[-6,50],[25,44],[-2,17],[-51,55],[-71,55],[-20,9],[-1,59],[3,44],[-6,40],[-14,23],[-1,18],[29,43],[-18,28],[-106,70],[-40,35],[-73,7],[-7,23],[11,49],[25,59],[40,58],[13,31],[15,52],[5,37],[45,52],[0,14],[-12,18],[-36,11],[-36,4],[-14,9],[-5,28],[5,114],[-12,68],[-15,50],[10,111],[-26,23],[-39,58],[-17,50],[9,18],[8,33],[6,43],[-2,30],[-36,30],[-28,31],[-3,34],[-11,42],[-15,33],[-7,22],[14,13],[51,10],[76,-7],[61,-1],[35,22],[43,201],[39,54],[46,30],[89,-71],[37,-25],[22,-1]],[[106277,89934],[-5,16],[4,39],[-1,60],[-18,53],[-54,47],[-57,33],[-72,34],[-54,15],[-29,4],[-7,19],[-10,17],[-25,15],[-54,20],[-45,4],[-37,-32]],[[110972,38694],[16,-59],[35,-99],[40,-73],[49,-64],[42,-38],[28,-12],[177,4],[64,-38],[55,-49],[14,-76],[37,-48],[39,-38],[17,-4],[29,9],[47,1],[44,-17],[21,-16],[2,-64],[14,-28],[60,-11],[61,-5],[59,-43],[63,-8],[74,-18],[35,-46],[78,-48],[96,-43],[69,-48],[36,-22]],[[95754,89392],[-6,-79],[1,-154],[-7,-28],[-40,-65],[-43,-117],[-12,-77],[-12,-15],[-171,0],[-25,-13],[-3,-17],[8,-20],[-4,-19],[-13,-16],[7,-26],[30,-29],[54,-18],[58,-2],[29,4],[22,-21],[22,-32],[-2,-40],[-8,-54],[-28,-50],[-79,-58],[-35,-20],[-33,-10],[-16,-15],[-7,-20],[1,-17],[56,-46],[-1,-11],[-16,-24],[-22,-22],[-145,-47],[-60,4],[-34,-24],[-10,-4],[-38,21],[-84,25],[-32,-9],[-18,-13],[-53,-17],[-38,-25],[0,-34],[67,-85],[24,-17],[1,-32],[32,-41],[34,-50],[3,-32],[-3,-33],[-18,-46],[-58,-107],[-1,-21],[5,-16],[20,-4],[15,-8],[-4,-15],[-109,-75],[-14,-13],[-46,4],[-7,-12],[6,-21],[18,-17],[39,-10],[33,-19],[27,-37],[-35,-127]],[[97293,84258],[10,16],[10,25],[-6,21],[-19,21],[-11,23],[-3,22],[-5,18],[-4,17],[-6,13]],[[85620,51685],[37,35],[50,-9],[78,-28],[16,28],[59,140],[-2,52],[-6,37],[35,96],[27,37],[14,40],[-4,55],[-21,21],[-27,-4],[-33,13],[-49,32],[-25,28],[8,127],[4,39],[18,23],[27,6],[77,4],[62,-14],[54,-9],[29,0],[24,-37],[31,-39],[28,0],[9,29],[-6,125],[-18,67],[-42,64],[-108,54],[-3,77],[11,83],[24,30],[80,53],[-14,28],[-26,30],[-51,31],[12,99],[2,88],[-43,-10],[-44,-5],[-37,27],[-31,54],[-6,148],[0,170],[-6,76],[12,40],[38,37],[42,48],[14,31]],[[95945,81545],[-2,46],[-6,35],[27,38],[43,44],[40,57],[17,41],[-8,27],[-18,40],[-25,3],[-147,-34],[-34,9],[-109,52],[-118,65],[-43,46],[-17,46],[12,30],[-9,29],[-23,39],[20,45],[37,55],[18,37],[31,10],[15,23],[-25,91],[-13,15],[-21,11],[-32,1],[-57,19],[-41,32],[-9,42],[-21,41],[-37,38],[-5,41],[42,22],[57,0],[40,-7],[90,65],[33,6],[30,15],[24,89],[20,27],[4,16],[-17,19],[-73,63],[-33,66],[-53,74],[-48,33],[-10,26],[-1,32],[10,28],[88,45],[52,47]],[[109818,102372],[-43,-10],[-133,-40],[-82,-27],[-98,-20],[25,-26],[163,-6],[26,-7],[18,-14],[3,-22],[-17,-35],[-176,-192],[-5,-41],[57,-113],[81,-133],[244,-60],[182,-46],[116,-109],[192,-145],[102,-54],[6,-16],[-30,-100],[-124,-100],[-115,-84],[-119,-101],[-93,-87],[-101,-103],[-12,-34],[-2,-32],[18,-35],[129,-127],[50,-64],[61,-70],[51,-77],[30,-68],[52,-66],[32,-34],[54,-48],[64,-71],[22,-56],[97,-195],[10,-50],[-5,-37],[-43,-9],[-94,-6],[-103,-24],[-5,-8],[67,-46],[-59,-78],[-9,-113],[-63,-59],[-6,-14],[3,-11],[11,-9],[117,-16],[10,-16],[1,-33],[-11,-31],[-58,-23],[-63,-33],[-14,-31],[2,-28],[21,-47],[42,-54],[53,-34],[187,-33],[24,-26],[10,-37],[-4,-36],[-87,-72],[1,-27],[36,-67],[42,-64],[183,-69],[63,-37],[17,-31],[9,-48],[-1,-53],[-15,-47],[-57,-60],[-133,-119],[-133,-46],[-8,-10],[41,-38],[235,-153],[153,-71],[206,-96],[134,-76],[43,-55],[57,-61],[65,-50],[47,-43],[17,-28],[-1,-30],[-63,-90],[-35,-69],[-63,-103],[-64,-71],[-162,-130],[-239,-162],[-55,-49],[-112,-85],[-192,-171],[-50,-38],[-157,-136],[-71,-44],[-56,-40],[-156,-129],[-167,-98],[-164,-91],[-49,-46],[-62,-35],[-73,-34],[-30,-19],[-165,-124],[-229,-173],[-43,-66]],[[111049,103000],[35,-109],[-1,-38],[-17,-36],[-23,-19],[-47,-8],[-112,3],[-152,43],[-98,41],[-31,1],[-13,-5],[24,-40],[-7,-32],[-15,-33],[-20,-31],[-29,-26],[-60,-33],[-104,-27],[-288,-51],[-22,-23],[-93,-143],[-25,-21],[-34,-18],[-99,-23]],[[126760,64175],[5,120],[-1,60],[5,92],[45,128],[54,163],[39,109],[34,94],[27,75],[15,78],[-8,55],[-18,20],[-15,26],[51,41],[96,27],[54,-5],[74,20],[59,18],[4,24],[-16,41],[-25,60],[-83,6],[-25,17],[29,88],[-1,28],[-11,33],[-12,55],[6,72],[17,48],[0,39],[-8,81],[3,71],[17,36],[31,33],[29,17],[31,-1],[24,-14],[10,-38],[-6,-26],[-18,-3],[-6,-11],[25,-50],[36,-49],[27,8],[31,38],[33,32],[41,27],[29,53],[26,35],[22,5]],[[122487,79959],[-35,-53],[-57,-96],[-25,-51],[-61,-47],[-100,-49],[-56,-22],[-60,-103],[-66,-100],[-45,-11],[-129,16],[-46,9],[-131,44],[-37,27],[-36,116],[-40,50],[-51,31],[-35,27],[-14,28],[-37,41],[-68,60],[-49,57],[-39,16],[-48,-21],[-28,-5],[-13,10],[-9,48],[-70,17]],[[55815,47370],[-29,1],[-23,26],[-4,32],[-12,36],[-29,11],[-55,-13],[-16,9],[-33,39],[-27,42],[-6,40],[-18,-3],[-41,-37],[-29,-8],[-22,10],[-25,-3],[-64,-39],[-37,-9],[-27,-40],[-177,-18],[-46,-10],[-105,68],[-28,23],[-14,3],[-11,-4],[-12,-15],[-17,-87],[-16,-23],[-28,-19],[-27,-34],[-5,-34],[41,-18],[35,-65],[38,-52],[30,-46],[-4,-52],[-6,-73],[-21,-25],[-37,-13],[-134,36],[-102,32],[-44,7],[-19,8]],[[121102,79998],[-16,-30],[-37,-53],[-29,-28],[-33,-4],[-32,-12],[-12,-29],[-1,-37],[6,-27],[8,-10],[33,-8],[33,-78],[51,-40],[80,-45],[71,-51],[35,-47],[-7,-34],[-23,-70],[-59,-59],[-50,-15],[-17,5],[-33,19],[-65,45],[-70,36],[-55,-11],[-35,-14],[-71,16],[-83,31],[-44,31],[-19,22],[13,40],[-190,73],[-91,20],[-41,-22],[-140,-109]],[[83744,55681],[5,62],[-43,43],[-1,21],[4,58],[19,122],[-2,46],[18,91],[-28,41],[-7,30],[-31,49],[-37,68],[-8,55],[-13,44],[-34,66],[-26,10],[-54,10],[-9,-22],[-20,-33],[-18,-10],[-30,41],[-11,34],[0,32],[-40,54],[-63,101],[6,83],[39,45],[12,34],[3,38],[-17,46],[-21,36],[6,80],[-6,111],[-31,56],[-29,40],[-40,44],[-35,68],[14,93],[13,63],[-60,133]],[[55815,47370],[16,-11],[26,-17],[23,-39],[53,-31],[91,-44],[42,-1],[39,-13],[24,-14],[26,25],[93,67],[45,38],[30,29],[23,27],[17,7],[12,-16],[10,-22],[33,-13],[77,-25],[35,-8],[50,22],[43,37],[20,13],[32,-37],[21,-52],[15,-22],[32,5],[63,-8],[47,-17],[29,2],[40,23],[21,45],[56,42],[54,38],[30,52],[46,85],[15,36],[3,62],[64,178],[24,33],[14,56],[26,66],[0,54],[19,53],[36,46],[27,28],[43,77],[30,72],[76,161],[5,45],[30,27],[10,35],[32,43],[34,33],[14,50],[25,52],[54,39],[20,17]],[[92852,50704],[1,48],[18,139],[11,54],[14,41],[-14,50],[-14,67],[-6,105],[17,32],[5,40],[-4,62],[0,208],[10,22],[12,18],[1,27],[-22,54],[-21,61],[1,88],[-8,86],[-14,39],[10,145],[6,184],[-5,81],[13,58],[7,142],[-1,139],[27,219],[80,11],[95,18],[42,87],[24,109],[-7,108],[18,35],[38,59],[68,83],[-2,92],[19,29],[32,21],[47,11],[52,46],[29,80],[28,128],[-45,89],[1,20],[17,48],[27,48],[22,16],[51,-13],[8,4],[8,15],[33,142],[-3,38],[-47,95],[-8,67],[-7,100],[-12,89],[-13,34],[-25,28],[-12,18],[-97,181],[2,85],[40,110],[27,53]],[[99550,41629],[-16,13],[-50,55],[-58,88],[-21,14],[-33,-2],[-51,-32],[-50,-51],[-90,-46],[-76,-26],[-7,-32],[-17,-55],[-25,-34],[-67,-11],[-24,-48],[-58,-95],[-39,-43]],[[101775,83799],[-58,20],[-68,8],[-13,-11],[-28,-11],[-14,-20],[11,-78],[-17,-13],[-78,8],[-26,-9],[-43,-55],[-43,-23],[-55,-16],[-41,-20],[-52,-17],[-44,-10],[-18,-24],[-10,-26],[3,-26],[44,-50],[6,-53],[-4,-65],[-11,-35],[-17,-24],[-111,-30],[-114,-53],[-3,-12],[52,-48],[3,-12],[-44,-27],[-4,-27],[5,-32],[23,-32],[8,-29],[-63,-21],[-85,7],[-100,41],[-36,-6],[-34,-21],[-35,9],[-38,25],[-55,52],[-26,32],[-11,34],[-15,5],[-22,-10],[-19,-42],[-50,-73],[-37,-20],[-56,4],[-79,-1],[-49,-6],[-60,26],[-14,-5],[0,-17],[-23,-27],[-37,-18],[-170,40],[-24,33]],[[103318,83330],[-3,0],[-44,-17],[-71,-10],[-36,7],[-66,-78],[-20,-14],[-62,-24],[-51,-11],[-44,9],[-17,1],[-194,4],[-101,16],[-65,31],[-44,34],[-21,37],[-50,23],[-79,8],[-62,37],[-44,67],[-60,52],[-76,39],[-60,55],[-44,70],[-80,64],[-115,56],[-34,13]],[[104182,83476],[-21,14],[-31,13],[-147,16],[-58,-12],[-78,5],[-71,14],[-54,-12],[-47,-56],[-23,-19],[-19,-12],[-40,-17],[-34,-21],[-45,-16],[-40,3],[-38,24],[-14,-6],[-12,-22],[-20,-19],[-57,-23],[-15,0]],[[101775,83799],[-7,18],[-57,70],[-24,26],[3,35],[-12,20],[-20,13],[-11,51],[-7,37],[-16,24],[-123,5]],[[124228,65744],[-58,-17],[-55,-18],[-45,1],[-37,7],[-24,17],[-47,70],[-33,90]],[[107423,30777],[-13,-41],[-9,-59],[12,-44],[26,-60],[37,-52],[28,-31],[34,-77],[34,-96],[45,-74],[131,-171],[14,-62],[19,-60],[82,-117],[13,-39],[-6,-79],[85,-238],[56,-139],[47,-25],[151,-148],[131,-119],[154,-80],[114,-53],[55,-39],[28,-37],[23,-71],[12,-123],[4,-80],[121,3],[101,-7],[35,-16],[13,-23],[-3,-53],[2,-78],[4,-63],[-10,-68],[-7,-79],[-5,-99],[15,-39],[98,-124],[41,-80],[43,-122],[25,-39],[21,-16],[88,-13],[226,-51],[140,-47],[110,-48],[47,-12],[22,-13],[8,-12],[-14,-106],[5,-34],[12,-31],[19,-24],[23,-15],[84,-11],[50,-65],[32,-30]],[[141370,74724],[-48,-13],[-98,-7],[-34,1],[-48,2],[-98,27],[-132,36],[-136,51],[-73,40],[-25,14],[-62,41],[-44,36],[-8,94],[-32,-7],[-75,-34],[-87,-21],[-47,-1],[-20,16],[-28,99],[-21,28],[-39,11],[-43,17],[-21,26],[-5,33],[19,37],[23,29],[3,176],[-14,62],[-12,53],[-32,65],[-28,40],[-44,38],[-68,38],[-61,15],[-73,-29],[-23,11],[-31,120],[-19,25],[-131,49],[-58,12],[-68,-16],[-39,-13],[-31,22],[-49,28],[-47,19],[-59,0],[-39,-11]],[[109204,80062],[-88,15],[-30,-5],[-20,-20],[-40,4],[-51,0],[-52,-24],[-29,-10],[-39,22],[-72,64],[-44,45],[-33,12],[-33,-14],[-117,-15],[-28,-26],[-54,-29],[-55,-14],[-78,-10],[-41,2],[-23,-14],[-20,-43],[-13,-41],[-11,-17],[-98,-20],[-21,-24],[-6,-23],[2,-23]],[[157610,55105],[-10,21],[-117,295],[-20,137],[20,105],[12,36],[-34,55],[-47,63],[-85,83],[-5,130],[-19,154],[-25,52],[-39,95],[-21,79],[-7,207],[11,17],[60,6],[76,15],[12,34],[-13,27],[49,47],[70,103],[54,108],[39,68],[23,67],[79,96],[109,66],[73,15],[77,23],[74,32],[35,3],[91,-39],[50,-10],[51,1],[54,-4],[47,4],[112,27],[119,-22],[106,17],[131,32],[65,-20],[58,-31],[9,-64],[13,-29],[20,-22],[26,0],[33,44],[28,46],[9,8]],[[148537,67978],[-6,-15],[-79,-66],[-14,-35],[18,-34],[31,-29],[14,-27],[14,-86],[40,-24],[79,-56],[69,-40],[119,27],[33,-19],[59,-19],[45,-6],[27,-14],[15,-14],[-2,-17],[2,-18],[66,-4],[34,-11],[116,19],[116,25],[54,77],[23,5],[67,30],[66,-33],[72,-44],[39,-14],[77,-7],[75,5],[180,21],[99,-11],[90,64],[19,0],[40,-49],[99,-5],[53,24],[58,18],[36,6],[29,1],[36,-5],[33,16],[15,33],[-3,50],[-24,54],[-21,32],[-4,17],[6,39],[19,55],[34,63],[-25,61],[-35,71],[-26,6],[-65,-16],[-69,3],[-55,43],[-41,52],[-10,45],[12,54],[18,50],[4,18]],[[158342,46505],[-1,46],[-6,56],[-103,28],[-48,21],[-78,-20],[-44,-72],[-28,-72],[2,-32],[4,-14]],[[155791,50764],[13,38],[15,126],[10,25],[25,13],[29,-4],[55,-109],[141,-68],[42,-16],[56,27],[25,-17],[25,-28],[15,-78],[37,-71],[74,10],[27,-10],[15,-3],[15,-63],[6,-109],[-7,-64],[-53,-91],[-7,-62],[28,-38],[36,-41],[21,-31],[22,5],[28,21],[25,54],[18,46],[95,51],[98,46],[13,-5],[16,-20],[32,-67],[18,-14],[26,-7],[46,7],[54,38],[28,71],[12,56],[77,97],[9,73],[21,47]],[[94976,87304],[8,-15],[73,-44],[23,-34],[52,-34],[-43,-42],[6,-19],[16,-19],[59,-12],[30,-27],[2,-43],[13,-69],[-122,-69],[-35,-77],[-3,-15]],[[44726,61712],[14,-24],[30,-167],[2,-53],[-29,-80],[4,-32],[64,-74],[1,-27],[-7,-27],[-55,-70],[-42,-49],[13,-55],[34,-52],[4,-44],[-10,-58],[-52,-72],[-28,-26],[-77,-3],[-9,-11],[39,-70],[43,-79],[72,-62],[16,-58],[-17,-55],[-3,-136]],[[100190,56237],[-85,148],[-109,191],[-102,177]],[[121168,69446],[105,135],[49,72],[88,157],[45,112],[44,124],[37,96],[8,18],[22,32],[49,34],[70,31],[118,14],[83,1],[19,-2],[53,-15],[145,-78]],[[148032,68435],[-7,28],[7,24],[20,13],[87,16],[97,36],[39,19],[30,18],[30,30],[27,-1],[88,-43],[30,-27],[17,-82],[13,-32],[-13,-84],[-52,-202],[10,-76],[44,-55],[38,-39]],[[32892,56779],[-7,39],[0,42],[37,58],[68,77],[45,39],[22,8],[29,-4],[29,22],[25,53],[26,34],[65,35],[15,14],[-5,29],[-15,58],[3,35],[21,17],[26,3],[53,14],[23,-3],[13,-9]],[[171245,37747],[10,-27],[24,-34],[17,-6],[12,8],[96,-12],[23,12],[37,53],[24,29],[16,62],[4,40]],[[171817,38077],[-5,-74],[14,-18],[24,-9],[82,50],[16,-10],[16,-22],[0,-66],[-32,-55],[-79,-5],[-11,-15],[-1,-34],[6,-33],[18,-26],[24,-46],[22,-107]],[[165497,49492],[18,-27],[38,-96],[25,-96],[9,-147],[30,-62],[-5,-13],[-18,-10],[-28,-5],[-50,14],[-41,22],[-36,158],[-16,90],[2,107],[-2,65]],[[161936,47123],[-58,-108],[6,-39],[14,-35],[42,-25],[12,-133],[53,-76],[53,-69],[39,-34],[43,-49],[30,-46],[32,-39],[48,-37],[129,-160],[54,-47],[41,-47],[28,-17],[71,13],[209,115],[37,8],[68,20],[120,-6],[127,-40],[41,-1],[39,24],[54,-7],[51,-13],[25,11],[74,83],[101,25],[32,83],[25,78],[12,83],[42,33],[59,29],[86,37],[302,6],[29,-16],[7,-42],[-7,-32],[12,-19],[40,-2],[38,-20],[150,-66],[64,-21],[36,5],[70,-60],[38,21],[51,42],[49,56],[43,45],[63,17],[81,-2],[97,15],[72,24],[81,-39],[22,12],[14,39],[42,85],[18,57],[16,109],[12,27],[30,15],[32,20],[8,33],[12,38],[-10,32],[-18,27],[-19,91],[6,42],[12,31],[32,16],[86,67],[76,78],[42,39],[18,25],[1,36],[-33,38],[-32,18],[-2,43],[1,30],[10,29],[-5,27],[0,41],[20,45],[47,65],[37,43],[41,-27],[47,12],[46,22],[25,77],[4,37],[-6,29],[15,111],[4,15],[30,70],[3,46],[-17,109],[11,82],[4,169],[18,31],[21,88],[33,91],[67,50],[35,66],[15,12],[23,0],[81,-47],[73,53],[66,6],[54,-7],[31,-22],[30,-16],[65,52],[25,-9],[23,-18],[32,1],[38,13],[94,-13],[166,-2],[115,-31],[112,-88],[56,-18],[134,-3],[90,15]],[[97857,84100],[17,-8],[65,-2],[71,-6],[45,-43],[45,-15],[64,-5],[42,6],[21,17],[24,51],[46,63],[71,33],[122,6],[61,12],[64,-1],[47,-10],[50,2],[125,44],[129,35],[18,-6],[3,-12],[-23,-27],[-23,-36],[15,-40],[74,-82],[40,-63],[37,-47],[59,-25],[77,-15],[66,-6],[68,-18],[235,-43],[118,-13],[89,-2],[136,-29]],[[99955,83815],[-13,-47],[-28,-12],[-47,-27],[-55,-38],[-51,-43],[-14,-46],[14,-30],[14,-11],[18,10],[27,-6],[35,-17],[56,-16],[2,-16],[-12,-20],[-44,-36],[-40,-41],[-4,-25],[5,-18],[14,-11],[59,5],[8,-15],[-28,-105],[9,-18],[51,-17],[38,-26],[71,-66],[28,-54],[-19,-18],[-45,-9],[-36,4]],[[109850,43208],[9,46],[22,51],[25,6],[62,-21],[64,-43],[34,-98],[27,-14],[47,0],[121,13],[31,-2],[55,24],[54,41],[16,43],[13,95],[12,173],[27,2],[77,-62],[16,-4],[17,2],[26,31],[33,25],[24,-1],[89,29],[47,-52],[30,-16],[16,-4]],[[150917,63576],[5,-31],[1,-273],[6,-117],[21,-96],[4,-37],[-21,-30],[-20,-5],[-19,46],[-44,36],[-64,38],[-27,25],[-33,-10],[-46,-57],[-18,-54],[8,-75],[14,-74],[32,-42],[3,-47],[12,-60],[16,-55],[8,-60]],[[92026,80579],[-51,78],[-36,16],[-55,3],[-63,24],[-65,30],[-159,49],[-44,6],[-17,-8],[-12,-29],[-6,-83],[-7,-9],[-73,-2],[-91,11],[-42,-6],[-37,0],[-35,22],[-156,-25],[-26,12],[-38,37],[-42,30],[-33,16],[-28,17],[-26,3],[-38,-17],[-54,-7],[-44,2],[-24,-2],[-99,91],[-15,25],[-49,7],[-61,1],[-156,59],[-71,31],[-11,19],[1,16],[-12,-4],[-22,-27],[-11,-22],[-15,-4],[-23,4],[-21,12],[-12,16],[13,28],[24,36],[10,40],[-2,35],[-40,23],[-58,10],[-42,2],[-55,21],[-27,14],[-25,40],[-1,28]],[[92026,80579],[20,21],[27,18],[43,-7],[92,-25],[19,-23],[1,-16],[-17,-26],[-5,-18]],[[92206,80503],[99,-38],[44,-26],[15,-27],[23,-29],[30,-4],[42,27],[66,29],[112,-26],[125,-36],[55,-5],[2,18],[9,26],[21,12],[31,4],[42,14],[49,22],[51,9],[54,-17],[64,-13],[38,0]],[[92026,80579],[-9,-39],[5,-15],[5,-27],[-1,-30],[13,-20],[24,-2],[31,6],[34,12],[60,33],[18,6]],[[139491,76155],[18,15],[58,36],[46,42],[25,34],[-13,54],[-72,66],[-46,35],[-14,23],[12,71],[17,70],[-11,27],[-14,23],[-6,77],[-31,92],[-34,54],[-10,73],[-2,68],[42,107],[-16,47],[-43,41],[-149,74],[-153,49],[-58,-2],[-37,3],[-42,-43],[-26,-57],[-36,-5],[-65,24],[-44,36],[-30,76],[-24,98],[-14,30],[7,27],[15,23],[42,22],[7,23],[-7,27],[-33,35],[-34,50],[-54,103],[10,56],[9,82],[-3,43]],[[139491,76155],[-33,-5],[-47,20],[-18,30],[-8,4],[-37,-20],[-71,-25],[-121,-65],[3,-16],[78,-67],[19,-21],[9,-7]],[[104649,79139],[87,5],[31,6],[114,3],[52,33],[36,-3],[75,-28],[33,22],[98,45],[97,130],[41,19],[94,8],[30,15],[34,-3],[106,-26],[60,-4],[71,18],[78,31],[20,111],[18,16],[49,4],[37,-1]],[[105034,80292],[-111,-23],[-37,-27],[-22,-47],[-7,-25],[-20,0],[-32,24],[-41,38],[-54,-3],[-182,-83],[-18,-43],[-4,-94],[-12,-26],[-20,-16],[-75,10],[-8,6]],[[105540,80347],[-17,6],[-26,23],[-24,7],[-61,-27],[-61,-17],[-48,13],[-47,1],[-33,-11],[-25,-4],[-49,-30],[-78,-21],[-37,5]],[[105540,80347],[50,12],[16,25],[50,67],[6,33],[-6,19],[-33,33],[-23,70],[17,67],[2,34],[-17,33],[17,42],[36,23],[23,7],[96,5],[61,84],[36,26],[38,48],[18,17],[16,37],[6,38],[-76,53],[-26,40],[-33,44],[-46,31],[-92,52],[-36,53],[-16,69],[-24,52],[-27,34],[-5,28],[-11,34],[-3,66],[22,89],[14,31],[31,9],[83,47],[4,60],[15,38],[26,22],[24,14]],[[105910,79540],[8,17],[14,205],[35,92],[-1,19],[-7,14],[-31,15],[-23,50],[-47,130],[-26,27],[-73,27],[-65,38],[-54,50],[-100,123]],[[103015,80549],[1,-30],[25,-35],[27,-39]],[[103015,80549],[-58,22],[-27,11],[-117,75],[-51,42],[-81,54],[-50,32],[-26,47],[-40,11],[-47,-16]],[[142092,72984],[21,-33],[41,-45],[35,-34],[30,-20],[157,-46],[13,-20],[-23,-92],[-4,-49],[66,-116],[41,-86],[-4,-35],[-15,-37],[-55,-60],[-60,-52],[-47,-5],[-32,-3],[-28,-18],[-39,-72],[-44,-19],[-51,-6],[-53,45],[-43,46],[-11,26],[-11,48],[-23,32],[-45,-15],[-68,-6],[-73,-11],[-14,-11],[-1,-20],[18,-44],[15,-57],[9,-80],[20,-53],[6,-17],[118,-159],[31,-33],[6,-21],[-10,-58],[-21,-68],[4,-53],[39,-60],[32,-41],[-31,-56],[-18,-65],[20,-29],[-10,-93],[10,-17],[22,-8],[34,7],[35,24],[30,5],[18,-7],[24,71],[21,10],[41,-20],[81,-132],[69,-113],[20,-21],[12,-13],[68,-58],[46,-37],[64,13],[85,3],[49,-36],[29,-25],[107,-93],[44,7],[29,-25],[8,-63],[-13,-64],[3,-31],[45,-6],[96,-42],[85,-38],[44,-12],[47,-28],[42,-45],[82,-58],[72,-44],[16,-60]],[[104248,80770],[80,25],[12,18],[-18,37],[10,24],[97,66],[16,31],[5,24],[-13,25],[-18,39],[9,17],[50,23],[41,27],[24,2],[15,-19],[0,-20],[13,-34],[30,-18],[50,-29],[57,-20],[46,-40],[61,-72],[10,-35],[55,-32],[52,-36],[-8,-66],[176,-57],[39,0],[19,-10],[0,-15],[-14,-46],[-72,-142],[-6,-30],[-52,-31],[-7,-18],[15,-39],[14,-28]],[[104248,80770],[-84,-24],[-14,-36],[-41,4],[-48,0],[-16,-23],[23,-38],[15,-45],[-12,-61],[-4,-8]],[[103505,81352],[-2,-10],[3,-30],[15,-29],[51,-29],[75,-59],[89,-108],[40,-32],[37,-8],[71,-44],[50,-11],[55,-12],[145,-94],[65,-27],[46,-35],[5,-33],[-2,-21]],[[33365,57340],[16,-4],[108,-42],[32,8],[41,-34],[20,-26],[17,-37],[85,-73],[15,-32],[63,-44],[26,-33],[27,-14],[54,-12],[45,-18],[5,-12],[5,-49],[9,-42],[22,-2],[26,20],[86,55],[81,37],[45,-22],[27,-46],[31,-21],[64,13],[58,-4],[46,-40],[10,-24],[-28,-134],[-10,-57],[-5,-49],[17,-13],[16,-19],[-4,-26],[-50,-43]],[[34674,56155],[179,10],[32,13],[33,38],[17,53],[2,51],[7,36],[29,36],[53,11],[40,4],[12,23],[-12,78],[-22,188],[-4,52],[7,39],[17,15],[79,9],[151,-16],[29,12],[61,107],[56,78],[40,35],[31,11],[37,-70],[127,-100],[22,7],[12,5],[4,14],[-2,46],[32,42],[66,38],[66,66],[67,95],[58,56],[49,17],[19,26],[-12,35],[4,50],[19,65],[29,37],[37,10],[15,21],[-8,30],[8,34],[33,55],[81,47],[46,-16],[38,-63],[54,-43],[70,-23],[55,9],[38,39],[35,12],[31,-15],[16,8],[2,34],[16,7],[30,-18],[27,-4],[24,9],[9,16],[5,16],[17,13],[61,-12],[68,19],[75,51],[50,22],[24,-6],[30,26],[34,57],[79,26],[166,-12]],[[42461,45363],[-116,57],[-99,83],[-103,22],[-67,51],[-61,80],[-33,53],[-27,27],[-131,78],[-26,7],[-50,-36],[-16,-21],[-3,-62],[-6,-35],[-44,-22],[-70,5],[-49,22],[-32,4],[-7,-18],[-18,-8],[-40,6],[-59,17],[-53,23],[-72,48],[-33,-6],[-83,10],[-66,28],[-18,26],[-29,174],[-8,12],[-29,8],[-49,24],[-30,28],[-16,48],[-20,46],[-81,-10],[-134,60],[-93,58],[-85,64],[-129,126],[-49,31],[-61,39],[-36,62],[-59,62],[-20,17]],[[53890,48229],[0,0],[-5,2],[-28,20],[-6,24],[4,77],[-46,58],[-72,73],[-22,91],[-27,58],[-80,120],[-14,82],[-1,58],[29,53],[39,94],[16,85],[12,44],[21,58],[18,75],[-14,46],[-24,46],[-8,33],[24,50],[23,35],[26,5],[34,21],[26,30],[41,8],[50,3],[103,0],[52,13],[16,24],[-2,47],[26,42],[27,18],[11,14],[2,15],[-7,15],[-11,9],[-29,3],[-25,73],[17,32],[22,59],[7,33],[34,52]],[[56160,48195],[12,22],[35,78],[2,68],[10,48],[-10,26],[-18,7],[-31,63],[-20,53],[-54,53],[-38,55],[-61,127],[5,70],[-17,26],[-19,26],[1,32],[-13,79],[-16,75],[-5,47],[15,81],[-9,90],[-20,47],[-6,72],[4,64],[17,37],[-3,45],[78,143],[59,83],[54,59]],[[53361,17458],[-20,78],[-23,84],[0,80],[11,114],[24,132],[19,98],[8,76],[17,18],[75,12],[54,67],[16,40],[2,54],[-7,68],[-26,155],[-12,139]],[[53881,20556],[-23,-32],[-4,-56],[-40,-74],[-76,-91],[-27,-80],[35,-99],[5,-121],[-15,-49],[-34,-16],[-8,-31],[19,-46],[1,-61],[-16,-75],[-36,-86],[-55,-96],[-13,-65],[28,-32],[14,-35],[0,-37],[-12,-53],[-23,-69],[-34,-52],[-47,-33],[-13,-43],[18,-51],[3,-54],[-14,-56],[8,-54],[29,-53],[-2,-60],[-50,-123]],[[55815,24359],[51,0],[23,-26],[37,-14],[39,30],[34,14],[53,1],[28,34],[33,5],[23,-18],[22,-22],[47,-5],[37,-58],[41,-17],[18,-66],[26,-174],[50,-102],[49,-117],[1,-52],[-27,-53],[-5,-75],[-17,-184],[-5,-68],[16,-46],[7,-64],[-27,-79],[-51,-118],[-50,-32],[-13,-1],[-68,-68],[-47,-26],[-28,18],[-31,-30],[-36,-76],[-43,-34],[-78,-19],[-24,-9],[-45,2],[-39,-19],[-33,-40],[-35,-15],[-37,10],[-34,-15],[-30,-40],[-17,-44],[-5,-46],[-29,-32],[-55,-17],[-19,-24],[4,-32],[-25,-26],[-91,-26],[-67,-47],[-41,-68],[-43,-42],[-68,-26],[-93,-69],[-13,-42],[35,-39],[13,-35],[-10,-30],[-29,-5],[-48,23],[-34,4],[-20,-13],[-10,-24],[1,-36],[-17,-25],[-35,-13],[-23,-29],[-9,-47],[-45,-58],[-79,-71],[-62,-95],[-46,-119],[-54,-79],[-61,-37],[-42,-54],[-23,-69],[-65,-108],[-108,-146],[-97,-100],[-87,-54],[-49,-62],[-11,-68],[-57,-78],[-102,-88],[-30,-39]],[[104427,102384],[177,-47],[8,-10],[1,-24],[6,-26],[171,-64],[49,-34],[106,-52],[27,-28],[98,-33],[69,-35],[82,-28],[95,-44],[128,-36],[108,-11],[271,-60],[47,-20],[78,-42],[79,-48],[55,-100],[88,-5],[24,-35],[76,-59],[107,-51],[-4,-18],[-85,-48],[-9,-65],[8,-82],[27,-68],[-3,-20],[-21,-23],[-25,-36],[-9,-32],[2,-16],[8,-8],[45,-1],[80,-8],[47,-14],[27,-77],[-10,-15],[-67,-36],[-20,-28],[-2,-41],[12,-45],[24,-50],[52,-54],[72,-57],[46,-46],[22,-33],[9,-23],[-33,-28],[-28,-57],[-6,-65],[-13,-43],[-63,-58],[-43,-21],[-13,-31],[-5,-51],[13,-63],[4,-43],[14,-30],[19,-21],[101,-35],[56,-72],[36,-59],[68,-152],[-16,-38],[18,-33],[21,-55],[-1,-37],[-47,-84]],[[93834,87828],[-10,-31],[-25,-34],[-85,-50],[-90,-32],[-46,4],[-31,17],[-17,18],[-48,17],[-65,9],[-41,-19],[-29,-18],[-26,3],[-19,15],[-15,23],[-19,71]],[[94976,87304],[-127,3],[-33,4],[-34,13],[-16,26],[-19,31],[5,19],[58,54],[8,15],[-6,8],[6,23],[45,81],[5,32],[-20,23],[-28,13],[-93,24],[-44,34],[-20,29],[-21,9],[-31,-10],[-76,-11],[-63,16],[-74,55],[-17,50],[-9,38],[-18,14],[-25,-20],[-31,-31],[-62,-4],[-18,8],[-3,17],[-4,16],[-17,20],[-18,12],[-79,-58],[-29,1],[-37,22],[-18,21],[-40,-12],[-37,-27],[13,-50],[-20,-9],[-45,5],[-50,20]],[[95202,86234],[25,4],[49,-12],[49,-40],[21,-40],[5,-22],[21,-24],[83,-107],[26,-6],[29,17],[19,23],[27,4],[43,-10],[28,-12],[13,-47],[10,-9],[19,10],[33,3],[53,-12],[74,13],[58,20],[30,-1],[49,-54],[55,-21],[121,-16],[131,-26],[51,-20],[35,-10],[4,-72],[-11,-11],[-130,-144],[-55,-52],[-27,-73],[-20,-113],[-38,-107],[-58,-102],[-21,-76],[16,-51],[-10,-80],[-35,-109],[-6,-82],[23,-56],[33,-11]],[[97257,84643],[-113,62],[-108,59],[-35,0],[-160,-12],[-4,5],[-28,34],[-24,11],[-15,-6],[-10,-9],[-17,1],[-72,55],[-29,8],[-40,-8],[-48,-29],[-21,-36],[6,-20],[25,-9],[65,6],[10,-6],[2,-12],[-7,-11],[-53,-10],[-16,-13],[-15,-4],[-10,-2],[-56,14],[-84,0],[-67,-25],[-108,-10],[-148,5],[-53,19]],[[97259,84434],[53,100],[11,62],[-47,37],[-19,10]],[[97293,84258],[-50,5],[-10,-1],[-5,29],[3,62],[28,81]],[[95640,83325],[-11,27],[-33,48],[-36,29],[-26,31],[-34,34],[-21,29],[29,90],[-21,32],[-11,46],[5,31],[-11,7],[-116,18],[-97,-6],[-69,-30],[-56,-50],[-7,-11],[3,-9],[28,-47],[-47,-48],[-73,-38],[-52,-4],[-23,7],[0,52],[42,20],[39,34],[13,48],[5,34],[-41,40],[5,25],[25,48],[15,42],[20,36],[80,60],[81,59],[12,64],[6,77],[12,18],[109,47],[27,18],[13,26],[86,87],[85,85],[17,29],[14,17],[0,14],[-10,11],[-41,7],[-13,27],[44,49],[55,30],[53,0],[21,-14],[-1,-16],[23,-17],[41,-6],[50,6],[49,18],[31,44],[18,32],[78,38]],[[86318,76112],[-39,205],[-19,79],[-5,51],[39,118],[42,48],[56,99],[69,82],[73,20],[32,12],[27,63],[15,55],[-11,5],[-85,-11],[-153,228],[4,36],[20,54],[12,68],[4,54],[39,46],[61,47],[52,66],[25,64],[6,59],[-29,42],[-84,23],[-86,167],[-19,105],[-18,11],[-53,48],[-51,89],[-8,14],[53,16],[217,1],[46,19],[7,7],[39,70],[42,114],[10,70],[-14,29],[-72,71],[-3,21],[12,33],[43,36],[58,40],[31,35],[-7,28],[-17,28],[-3,27],[11,33],[3,112],[8,29],[-12,101],[-14,84],[-45,107],[8,24],[21,20],[69,38],[56,88],[80,73],[105,60],[74,65],[29,50],[20,14],[-6,23],[-14,34],[-41,34],[-55,19],[-60,-1],[-37,7],[-11,26],[5,70],[-4,70],[-11,32],[-28,24],[-55,-6],[-48,19],[-36,5],[-21,-16],[-106,5],[-45,11],[-31,14],[-20,-8],[-11,-13],[-2,-22],[-7,-28],[-38,-25],[-87,-26],[-71,2],[-64,18],[-21,14],[-31,12],[-132,-15],[-16,11],[-45,-27],[-67,-31],[-37,-1],[-14,6],[-5,14],[-28,49],[8,25],[53,76],[-6,18],[-22,24],[-20,35],[-5,18],[-35,3],[-36,-18],[-139,-38],[-34,-14],[-60,-36],[-61,-56]],[[100029,85668],[-8,-16],[-3,-50],[1,-54],[-9,-28],[-40,-37],[-20,-8],[-11,-8],[-122,48],[-10,-8],[-7,-6],[-33,-140],[-22,-27],[-34,-25],[-69,-24],[-49,-10],[-37,-12],[-120,-59],[-53,-36],[-35,-44],[0,-26],[58,-75],[67,-78],[0,-68],[-30,-51],[-6,-20],[19,-7],[37,-3],[31,-9],[14,-36],[-4,-62],[-11,-59],[-11,-25],[-30,-2],[-58,26],[-44,29],[-18,18],[-1,22],[10,14],[-16,26],[-55,25],[-59,-11],[-44,-16],[-28,1],[-31,23],[-47,19],[-61,12],[-38,12],[-8,-7],[4,-52],[-11,-22],[-303,-30],[-93,-28],[-67,-36],[-50,-15],[-12,-22],[-49,-30],[-56,-9],[-13,10],[-36,-14],[-60,-13],[-40,4],[-18,24],[-38,36],[-15,25],[1,16],[-84,3],[-54,19],[-114,-4],[-28,8],[-6,-9],[-17,-102],[-22,-42],[-37,-44],[-46,-24],[-37,-4],[1,32],[10,38],[-27,9],[-40,4],[-20,11],[5,29],[-9,17],[-17,21],[-40,26],[-86,38],[-58,20],[-22,-21],[-41,-20],[-66,6],[-16,-8]],[[101501,84098],[-36,-15],[-39,-36],[2,-79],[-5,-7],[-9,-16],[-124,28],[-4,-1],[-82,-10],[-57,-36],[-68,-20],[-144,11],[-140,-14],[-33,-11],[-36,-6],[-34,-21],[-19,-30],[-35,-37],[-50,-29],[-53,-23],[-13,-19],[-18,-11],[-30,14],[-24,-1],[-30,10],[-98,11],[-109,17],[-51,17],[-59,13],[-63,11],[-57,2],[-28,5]],[[103015,80549],[12,4],[16,12],[36,34],[7,18],[-2,27],[-50,85],[-7,55],[-7,102],[11,25],[18,11],[87,13],[-1,80],[5,24],[18,33],[11,31],[48,43],[66,52],[29,1],[25,-7],[29,-44],[31,5],[6,54],[-41,70],[-21,45],[7,25],[15,13],[35,-9],[33,-12],[21,9],[34,6],[19,-2]],[[103505,81352],[39,42],[30,6],[38,2],[26,-22],[33,-4],[18,27],[10,39],[-4,50],[-80,117],[-69,81],[-8,18],[15,15],[24,8],[25,-6],[68,-6],[64,7],[23,20],[0,27],[-24,25],[-76,66],[-59,59],[-69,45],[-52,18],[-15,23],[-6,25],[6,45],[3,57],[12,36],[47,68],[44,72],[28,69],[14,64],[-5,18],[-24,14],[-49,14],[-68,-12],[-57,-23],[-23,-2]],[[103384,82454],[-43,-4],[-67,15],[-31,26],[-6,27],[0,25],[-22,40],[-54,43],[-112,6],[-42,14],[-43,15],[-47,11],[-43,-1],[-52,-11],[-91,19],[-31,-25],[-48,-29],[-40,1],[-79,66],[-24,4],[-69,-33],[-28,-2],[-22,11],[-93,25],[-43,5],[-31,-12],[-55,13],[-133,87],[-83,-66],[-168,16],[-50,-45],[-57,-85],[-46,-41],[-41,15],[-47,37],[-84,97],[-42,17],[-48,5],[-42,-11],[-23,-20],[-17,-141],[-15,-125],[-1,-75],[93,-69],[109,-119],[35,-13],[17,-39],[26,-101],[28,-113],[56,-74],[50,-54],[61,-47],[77,-74],[62,-81],[17,-29],[122,-107],[118,-110],[105,-38],[17,-20],[1,-84],[11,-32],[71,-88],[144,-128],[16,-30],[5,-22],[-9,-17],[-38,-18]],[[103384,82454],[-8,28],[10,13],[18,-1],[14,-6],[16,13],[10,39],[-24,135],[43,12],[1,19],[4,17],[44,-23],[63,0],[55,4],[8,14],[0,19],[-12,15],[-19,12],[-14,19],[-37,8],[-116,48],[-58,52],[2,55],[17,30],[20,10],[-6,10],[-66,26],[-23,35],[19,45],[-34,92],[-36,57],[36,24],[4,35],[3,20]],[[102057,85530],[21,64],[50,86],[47,49],[34,17],[70,-15],[120,-13],[92,12],[86,38],[47,33],[40,36],[13,22],[18,11],[71,20],[23,24],[9,45],[6,50],[15,37],[18,27],[132,65],[12,22],[21,23],[39,25],[38,36],[40,22],[51,-3],[48,5],[37,12],[16,2]],[[102182,85041],[-39,27],[-12,36],[-62,95],[-69,156],[-2,45],[27,51],[26,39],[3,31],[3,9]],[[102182,85041],[18,5],[66,-7],[16,-9],[10,-2],[106,-85],[100,-64],[81,-33],[121,-3],[127,-2],[214,11],[160,8],[11,16],[24,38],[-19,33],[1,39],[27,50],[79,42],[227,18],[130,31],[20,42],[43,42],[39,9],[55,-20],[65,-36],[57,-20],[33,13],[116,62],[132,60],[91,165],[10,26],[99,19],[144,-3],[74,-22],[56,-11],[83,4],[121,35],[44,-1],[35,-25],[37,-22],[26,-26],[19,-37],[11,-14],[16,-19],[31,-27],[29,-7],[223,46],[13,10]],[[100672,87393],[3,11],[67,113],[30,71],[34,130],[-41,103],[-12,48],[-19,23],[-117,50],[-9,17],[18,68],[-9,28],[-28,30],[-37,60],[-14,51],[47,60],[12,44],[20,60],[15,33],[3,9],[-31,23],[-8,33],[9,47],[-17,36],[-41,22],[-27,30],[-13,38],[10,59],[32,80],[-68,97],[-168,113],[-81,79],[7,45],[35,40],[64,37],[49,65],[27,77],[1,15],[2,55],[-75,225],[-12,56],[-9,68],[-44,175],[8,26]],[[105884,84992],[-13,11],[-6,30],[7,27],[-14,25],[-35,29],[-8,12],[-44,-2],[-12,-3],[-4,1],[-61,24],[-40,59],[-62,31],[-48,11],[-22,25],[-14,34],[-14,25],[-2,2],[-10,39],[-15,4],[-3,1],[-61,-7]],[[109573,81524],[-105,-1],[-31,4],[-99,23],[-111,40],[-66,80],[-41,57],[-95,-26],[-17,7],[-26,27],[-71,18],[-88,1],[-197,103],[-22,18],[-154,-17],[-232,-52],[-176,-63],[-183,-113],[-74,-85],[-86,-46],[-122,-34],[-218,13],[-227,43],[-244,46],[-132,-25],[-178,19],[-269,55],[-200,17],[-197,-33],[-34,25],[-7,29],[8,40],[28,32],[47,25],[26,25],[2,25],[-53,41],[-110,56],[-46,35]],[[104182,83476],[38,-48],[37,-62],[51,-29],[62,-34],[31,-24],[46,-75],[37,-36],[12,2],[12,9],[9,8],[9,-7],[1,-23],[2,-49],[-9,-54],[13,-50],[1,-16],[-9,-14],[1,-13],[13,-14],[49,-33],[46,-51],[53,-36],[49,-23],[31,-2],[51,-41],[100,-30],[32,-11],[22,-17],[16,-19],[1,-22],[-15,-10],[-22,-28],[-9,-35],[-16,-9],[-16,-1],[-11,-10],[2,-15],[14,-14],[21,-13],[40,-13],[39,-19],[0,-15],[-8,-17],[-51,-6],[-37,-3],[-17,-6],[1,-29]],[[105910,79540],[70,-9],[85,-2],[54,51],[85,4],[40,8],[66,-11],[64,1],[82,22],[77,35],[60,-3],[24,6],[14,8],[15,48],[113,3],[38,-5],[63,-1],[65,26],[20,-2],[33,-71],[17,-20],[36,-19],[79,-52],[14,13],[33,18],[95,-24],[90,-41],[76,-59],[85,17],[94,29],[61,9],[66,4],[39,12],[90,-15],[92,32],[45,29],[12,41],[-7,71],[-21,72],[-22,26],[-7,27],[12,26],[15,17],[60,15],[78,-22]],[[108110,79854],[57,-17],[34,-27],[21,-25],[32,-21],[24,-5],[18,-74],[10,-91],[-15,-39],[-42,-9],[-133,-86],[-3,-79],[1,-38],[3,-27],[14,-23],[0,-32],[-15,-36],[-58,-58],[-40,-47],[-45,-64],[-26,-7],[-20,-11]],[[104067,80539],[-12,2],[-69,-36],[-51,-16],[-46,-9],[-22,17],[-11,24],[2,67],[-8,23],[-16,11],[-32,-16],[-37,-52],[-34,-61],[-51,-63],[-42,-60],[-46,-77],[-31,-63],[32,-36],[20,-49],[-6,-38],[6,-21],[-10,-65],[-2,-41]],[[108302,85250],[61,3],[48,-6],[73,-37],[52,-46],[20,-37],[44,-52],[47,-73],[50,-97],[12,-49],[19,-53],[38,-64],[73,-72],[10,-13],[33,-51],[63,-111],[53,-45],[46,-48],[23,-49],[33,-45],[78,-58],[63,-54],[50,-153],[36,-71],[22,-54],[-11,-110],[14,-47],[-29,-85],[-52,-172],[-12,-137],[9,-74],[1,-48],[13,-30],[13,-62],[3,-55],[-19,-15],[-26,-13],[-10,-11],[24,-25],[32,-46],[33,-52]],[[105884,84992],[24,14],[91,35],[23,35],[32,32],[41,-3],[133,-78],[142,5],[26,-3],[8,-1],[18,-7],[189,-38],[30,4],[8,3],[76,-32],[67,4],[64,23],[67,7],[61,-13],[47,-45],[120,-96],[36,-35],[56,5],[61,18],[62,64],[190,72],[145,18],[142,29],[164,21],[48,59],[26,40],[19,75],[88,21],[84,16],[30,9]],[[105666,85920],[26,4],[79,-31],[70,-16],[19,15],[8,20],[-3,15],[-56,46],[-35,29],[-3,17],[13,40],[7,45],[-8,48],[-38,107],[-8,46],[37,55],[119,132],[40,50],[54,60],[148,143],[93,83],[63,47],[92,80],[41,41],[168,27],[21,39],[31,42],[24,18],[3,72],[-31,87],[-25,31],[-19,21],[12,19],[19,6],[23,3],[28,21],[-6,23],[-71,56],[-31,43],[-48,110],[-98,114],[-31,37],[-4,35],[14,35],[-13,45],[-35,57]],[[106355,87937],[-43,83],[4,75],[23,43],[29,39],[-12,58],[29,77],[0,56],[-12,24],[-23,27],[-62,31],[-28,24],[-85,32],[-84,40],[-14,25],[4,17],[15,25],[64,75],[69,72],[45,29],[236,93],[36,33],[9,55],[1,40],[-5,71],[-14,101],[-18,70],[-45,131],[-123,270],[-74,281]],[[104607,91045],[113,-20],[144,1],[59,10],[37,-34],[70,-33],[83,-28],[123,-50],[128,-30],[43,-4],[135,4],[142,-4],[39,-73],[71,-34],[57,-48],[4,-27],[-79,-170],[-16,-57],[-3,-58],[29,-72],[27,-40]],[[111626,88418],[-3,20],[-44,78],[-26,35],[-32,18],[-15,23],[-1,94],[6,87],[20,12],[-58,71],[-5,55],[29,27],[1,22],[-20,33],[-59,52],[-58,59],[-38,47],[-23,22],[28,36],[40,65],[16,37],[19,10],[93,5],[69,-1],[51,-14],[19,-31],[47,-33],[133,-14],[56,1],[70,31],[113,68],[28,49],[70,35],[43,13],[39,6],[4,29],[-3,40],[-13,24],[-140,81],[-17,27],[-11,31],[16,30],[0,32],[-162,73],[-134,13],[-111,-4],[-43,15],[19,37],[27,66],[8,54],[-8,25],[-22,21],[-105,45],[-146,70],[-67,79],[-35,83],[-39,50],[-71,32],[5,21],[47,78],[-2,11],[-20,20],[-88,39],[-120,72],[-5,18],[8,46],[17,44],[24,22],[71,90],[0,31],[-12,41],[-52,71],[-41,45],[-3,24],[7,19],[26,25],[25,30],[6,106],[-1,37],[-16,21],[-17,9],[-36,-5],[-51,17],[-38,28],[-24,9],[-25,28],[-72,56],[-13,15],[-143,48],[-124,-7],[-68,7],[-36,-10],[-37,-31],[-52,-20],[-38,-1],[-35,-15],[-96,-55],[-45,33],[-38,49],[13,42],[16,38],[-2,26],[-13,22],[-60,24],[-126,44],[-36,0],[-54,-16],[-99,-49],[-35,10],[-32,39],[-35,49],[-47,25],[-102,-3],[-9,-1],[-49,-29],[-21,3],[-88,72]],[[111626,88418],[12,-2],[60,-23],[64,-20],[44,-1],[52,4],[61,27],[43,25],[51,131],[19,19],[28,10],[47,1],[89,-24],[104,-22],[60,3],[161,69],[89,11],[107,-16],[104,-1],[79,10],[54,-24],[67,-53],[60,-79],[63,-145],[184,-165],[3,-32],[-15,-20],[-90,-20],[-77,-11],[-3,-28],[20,-31],[35,-45],[5,-57],[-1,-53],[15,-47],[29,-19],[3,-23],[-33,-29],[-10,-18],[13,-9],[166,-6],[82,-28],[61,-25],[31,-3],[70,17],[79,10],[48,1],[18,-18],[15,-50],[27,-49],[26,-14],[46,2],[28,-2],[14,-19],[-16,-28],[4,-31],[20,-37],[24,-87],[22,-26],[15,-33],[0,-37],[-19,-33],[-13,-26],[13,-59],[50,-66],[37,-16],[29,-59],[53,-19],[80,50],[60,26],[76,-15],[70,-9],[48,-34],[35,-46],[40,-26],[41,14],[84,-14],[39,-37],[39,-21],[49,30],[41,38],[148,39],[92,10],[26,8],[54,28],[57,18],[52,-5],[50,-58],[53,-40],[14,-64],[64,-87],[159,-119],[63,-37],[42,7],[22,9],[11,13],[9,58],[20,21],[33,1],[124,-73],[65,-7],[62,-2],[83,-56],[92,-50],[71,-5],[56,20],[39,11],[23,-19],[23,-42],[36,-33],[43,-9],[61,-2],[105,-64],[100,-65],[62,-4],[53,20],[47,4],[32,-16],[9,-28],[-24,-38],[0,-54],[44,-51],[2,-51],[-13,-46],[-25,-42],[-61,-59],[-56,-54],[-84,-22],[-47,-24],[13,-40],[30,-37],[72,-30],[81,-22],[9,-24],[-12,-13],[-52,-11],[-72,12],[-24,-21],[-33,-36],[-22,-63],[-17,-59],[78,-16],[46,-24],[14,-48],[16,-54],[5,-48],[-26,-24],[-2,-24],[12,-11],[34,-6],[26,-11],[2,-25],[-50,-57],[-45,-110],[-25,-59],[2,-63],[-28,-35],[-50,-3],[-173,-6],[-150,3],[-65,9],[-102,5],[-50,-15],[-67,-101],[-51,-40],[-83,-36],[-92,-10],[-53,-42],[-18,-66],[-2,-58],[-8,-29],[-20,-25],[-7,-18],[4,-20],[21,-8],[26,-9],[0,-14],[-10,-19],[-29,-20],[-12,-30],[2,-33],[6,-37]],[[119170,79351],[10,-35],[40,-49],[48,-30],[26,-33],[42,-111],[17,-61],[-6,-60],[-29,-60],[-64,-76],[16,-32],[14,-41],[-5,-31],[45,-96],[21,-60],[-17,-14],[-11,-20],[81,-46],[97,-39],[41,-7],[111,18],[72,4],[71,-37],[104,-89],[112,-117],[23,-35]],[[120029,78194],[9,-16],[22,-28]],[[120060,78150],[14,-18],[104,-169],[47,-50],[26,-42],[19,-48],[31,-32],[43,-17],[51,-46],[35,-35],[58,-74],[62,-28],[224,-53],[124,-25]],[[120898,77513],[36,-7],[96,36],[111,-5]],[[121141,77537],[42,-2],[147,151],[45,50],[88,26],[50,60],[79,73],[97,68],[89,62],[68,37],[124,86],[77,31],[67,-1],[100,-102],[85,-93],[26,-40],[-42,-37],[-78,-35],[-15,-26],[-6,-33],[3,-31],[11,-26],[96,-60],[11,-33],[0,-33],[-11,-21],[-21,-12],[-67,-17],[-57,-19],[-20,-19],[-17,-23],[2,-25],[18,-29],[117,-78],[13,-29],[23,-38],[29,-24],[49,-7],[23,-16],[114,-144],[27,-10],[133,32],[18,-2]],[[147844,85994],[75,2],[34,18],[27,28],[56,30],[12,34],[1,69],[37,58],[93,17],[36,9],[38,-9],[60,8],[57,3],[32,-18],[42,-15],[54,2],[19,27],[2,38],[24,10],[29,-26],[16,-20],[25,-9],[65,24],[46,25],[14,53],[27,25],[36,-13],[62,1],[51,40],[67,32],[49,15],[10,27],[-23,60],[6,66],[65,37],[87,5],[64,25],[18,70],[31,20],[32,8],[78,11],[57,29],[34,13],[98,38],[90,7],[38,31],[30,38],[50,15],[51,33],[67,43],[27,6],[111,24],[43,9],[26,6],[48,-2],[20,45],[49,33],[48,11],[24,32],[47,42],[63,23],[99,3],[95,-4],[57,7],[47,61],[9,31],[11,31],[38,12],[46,-51],[39,-31],[60,-33],[30,-30],[36,-5],[37,23],[26,56],[50,9],[55,-9],[14,-28],[5,-26],[25,-48],[60,-42],[77,2],[31,8],[76,-6],[73,-9],[81,-10],[23,-2],[87,-5],[125,-7],[56,3],[113,-13],[23,-37],[21,-88],[18,-84],[5,-67],[29,-35],[38,-11],[25,-27],[44,-37],[32,-53],[39,3],[28,13],[60,4],[77,-4],[53,-29],[21,-39],[43,-21],[35,7],[106,0],[36,-2],[36,-22],[53,-3],[28,27],[91,18],[53,38],[40,1],[31,-19],[24,-25],[34,11],[19,21],[30,0],[30,-13],[76,-24],[56,-44],[42,-4],[55,13],[26,6],[24,-22],[36,-11],[27,16],[46,11],[177,-24],[41,-43],[31,-21],[26,-35],[46,-26],[98,9],[37,26],[80,58],[31,56],[40,18],[45,9],[42,0],[44,2],[53,41],[44,15],[64,52],[12,24],[31,61],[20,39],[32,61],[17,100],[10,53],[-8,38],[-38,20],[-49,9],[-43,29],[-31,34],[-19,47],[-25,55],[1,40],[-7,31],[-22,27],[-41,46],[-20,35],[7,54],[49,94],[4,43],[6,27],[-2,25],[15,56],[27,24],[32,60],[42,27],[53,2],[22,17],[12,60],[25,46],[17,33],[32,35],[186,69],[77,86],[28,43],[30,93],[28,39],[42,-13],[50,-54],[36,-1],[55,-30],[149,-62],[81,-19],[52,-6],[69,-18],[44,-36],[87,-59],[73,-15],[126,-6],[154,-4],[44,-10],[113,-43],[124,-47],[118,-42],[89,-33],[52,-32],[50,-18],[54,16],[68,-4],[162,-38],[102,-32],[86,-24],[28,-33],[3,-43],[-11,-37],[6,-90],[27,-47],[11,-62],[10,-61],[-7,-59],[13,-31],[26,-19],[26,-41],[-8,-44],[-12,-26],[2,-40],[31,-34],[46,-7],[40,-8],[50,-54],[88,-61],[53,-17],[61,-27],[116,-27],[79,-8],[47,-22],[45,-53],[76,-11],[48,-18],[89,-22],[58,13],[51,18],[35,-3],[66,-12],[78,-3],[65,13],[52,37],[61,50],[72,25],[84,10],[58,20],[188,34],[76,6],[59,32],[52,26],[76,11],[102,-27],[98,-22],[118,-8],[78,-31],[55,-29],[88,-23],[97,11],[133,9],[89,-13],[92,-53],[56,-43],[64,-91],[67,-44],[58,-36],[73,-2],[184,-3],[101,-19],[83,-10],[21,-19],[-9,-62],[3,-90],[-1,-41],[18,-31],[29,-5],[15,-44],[42,-26],[74,-31],[125,-106],[75,-45],[59,-15],[77,10],[121,0],[204,0],[141,-32],[48,-22],[143,-25],[158,-28],[133,-29],[78,37],[69,4],[66,-27],[65,-41],[51,4],[77,19],[243,114],[85,43],[60,-11],[53,15],[41,13],[104,17],[63,5],[66,10],[93,7],[191,75],[78,14],[130,-20],[71,13],[70,38],[91,39],[23,62],[47,87],[100,63],[82,56],[83,54],[102,45],[96,32],[123,86],[97,43],[49,14],[58,-15],[108,-12],[78,4],[44,-10],[88,-42],[80,-37],[62,-65],[114,-91],[58,-31],[41,-12],[103,-9],[84,-4],[50,20],[84,39],[135,48],[53,-1],[87,-26],[129,-48],[52,-35],[34,-44]],[[166494,86540],[133,-71],[85,-37],[145,-56],[150,-13],[143,-61],[73,-18],[40,0],[202,148],[171,125],[197,97],[144,14],[109,28],[73,44],[42,73],[13,102],[-29,62],[-70,21],[-19,22],[35,22],[25,42],[16,64],[41,60],[66,57],[36,63],[7,69],[39,69],[72,69],[40,64],[7,59],[36,72],[99,128],[65,147],[110,101],[177,103],[110,103],[44,102],[-3,90],[-51,78],[-10,79],[32,80],[-28,61],[-88,40],[-104,9],[-121,-20],[-68,25],[-15,71],[33,57],[80,43],[131,106],[183,168],[181,93],[272,27],[219,54],[222,56],[161,28],[28,-19],[87,-4],[148,9],[138,25],[127,38],[100,9],[74,-20],[42,-1],[30,-3],[16,0],[31,17],[86,-30],[164,-86],[103,-39],[42,9],[47,-24],[50,-58],[62,-34],[113,-15],[111,-64],[45,-3],[16,35],[42,21],[67,5],[97,-31],[127,-68],[80,-30],[32,8],[35,-12],[27,-32],[3,-39],[-10,-21],[31,-33],[35,0],[58,-16],[45,-58],[40,-27],[29,-24],[5,-19],[2,-20],[-8,-15],[-16,-25],[-4,-27],[19,-31],[72,-22],[24,-23],[6,-29],[22,-32],[49,-37],[18,-31],[-11,-25],[14,-21],[24,-16],[5,-60],[2,-34],[40,-38],[8,-79],[27,-87],[93,-119],[30,-65],[-8,-76],[14,-36],[42,-18],[20,-32],[-3,-48],[17,-29],[13,-32],[-9,-49],[13,-44],[22,-26],[15,-47],[9,-60],[62,-94],[115,-129],[70,-100],[26,-72],[0,-58],[-25,-46],[-2,-34],[23,-21],[6,-28],[-9,-36],[38,-43],[126,-74],[-50,-113],[-14,-80],[7,-83],[31,-59],[56,-35],[34,-36],[14,-37],[67,-41],[119,-44],[154,-7],[187,28],[115,5],[42,-19],[14,-29],[-14,-39],[32,-25],[77,-12],[53,-25],[29,-37],[35,-10],[42,16],[41,-2],[40,-21],[26,7],[22,23],[36,0],[38,-1],[23,-54],[37,-30],[51,-7],[79,-66],[158,-187],[103,-66],[102,-21],[128,-4],[42,-73],[-34,-76],[-8,-64],[29,-23],[40,-76],[56,-43],[11,-35],[26,-39],[-11,-71],[-48,-105],[13,-89],[75,-75],[43,-71],[12,-68],[18,-42],[27,-15],[77,5],[127,25],[94,-4],[60,-34],[147,-1],[236,31],[149,10],[62,-12],[55,44],[49,100],[45,47],[42,-6],[68,32],[92,71],[80,34],[102,-4],[108,-3],[68,29],[63,62],[110,54],[235,71],[57,12],[27,-4],[78,-11],[69,-28],[66,-56],[10,-36],[-7,-47],[-15,-27],[-27,-31],[-25,-50],[16,-39],[38,-83],[32,-60],[34,-71],[-15,-26],[-21,-49],[-65,-83],[-35,-32],[-37,-31],[-66,-8],[-27,-7],[-32,-13],[-20,-30],[-22,-20],[-37,-42],[-3,-36],[17,-53],[8,-54],[-42,-49],[-33,-75],[-10,-23],[-16,-56],[-5,-20],[-10,-120],[-42,-81],[-59,-95],[13,-57],[10,-52],[-14,-26],[-4,-22],[-8,-50],[-19,-20],[-53,-31],[-32,-38],[7,-58],[-17,-50],[-24,-45],[-26,-28],[-37,-19],[-24,-16],[-19,-56],[-5,-44],[-18,-43],[11,-44],[-19,-39],[-52,-26],[-30,-16],[-27,-7],[-53,-41],[-47,-143],[-10,-84],[11,-74],[-66,-46],[-49,-37],[-31,14],[-32,12],[-75,16],[-37,11],[-75,24],[-120,31],[-118,35],[-73,19],[-58,15],[-45,24],[-37,44],[-36,-18],[-35,-51],[-56,-31],[-26,-57],[-23,-43],[-59,-59],[-26,-24],[-116,-39],[-26,-13],[-94,-9],[-32,-17],[-33,-37],[-9,-36],[24,-39],[36,-77],[17,-53],[25,-104],[84,-328],[-27,-57],[-25,-246],[6,-44],[-3,-69],[2,-51],[17,-12],[23,-18],[11,-30],[-3,-45],[-11,-33],[-18,-66],[-24,-95],[-25,-37],[-18,-29],[-14,-20],[-2,-68],[-10,-44],[-40,-16],[-41,-26],[-48,10],[-42,-6],[-52,-17],[-94,-20],[-55,-27],[-26,-19],[-18,-24],[-3,-22],[13,-12],[52,-9],[36,-42],[5,-47],[-37,-26]],[[175438,80529],[-18,29],[-31,9],[-58,41],[-42,44],[-32,50],[2,105],[-6,16],[-57,22],[-18,31],[-27,15],[-39,-10],[-29,11],[-23,17],[-28,2],[-24,-28],[-13,-58],[-40,-97],[-4,-59],[-17,-83],[-17,-107],[-14,-22],[-46,-3],[-15,-7],[-24,-36],[-28,-6],[-25,21],[-40,21],[-37,3],[-34,-21],[-39,-46],[-23,-38],[-8,-34],[-6,-43],[-40,-41],[-36,-22],[-76,-61],[-24,-25],[-54,0],[-58,2],[-79,-16],[-129,-9],[-77,13],[-96,-12],[-74,-20],[-11,-29],[3,-44],[15,-29],[18,-19],[31,-59],[32,-57],[49,-37],[21,-39],[1,-37],[-24,-46],[-35,-61],[-33,-37],[-24,1],[-38,22],[-26,27],[-61,10],[-149,-17],[-75,12],[-35,22],[-63,2],[-97,30],[-58,9],[-28,19],[-6,44],[-27,30],[-16,36],[-35,45],[-34,23],[-33,9],[-36,-27],[-39,-25],[-28,6],[-14,-7],[-16,-20],[-62,-42],[-15,-39],[-25,-81],[-17,-84],[-15,-30],[-25,-5],[-25,-25],[-54,-79],[-49,-72],[-70,-50],[-33,-45],[-17,-40],[-51,-58],[-73,-10],[-59,-17],[-36,-4],[-26,-23],[-19,-35],[-9,-14],[-33,0],[-33,-30],[-81,-69],[-67,-12],[-83,-46],[-73,-34],[-30,-20],[-8,-21],[-11,-27],[-35,-6],[-34,1],[-76,-62],[-39,-53],[-149,-114],[-61,-64],[-16,-82]],[[175438,80529],[18,-50],[41,-49],[22,-35],[4,-37],[19,-21]],[[136950,78635],[-38,-3],[-159,-28],[-32,11],[-24,44],[-21,47],[-41,17],[-47,13],[-17,19],[-1,23],[5,22],[3,12],[108,90],[96,82],[9,6],[9,15],[16,28],[0,15],[-72,32],[-3,15],[15,15],[0,21],[-51,59],[-89,92],[-25,10],[-19,-6],[-35,-90],[-17,-22],[-101,-59],[-84,-41],[-150,-71],[-39,-23],[-28,4],[-27,14],[-84,73],[-55,25],[-36,-25],[-31,-36],[3,-73],[-35,-39],[-35,-18],[64,-197],[-7,-25],[-48,-7],[36,-74],[-31,-9],[-76,17],[-102,12],[-193,-33],[-15,-13],[-5,-16],[11,-15],[94,-2],[92,8],[25,-14],[4,-25],[-11,-15],[-30,-2],[-67,-15],[-8,-16],[-2,-15],[23,-43],[25,-28],[3,-16],[-10,-14],[-13,-5],[-23,20],[-13,-4],[-6,-18],[-6,-22],[-15,-16],[-31,9],[-31,-7],[-19,-78],[-15,-90],[-52,-59],[-28,-22],[-41,-6],[-62,7],[-38,9],[-108,13],[-109,24],[-123,23],[-114,-53],[-33,-32],[-20,-30],[-22,-13],[-49,-185],[5,-21],[27,-16],[140,-38],[21,-16],[12,-18],[6,-83],[11,-12],[48,-10],[70,1],[54,8],[55,-8],[38,-18],[19,-28],[10,-31],[-65,-182],[5,-66],[20,-96],[37,-74],[69,-73],[53,-47],[11,-22],[3,-34],[-9,-44],[-30,-69],[-37,-60],[-41,-26],[-56,-77],[-49,-94],[-95,-124],[-32,-69],[-11,-200],[-25,-60]],[[114294,75071],[48,-6],[104,-64],[17,2],[31,85],[30,29],[64,25],[18,139],[30,26],[36,15],[55,2],[48,8],[3,25],[-67,160],[5,40],[33,161],[20,63],[20,20],[76,-8],[107,-28],[28,-46],[52,-41],[78,2],[91,-7],[70,-3],[57,29],[127,54],[63,18],[57,24],[184,88],[74,-7],[51,-11],[38,-14],[87,-61],[72,-61],[50,-18],[90,1],[131,-11],[160,1],[94,17],[119,30],[213,72],[281,151],[165,73],[71,8],[92,1],[93,-19],[105,-14],[48,2],[114,15],[147,30],[93,25],[112,41],[69,68],[23,7],[29,-12],[13,-5],[29,-38],[30,-100]],[[114008,71411],[-18,-126],[1,-1],[-15,-78],[6,-13],[19,-68],[-36,-123],[-41,-101],[-14,-48],[-40,-106],[-40,-123],[-22,-85],[5,-31],[-10,-155],[6,-45],[-48,-135],[-9,-67],[-19,-90],[-33,-191]],[[114073,72167],[14,-130],[-24,-111],[-2,-98],[17,-181],[-38,-76],[-22,-91],[-10,-69]],[[114112,72403],[-11,-11],[-14,-23],[-2,-17],[-12,-185]],[[148032,68435],[-56,11],[-58,6],[-47,-4],[-115,-53],[-39,-5],[-43,5],[-59,2],[-112,-2],[-97,14],[-78,74],[-56,33],[-59,25],[-59,19],[-20,40],[-19,20],[-49,7],[-39,-15],[-24,-100],[-21,-20],[-49,-9],[-52,26],[-71,51],[-29,58],[-24,18],[-37,-25],[-2,-73],[-8,-50],[-45,-20],[-26,15],[-21,51],[-52,120],[-53,70],[-52,47],[-173,-1],[-128,13],[-58,20],[-22,46],[21,92],[25,73],[0,17],[-22,8],[-37,6],[-138,-46],[-37,5],[-25,16],[-29,13],[-24,22],[-17,31],[-120,77],[-35,42],[-64,53],[-54,36],[-34,103],[-31,99],[-17,52],[-51,28],[-56,21],[-94,-43],[-77,-32],[-56,-4],[-82,101],[-66,110],[-77,95],[-52,48],[-91,5],[-104,53],[-137,122],[-100,91],[-172,101],[-40,42],[-15,37],[-24,71],[-36,67],[-121,29],[-138,21],[-145,-41],[-105,-202],[-50,-44],[-43,-2],[-36,51],[-29,54]],[[143445,70327],[-29,13],[-37,-7],[-39,-26],[-18,-17],[-88,-103],[-46,-32],[-41,-46],[-95,-140],[-55,-130],[-40,-123],[1,-87],[-15,-102],[-41,-58],[-25,-19],[-30,-88],[-21,-102],[12,-33],[51,-45],[50,-43],[63,-47],[61,-45],[39,-6],[11,25],[14,25],[45,-13],[54,-44],[35,-35],[16,-12],[94,-58],[78,-49],[98,-62],[25,-37],[21,-40],[46,-53],[113,-95],[97,-67],[79,-55],[61,-38],[29,6],[31,20],[27,12],[32,-11],[49,-29],[113,-90],[106,-69],[115,12],[31,-11],[22,-63],[14,-65],[129,-42],[85,-19],[97,-35],[49,-26],[51,33],[10,28],[40,17],[68,-7],[126,-50],[53,-15],[44,47],[83,22],[43,25],[89,-53],[162,-65],[84,-41],[20,-40],[9,-39],[-1,-92],[21,-42],[162,-94],[54,-40],[43,-13],[25,-1],[17,-12],[14,-54],[12,-12],[31,-13],[34,-8],[106,46],[72,35],[52,-9],[33,-39],[5,-56],[19,-61],[37,-29],[40,-3],[98,40],[79,-31],[72,-11],[80,-20],[32,-14],[83,-50],[102,-50],[40,5],[164,94],[14,-12],[33,-89],[50,-32],[78,-28],[81,52],[65,-15],[77,-5],[75,25],[65,6],[94,-45],[21,11],[18,28],[36,129],[33,114],[-3,69],[-30,99],[-76,130],[-6,40],[26,227],[28,130],[24,62],[27,88],[5,41],[-3,37],[-26,22]],[[153985,68722],[-8,-52],[-5,-57],[23,-45],[3,-40],[-5,-37],[-19,-25],[-52,-15],[-44,-43],[-70,-64],[-56,-51],[-41,-45],[-14,-47],[4,-59],[12,-62],[130,-228],[-1,-39],[-41,-11],[-55,25],[-47,37],[-54,98],[-42,29],[-43,6],[-253,-50],[-54,-14],[-83,-36],[-59,-74],[-42,-67],[-44,-27],[-64,-52],[-177,-161],[-103,-69],[-67,-25],[-47,-37],[-25,-59],[-19,-42],[-6,-105],[11,-129],[26,-82],[13,-17],[3,-24],[-26,-45],[-34,-38],[-16,-23],[-15,-117],[-30,-58],[-55,-85],[-48,-65],[-77,-49],[-29,-41],[-27,-74],[-17,-63],[-1,-23],[9,-20],[32,-22],[38,-22],[19,-33],[2,-41],[-29,-97],[-51,-135],[-59,-107],[-60,-102],[-14,-33],[-55,-125],[-47,-172],[-32,-116],[-28,-79],[-34,-4],[-41,25],[-101,34],[-64,27],[-47,25],[-32,-1],[-45,-16],[-45,-11],[-27,12],[-63,72],[-18,-9],[-13,-35],[42,-204],[28,-76],[-5,-127],[-10,-156],[-17,-170],[-11,-39],[-26,-45],[-36,-12],[-32,17],[-25,-4],[-9,-28],[8,-74],[-31,-84],[-23,-73],[6,-70],[11,-71],[36,-154],[1,-56],[-8,-51],[-19,-21],[-33,4],[-18,-21],[-13,-32],[-37,-117],[-36,-12],[-35,17],[-54,79],[-33,22],[-20,-1],[-9,-21],[-15,-46],[-14,-32],[-36,-27]],[[155794,62206],[-77,52],[-32,29],[-41,8],[-42,-33],[-34,-36],[-34,-13],[-53,-4],[-69,18],[-47,17],[-7,-9],[25,-75],[10,-60],[-11,-32],[-22,-26],[-34,-20],[-39,-12],[-35,1],[-56,29],[-43,1],[-37,-14],[-22,-22],[-12,-26],[-22,-149],[-19,-46],[-26,-27],[-27,-2],[-36,7],[-38,-6],[-173,-58],[-25,-5],[-54,-5],[-50,-1],[-35,3],[-83,59],[-40,6],[-22,-17],[-15,-79],[-49,-50],[-64,-110],[-15,-160],[7,-111],[-58,-111],[-6,-53],[31,-257],[-5,-27],[-12,-13],[-36,-9],[-61,-27],[-40,-25],[-20,-3],[-56,19],[-15,1],[4,-20],[45,-111],[48,-53],[48,6],[22,-10],[-7,-27],[19,-69],[44,-113],[13,-84],[-27,-84],[6,-30],[14,-18],[42,-77],[88,-122],[86,-132],[72,-110],[53,-77],[118,-141],[21,-67],[4,-134],[29,-78],[27,-55],[19,-46],[43,-152],[19,-21],[94,92],[22,-19],[12,-35],[0,-44],[-15,-50],[-30,-47],[-146,-107],[-12,-93],[-10,-140],[-2,-172],[6,-129],[-5,-29],[-13,-14],[-55,5],[-79,-65],[-28,-6],[-35,-25],[-26,-30],[-9,-47],[16,-141],[28,-133],[56,-98],[44,-77],[61,-107],[49,-94],[97,-102],[137,-153],[53,-85],[46,-102],[33,-88],[12,-116],[10,-65],[3,-218],[-25,-49],[-19,-58],[10,-60],[32,-57],[0,-65],[30,-118],[50,-71],[49,-49],[21,-38],[-7,-61],[14,-65],[11,-71],[19,-98],[39,-83],[60,-254],[-2,-26],[-25,-52],[-38,-46],[-24,-15],[-23,-48],[-54,-136],[-109,-235],[-106,-152],[-90,-109],[-64,-66],[-19,-39],[0,-31],[11,-55],[-4,-104],[-14,-66],[-19,-70],[-10,-62]],[[155794,62206],[-5,-49],[16,-10],[22,23],[28,55],[31,31],[34,7],[36,-38],[37,-82],[39,-46],[18,-6],[13,-37],[2,-36],[-18,-76],[-31,-89],[-45,-109],[15,-92],[60,-75],[73,-45],[76,13],[41,22],[33,36],[31,16],[39,5],[122,-26],[37,-26],[5,-51],[-15,-131],[19,-95],[34,-102],[5,-92],[-43,-152],[-35,-144],[-39,-70],[-29,-45],[-9,-30],[2,-29],[28,-43],[28,-56],[8,-53],[-3,-66],[-20,-90],[-74,-195],[-59,-176],[31,-35],[58,-26],[39,-25],[40,16],[85,104],[74,77],[91,78],[6,6],[80,57],[36,52],[20,67],[29,26],[36,-15],[47,29],[56,72],[43,34],[30,-5],[54,-46],[78,-85],[69,-50],[61,-16],[29,-32],[-1,-47],[13,-30],[29,-13],[12,5],[-3,23],[27,34],[58,43],[59,26],[60,8],[39,35],[26,93],[-1,-4],[38,70],[33,31],[41,16],[10,22],[-19,28],[1,28],[24,29],[51,12],[78,-4],[92,-29],[105,-55],[69,-17],[32,19],[64,-84],[96,-188],[81,-143],[69,-96],[71,-74],[76,-51],[54,-71],[49,-133],[-37,-184],[-10,-159],[5,-195],[44,-150],[85,-104],[49,-84],[14,-64],[65,-55],[118,-46],[49,-41],[-20,-38],[-2,-43],[17,-49],[41,-41],[64,-32],[39,-34],[12,-36],[-1,-58],[-15,-81],[-27,-62],[-39,-43],[-5,-34],[-10,-52],[0,-106],[28,-71],[8,-90],[-15,-74],[-15,-150],[-2,-58],[-14,-50],[-34,-48],[-52,-46],[-64,-40],[-39,-18]],[[156450,63237],[-37,-81],[-99,-85],[-70,-42],[-41,-2],[-34,-50],[-29,-100],[-29,-59],[-30,-17],[-20,-38],[-9,-58],[17,-31],[45,-4],[3,-16],[-37,-29],[-47,-10],[-55,9],[-53,-23],[-49,-54],[-43,-116],[-35,-179],[-4,-46]],[[153985,68722],[21,30],[49,82],[30,59],[16,25],[23,45],[39,6],[39,-15],[23,-25],[23,-51],[25,-42],[31,0],[31,6],[15,-6],[30,-35],[57,-84],[25,-22],[24,-36],[13,-71],[8,-73],[71,-251],[21,-52],[16,-41],[34,-10],[27,41],[10,43],[29,14],[33,-7],[62,-41],[33,-21],[17,-125],[3,-145],[-5,-45],[27,-120],[9,-139],[5,-75],[1,-72],[-5,-95],[-14,-127],[-25,-108],[9,-90],[-14,-41],[-59,-21],[-5,-34],[17,-57],[41,-71],[1,-45],[-20,-30],[-43,-3],[-60,-28],[-41,-92],[-44,-75],[-24,-15],[-80,21],[-19,-19],[-28,-128],[-23,-55],[-35,-47],[-31,-27],[-29,-19],[-63,13],[-34,-78],[-34,-102],[-3,-52],[18,-83],[-9,-23],[-35,-18],[-56,-38],[-35,-118],[2,-115],[20,-40],[39,-17],[28,-35],[3,-56],[24,-69],[-12,-81],[-79,-117],[-2,-64],[42,-20],[36,9],[45,28],[53,45],[116,65],[127,38],[100,7],[85,-3],[42,-14],[12,-24],[117,38],[25,2],[21,2],[-1,-25],[-85,-104],[-16,-49],[2,-52],[35,-48],[34,-38],[29,-93],[-22,-86],[14,-31],[25,-35],[16,-50],[1,-60],[-14,-96],[124,-50],[107,-22],[78,-6],[49,-22],[31,-19],[21,-34],[6,-38],[-26,-26],[-53,-84],[-30,-113],[3,-84],[-3,-73],[-62,-105],[-24,-73],[-21,-74],[0,-32],[13,-23],[26,-13],[45,-8],[55,8],[132,-17],[151,-33],[59,-18],[20,-33],[-5,-71],[-10,-67],[10,-51],[24,-47],[41,-16],[35,-18],[7,-36],[-11,-48],[18,-39],[20,-25],[43,-15],[88,32],[61,-14],[56,-22],[47,11],[47,28],[102,124],[119,67],[39,16],[27,-8],[6,-9],[-2,-25],[13,-102],[-6,-12]],[[157089,63907],[36,-79],[76,-87],[92,-125],[29,-57],[61,-44],[18,-43],[14,-66],[6,-50],[13,-29],[22,-12],[28,14],[21,26],[17,72],[12,8],[19,-60],[20,-10],[27,-8],[20,-26],[6,-45],[-6,-47],[-26,-52],[-14,-55],[-10,-84],[-13,-59],[21,-53],[142,-256],[69,-42],[163,-50],[59,-35],[52,-33],[51,16],[50,76],[59,43],[110,66],[31,3],[61,-26],[100,-76],[72,-72],[45,-38],[34,-34],[-5,-38],[-28,-38],[-35,-21],[-46,-36],[-25,-36],[15,-14],[68,-9],[79,-32],[24,-38],[4,-33],[9,-53],[14,-16],[74,10],[23,-12],[26,-28],[26,-71],[-1,-53],[-53,-59],[-19,-35],[-9,-56],[-38,-68],[-100,-112],[-27,-6],[-185,61],[-86,-3],[-41,-2],[-20,-3],[-12,-24],[24,-68],[8,-67],[-23,-51],[-62,-45],[-23,-22],[-3,-28],[17,-31],[57,-31],[66,-29],[218,-174],[47,-41],[61,-61],[67,-47],[179,-62],[78,-41],[21,-23],[-1,-28],[-21,-36],[-17,-63],[-1,-38],[19,-37],[32,-55],[71,-86],[39,-37],[42,-9],[38,-20],[39,-64],[45,-77],[6,-54],[19,-69],[42,-80],[57,-77],[79,-95],[46,-68],[21,-26],[170,-164],[42,-60],[59,-116],[26,-17],[24,-23],[15,-64],[5,-46],[8,-140],[31,-42],[28,-51],[12,-38],[26,-27],[28,-6],[34,31],[26,30],[12,-9],[27,-98],[24,-36],[47,-34],[43,-26],[96,-119],[51,-43],[34,-13],[30,-21],[9,-37],[-11,-38],[-21,-25],[-111,-68],[-15,-30],[16,-45],[28,-57],[30,-49],[38,-48],[78,-78],[68,-62],[37,-67],[20,-45],[-12,-54],[-29,-59],[-22,-51],[-38,-29],[-10,-34],[15,-53],[13,-36],[-7,-45],[4,-93]],[[108809,49665],[-186,73],[-28,1],[-33,-12],[-98,-90],[-31,-11],[-35,8],[-87,11],[-297,71],[-228,68],[-69,25],[-122,23],[-80,-46],[-76,-160],[-22,-31],[-119,-47],[-56,13],[-137,-44],[-213,66],[-75,-13],[-60,-33],[-152,-73],[-93,-41],[-108,-37],[-102,-58],[-69,-31],[-67,0],[-61,33],[-66,28],[-80,5],[-83,-16],[-70,-64],[-28,-45],[-62,-121],[-72,-196],[-28,-39],[-8,-4],[-18,-17],[-332,98],[-143,23],[-96,-30],[-121,55],[-53,9],[-25,-17],[-67,25],[-110,67],[-105,28],[-94,-10],[-58,22],[-46,66],[-60,119],[-108,118],[-145,95],[-90,71],[-36,48],[-78,27],[-120,5],[-115,-47],[-164,-148],[-153,-303],[-86,-117],[-68,-30],[-17,-73],[34,-116],[9,-134],[-24,-227],[9,-165]],[[110844,43472],[-13,-22],[-59,-154],[-11,-23],[6,-14],[25,-30],[-14,-48],[-6,-13],[-11,-46],[6,-41],[14,-16],[38,-20],[58,-14],[68,-35],[46,-6],[11,-25],[-3,-45],[12,-39],[0,-69],[-14,-61],[-70,-29],[-36,-31],[-10,-16],[9,-18],[5,-25],[-66,-61],[-68,-79],[-16,-54],[-13,-63],[-20,-41],[-52,-58],[-52,-118],[-26,-76],[-129,-183],[-115,-91],[-34,-31],[-203,5]],[[109850,43208],[0,-31],[1,-35],[31,-42],[57,-86],[46,-81],[2,-70],[-9,-118],[-2,-67],[5,-93],[0,-173],[-4,-122],[8,-64],[70,-152],[30,-169],[16,-123]],[[110213,44307],[-25,-18],[-45,-48],[-43,-33],[-32,-8],[-54,-86],[-46,-81],[-35,-79],[-9,-37],[7,-102],[5,-122],[-11,-52],[-16,-31],[-75,-66],[-50,-48],[-23,-24],[-12,-39],[21,-89],[2,-66],[18,-39],[60,-31]],[[113891,49981],[-11,15],[-57,58],[-53,76],[-32,84],[-31,68],[-16,154],[-40,95],[-38,116],[-58,221],[-25,76],[-46,51],[-49,47],[-51,98],[-132,86],[-51,68],[-88,116],[-22,59],[-7,58],[-27,55],[-49,62],[-153,133],[-42,16],[-54,15],[-81,13],[-107,30],[-94,52],[-43,37],[-10,26],[9,43],[34,73],[65,174],[44,120],[31,33],[82,9],[88,-4],[65,-9],[90,-1],[109,10],[43,40],[34,44],[14,31],[5,77],[0,63],[-7,238],[-4,146],[-5,167],[1,77],[27,178],[25,102],[17,54],[68,170],[13,54],[2,50],[-25,229],[44,107],[57,107],[49,45],[42,31],[19,-13],[47,-49],[62,-49],[29,11],[43,42],[32,45],[-4,80],[28,165],[-5,95],[30,118],[34,166],[15,105],[19,56],[90,116],[78,164],[50,119],[94,195],[48,72],[39,30],[58,20],[108,18],[78,16],[11,26],[7,39],[1,88],[15,150],[33,147],[40,111],[22,50],[25,49],[29,82],[36,178],[-2,121],[52,221]],[[105873,54456],[-27,7],[-57,22],[-68,19],[-84,16],[-80,-37],[-87,-48],[-27,-35],[-24,-21],[-39,4],[-34,-7],[-19,-33],[-32,-38],[-125,-77],[-26,-28],[-16,-28],[0,-30],[13,-63],[0,-79],[-28,-63],[-33,-43],[-36,-16],[-31,-9],[-20,-26],[-66,-144],[-28,-26],[-57,4],[-164,-216],[-17,-63],[-60,-90],[-76,-100],[-68,-48],[-5,-19],[-19,-19],[-41,-22],[-145,-122],[-175,5],[-77,-48],[-74,-21],[-110,-23],[-33,2],[-140,-10],[-165,3],[-63,-17],[-59,-46],[-44,-41],[-6,-13],[6,-17],[-1,-14],[115,-99],[29,-49],[-29,-48],[-14,-7],[-2,-2],[-19,-38],[-67,-112],[-103,-133],[-52,-38],[-21,-25],[-27,-88],[-18,-13],[-71,-11],[-139,-10],[-193,-28],[-116,-10],[-72,8],[-102,-61],[-36,-15],[-22,-6],[-100,-59],[-84,-91],[-29,-18],[-118,-38],[-46,-63],[-22,-6],[-75,83],[-51,76],[-25,76],[-4,25],[-14,-5],[-41,-34],[-36,-38],[-16,-73],[-122,-50],[-103,-42],[-47,-53],[-73,-27],[-93,11],[-72,22],[-71,7]],[[99692,47234],[-15,51],[-32,27],[-58,3],[-170,-11],[-130,8],[-42,7],[-46,14],[-109,12],[-134,-10],[-31,3],[-107,-2],[-246,14],[-136,-2],[3,-32],[-9,-23],[-7,-54]],[[98295,42222],[38,127],[29,59],[35,41],[139,99],[21,-4],[97,-129],[30,-11],[35,4],[40,-5],[20,25],[3,33],[-29,38],[-4,40],[20,43],[12,49],[30,57],[3,26],[-32,30],[-65,44],[-44,43],[-17,41],[12,53],[36,43],[-2,23],[-32,39],[-23,41],[-24,25],[-65,16],[12,55],[25,81],[5,63],[-18,163],[2,30],[18,15],[39,-18],[39,-25],[107,36],[37,5],[31,-31],[43,-24],[247,68],[5,69],[14,63],[2,47],[-11,31],[-12,23],[-7,47],[0,50],[23,24],[79,61],[25,-3],[55,-32],[51,-52],[46,-108],[32,-93],[51,-114],[107,-46],[129,-29],[69,8],[99,96],[57,75],[18,41],[32,-21],[37,-99],[24,-38],[6,-37],[-16,-46],[16,-29],[69,-21],[60,20],[28,40],[45,53],[0,44],[-24,29],[0,39],[25,32],[25,85],[7,62],[24,39],[46,28],[16,25],[25,147],[-13,53],[0,44],[29,57],[5,92],[-12,151],[-8,104],[-9,109],[22,142],[23,149],[-4,37],[-32,45],[-39,42],[-102,34],[-37,54],[-30,57],[-21,18],[-111,23],[-25,33],[10,92],[10,137],[-4,96],[20,76],[22,58],[49,61],[26,72],[14,18],[93,12],[34,30],[26,30],[11,41],[32,67],[29,46],[3,31],[-6,44],[-29,85],[-33,70],[-20,26],[-41,166],[-38,39],[-74,21],[-139,19],[-84,-30],[-128,-56],[-98,-38],[-63,-22],[-38,6],[-16,25],[24,22],[13,50],[-16,73],[-25,66],[-14,93],[6,116],[24,109],[51,141],[3,58]],[[101105,51656],[34,66],[13,50],[3,61],[-5,41],[-42,20],[-27,32],[-61,192],[-62,196],[-88,194],[-96,124],[-69,75],[-22,10],[-36,24],[-25,22],[-127,131],[-131,147],[-34,67],[-66,101],[-74,103],[-38,47],[-18,85],[51,76],[54,97],[67,64],[87,5],[142,-27],[154,-9],[152,20],[40,14],[39,-1],[82,-23],[142,5],[74,39],[-79,67],[-86,106],[-80,116],[-48,105],[-45,135],[-41,167],[-25,216],[4,123],[13,88],[43,142],[-29,84],[7,67],[-5,100],[-13,51],[-56,166],[-11,18],[-49,114],[-22,192],[-55,127],[-89,61],[-51,75],[-19,131],[-35,35],[-140,46],[-117,1]],[[100190,56237],[62,-384],[7,-73],[5,-33],[4,-31],[8,-52],[49,-23],[92,-10],[67,-38],[40,-63],[4,-10],[21,-48],[5,-35],[-6,-101],[-13,-129],[-23,-83],[13,-114],[-4,-48],[-11,-33],[-41,-38],[-56,-38],[-133,-109],[-39,-16],[-56,-3],[-48,-28],[-58,-59],[-124,-220],[-106,-221],[-37,-183],[-41,-175],[-94,-111],[-13,-63],[-4,-36],[-3,-84],[-11,-140],[-15,-67],[-15,-20],[-101,-42],[-58,-51],[-35,-101],[-12,-110],[-21,-125],[-11,-109],[-16,-57],[-33,-59],[-51,-65],[-45,-36],[-116,-23],[-59,-145],[-51,-114],[-1,-45],[-49,-235],[-84,-177],[-6,-62],[0,-52],[-106,-156],[-28,-45],[-27,-61],[27,-58],[30,-52],[4,-18],[-48,-50],[-84,-86],[-50,-52],[-11,-28],[-7,-130],[-15,-35],[-33,-47],[-49,-52],[-50,-41],[-56,-28],[-54,-11],[-31,17],[-17,39],[-31,159],[-15,34],[-35,31],[-70,86],[-70,88],[-85,62],[-18,-4],[-14,-17],[-24,-88],[-24,-33],[-45,-11],[-77,-1],[-57,13],[-13,17],[-11,38],[-16,31],[-68,-62],[-106,-97],[-34,-16],[-27,-20],[-35,-91],[-42,-97],[-56,-51],[-54,-43],[-31,-37],[-45,-44],[-86,-110],[-116,-146],[-41,-76],[-40,-112],[-23,-125],[-26,-137],[-37,-220],[-56,-124],[-48,-99],[-36,-77],[-19,-64]],[[93426,55097],[38,29],[7,25],[-11,31],[-19,23],[-4,49],[5,33],[13,36],[-5,75],[1,116],[7,168],[1,102],[80,76],[115,126],[59,132],[31,100],[39,331],[28,21],[33,15],[116,121],[89,45],[68,26],[103,22],[63,-9],[116,-5],[91,11],[77,66],[35,19],[50,11],[223,-89],[224,-84],[41,8],[34,-12],[56,-45],[82,-98],[49,-63],[24,-37],[115,-211],[42,-53],[43,-29],[44,-11],[34,4],[32,24],[43,47],[66,22],[53,-5],[279,191],[27,2],[81,-15],[90,-26],[233,-191],[190,-125],[134,-42],[157,-29],[268,-9],[203,268],[75,58],[90,53],[29,9],[159,40],[312,34],[293,-14],[57,-11],[124,-36],[192,-87],[83,-83],[130,-14],[93,16],[30,83],[94,109],[68,45],[72,56],[114,71],[94,32],[84,80],[67,26],[115,2]],[[92647,55262],[-17,-47],[-49,-122],[-36,-51],[-162,-174],[-80,20],[-166,-35],[-25,40],[-39,5],[-48,-7],[-17,-15],[-6,-17],[-17,-24],[-31,-69],[-23,-17],[-30,-11],[-36,1],[-21,-9],[-1,-34],[-6,-30],[-25,-14],[-10,-34],[2,-32],[-14,-15],[-32,8],[-18,9]],[[91870,50473],[-1,46],[-29,8],[-36,16],[-22,23],[-31,55],[-11,42],[-47,7],[-58,48],[-56,54],[-19,55],[5,25],[-8,26],[-19,10],[-50,123],[-31,50],[-14,40],[5,31],[-7,42],[10,33],[27,20],[8,25],[2,52],[16,107],[9,105],[-28,29],[-35,8],[-17,30],[-7,49],[0,43],[68,149],[-14,345],[10,52],[31,37],[27,42],[-1,41],[-46,103],[-85,79],[-44,64],[-24,57],[-4,31],[52,45],[23,31],[3,36],[-21,65],[3,116],[20,88],[21,113],[-2,33],[-51,67],[-27,10],[-22,-5],[-53,-45],[-19,-4],[-12,13],[-5,18],[18,26],[-6,33],[15,29],[34,13],[10,15],[-46,13],[-5,20],[3,19],[13,4],[15,-1],[8,13],[6,96],[6,34],[6,66],[7,257],[10,26],[1,20],[-31,12],[-75,69],[-44,53],[-38,54],[-32,36],[-63,55],[-19,35],[-2,35],[19,70],[30,75],[15,107],[-9,28],[-41,50]],[[89361,53270],[7,-41],[-13,-66],[3,-41],[17,-16],[-9,-52],[-37,-90],[-1,-53],[37,-17],[27,-56],[15,-97],[16,-32],[2,-20],[26,-234],[33,-234],[-21,-31],[-29,-9],[-18,-11],[-6,-22],[13,-32],[-8,-29],[-36,-20],[-78,-75],[-6,-29],[-20,-64],[-18,-38],[-25,-72],[-41,-190],[-15,-158],[-2,-48],[-16,-34],[-17,-49],[-85,-135],[-43,-110],[5,-48],[2,-48],[-13,-35],[3,-93],[10,-78],[15,-77],[62,-216],[32,-132],[20,-106],[17,-71],[16,-29],[7,-27],[91,-20],[18,-16],[25,-138],[-4,-62],[-18,-24],[0,-53],[-4,-65],[-13,-26],[-51,-4],[-35,-24],[-45,9],[-44,-2],[-18,-32]],[[87534,54049],[11,48],[18,67],[2,65],[12,105],[-7,132],[-14,92],[43,38],[49,34],[31,62],[32,141],[13,121],[-9,44],[-17,36],[-13,52],[-7,64],[9,55],[37,52],[47,43],[33,21],[89,21],[110,32],[64,36],[47,36],[26,29],[26,59],[43,46],[33,46],[4,128],[0,73],[-24,40],[-14,35],[164,100],[1,71],[-23,79],[-32,63],[-12,55],[46,65],[40,48],[29,42],[65,62],[67,17],[60,-24],[180,-148],[31,-9],[37,11],[48,39],[61,31],[23,98],[-3,146],[14,67],[33,12],[103,-28],[27,-2],[30,10],[21,25],[0,47],[-5,42],[33,135],[62,101],[124,127],[39,26],[45,13],[222,-87],[36,21],[54,216],[61,21],[72,4],[47,18],[24,15],[106,82],[187,112],[100,48],[20,18],[72,79],[95,91],[61,18],[84,7],[53,-15],[14,-26],[17,-13],[110,38],[157,-61],[136,-61]],[[89361,53270],[-13,-20],[-32,-26],[-33,0],[-37,62],[-17,28],[-31,63],[-26,63],[-35,28],[-34,26],[-42,80],[-41,38],[-42,-11],[-63,15],[-126,20],[-135,-6],[-56,-19],[-56,-29],[-140,-64],[-56,-32],[-42,-80],[-48,2],[-48,25],[-29,37],[-65,-8],[-62,35],[-59,70],[-45,23],[-56,50],[-15,96],[-36,68],[-33,93],[-49,42],[-56,23],[-77,-5],[-51,37],[-41,55]],[[85620,51685],[12,-10],[20,-25],[18,-86],[73,-279],[-4,-77],[-14,-50],[-1,-49],[-5,-49],[-44,-79],[-131,-163],[11,-14],[31,-19],[32,-9],[26,5],[32,-41],[36,-51],[37,-27],[54,-23],[47,-3],[40,9],[56,-10],[60,-42],[22,-70],[14,-61],[21,-31],[3,-52],[43,-46],[60,-10],[79,-54],[21,3],[8,7],[10,-11],[20,-156],[15,-83],[-8,-34],[-11,-26],[0,-127],[-36,-72],[-6,-80],[-10,-26],[-38,-23],[0,-61],[-11,-74],[-4,-79],[11,-205],[2,-153],[17,-29]],[[85620,51685],[-23,22],[-27,32],[-10,43],[-18,9],[-34,1],[-31,-25],[-14,-44],[-2,-51],[-5,-39],[-19,-24],[-38,-62],[-17,-57],[-22,-49],[-32,2],[-15,7],[-10,-13],[-49,-27],[-42,-8],[-11,29],[-24,23],[-28,45],[-31,36],[-59,26],[-24,-11],[-28,3],[-18,14],[2,22],[31,56],[18,51],[10,55],[0,53],[-17,75],[-27,60],[-6,34],[3,49],[-6,46],[-9,24],[-4,45],[-9,41],[-15,16],[-9,69],[2,71],[-23,27],[-36,19],[-21,28],[-14,31],[-13,9],[-11,-2],[-10,-19],[-12,-4],[-21,66],[-9,3],[-15,-15],[-167,-74],[-8,29],[-14,34],[-32,11],[-55,-25],[-33,-3]],[[87534,54049],[-21,12],[-89,-6],[-97,-36],[-33,-29],[-8,-39],[-21,-26],[-31,-30],[-30,-36],[-53,5],[-52,25],[-26,25],[-2,14],[17,36],[14,39],[1,25],[-17,63],[-14,67],[6,33],[-13,99],[-7,5],[-68,-26],[-25,-6],[-14,-11],[-4,-19],[16,-63],[-10,-11],[-38,2],[-53,21],[-58,57],[-14,-18],[-7,-46],[-4,-55],[15,-99],[-15,-35],[-39,6],[-52,0],[-45,-9],[-30,-3],[-19,-35],[-8,-39],[18,-44],[-3,-19],[-14,-17],[-18,-10],[-14,1],[-42,49],[-50,18],[-117,28],[-14,66],[-20,1],[-27,36],[-26,46],[-23,-3],[-19,-13],[-64,5],[-57,-70],[-42,-87],[-45,-42],[-49,-18],[-20,-1]],[[81384,54473],[28,43],[35,66],[107,275],[38,63],[24,22],[51,3],[98,36],[81,61],[40,25],[93,-7],[109,11],[142,59],[3,81],[-1,103],[-5,41],[-51,37],[-29,32],[-25,41],[-31,29],[1,31],[38,26],[25,13],[58,0],[19,15],[14,26],[17,67],[6,70],[-39,94],[3,67]],[[83744,55681],[-18,-22],[-19,-48],[-18,-60],[-17,-40],[6,-26],[50,-52],[71,-73],[29,-9],[33,17],[51,58],[41,62],[40,30],[46,-1],[37,-44],[45,-97],[41,-89],[5,-9],[17,-14],[20,0],[22,22],[16,13],[19,40],[80,123],[60,33],[21,9],[43,19],[69,-29],[101,-51],[123,-61],[43,-10],[25,10],[37,83],[45,33],[66,38],[53,20],[30,2],[11,23],[6,33],[-6,35],[-34,63],[-1,19],[19,12],[42,9],[55,-6],[61,-28],[50,-39],[29,-46],[31,-100],[24,-96],[62,-154],[-2,-95],[-1,-110],[28,-21],[30,-9],[14,-16],[30,-85],[28,-24],[34,-6],[63,-54],[41,-22],[6,-16],[-2,-22],[-15,-29],[-25,-20],[-37,-37],[-30,-48],[-63,-117],[-1,-22],[13,-15],[26,-3],[27,8],[58,43],[45,-16],[43,-32],[16,-34],[4,-44],[-10,-57],[-1,-64],[14,-109],[23,-108],[23,-40],[145,-96],[14,-35],[7,-41],[-11,-55]],[[160573,57578],[-35,-33],[-33,-84],[-22,-6],[-57,30],[-19,-17],[-36,-61],[-63,-67],[-30,0],[-21,8],[-25,-29],[-35,-52],[-16,1],[-60,-12],[-24,17],[-29,43],[-47,45],[-43,31],[-23,21],[-21,37],[-19,24],[-35,-53],[-59,-49],[-57,9],[-27,8],[-23,-72],[-16,-13],[-101,-13],[-19,-11],[16,-67],[60,-112],[18,-64],[-38,-105],[-105,2],[-47,43],[-43,60],[-16,30],[-134,58],[-90,-40],[-28,2],[-42,43],[-25,32],[-25,49],[-14,49],[-2,22]],[[164799,49242],[23,-26],[47,-32],[36,-40],[24,-52],[17,-50],[1,-41],[22,-34],[60,-6],[20,-43],[42,-74],[38,-54],[24,-20],[30,11],[46,49],[33,59],[22,81],[-18,11],[31,61],[6,32],[-14,30],[-18,28],[-7,74],[-13,94],[-8,42],[24,30],[52,39],[51,45],[53,36]],[[34098,58423],[-28,-29],[-60,-65],[-109,-111],[-98,-99],[-94,-91],[-85,-81],[-10,-8],[-107,-58],[-18,-27],[-23,-115],[-10,-28],[19,-64],[19,-98],[-6,-52],[-74,-63],[-34,-57],[-15,-37]],[[41111,52591],[-12,-11],[-36,-65],[-20,-55],[46,-59],[14,-62],[26,-68],[41,-68],[45,-126],[11,-51],[-13,-33],[-43,-20],[-41,-59],[-11,-72],[8,-36],[-121,-115],[-31,-19],[-21,18],[-26,57],[-31,47],[-16,16],[-10,1],[-10,-11],[-4,-25],[16,-108],[-14,-44],[-41,-34],[-47,-176]],[[51857,49741],[-137,194],[-138,196],[-135,192],[-9,26],[57,91],[50,66],[42,37],[20,33],[-15,141],[1,51],[-20,55],[-14,61],[17,52],[20,36],[27,14],[63,12],[44,6],[16,20],[26,24],[34,2],[67,-17],[30,31],[55,42],[123,73],[28,47],[19,74],[-2,34],[-12,14],[-31,12],[-47,1],[-38,-19],[-38,11],[-33,45],[-2,38],[20,53],[-11,35],[-62,111],[0,31],[45,50],[25,43],[35,102],[28,34],[86,11],[21,22],[44,54],[65,62],[95,49],[26,89],[17,25],[75,47],[13,25],[-2,22],[-120,201]],[[51857,49741],[19,-8],[26,-23],[24,-68],[20,-72],[0,-37],[-15,-47],[-33,-54],[-41,-44],[-59,-37],[-47,-35],[-39,-92],[-23,-33],[-22,-13],[-43,-12],[-69,3],[-46,7],[-56,-69],[-72,-25],[-49,-95],[-172,-75],[-168,-58],[-47,-23],[-166,48],[-40,-15],[-46,-45],[-43,-34],[-36,-2],[-30,-18],[-18,-64],[-16,-221],[-59,-65],[-73,0],[-49,76],[-59,58],[-102,137],[-29,18],[-26,-1],[-95,-41],[-45,18],[-37,21],[-60,-7],[-109,-1],[-69,-2],[-33,38],[-32,76],[-21,28],[-24,22],[-41,11],[-175,-1],[-32,0],[-24,15],[-34,65],[-37,31],[-43,2],[-18,-37],[74,-117],[22,-64],[65,-93],[189,-195],[35,-62],[-4,-80],[-1,-121],[7,-115],[48,-165],[69,-167],[18,-107],[-13,-79],[-13,-42],[2,-19],[14,-17],[65,-24],[137,-16],[82,0],[127,-18],[9,-59],[-12,-97],[-25,-55],[-21,-16],[-68,-13],[-73,-60],[-104,-59],[-60,-8],[-25,-11],[-21,-18],[-18,-22],[-20,-111],[-31,-124],[-58,-74],[-65,-62],[-65,-7],[-52,5],[-26,-18],[-38,-50],[-53,-63],[-42,-33],[-55,3],[-60,-31],[-75,-50],[-50,-42],[-43,-71],[-61,-74],[-62,-52],[-30,-65],[-43,-82],[-53,-2],[-5,49],[26,79],[-28,68],[-51,36],[-23,11],[-24,-4],[-60,-34],[-74,-61],[-46,-44],[-41,-20],[-85,-18],[-71,-10],[-29,13],[-54,45],[-122,140],[-166,191]],[[125020,79906],[131,136],[113,96],[91,57],[28,14],[126,48],[162,44],[119,31],[156,28],[51,5],[74,-1],[61,-26],[37,-19],[130,-83],[132,-84],[114,-93],[32,-38],[18,-46],[14,-44],[96,-141],[39,-65],[57,-84],[45,-41],[44,-51],[30,-42],[34,-20],[38,-7],[86,13],[104,26],[61,11],[28,-1]],[[127271,79529],[171,-10],[154,-8],[189,-11],[57,-9],[68,-9],[33,-2],[30,36],[20,20],[15,16],[-3,18],[-24,15],[-38,50],[-21,180],[-14,154],[45,48],[52,35],[74,105],[40,33],[59,27],[197,7],[83,20],[27,34],[43,86],[15,70],[24,32],[29,24],[31,-1],[58,-21],[44,-11],[32,-16],[28,-24],[28,-43],[4,-29],[13,-16],[22,-1],[17,0],[11,7],[8,14],[-6,19],[-38,55],[-84,99],[-54,41],[-28,22],[-6,21],[35,31],[35,18],[60,-13],[80,-8],[36,16],[36,80],[91,-85],[95,-94],[35,-18],[68,-10],[56,-3],[24,-11],[26,-24],[50,-104],[50,-27],[62,-19],[202,1],[61,-5],[51,-49],[31,-20],[14,-17],[-3,-22],[-13,-27],[-1,-52],[-4,-41],[-16,-19],[-5,-18],[14,-16],[93,-39],[32,-41],[23,-19],[6,-26],[-16,-17],[-44,9],[-21,-28],[0,-48],[31,-46],[9,-42],[-21,-40],[-24,-57],[0,-41],[14,-23],[71,-41],[165,-105],[38,-5],[156,25],[72,2],[43,-16],[121,-15],[38,-17],[41,-1],[56,5],[37,47],[20,11],[17,7],[34,2],[96,-30],[100,-63],[66,-58],[33,-52],[42,-113],[50,-173],[60,-117],[71,-61],[50,-112],[43,-244],[26,-50],[28,-26],[81,-70],[165,-117],[98,-69],[151,-110],[138,-101],[139,-156],[28,-23],[122,-84],[136,-87],[95,20],[143,-133],[58,-49],[25,-17],[104,-53],[165,-109],[209,-157],[138,-91],[37,-11],[37,1],[40,19],[43,16],[74,-21],[80,-36],[51,-28],[58,-40],[46,-38],[36,-17],[119,-33],[20,-20],[13,-22],[2,-23],[-67,-121],[-9,-154],[0,-115],[7,-91]],[[122913,83664],[-31,10],[-146,77],[-119,54],[-106,48],[-16,9],[-29,24],[-20,36],[-5,40],[11,30],[25,19],[31,7],[27,-6],[30,-18],[53,-22],[70,-4],[43,17],[5,40],[-82,149],[-76,120],[-73,133],[-31,49],[-90,111],[-89,111],[-70,97],[-37,31],[-114,12],[-216,24],[-76,12],[-61,-29],[-62,-23],[-58,43],[-46,69],[-24,59],[12,59],[4,88],[-35,87],[-39,43],[-97,33],[-125,73],[-33,133],[60,191],[98,135],[70,57],[34,49],[11,43],[-9,41],[-42,44],[-64,42],[-33,52],[13,112],[43,160],[66,129],[89,71],[77,51],[30,47],[2,68],[-2,63],[20,47],[33,36],[34,33],[48,37],[62,9],[69,-29],[93,-79],[136,-156],[78,-102],[28,-31],[71,-61],[64,-24],[107,38],[103,44],[33,28],[21,42],[-16,71],[-21,47],[-23,59],[-32,104],[-22,162],[-26,51],[19,6],[51,-10],[48,-5],[68,36],[94,67],[171,103],[36,69],[29,76],[48,47],[108,15],[101,24],[71,54],[112,48],[91,28],[41,27],[28,40],[105,112],[83,69],[72,70],[25,45],[57,-8],[88,-31],[94,-28],[68,-44],[14,-45],[7,-35],[28,-18],[33,-4],[50,9],[88,2],[107,58],[150,97],[137,31],[72,-23],[59,-72],[48,-68],[48,-25],[30,-1],[11,-1],[61,16],[59,-3],[53,-23],[88,-3],[122,18],[13,7],[59,-10],[71,-31],[56,-37],[99,-122],[57,-31],[116,-43],[55,-38],[64,-62],[33,-37],[69,-67],[80,-110],[14,-88],[18,-75],[30,-35],[24,-4],[27,12],[25,34],[9,56],[-8,100],[-20,82],[-26,26],[-13,28],[17,37],[45,17],[55,-11],[91,-47],[95,-59],[117,-103],[107,-65],[117,-53],[93,-15],[72,15],[85,43],[78,49],[35,52],[26,57],[117,75],[107,69],[49,-13],[34,-19],[110,42],[38,11],[105,16],[108,-24],[87,-73],[83,-48],[75,6],[62,24],[41,46],[31,54],[41,35],[7,2],[133,-19],[84,3],[9,8],[110,-15],[121,-76],[76,-85],[97,-108],[45,-35],[65,-15],[51,-7],[69,-17],[182,-22],[28,-14],[18,-17],[-16,-60],[16,-15],[147,43],[40,31],[48,89],[44,90],[32,33],[35,9],[34,-13],[49,-53],[65,-54],[88,-21],[55,-8],[83,-5],[197,27],[184,65],[105,71],[49,107],[30,121],[47,76],[-19,78],[-93,75],[-31,22],[-225,42],[-14,30],[-13,7],[-222,65],[-107,29],[-30,43],[-20,57],[-69,51],[-137,46],[-24,35],[22,36],[109,40],[124,83],[48,17],[110,4],[102,68],[71,39],[37,46],[-10,48],[-102,144],[-31,88],[18,57],[59,61],[33,34],[40,60],[27,32],[103,14],[125,6],[86,-15],[120,-7],[109,-11],[56,-10],[40,18],[30,33],[-1,42],[-43,42],[-161,54],[-69,45],[-54,-5],[-90,14],[-81,30],[-72,10],[-24,41],[15,57],[28,33],[53,16],[58,-8],[63,24],[18,14],[6,18],[-10,25],[-30,22],[-41,5],[-48,-18],[-57,-12],[-96,27],[-77,32],[4,29],[57,44],[25,35],[0,50],[0,57],[20,67],[56,46],[67,24],[171,-44],[213,-40],[37,6],[11,21],[24,19],[297,9],[57,25],[29,21],[285,30],[34,28],[42,26],[65,-1],[79,11],[108,32],[77,17],[13,2],[82,-7],[101,25],[22,10],[16,20],[88,36],[169,31],[42,-19],[80,-8],[103,14],[76,23],[45,-23],[60,-24],[44,20],[23,64],[29,61],[51,30],[40,10],[36,24],[28,25],[149,-4],[133,61],[26,-27],[174,6],[215,40],[128,18],[222,42],[103,33],[147,21],[135,15],[88,59],[71,8],[87,5],[53,14],[34,22],[23,41],[-13,51],[-12,38],[62,21],[88,7],[56,8],[122,86],[84,41],[86,26],[175,-14],[159,-13],[159,-41],[84,-51],[72,-38],[69,-19],[61,-12],[72,18],[50,23],[30,34],[44,24],[163,19],[34,-36],[77,-110],[53,-146],[87,-195],[38,-95],[-17,-50],[0,-69],[-4,-75],[-65,-85],[26,-40],[158,-45],[220,17],[136,35],[75,-13],[40,22],[25,63],[53,14],[53,-44],[39,-75],[38,-48],[-3,-57],[14,-74],[27,-18],[54,28],[36,16],[8,23],[-15,27],[-7,28],[12,26],[25,11],[77,-9],[112,-14],[133,-104],[71,-19],[30,-2],[67,6],[81,30],[55,38],[18,18],[31,-3],[30,-17],[2,-38],[-24,-55],[-80,-51],[-101,-47],[-60,-86],[-13,-89],[27,-46],[22,-31],[7,-42],[22,-6],[41,18],[112,88],[57,22],[82,14],[136,-7],[91,-29],[44,-40],[48,-33],[33,14],[17,38],[1,44],[14,36],[148,88],[98,59],[35,7],[66,-12],[40,6],[109,55],[101,63],[10,43],[4,38],[25,18],[142,13],[23,7],[122,44],[168,75],[81,44],[149,20],[27,12],[49,30],[93,41],[51,5],[-31,-100],[-56,-115],[-31,-30],[-151,5],[0,-32],[24,-48],[17,-27],[18,-24],[41,-42],[158,-99],[201,-125],[218,-142],[152,-98],[61,-51],[40,-40],[112,-144],[106,-136],[179,-240],[159,-232],[175,-256],[101,-147],[207,-310],[55,-95],[105,-179],[93,-169],[81,-149],[52,-14],[4,41],[9,27],[26,15],[61,44],[32,11],[48,-5],[51,22],[18,43],[-12,78],[-7,36],[17,39],[28,15],[38,12],[35,7],[30,43],[54,14],[51,-9],[41,-1],[37,-32],[20,-44],[40,-3],[65,4],[8,-36],[-18,-62],[-23,-47],[-3,-38],[34,-19],[126,17],[44,-8],[14,-39],[18,-32],[9,-39],[-13,-43],[22,-26],[109,0],[76,20],[118,2],[106,-46],[73,7],[74,19],[109,-12],[76,36],[52,45],[17,36],[27,20],[102,0],[65,3],[48,52],[43,24],[73,4],[54,0],[145,-48],[88,-40],[92,-57],[55,-36],[37,-81],[63,-59],[49,-70],[12,-68],[41,-123],[43,-41],[50,0],[63,-17],[70,-13],[150,-92],[55,-2],[42,-22],[7,-43],[-16,-48],[16,-47],[49,-60],[39,-59],[48,-70],[14,-41],[38,-13],[52,20],[82,-15],[247,-41],[34,-5],[26,-42],[36,4],[41,1],[57,-5],[39,39],[33,34],[81,42],[67,57],[57,51],[42,6],[35,-23],[1,-44],[-42,-32],[-33,-39],[8,-39],[56,-3],[64,-58],[91,-137],[31,-29],[45,-27],[50,-12],[55,-19],[41,-57],[17,-51]],[[113199,71282],[9,-25],[22,-69]],[[113230,71188],[53,-176],[47,-138],[58,-191],[18,-73],[7,-51],[84,-210],[49,-172],[36,-140],[51,-205],[22,-72]],[[113056,48932],[129,164],[132,166]],[[118165,48732],[-94,1],[-166,-13],[-70,-14],[-35,-3],[-63,0],[-52,16],[-35,24],[-43,54],[-95,110],[-70,68],[-153,-79],[-137,-78],[-195,-111],[-111,-80],[-34,-80],[-86,-145],[-76,-90],[-29,-11],[-174,19],[-62,18],[-104,17],[-139,31],[-94,34],[-101,4],[-146,12],[-90,24],[-91,81],[-118,97],[-121,100],[-124,103],[-148,119],[-161,129],[-37,13],[-16,3],[-174,6],[-182,6],[-123,4],[-39,15],[-27,29],[-38,96]],[[106210,30903],[-202,-48],[-287,-68],[-194,-46],[-235,-56],[-156,-35],[-195,-44],[-31,1],[-52,31],[-113,6],[-133,-42],[-105,-11],[-78,19],[-76,36],[-74,54],[-128,19],[-183,-14],[-176,10],[-169,36],[-121,14],[-73,-8],[-79,12],[-83,31],[-70,52],[-84,110],[-65,105],[-17,15],[-21,16],[-21,4],[-185,3],[-177,3],[-101,0],[-247,0],[-248,1],[-247,0],[-247,1],[-247,0],[-248,1],[-247,0],[-247,1],[-131,0],[-122,-8],[-135,-10],[-19,4],[-32,13],[-22,23],[-73,60],[-63,45],[-85,76],[-56,84],[-46,26],[-83,15],[-62,15],[-51,3],[-89,-39],[-67,-39],[-48,-38],[-83,-43],[-70,-43],[-122,6],[-27,-6],[-68,3],[-64,37],[-64,-3],[-72,-48],[-103,-19]],[[107423,30777],[125,-42],[68,-4],[53,21],[66,-28],[79,-77],[85,-15],[93,48],[126,-15],[157,-77],[131,-15],[156,68],[139,190],[130,179],[129,206],[77,166],[114,135],[149,105],[153,88],[233,108],[0,0],[46,89],[16,97],[0,135],[12,88],[24,39],[39,32],[50,40],[153,103],[129,65],[157,43],[171,1],[166,0],[94,1]],[[106210,30903],[138,34],[132,33],[154,32],[123,26],[31,7],[295,-30],[129,-21],[45,-21],[59,-54],[107,-132]],[[111319,26977],[91,85],[92,120],[107,140],[96,125],[84,110],[116,151],[114,149],[26,19],[12,12],[-50,132],[80,154],[4,100],[-4,96],[10,44],[24,38],[92,80],[70,128],[58,119],[79,191],[8,45],[1,47],[-22,64],[-53,105],[-38,91],[-35,140],[35,121],[12,74],[0,39],[-15,38],[-39,28],[-32,19],[-11,50],[0,60],[14,33],[86,53],[19,29],[11,33],[0,46],[27,116],[32,109],[3,39],[-12,34],[-9,62],[-6,94],[0,262],[17,270],[-8,153],[-55,177],[-5,127],[40,88],[6,53],[-29,7],[-60,5],[-44,17],[-68,72],[-119,61],[-135,55],[-196,17],[-163,177],[-128,28],[-41,23],[-123,106],[-192,10],[-199,10],[-125,3],[-18,14],[-7,147],[-1,130]],[[99035,40500],[32,-17],[58,-17],[80,19],[142,40],[77,49],[68,32],[55,9],[75,7],[76,-21],[29,15],[16,1],[179,0],[75,6],[138,-2],[87,-7],[50,-9],[134,-13],[168,3],[59,7],[220,5],[217,4],[195,4],[215,0],[165,-1],[75,-29],[68,-54],[31,-49],[15,-21],[20,-52],[38,-41],[13,-64],[-11,-86],[5,-104],[22,-121],[45,-127],[69,-133],[30,-106],[-9,-78],[21,-83],[51,-87],[38,-46],[21,-35],[58,-134],[108,-213],[80,-160],[29,-19],[41,7],[87,16],[87,3],[62,-33],[25,6],[93,63],[93,20],[96,26],[51,27],[58,0],[159,-52],[29,-2],[129,0],[128,28],[18,215],[2,42],[30,81],[39,70],[5,67],[-2,92],[28,111],[86,89],[139,42],[79,8],[124,25],[189,25],[70,-4],[5,-12],[-40,-154],[0,-50],[14,-51],[32,-28],[196,-3],[181,-3],[207,-9],[155,-7],[20,-8],[15,-12],[23,-76],[-5,-149],[-34,-217],[13,-203],[61,-190],[7,-290],[-22,-173],[-27,-219],[-11,-247],[28,-104],[60,-108],[90,-113],[70,-147],[50,-180],[18,-114],[-13,-46],[1,-81],[15,-116],[-17,-76],[-50,-38],[-16,-51],[25,-100],[6,-90],[20,-34],[14,-25],[23,-4],[51,32],[60,60],[48,26],[68,-3],[96,-17],[169,-7],[52,11],[157,81],[42,6],[62,-8],[88,-23],[89,-6],[43,26],[4,32],[14,43],[24,16]],[[80402,56656],[164,8],[198,-3],[216,-4],[102,-2],[54,117],[101,51],[105,19],[54,-5],[57,-17],[110,-96],[68,-22],[58,-22],[41,-46],[66,-47],[51,-12],[31,7],[51,18],[34,14],[109,6],[81,-53],[17,-59],[-14,-59],[-108,-33],[-150,-50],[-124,28],[-150,68],[-89,49],[-36,20],[-55,31],[-48,33],[-47,22],[-35,14],[-26,-18],[-13,-41],[-21,-46],[-27,-27],[-127,-17],[-113,-17],[-61,-14],[-41,-11],[-12,-139],[-129,2],[-126,1],[-131,-2],[-141,-3],[-36,-28],[-38,-46]],[[91244,57748],[-9,-38],[-1,-68],[-11,-107],[-14,-128],[56,-83],[67,-90],[18,-35],[-17,-88],[12,-51],[36,-86],[60,-110],[62,-112],[43,-15],[40,-9],[25,-20],[36,-19],[36,-13],[32,-25],[20,-24],[26,-69],[70,-46],[48,-45],[-19,-23],[-61,9],[-57,20],[-8,-33],[-2,-128],[9,-105],[13,-15],[58,-19],[137,-138],[124,-130],[41,-34],[69,-13],[77,-5],[33,12],[74,66],[40,7],[36,-2],[20,-10],[36,-54],[33,-81],[10,-59],[-3,-32],[-12,-12],[-61,-16],[-26,-12],[-7,-17],[10,-41],[12,-25],[66,-117],[96,-157],[30,-41]],[[103128,48320],[-37,26],[-35,77],[-16,16],[-101,-35],[-53,-31],[-27,-31],[-22,-5],[-32,43],[-25,7],[-40,-7],[-40,0],[-27,6],[-17,-4],[-48,25],[-173,64],[-30,21],[-35,-2],[-90,-56],[-48,-15],[-143,-35],[-154,-17],[-59,0],[-40,-25],[-26,-35],[-18,-77],[-30,-133],[-13,-36],[2,-52],[-9,-89],[-4,-80],[6,-54],[-44,-107],[-52,-131],[-44,-112],[-44,-113]],[[101559,47317],[-4,-48],[-39,-30],[-23,-50],[-7,-71],[12,-85],[30,-101],[1,-59],[-11,-8],[-19,-19],[-20,-12],[-54,69],[-60,46],[-91,81],[-91,30],[-118,5],[-51,-10],[-37,30],[-51,36],[-28,9],[-39,-27],[-27,-2],[-33,11],[-67,-1],[-6,47],[-12,9],[-72,-4],[-23,39],[-9,-5],[-29,12],[-58,56],[-61,-37],[-128,5],[-163,-1],[-169,-2],[-155,2],[-155,2]],[[101105,51656],[-65,-137],[-86,-78],[-26,-47],[-13,-59],[-19,-59],[-45,-126],[-34,-104],[-33,-32],[-78,-156],[-53,-157],[-10,-41],[-17,-30],[-25,-24],[-91,-49],[-30,-24],[-24,-29],[-22,-33],[-7,-40],[22,-56],[25,-44],[25,-3],[23,2],[14,-26],[11,-16],[0,-305],[-21,-46],[0,-20],[-10,-53],[-3,-59],[6,-23],[19,-19],[25,-41],[13,-93],[31,-330],[14,-52],[26,-37],[79,-71],[84,-93],[26,-61],[15,-100],[32,-78],[0,-27],[-13,-10],[-32,-1],[-21,-6],[18,-57],[43,-99],[72,-103],[78,-111],[63,-91],[79,-105],[62,-82],[64,-85],[48,-20],[36,-6],[15,-16],[19,-39],[32,-43],[36,-56],[12,-57],[-15,-55],[15,-78],[1,-7],[12,-31],[-4,-27],[7,-104],[19,-90],[31,-78]],[[101560,47323],[-1,-6]],[[113056,48932],[-152,-194],[-112,-143],[-18,-21],[-33,-26],[-107,-1],[-109,17],[-102,87],[-103,-67],[-65,-22],[-39,-7],[-92,-11],[-128,-36],[-59,-46],[-31,-36],[-26,-65],[-13,-7],[-24,8],[-33,26],[-69,38],[-34,84],[-32,51],[-27,26],[-109,-83],[-53,-20],[-43,2],[-79,47],[-88,40],[-45,0],[-67,-50],[-77,-75],[-39,-74],[-20,-44]],[[99550,41629],[-10,-13],[-71,-37],[-76,-34],[-100,-139],[-51,-60],[-15,-15],[-46,-34],[-33,-28],[1,-16],[22,-18],[23,-30],[-2,-227],[-10,-224],[-12,-19],[-64,-7],[-84,-16],[-27,-10]],[[111745,24045],[-13,59],[-5,92],[42,117],[-3,225],[4,79],[0,156],[-1,190],[-1,170],[2,146],[-13,70],[-10,38],[-28,77],[-32,162],[-38,122],[-48,80],[-16,43],[-16,57],[-46,100],[-38,58],[-10,47],[1,120],[-42,217],[-30,158],[-46,171],[-31,115],[-5,19],[-3,44]],[[111745,24045],[-17,-10],[-32,-10],[-149,94],[-146,100],[-21,3],[-31,-11],[-82,-72],[-77,-113],[-36,-97],[-57,-100],[-91,-160],[-10,-35],[-1,-130],[5,-125],[8,-17],[49,-6],[36,-102],[81,-162],[136,-104],[126,-47],[176,-12],[140,4],[-8,109],[14,175],[17,118],[20,6],[37,-12],[20,-12]],[[111852,23317],[-5,264],[-18,58],[-19,84],[-4,55],[12,54],[5,87],[-5,76],[-60,38],[-13,12]],[[112555,33895],[-138,-59],[-73,-31],[-208,-89],[-181,-77],[-47,-14],[-94,-38],[-47,-23],[-163,-67],[-69,-34],[-55,-33],[-135,-50],[-128,-47],[-139,-48],[-156,-55],[-88,-39],[-59,-34],[-139,-68],[-6,-17],[2,-46],[18,-96],[34,-87],[29,-50],[19,-129],[11,-113]],[[113691,35903],[-86,2],[-108,-11],[-26,-26],[-8,-57],[-34,-119],[-19,-44],[-40,-80],[-56,-112],[-12,-37],[2,-38],[33,-152],[35,-161],[11,-63],[25,-213],[14,-151],[2,-89],[11,-119],[31,-64],[33,-40],[122,-24],[36,-30],[69,-75],[151,-209],[83,-134],[73,-117],[130,-218],[102,-170],[12,-159],[17,-23],[-34,-118],[-22,-190],[16,-126],[-7,-216],[-19,-230],[-23,-82],[-30,-31],[-71,-24],[-155,-29],[-24,-27],[-20,-44],[-31,-106],[-37,-107],[-12,-46],[7,-10],[34,-55],[33,-139],[6,-238],[-12,-18],[-46,-10],[-49,3],[-21,13],[-18,27],[-13,51],[32,35],[12,62],[-21,54],[-42,12],[-53,48],[-113,160],[-94,112],[-55,92],[-56,37],[-16,23],[-13,39],[-1,56],[5,42],[-17,47],[-57,72],[-26,40],[-1,48],[24,46],[48,56],[37,115],[13,74],[69,148],[9,129],[1,103],[-4,77],[-17,158],[-12,109],[-85,143],[-27,14],[-80,-13],[-69,-21],[-34,-29],[-51,-2],[-135,-25],[-42,-11],[-25,-25],[-14,-6],[-85,111],[-74,119],[-95,203],[-27,25]],[[110213,44307],[2,25],[-10,194],[-1,119],[18,75],[10,85],[1,76],[26,129],[-9,77],[33,271],[8,44],[13,130],[21,41],[18,15],[24,81],[46,128],[31,66],[-7,144],[5,98],[8,22],[67,36],[88,91],[37,107],[52,68],[101,44],[1,0],[300,366],[139,197],[61,101],[2,37],[12,47],[-25,37],[-29,34],[-9,31],[-25,16],[-36,-1],[-24,23],[-27,44],[-27,28],[-85,-2],[-66,45],[1,62],[26,122],[50,139],[2,39],[-7,32],[-12,28],[-22,28],[-21,34],[16,100],[31,98],[26,49],[25,55],[-7,46],[-37,22]],[[114702,57208],[-21,238],[-14,158],[-14,168],[-14,158],[61,98],[29,92],[73,300],[29,60],[58,161],[8,46],[57,203],[-6,135],[-11,136],[31,81],[28,64],[-2,55],[12,127],[9,31],[34,2],[70,-16],[51,13],[59,0],[46,4],[27,38],[37,148],[24,30],[19,9],[52,27],[44,43],[37,31],[13,7],[39,4],[38,18],[18,21],[49,16],[47,-9],[32,18],[22,12],[24,1],[22,17],[9,26],[15,17],[37,38],[17,28],[8,28],[7,23],[16,37],[65,95],[56,55]],[[118485,55732],[-58,86],[-42,75],[-58,90],[-57,41],[-61,51],[-60,118],[-61,131],[-90,106],[-170,154],[-155,195],[-119,204],[-76,106],[-33,27],[-158,66],[-111,93],[-85,77],[-52,21],[-51,2],[-108,-15],[-90,48],[-37,0],[-61,14],[-47,17],[-55,-20],[-114,-34],[-46,7],[-26,48],[-15,37],[-39,38],[-33,0],[-18,-34],[-119,-87],[-199,-47],[-47,3],[-35,35],[-100,147],[-29,24],[-23,3],[-46,17],[-44,29],[-38,60],[-38,35],[-42,-119],[-72,-207],[-39,-111],[-50,-143],[-15,-5],[-26,11],[-99,178],[-62,67],[-47,-7],[-34,-32],[-21,-60],[-24,-37],[-25,-14],[-54,7],[-83,28],[-86,-6],[-88,-40],[-12,-2]],[[108776,92893],[1,19],[11,51],[19,45],[59,48],[15,32],[18,29],[136,34],[15,13],[1,12],[-6,11],[-30,17],[-32,24],[-19,66],[-47,102],[-44,69],[-10,40],[12,46],[16,46],[1,44],[-68,246],[5,45],[19,44],[32,37],[70,49],[88,88],[59,116],[31,70],[26,16],[51,4],[19,21],[10,13],[43,12],[15,14],[-12,24],[-43,41],[-35,25]],[[139113,72509],[32,-34],[83,2],[68,-15],[28,15],[20,-11],[-13,-124],[10,-73],[18,-21],[66,-30],[128,4],[76,-35],[84,-39],[44,-44],[20,-33],[-6,-53],[-45,-61],[-75,-30],[-43,-12],[-215,-116],[-67,-49],[-52,-59],[-19,-44],[-10,-43],[46,-156],[8,-48],[-38,-168],[-11,-63],[14,-43],[46,-17],[10,-36],[4,-28],[-79,-62],[-84,-55],[-26,0],[-80,-102],[-134,-206],[-71,-69],[-5,-35],[-5,-34],[27,-58],[6,-49],[-31,-50],[-50,-57],[-97,-49],[-124,-51],[-55,-31],[-42,-133],[-38,-134],[-17,-49],[-67,-154],[-116,-227],[-29,-49],[-179,-110],[-184,-119],[-32,-45],[-38,-108],[-35,-119],[-33,-62],[-116,-140],[-38,-107],[-12,-70],[-100,-39],[-112,-37],[-163,-12],[-68,-20],[-201,-96],[-49,-4],[-39,16],[-30,33],[-27,54],[-13,85],[-39,38],[-52,32],[-55,2],[-55,-36],[-48,-39],[-33,-33],[-31,-37],[-62,-128],[-99,-182],[-111,-133],[-41,-39],[-25,-30],[-35,-45],[-20,-42],[-28,-139],[-15,-124],[7,-27],[17,-24],[60,-36],[87,-59],[114,-34],[95,-6],[36,-25],[22,-35],[5,-28],[-4,-103],[-11,-109],[-36,-118],[1,-67],[14,-66],[106,-168],[39,-17],[80,-4],[37,3],[41,17],[29,-11],[22,-21],[6,-34],[-4,-167],[33,-76],[63,-103],[50,-118],[47,-141],[46,-111],[17,-57],[-29,-28],[-17,-29],[-4,-39],[6,-41],[-4,-29],[21,-35],[25,-12],[0,-25],[-40,-32],[-35,1],[-27,-15],[-53,-68],[-24,-13],[-33,-6],[-37,6],[-52,28],[-15,42],[6,46],[-12,26],[-37,-5],[-129,-46],[-123,-56],[-22,-39],[-28,-41],[-57,-16],[-83,-5],[-57,6],[-53,43],[-49,40],[-74,2],[-135,-6],[-75,0],[-44,15],[-43,-11],[-54,16],[-24,-22],[-23,-2],[-18,37],[-12,4],[-15,-5],[-12,-13],[-8,-22],[-2,-248],[-89,2],[-63,0],[-70,-13],[-64,-19],[-31,-23],[-44,-35]],[[36605,54506],[-35,-4],[-56,14],[-94,44],[-43,6],[-62,-38],[-73,-50],[-174,78],[-122,54],[-110,50],[-30,19],[-24,-4],[-21,-26],[-23,-46],[-8,-13],[-13,-13],[-14,-3]],[[37554,52107],[-3,49],[-19,57],[-23,47],[-48,49],[-3,18],[19,25],[88,71],[11,29],[2,62],[-9,59],[-39,86],[22,54],[45,43],[47,34],[8,14],[-9,29],[-27,32],[-63,54],[-39,4],[-1,156],[2,165],[9,16],[24,10],[18,25],[11,49],[27,17],[51,-37],[51,-34],[21,11],[16,17],[11,16],[4,15]],[[47894,46460],[-13,55],[7,56],[-30,83],[-17,87],[-15,30],[-5,66],[-36,118],[-29,96],[-27,49],[11,42],[-11,42],[-22,34],[-32,110],[11,47],[-9,47],[-27,33],[-38,35],[-51,72],[-62,69],[-31,28],[-21,11],[-19,65],[-14,20],[-31,5],[-65,28],[-59,-33],[-2,51],[17,31],[207,243],[104,111],[11,17],[10,26],[7,34],[-24,40],[-98,187],[-33,35],[-34,29],[-38,79],[-45,183],[-33,92],[-10,71],[2,80],[-12,61],[-27,43],[0,131],[27,219],[6,166],[-13,114],[23,86],[61,60],[34,91],[7,125],[36,102],[66,80],[22,78],[-21,78],[-7,50],[-55,51],[-103,35],[-85,4],[-52,-39],[-132,-37],[-212,-34],[-171,1],[-130,34],[-99,-12],[-67,-57],[-48,-12],[-27,31],[-30,8],[-45,-19],[-8,9],[-101,153],[-93,143],[-107,170],[-123,196],[-22,13],[-38,-2],[-51,-3],[-78,20],[-54,29],[-42,27],[-77,35],[-53,6],[-47,-10],[-131,-69],[-75,-6],[-57,-1],[-155,34],[-106,5],[-123,-22],[-53,-13],[-73,35],[-50,53],[-47,126],[-33,99],[-57,20],[-64,17],[-31,33],[-19,57],[-4,74],[6,119],[6,43],[9,129],[35,67],[22,33],[-4,54],[-17,110],[-17,79],[-71,88],[-90,114],[-39,182],[-45,215],[-36,22],[-34,-11],[-36,11],[-32,86],[-32,16],[-50,-30],[-37,-24],[-93,-21],[-19,21],[7,27],[39,79],[46,100],[54,92],[50,93],[37,100],[25,198],[18,137],[45,244],[85,195],[31,89],[76,117],[35,63],[47,50],[128,68],[152,334],[35,53],[154,50],[119,39],[88,41],[29,21],[23,10]],[[46881,2274],[-11,55],[-83,14],[-81,14],[-136,39],[-182,60],[-182,0],[-145,50],[-160,55],[-338,5],[-297,4],[-305,3],[-195,2],[-130,2],[-34,21],[11,69],[-48,51],[-70,61],[-86,44],[-42,58],[-47,66],[26,58],[41,141],[1,63],[-37,43],[-11,62],[11,29],[34,22],[20,102],[-16,99],[-26,89],[-33,39],[-44,19],[-32,3],[-72,-33],[-118,9],[-40,-13],[-58,-36],[-82,-53],[-46,19],[-14,56],[-30,49],[-20,43],[-14,71],[-24,91],[-49,108],[-74,87],[-4,78],[-14,99],[38,96],[-22,79],[-46,95],[14,99],[46,54],[14,69],[211,11],[-9,93],[35,75],[39,68],[34,31],[75,27],[88,40],[50,45],[24,40],[15,52],[4,55],[-15,118],[17,37],[54,48],[93,42],[40,113],[-23,98],[-51,78],[-66,35],[-5,80],[29,76],[39,81],[45,94],[-2,65],[40,38],[116,86],[40,83],[41,23],[48,10],[2,47],[-34,47],[-6,59],[4,66],[11,87],[54,32],[80,71],[21,45],[3,60],[-23,124],[-20,89],[-10,33],[-37,61],[-27,38],[43,47],[81,51],[34,72],[-31,62],[-46,33],[-14,94],[17,120],[34,37],[120,18],[11,62],[92,87],[-3,84],[-58,51],[-57,83],[-42,73],[-140,40],[-148,22],[-20,69],[6,40],[69,-16],[112,14],[85,3],[59,7],[68,10],[63,-29],[63,18],[25,109],[40,58],[6,55],[-40,44],[-73,13],[-320,35],[-9,43],[2,73],[13,75],[-1,37],[30,32],[33,68],[23,45],[-23,59],[-51,87],[37,40],[3,48],[-12,46],[-53,52],[-46,72],[0,77],[54,20],[37,23],[8,47],[-20,59],[-75,17],[-101,36],[-31,30],[-28,62],[21,176],[-11,106],[-9,59],[25,45],[34,41],[-16,94],[-30,50],[10,38],[29,38],[24,48],[21,11],[32,-27],[54,16],[65,38],[7,45],[-13,65],[-48,162],[-44,100],[9,36],[17,38],[-13,138],[4,83],[3,246],[5,84],[-44,85],[6,81],[31,58],[29,80],[22,70],[23,32],[39,15],[9,39],[-18,29],[-50,46],[-11,55],[10,43],[25,25],[38,0],[29,61],[8,76],[6,34],[-22,45],[-16,104],[-15,59],[18,25],[25,9],[43,-14],[31,7],[5,32],[4,33],[11,23],[28,77],[29,95],[7,67],[-11,182],[16,41],[31,39],[44,35],[57,30],[71,43],[88,16],[35,47],[25,63],[7,52],[-34,36],[-44,43],[-21,108],[-11,100],[-7,125],[-44,109],[-46,121],[-12,109],[15,59],[18,94],[-19,43],[-23,77],[24,60],[29,93],[-4,47],[-23,113],[-21,63],[21,68],[34,63],[26,34],[-4,54],[11,45],[51,30],[47,56],[33,6],[41,0],[26,16],[11,43],[7,47],[65,59],[37,54],[69,11],[34,59],[1,75],[-8,76],[23,88],[-26,134],[3,71],[-27,59],[6,63],[-15,41],[-40,15],[-14,50],[19,25],[38,19],[47,38],[36,186],[17,55],[16,66],[-2,35],[23,49],[28,76],[45,73],[26,50],[25,68],[7,40],[32,20],[36,6],[43,12],[18,25],[-3,36],[-3,80],[-13,127],[-8,164],[7,107],[29,109],[26,58],[-7,45],[-7,50],[-50,27],[-47,-24],[-32,7],[-42,58],[-13,60],[7,84],[33,52],[13,65],[-19,20],[-42,44],[-39,149],[5,128],[-39,33],[-18,100],[-40,36],[-16,74],[-13,77],[6,34],[41,9],[24,60],[-18,34],[-31,30],[-41,-3],[-36,35],[-49,145],[-39,80],[12,116],[8,91],[17,78],[6,62],[30,29],[28,-13],[26,6],[25,50],[27,32],[-2,24],[-16,27],[-8,48],[19,56],[32,129],[49,143],[21,53],[-5,45],[10,20],[33,-22],[95,25],[31,63],[13,56],[28,32],[-12,45],[-39,13],[-24,21],[10,51],[13,118],[-2,86],[-35,185],[-29,182],[20,61],[62,84],[47,38],[8,47],[46,216],[6,118],[30,65],[20,122],[84,106],[25,70],[33,6],[18,23],[44,78],[58,80],[50,40],[12,63],[24,87],[49,143],[28,100],[37,36],[43,130],[19,77],[49,32],[39,9],[37,-36],[39,6],[35,46],[86,30],[38,17],[18,45],[0,79],[-36,59],[-72,112],[-62,125],[-7,40],[0,43],[11,54],[29,62],[75,102],[-8,73],[-54,267],[-21,74],[-37,137],[5,54],[33,151],[29,61],[42,11],[23,20],[7,28],[-28,33],[-12,43],[-13,61],[-39,21],[-23,51],[0,75],[36,97],[39,27],[16,42],[41,40],[38,30],[32,57],[131,69],[104,53],[203,103],[140,70],[13,49],[11,33],[64,248],[84,321],[52,201],[-120,148]],[[46761,2030],[-2,-245],[-1,-241],[-1,-226],[-1,-225],[-1,-218],[-1,-223],[-5,-251],[-3,-186],[-2,-55],[125,21],[131,15],[131,-1],[227,-25],[228,-22],[129,-16],[111,-32],[207,-63],[119,-37]],[[105813,90278],[-22,-6],[-364,9],[-346,13],[-319,13],[-307,12],[-295,12],[-183,11],[-181,10],[-26,10]],[[122403,68990],[-113,-2],[-141,-3],[-115,-1],[-130,-2],[-57,78],[-19,85],[-21,88],[-57,125],[-190,30],[-101,16],[-166,24],[-125,18]],[[120027,76082],[0,-6],[21,-59],[53,-218],[31,-28],[34,-23],[25,-33],[9,-32],[-3,-51],[1,-59],[15,-45],[19,-34],[19,-17],[28,-2],[33,-8],[22,-34],[71,-248],[7,-33],[30,-10],[49,5],[50,-26],[54,-41],[51,-75],[34,-12],[107,11],[146,-12],[68,-39],[-7,-24],[-53,-27],[-92,-32],[-28,-54],[-15,-69],[3,-39],[22,-43],[66,-85],[3,-31],[12,-43],[12,-29],[-13,-57],[-60,-39],[-78,-43],[-157,-189],[-11,-41],[1,-113],[-16,-32],[-49,1],[-39,6],[-2,-40],[-25,-52],[-14,-45],[58,-108],[10,-57],[-9,-52],[-54,-89],[-31,-61],[8,-13],[41,-24],[130,-197],[41,-69],[55,18],[20,-1],[16,-12],[10,-23],[0,-29],[-14,-45],[70,-18],[25,-45],[82,-153],[-3,-46],[-39,-72],[-1,-48],[9,-43],[12,-15],[120,-7],[51,-17],[125,-78],[141,-121],[116,-98],[99,-84],[106,6],[29,-16],[26,-26],[31,-69],[60,-156],[52,-52],[79,-125],[75,-117],[-49,-159],[-48,-165],[0,-214],[0,-115],[101,-5],[113,-5],[0,-137],[1,-138],[1,-158],[33,-6],[53,-34],[22,-51],[29,-27],[34,-5],[34,-25],[33,-46],[12,-34],[-9,-24],[7,-41],[23,-59],[29,-28],[44,-35]],[[130685,74826],[-15,33],[-2,38],[15,46],[-4,87],[-30,63],[-34,27],[4,19],[15,44],[19,38],[0,76],[-24,81],[-9,118],[6,115],[-33,58],[-266,1],[-236,-5],[-14,14],[-92,145],[-74,110],[-74,65],[-169,79],[-81,34],[-69,61],[-57,66],[-14,92],[-12,30],[-16,24],[-18,11],[-22,-2],[-196,106],[-78,28],[-74,-23],[-33,-3],[-65,30],[-74,-41],[-31,-3],[-45,10],[-36,15],[-99,97],[-83,39],[-59,25],[-115,37],[-123,19],[-63,16],[-45,21],[-11,14],[0,35],[-3,47],[-15,33],[-31,41],[-43,30],[-74,-5],[-112,3],[-85,30],[-68,6],[-81,-6],[-67,0],[-47,-23],[-28,-25],[-18,-80],[-16,-12],[-28,-6],[-37,5],[-78,-1],[-135,14],[-170,4],[-127,-40],[-101,-57],[-97,-66],[-113,-102],[-33,-46],[-67,-182],[-30,-26],[-38,-21],[-40,-4],[-77,-27],[-103,-44],[-70,-18],[-179,10]],[[182188,43307],[0,-168],[0,-167],[0,-168],[0,-168],[0,-167],[0,-168],[0,-168],[0,-167],[0,-168],[1,-168],[0,-167],[0,-168],[0,-168],[0,-167],[0,-168],[0,-167],[0,-168],[0,-168],[0,-71],[-20,-88],[-45,-131],[-8,-106],[37,-83],[36,-53],[0,-138],[0,-168],[0,-168],[0,-167],[0,-168],[0,-168],[0,-167],[0,-168],[1,-168],[0,-167],[0,-168]],[[97253,70381],[-63,-42],[-71,-52],[52,-101],[100,-163],[61,-131],[21,-58],[47,-163],[39,-158],[10,-52],[14,-121],[-18,-336],[28,-426],[37,-213],[-59,-192],[-50,-183],[3,-92],[28,-144],[27,-106],[37,-56],[-7,-179],[-16,-65],[-112,-94],[-125,-86],[-35,-73],[-10,-81],[17,-66],[86,-146],[129,-219],[142,-241],[12,-61],[6,-171],[59,-215],[64,-94],[24,-70],[45,-50],[45,-37],[28,-5],[160,59],[272,-97],[258,-98],[19,-20],[57,-124],[92,-204],[69,-163],[61,-146]],[[82233,55903],[-217,1],[-184,1],[-232,1],[-163,1],[-152,1],[-118,-75],[-127,-81],[-171,-44],[-197,17],[-63,-12],[-65,-36],[-48,-26],[-67,-16],[-88,13],[-35,-8]],[[83744,55681],[-43,11],[-76,7],[-151,-32],[-52,13],[-99,-4],[-71,-18],[-90,-40],[-70,10],[-38,31],[-49,-2],[-56,17],[-60,31],[-54,15],[-59,56],[-27,10],[-20,-15],[-16,-18],[-17,-12],[-32,10],[-12,39],[10,37],[3,28],[-15,15],[-36,5],[-58,0],[-93,11],[-21,7],[-209,10]],[[91685,54517],[-166,-8],[-61,-23],[-36,0],[-2,19],[-4,11],[-210,64],[-147,38]],[[91740,54588],[-18,-42],[-21,-29],[-16,0]],[[1257,94933],[-83,68],[31,73],[37,88],[0,53],[-100,-3],[-151,-5],[-134,-4],[-100,-63],[-92,-57],[-145,45],[-165,51],[-47,-67],[-153,33],[-155,34],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241],[0,241]],[[6707,90568],[30,50],[53,54],[117,92],[63,66],[97,165],[30,48],[2,39],[-4,33],[-11,37],[-20,55],[-26,80],[-9,91],[20,79],[43,84],[8,51],[-6,53],[-22,42],[-27,36],[-75,-22],[-128,33],[-42,89],[-111,28],[-60,63],[-121,31],[-99,22],[-75,37],[-88,42],[-88,46],[-67,35],[-49,-2],[-112,-5],[-6,78],[-34,47],[13,42],[-62,21],[-92,32],[27,79],[20,61],[-81,18],[-117,25],[38,55],[30,43],[-45,65],[-90,107],[-70,77],[-91,120],[-81,105],[-65,86],[-55,59],[-77,107],[-100,119],[-95,94],[14,61],[-94,77],[-82,77],[-95,89],[-94,43],[-67,31],[-96,45],[-51,40],[-21,34],[-22,24],[-19,34],[-11,38],[-20,24],[-117,58],[-35,36],[-81,42],[-68,18],[-24,14],[-82,126],[13,45],[9,45],[-9,23],[-135,96],[-70,40],[-69,41],[-147,-53],[-150,-54],[-105,-20],[-145,-28],[48,-59],[-20,-44],[-45,-20],[-76,3],[-1,-148],[-72,-105],[-152,-2],[-81,-36],[-121,-54],[-98,-44],[-104,-70],[-53,10],[24,63],[-38,106],[-33,88],[-66,45],[-113,76],[-84,57],[-120,82],[-85,57],[-87,60],[-116,78],[-47,101],[-106,37],[-112,39],[-9,7]],[[11429,85855],[85,0],[62,0],[24,0],[69,0],[99,0],[66,0]],[[33668,58556],[-28,-1],[-114,9],[-77,-10],[-3,5],[6,205],[10,317],[7,232],[7,228],[6,170],[7,232],[6,200]],[[42461,45363],[-36,-29],[-38,-3],[-50,-9],[-69,28],[-28,0],[-4,-29],[47,-35],[45,-40],[16,-60],[26,-72],[65,-81],[40,-40],[2,-28],[-12,-53],[-3,-44],[22,-202],[-15,-12],[-24,-1],[-25,1],[-21,22],[-18,13],[-8,-31],[-18,-90],[-42,-202],[-37,-178],[-46,-62],[-66,-100],[-91,-136],[-132,-198],[-98,-91],[-77,-72],[-90,-84],[-116,-107],[-130,-61],[-182,-83],[-128,-60],[-95,-41],[-98,-44],[-130,-57],[-51,-54],[-83,-131],[-39,-64],[-36,-55],[-7,-25],[4,-16],[17,-26],[2,-27],[-23,-17],[-21,-3],[-9,13],[-7,31],[-21,30],[-25,9],[-15,-8],[-1,-27],[-33,-135],[-1,-66],[-14,-26],[1,-58],[-33,-55],[-14,-49],[-10,-41],[-27,-29],[-10,-45],[-24,-95],[-29,-75],[-21,-64],[-3,-48],[15,-34],[6,-27],[-14,-49],[-8,-37],[-37,-25],[-76,-60],[-30,-41],[-12,-46],[8,-40],[-3,-32],[-37,-13],[-13,-28],[-24,-51],[-28,-17],[-71,26],[-53,1],[-40,24],[-45,73],[-36,61],[-30,79],[-9,108],[-40,32],[-39,37],[-47,-10],[-56,-7],[-31,25],[-76,46],[-65,51],[-49,26],[-37,-12],[-23,-31],[-39,-56],[-59,-39],[-26,2],[-35,26],[-6,30],[28,48],[59,105],[-65,2],[-22,33],[-4,38],[-10,41],[13,49],[34,26],[51,-20],[35,-2],[24,47],[23,20],[24,15],[9,23],[-24,75],[-8,40],[8,23],[-1,46],[-1,35],[-15,30],[-1,45],[-13,24],[-4,26],[-1,30],[-17,15],[-17,15]],[[45897,41958],[-33,61],[-50,58],[-47,34],[-20,45],[-27,93],[-37,32],[-27,25],[-26,-4],[-27,-25],[-42,-17],[-28,3],[-114,64],[-19,6],[74,146],[131,260],[83,166],[92,184],[48,94],[6,16],[0,24],[-21,36],[-44,15],[-52,28],[-32,44],[-45,19],[-35,32],[-64,31],[-38,29],[-46,10],[-37,53],[-136,102],[-34,9],[-38,-15],[-56,-17],[-54,-55],[-67,-18],[-62,0],[-33,34],[-31,12],[-41,45],[-73,35],[-52,24],[-32,-11],[-42,-51],[-42,-50],[-34,-31],[-45,1],[-53,-46],[-53,-16],[-53,-8],[-61,-16],[-68,28],[-56,25],[-25,11],[-22,-8],[-35,-26],[-63,-11],[-49,-2],[-35,12],[-31,45],[-51,23],[-56,27],[-12,58],[9,43],[21,62],[-12,64],[-23,101],[-10,42],[-18,35],[-27,13],[-54,-10],[-58,38],[-37,37],[-18,45],[20,84],[-18,72],[-35,39],[-22,71],[-35,55],[-46,29],[-47,-3],[-36,17],[-41,59],[-39,23],[-43,57],[-82,25],[-42,23],[-25,35],[-32,63],[4,36],[-16,34],[-14,62],[-28,91],[-31,52],[-31,39],[-27,34],[-39,49],[-49,29],[-41,30],[-16,45],[-14,36],[-23,-2],[-33,3],[-37,9],[-38,27],[-33,32],[-54,55],[-29,7],[-26,0],[-39,-54]],[[47894,46460],[-122,-37],[-11,6],[-8,20],[4,157],[-2,178],[-18,72],[-56,117],[-74,154],[-21,44],[-31,26],[-37,3],[-27,-10],[-37,-29],[-34,-32],[-66,-93],[-67,-109],[-39,-24],[-39,-10],[-35,3],[-28,30],[-28,59],[-35,79],[-41,26],[-16,-24],[-13,-47],[-11,-46],[28,-58],[24,-45],[-41,1],[-132,0],[-152,0],[-151,0],[-137,0],[-126,0],[-48,3],[-49,27],[-47,13],[-25,-3],[-45,-25],[-57,-4],[-39,-25],[-32,3],[0,-136],[-1,-193],[-1,-206],[35,16],[30,-2],[22,-14],[62,11],[35,-6],[32,-5],[31,-1],[18,-16],[25,3],[27,18],[32,-11],[34,-29],[22,-44],[20,-53],[20,-28],[-1,-51],[-1,-41],[-7,-33],[9,-22],[6,-23],[-1,-13],[-12,-6],[-25,-4],[-27,-4],[-18,1],[-15,21],[-14,2],[-20,-2],[-22,12],[-18,26],[-34,26],[-35,-11],[-24,-13],[-26,-17],[-22,-17],[-23,5],[-29,-13],[-24,-19],[-33,-16],[-36,-7],[-40,-8],[-39,-3],[-44,-6],[-3,-108],[-5,-213],[-3,-140],[0,-130],[17,-48],[78,-100],[62,-52],[52,-59],[51,-25],[22,-22],[14,-36],[7,-38],[6,-33],[-6,-35],[-13,-32],[6,-35],[19,-27],[5,-35],[13,-32],[7,-33],[16,-24],[20,-16],[26,-27],[2,-26],[-2,-29],[-1,-22],[25,-50],[7,-35],[-12,-42],[-11,-145],[-28,-165],[-18,-127],[-29,-205],[-34,-239],[-42,-292],[-41,-288],[-40,-278],[-36,-252],[-39,-278],[-24,-168],[-12,-29]],[[46148,36420],[80,-179],[60,-131],[67,-150],[54,-120],[83,-182],[71,-158],[76,-168],[86,-191],[-28,-48],[-22,-39],[2,-66],[-34,-35],[-36,-21],[-43,-55],[-29,-48],[-1,-68],[5,-346],[-7,-94],[-22,-81],[-23,-41],[-13,-32],[33,-80],[31,-161],[24,-32],[29,-66],[14,-62],[-6,-24],[-59,-30],[-21,-25],[-6,-92],[-26,-34],[-43,-43],[-28,-50],[-23,-34],[-23,-21],[-12,-61],[-15,-61],[-54,-41],[-9,-76],[-1,-62],[29,-63],[93,-132],[9,-31],[-53,-79],[-31,-55],[-75,-169],[-1,-30],[18,-80],[113,-340],[19,-27],[35,-33],[57,4],[85,-37],[42,-42],[4,-20],[-10,-14],[-45,-28],[-51,-37],[-17,-35],[-3,-55],[11,-82],[-22,-27],[-50,-32],[-44,-45],[-43,-77],[-74,-115],[-26,-32],[-11,-40],[-42,-14],[-78,-78],[-14,-40],[13,-38],[40,-32],[27,-46],[7,-59],[0,-37]],[[46148,36420],[75,3],[151,-7],[146,-32],[99,-13],[42,-28],[9,-44],[28,-20],[31,8],[36,3],[81,45],[64,29],[57,36],[28,35],[70,122],[56,68],[52,23],[101,10],[32,-19],[41,2],[36,70],[54,76],[107,96],[55,26],[33,34],[59,5],[51,35],[246,242],[100,62],[62,11],[52,15],[88,35],[218,33],[141,14],[45,-33],[51,9],[43,55],[36,17],[26,-1],[38,-65],[18,-68],[-12,-51],[2,-76],[17,-99],[-9,-87],[-54,-115],[-26,-47],[-7,-48],[5,-65],[24,-106],[44,-147],[7,-109],[-31,-70],[-14,-61],[2,-51],[11,-36],[20,-21],[11,-41],[2,-61],[26,-60],[49,-57],[20,-55],[-10,-52],[3,-32],[14,-13],[14,10],[18,15],[16,-6],[34,-72],[4,-15],[19,-60],[6,-45],[50,-26],[55,-20],[30,-24],[60,-72],[51,-47],[63,-39],[21,-62],[39,-94],[107,-35],[125,-18],[80,-21],[97,50],[64,-7],[67,-34],[28,-23],[50,-48],[76,-62],[63,-23],[44,35],[42,12],[32,-15],[16,-67],[17,-45],[37,-34],[80,-88],[45,-36],[50,2],[105,-58],[111,-56],[58,-9],[57,8],[37,-21],[15,-68],[97,-136],[46,-53],[54,-45],[138,1],[42,-14],[62,12],[185,23],[34,8],[105,-60],[124,-84],[82,-67],[57,-37],[30,-60],[25,-62],[11,-67],[-15,-67],[-23,-27],[-7,-43],[9,-64],[41,-58],[16,-71],[22,-125],[25,-39],[17,-388],[-83,-3],[-117,-5],[34,-37],[97,-144],[89,-133],[14,-214],[9,-135],[13,-190],[7,-113],[223,-10],[256,-12],[308,-14],[271,-12],[27,1],[47,15],[31,21],[19,-1],[4,-46],[-7,-58],[0,-66],[-77,-132],[-5,-41],[12,-174],[27,-140],[14,-126],[31,-40],[92,-67],[139,-123],[55,-16],[47,16],[28,-50],[6,-81],[76,-228],[49,-144],[22,-50],[37,-26],[-7,-19],[-31,-7],[-13,-27],[-42,-162],[-56,-213],[-37,-149],[34,-2],[1,-42],[8,-63],[-42,-8],[-12,-22],[-48,-123],[-63,-160],[-65,-166],[-38,-99],[65,-72],[110,-121],[-18,-34],[-47,-17],[-39,-12],[-30,-45],[-17,-34],[-43,-11]],[[45897,41958],[-4,-54],[-20,-21],[-32,-5],[-49,38],[-36,-9],[-35,-3],[-50,45],[-18,44],[-39,36],[-81,-15],[-68,-1],[-56,8],[-50,-11],[-43,-47],[-32,-54],[-38,-46],[-110,-30],[-59,-1],[-52,-29],[-79,-11],[-54,-27],[-95,-14],[-114,-14],[-63,-41],[-26,-17],[-64,-56],[-113,-88],[-62,-31],[-75,-95],[-90,-89],[-58,-48],[-86,-21],[-36,-24],[-13,-29],[7,-34],[-14,-86],[-26,-159],[-8,-77],[-6,-38],[-57,-127],[-61,-119],[-30,-79],[-17,-57],[19,-48],[25,-86],[21,-69],[5,-46],[-7,-54],[-26,-49],[-40,-32],[-55,-9],[-113,-86],[-126,-127],[-41,-60],[-12,-56],[-18,-87],[8,-46],[22,-31],[23,-74],[2,-39],[-19,-21],[-36,-5],[-32,-7],[-24,-19],[-25,5],[-22,-10],[0,-31],[7,-36],[-3,-38],[-15,-24],[-13,-17],[13,-24],[22,-22],[34,-36],[47,-69],[36,-12],[30,-24],[3,-38],[-11,-38],[-26,-17],[-2,-34],[36,-40],[24,-29],[24,-43],[23,-60],[0,-38],[24,-48],[15,-41],[0,-38],[40,-39],[33,-28],[25,-27],[24,-16],[6,-29],[-3,-44],[35,-72],[64,-53],[52,-79],[33,-56],[63,-91],[2,-105],[-77,-120],[-77,-120],[126,3],[129,-2],[135,-35],[91,-33],[55,-15],[40,-38],[18,-60],[15,-49],[4,-70],[56,-58],[-4,-54],[-1,-78],[25,-1],[165,0],[180,-1],[174,15],[66,18],[79,94],[47,28],[46,44],[56,79],[44,36],[37,45],[56,44],[23,33],[19,12],[43,21],[-19,-43],[-14,-44],[-5,-64],[21,-69],[-17,-52],[-28,-46],[-1,-122],[0,-173],[-1,-148],[0,-186],[-1,-210],[-1,-140],[30,28],[41,25],[53,-65],[38,-28],[32,-6],[34,2],[45,13],[100,54],[68,44],[78,-3],[107,-17],[62,2]],[[50624,27116],[14,41],[40,161],[58,233],[59,242],[70,286],[1,202],[0,213],[100,175],[71,125],[61,118],[62,203],[41,135],[159,32],[268,71],[134,35],[283,74],[287,75],[301,5],[291,4],[226,-168],[172,-128],[190,-142],[13,-31],[13,-118],[-13,-137]],[[80088,62610],[-10,76],[14,90],[24,111],[26,154],[83,0],[148,0],[148,1],[149,0],[148,0],[148,0],[148,0],[148,1],[148,0],[148,0],[149,0],[148,1],[148,0],[148,0],[148,0],[148,0],[149,1],[97,0],[-5,109],[-5,87],[-6,117],[-6,116],[-6,117],[-6,109],[-6,109],[-5,101],[-5,93],[-9,54],[-31,106],[-7,52],[9,56],[21,52],[57,96],[88,74],[101,85],[77,65],[39,16],[121,22],[95,49],[92,48],[39,26],[4,90],[0,100],[0,113],[0,112],[0,112],[0,112],[0,113],[0,112],[0,112],[0,113],[0,112],[0,112],[0,112],[0,113],[0,112],[0,112],[0,112],[0,113],[0,98],[97,0],[120,0],[121,0],[120,0],[121,0],[120,0],[120,0],[121,0],[120,0],[120,0],[121,0],[120,0],[121,0],[120,0],[120,0],[121,0],[120,0],[132,0],[0,94],[0,135],[-1,185],[0,186],[0,164],[0,163],[0,137]],[[85493,67953],[121,-91],[122,-91],[121,-91],[122,-92],[121,-91],[122,-91],[121,-91],[122,-91],[121,-92],[122,-91],[121,-91],[122,-91],[121,-91],[122,-92],[121,-91],[122,-91],[102,-76],[156,-123],[146,-115],[146,-116]],[[85493,68259],[0,201],[0,175],[0,174],[0,120],[0,125],[3,57],[12,24],[66,40],[102,93],[38,41],[49,42],[172,125],[36,35],[167,144],[39,21],[90,14],[37,27],[50,58],[75,66],[48,31],[11,6],[31,4],[155,-19],[65,-15],[77,-12],[24,8],[21,21],[29,46],[7,55],[1,47],[5,21],[14,9],[33,-3],[46,-7],[92,2],[31,7],[105,10],[148,31],[117,41],[94,32],[100,84],[73,89],[77,132],[60,114],[123,72],[102,43],[59,17],[133,61],[113,91],[105,86],[81,11],[102,14],[23,17],[26,30],[1,53],[-31,38],[-37,20],[-26,22],[-27,4],[-14,25],[8,48],[4,44],[17,44],[-5,62],[-26,62],[-8,44],[2,44],[13,35],[38,23],[43,9],[62,-11],[107,14],[273,107],[19,33],[17,74],[20,65],[28,22],[15,4],[91,18],[129,24],[48,4],[141,-7],[102,-5],[165,-9],[118,-4],[102,-4],[130,-5]],[[85493,67953],[0,169],[0,137]],[[83169,57664],[-15,6],[-68,60],[-33,70],[-54,54],[-75,35],[-49,41],[-23,45],[-28,31],[-29,15],[-2,17],[6,22],[-7,42],[-44,93],[-41,43],[-35,-7],[-19,11],[-12,21],[-5,30],[-24,26],[-42,11],[-33,69],[-25,127],[-33,98],[-40,71],[-29,26],[-21,5],[-7,11],[-6,21],[-31,7],[-44,-21],[-40,7],[-19,34],[-27,3],[-34,-28],[-38,8],[-42,45],[-23,45],[-4,45],[-72,88],[-138,134],[-151,62],[-164,-8],[-91,6],[-20,21],[-20,-2],[-21,-24],[-21,-5],[-23,13],[-14,-10],[-6,-34],[-57,-18],[-110,0],[-88,-21],[-68,-41],[-95,-18],[-123,6],[-74,15],[-26,24],[-35,6],[-46,-13],[-41,-66],[-36,-119],[-30,-68],[-24,-16],[-25,-89],[-14,-148],[-21,-65]],[[87987,66064],[-226,0],[-302,0],[-206,0],[-212,0],[-198,0],[17,-188],[18,-205],[19,-205],[18,-205],[19,-205],[18,-206],[18,-205],[19,-205],[18,-205],[19,-205],[18,-205],[18,-205],[19,-205],[18,-205],[19,-205],[18,-205],[18,-205],[19,-205],[18,-205],[18,-205],[19,-206],[18,-205],[19,-205],[18,-205],[18,-205],[19,-205],[18,-205],[19,-205],[18,-205],[18,-205],[19,-205],[18,-205],[19,-205],[17,-199],[77,-104],[97,-132],[-28,-185],[-34,-222],[-36,-241],[-137,0],[-132,0],[-132,0],[-131,0],[-132,0],[-132,0],[-132,0],[-131,0],[-132,0],[-132,0],[-132,0],[-132,0],[-131,0],[-132,0],[-132,0],[-132,-1],[-131,0],[-123,0],[-76,6],[-27,19],[-9,125],[-23,-8],[-26,-37],[-14,-40],[5,-52],[-5,-44],[-84,-17],[-115,-30],[-120,-22],[-122,8],[-41,10],[-44,16],[-97,18],[-53,2],[-60,-4],[-71,-10],[-23,-23],[-54,-93],[-52,-109],[-34,1],[-38,59],[-104,112],[-127,147],[-58,73],[-31,10],[-61,-53],[-51,-50],[-54,-72],[-25,-68],[-19,-81],[-9,-95],[-20,-111],[-44,-89],[-52,-68],[-39,-31],[-15,-18],[-113,53]],[[93835,61238],[-205,-49],[-147,-35],[-158,-37],[-24,-6],[-29,-2],[-21,1],[-44,21],[-53,49],[-35,25],[-9,39],[21,51],[25,46],[10,36],[17,28],[23,22],[1,32],[-19,52],[-16,71],[1,130],[0,44],[0,15],[-47,50],[-89,55],[-82,32],[-38,12],[-90,19],[-125,35],[-44,23],[-81,121],[-40,31],[-188,21],[-62,20],[-51,28],[-44,39],[-24,66],[-8,54],[-16,26],[-207,130],[-53,45],[-28,41],[-1,61],[6,75],[-9,66],[-9,33],[-94,79],[-212,176],[-211,177],[-212,176],[-211,177],[-212,176],[-212,177],[-211,177],[-212,176],[-211,177],[-212,176],[-212,177],[-211,176],[-212,177],[-211,177],[-212,176],[-211,177],[-179,149],[-198,157]],[[93835,61238],[141,34],[145,36],[214,52],[231,57],[251,61],[57,37],[190,209],[86,94],[170,187],[132,144],[167,184],[177,184],[141,148],[222,167],[335,251],[334,252],[335,252],[335,252],[334,252],[335,251],[334,252],[335,252]],[[97253,70381],[-39,194],[-33,166],[-28,137],[-49,242],[-41,204],[-41,205],[-38,185],[-37,187],[-17,27],[-113,88],[-104,81],[-108,92],[-117,100],[-19,126],[-61,190],[-63,106],[-24,28],[-128,68],[-74,51],[-20,29],[-15,77],[-53,154],[-60,140],[-22,94],[-3,119],[12,86],[26,36],[126,107],[58,129],[71,48],[63,36],[50,42],[45,68],[34,73],[6,78],[14,124],[23,87],[53,98],[-22,79],[-28,85],[8,148],[-7,60],[-23,53],[-23,68],[-1,57],[22,149],[17,113],[27,148],[-9,41],[-20,31],[-61,33],[-1,20],[15,21],[90,72],[48,106],[41,22],[61,38],[-3,41],[-13,44]],[[106597,61530],[-309,195],[-310,195],[-309,195],[-310,195],[-309,195],[-310,195],[-310,195],[-309,195],[-310,196],[-309,195],[-310,195],[-309,195],[-310,195],[-309,195],[-310,195],[-309,195],[-214,135],[-231,-132],[-181,-103],[-238,-136]],[[107243,63591],[0,-411],[0,-411],[0,-411],[0,-411],[-2,-2],[-2,-1],[-2,-2],[-2,-1],[-160,0],[-159,0],[-159,0],[-160,0],[0,-103],[0,-102],[0,-103],[0,-103]],[[107353,71556],[-25,-23],[-35,-49],[-22,-44],[-60,-71],[-50,-77],[5,-112],[11,-113],[33,-111],[29,-124],[-8,-81],[-25,-99],[-29,-83],[-98,-171],[-15,-41],[6,-57],[59,-202],[5,-64],[35,-197],[33,-160],[36,-126],[5,-34],[0,-185],[0,-186],[0,-185],[0,-185],[0,-185],[0,-185],[0,-186],[0,-185],[0,-185],[0,-185],[0,-185],[0,-185],[0,-186],[0,-185],[0,-185],[0,-185],[0,-185],[0,-186],[0,-185],[0,-185],[0,-185],[0,-185],[0,-186],[0,-185],[0,-185],[0,-185],[0,-185],[0,-186],[0,-185],[0,-185],[0,-185],[0,-185]],[[105873,54456],[23,91],[28,134],[3,62],[-13,64],[-48,48],[-42,6],[-19,24],[-37,36],[-36,27],[-32,53],[-23,74],[16,264],[-11,36],[-48,9],[-11,19],[2,51],[-26,151],[-29,124],[16,69],[-41,94],[-76,40],[-73,-12],[-78,-19],[-47,6],[-32,17],[-23,35],[-11,40],[10,61],[43,113],[53,92],[109,84],[29,45],[16,50],[3,57],[-7,60],[-13,55],[-32,73],[-29,85],[0,58],[14,41],[29,50],[57,56],[14,11],[36,30],[32,22],[78,60],[19,28],[-7,34],[-19,28],[-32,39],[-6,48],[-10,82],[-16,51],[-12,39],[23,28],[33,40],[41,24],[65,21],[25,28],[8,55],[-2,52],[23,39],[31,82],[25,38],[42,43],[42,54],[19,63],[5,60],[-23,183],[49,76],[62,64],[89,-5],[139,14],[94,27],[67,-1],[154,-34],[12,8],[4,6],[8,49],[0,122],[0,368],[0,367],[-1,368],[0,368],[0,368],[0,368],[-1,368],[0,368]],[[107243,63591],[247,0],[247,0],[247,0],[247,-1],[246,0],[247,0],[247,0],[247,0],[247,0],[247,0],[246,0],[247,0],[247,0],[247,0],[247,0],[247,0],[75,0],[33,6],[63,154],[27,11],[42,-9],[14,-36],[-13,-52],[-21,-73],[121,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0],[212,0]],[[118165,48732],[-79,-146],[-96,-174],[-175,-320],[-134,-169],[-101,-128],[-9,-23],[0,-142],[1,-347],[1,-348],[1,-347],[2,-348],[1,-347],[1,-348],[1,-347],[1,-348],[0,-116],[89,-147],[86,-142],[115,-189],[61,-101],[10,-34],[-3,-68]],[[118836,54522],[-11,-32],[-27,-47],[-35,-47],[-30,-49],[-67,-137],[-2,-17],[8,-27],[37,-63],[37,-100],[21,-93],[17,-45],[46,-51],[66,-106],[35,-71],[72,-38],[24,-91],[55,-132],[59,-107],[57,-83],[63,-32],[26,-2],[133,-154],[102,-117],[25,-19],[183,-77],[211,-88],[169,-71],[215,-90],[212,-89],[199,-85],[280,-120],[225,-96],[178,-76],[37,-24],[212,0],[215,0],[220,0]],[[110972,38694],[-112,-22],[-162,-31],[-178,-35],[-184,-36],[-183,-35],[-173,-34],[-157,-31],[-48,-17],[23,-86],[-11,-91],[-31,-70],[-49,-87],[-22,-34],[-50,-68],[-42,-47],[-86,-81],[-54,-45],[0,-42],[91,-194],[41,-139],[17,-125],[-1,-73],[-4,-148],[-4,-177],[-6,-69],[24,-126],[-4,-98],[-61,-110],[-17,-108],[-31,-146],[-42,-201],[-31,-107],[17,-69],[15,-46],[16,-62],[33,-94],[38,-55],[22,-24],[126,-118],[52,-57],[79,-114],[59,-75],[82,-17],[99,-29],[54,-22],[37,11],[13,27],[-2,56],[-7,42],[11,32],[33,21],[86,4],[37,28],[29,7],[0,-124],[0,-120],[1,-144],[0,-166],[0,-136],[0,-145],[0,-166],[-1,-19],[-13,-38],[-34,-13],[-45,33],[-3,34],[-11,61],[-22,32],[-27,9],[-47,-16],[-65,-45],[-83,-39],[-33,-23],[-58,3],[-63,21],[-47,51],[-13,76],[-41,79],[-55,113],[-28,47],[-37,53],[-37,6],[-42,15],[-25,77],[-24,98],[-15,38],[-25,49],[-36,30],[-77,39],[-109,54],[-137,69],[-65,3],[-72,12],[-46,33],[-26,26],[-30,95],[-41,112],[-120,133],[-27,147],[-24,21],[-41,-12],[-32,-18],[-13,-40],[-32,-132],[-17,-61],[-12,-17],[-26,-20],[-43,-18],[-61,-9],[-87,3],[-107,20],[-58,15],[-158,22],[-45,11],[-64,28],[-47,29],[-152,63],[-69,-8],[-34,45],[-30,21],[-41,42],[-19,57],[-24,123],[6,65],[17,73],[-19,21],[-28,0],[-40,-26],[-70,-14],[-129,-32],[-45,-18],[-51,-14],[-38,-12],[-97,-71],[-34,-7],[-57,25],[-28,38],[28,42],[12,53],[-20,104],[-29,48],[-86,34],[-33,3],[-14,58],[-23,53],[-49,10],[-24,6]],[[106210,30903],[-129,137],[-146,156],[-151,174],[-114,136],[-55,78],[-100,104],[-72,50],[-28,26],[-71,276],[-39,253],[0,191],[0,265],[0,264],[-1,265],[0,264],[0,265],[0,265],[0,264],[0,265],[0,129],[149,0],[169,0],[177,0],[192,0],[192,0],[192,0],[134,0],[35,2],[42,8],[3,26],[-55,130],[3,46],[14,88],[23,77],[30,100],[4,59],[-25,192],[3,107],[7,111],[7,106],[-9,73],[10,40],[18,58],[10,65],[11,27],[-3,26],[-11,48],[-10,108],[-14,150],[-14,108]],[[113009,44625],[-3,140],[16,358],[-2,314],[14,158],[61,99],[28,73],[20,101],[32,82],[72,67],[13,37],[77,112],[45,145],[35,49],[43,45],[30,24],[51,24],[39,13],[7,12],[3,23],[-13,89],[17,30],[27,59],[31,56],[27,35],[16,36],[7,63],[1,45],[0,73],[-9,165],[-32,138],[-20,155],[14,51],[-25,91],[-13,5],[-21,20],[-26,85],[-20,78],[-13,20],[-86,68],[-43,161],[-49,36],[-26,160],[-5,46],[28,159],[-3,37],[-29,34],[-81,34],[-66,66],[8,23],[5,24],[-35,16],[-100,273]],[[113009,44625],[49,0],[46,-31],[52,-37],[138,-98],[138,-98],[137,-99],[138,-98],[138,-98],[137,-98],[138,-98],[138,-98],[138,-98],[137,-99],[138,-98],[138,-98],[137,-98],[138,-98],[138,-98],[138,-98],[65,-47],[10,-21],[12,-89],[7,-56],[-4,-49],[-37,-84],[-10,-43],[-1,-31],[9,-12],[31,-4],[27,-20],[10,-15],[20,-63],[25,-32],[59,-53],[99,-92],[99,-91],[99,-91],[99,-91],[100,-91],[99,-91],[99,-92],[99,-91],[48,-44],[21,-12]],[[98423,47239],[-150,0],[-198,0],[-186,0],[-126,0],[-212,0],[-71,37],[-21,24],[-4,28],[-3,18],[-16,6]],[[98423,47239],[1,-191],[0,-162],[1,-174],[1,-182],[1,-155],[0,-99],[-132,0],[-176,1],[-175,1],[-176,0],[-88,1],[-97,0],[-32,-5],[-21,-25],[-26,-6],[-30,22],[-36,10],[-10,22],[-18,40],[-37,5],[-18,-5],[-26,-23],[-29,-12]],[[107423,30777],[-27,5],[-199,-28],[-75,-35],[-169,-155],[-36,20],[-41,32],[-34,9],[-74,-37],[-75,-45],[-81,-63],[-68,-62],[-22,-33],[-106,-128],[-34,-21],[-31,-8],[-12,6],[-13,54],[-65,129],[-104,167],[-31,17],[-20,6],[-78,-8],[-224,-47],[-189,-40],[-290,-69],[-311,-55],[-192,-34],[-167,-10],[0,-166],[0,-337],[1,-336],[0,-337],[1,-336],[0,-336],[0,-337],[1,-336],[0,-337],[0,-146],[-5,-32],[-96,0],[-217,0],[-182,0],[-147,0],[0,-200],[0,-236],[0,-237],[1,-236],[0,-236],[0,-237],[0,-236],[0,-236],[1,-237],[0,-178]],[[104013,25018],[0,-346],[0,-367],[0,-367],[0,-366],[0,-367],[0,-367],[0,-367],[0,-367],[0,-116],[-66,2],[-134,-45],[-85,-59],[-37,-71],[-49,-44],[-61,-15],[-27,-37],[8,-58],[-24,-44],[-54,-31],[-88,9],[-121,49],[-154,11],[-187,-26],[-134,12],[-82,50],[-87,29],[-92,7],[-53,20],[-109,38],[-21,63],[-13,48],[-31,51],[-3,41],[24,31],[3,50],[-17,69],[-30,34],[-43,-2],[-27,26],[-10,55],[-25,41],[-61,43],[-79,-32],[-37,-48],[-22,-75],[-21,-38],[-10,-63],[-4,-44],[-21,-48],[-21,-19],[-21,9],[-41,-19],[-90,-70],[-26,-37]],[[104013,25039],[0,-21]],[[91685,54517],[-17,-89],[-34,-109],[-22,-35],[-16,-267],[11,-22],[8,-7],[107,-90],[141,-119],[100,-84],[8,-28],[1,-175],[2,-151],[20,-86],[5,-83],[24,-64],[92,-122],[22,-71],[2,-231],[2,-174],[12,-238],[0,-198],[0,-251],[0,-295],[0,-306],[-61,-4],[33,-95],[6,-87],[8,-28],[-16,-42],[13,-64],[26,-23],[67,-128],[23,-109],[-108,-36],[8,-28]],[[118756,58953],[121,113],[31,34],[17,30],[29,64],[39,21],[14,67],[-2,34],[-25,28],[-19,79],[7,99],[6,42],[13,76],[42,28],[10,22],[-32,49],[2,28],[72,80],[29,25],[46,24],[37,0],[41,-14],[38,-23],[36,-40],[39,-47],[59,-17],[40,4],[33,-20],[27,11],[32,24],[50,-2],[45,27],[128,13],[124,-8],[130,23],[129,-2],[130,-2],[29,-3],[28,-14],[110,-72],[83,-14],[168,-20],[178,-21],[155,-18],[131,17],[109,14],[30,-2],[32,-44],[66,-110],[62,-104],[108,-5],[70,39],[76,54],[47,43],[54,168],[35,109],[80,123],[67,102],[89,136],[50,75],[97,149],[93,58],[179,111],[175,110],[115,71],[97,33],[163,28],[192,33],[192,33],[204,35],[228,39],[157,27],[199,34],[166,29],[147,25],[152,26]],[[124687,61117],[28,-82],[29,-83],[28,-82],[29,-83],[29,-82],[28,-82],[29,-83],[28,-82],[29,-82],[29,-83],[28,-82],[29,-83],[28,-82],[29,-82],[29,-83],[28,-82],[28,-81],[46,-26],[28,-76],[39,-109],[39,-109],[39,-109],[40,-108]],[[126760,64175],[47,-94],[39,-77],[54,-107],[58,-113],[55,-108],[41,-80],[-22,-84],[-24,-91],[-23,-92],[-24,-91],[-24,-91],[-23,-91],[-24,-92],[-24,-91],[-23,-91],[-24,-92],[-24,-91],[-23,-91],[-24,-92],[-24,-91],[-23,-91],[-24,-91],[-24,-92],[-28,-110],[-69,-29],[-111,-47],[-111,-47],[-111,-48],[-111,-47],[-112,-47],[-111,-48],[-111,-47],[-111,-47],[-111,-47],[-111,-48],[-112,-47],[-111,-47],[-111,-48],[-111,-47],[-111,-47],[-111,-47],[-91,-39]],[[126760,64175],[-43,-66],[-10,-2],[-51,8],[-18,2],[-49,8],[-76,12],[-98,15],[-117,18],[-130,21],[-139,21],[-144,23],[-144,22],[-139,22],[-130,20],[-117,18],[-99,16],[-76,12],[-49,7],[-17,3],[-54,8],[-30,45],[-35,54],[-36,54],[-35,54],[-36,54],[-35,54],[-36,54],[-35,54],[-36,54],[-36,54],[-35,54],[-36,54],[-35,54],[-36,54],[-35,54],[-36,54],[-35,54],[-24,36],[-13,41],[-3,107],[0,23]],[[118472,76054],[0,-11],[-6,-29],[-73,-82],[-99,-111],[-71,-71],[-120,-118],[-89,-25],[-151,-43],[-40,-41],[-38,-67],[-22,-92],[-7,-57],[-3,-107],[35,-111],[34,-106],[4,-71],[-3,-69],[-33,-74],[-36,-102],[-20,-114],[-11,-216],[0,-183],[-3,-30],[-62,-129],[-73,-151],[-33,-35],[-159,-45],[-173,-111],[-193,-124],[-176,-112],[-185,-118],[-191,-122],[-137,-88],[-183,-117]],[[114226,72447],[69,-18],[40,-38],[67,-110],[103,-32],[42,-31],[57,-58],[69,-21],[219,-36],[175,122],[148,103],[167,117],[115,80],[195,136],[128,86],[169,114],[166,111]],[[114112,72403],[80,39],[34,5]],[[116396,71944],[95,98],[-29,88],[-70,-16],[-64,-21],[-38,138],[49,17],[-46,179],[-46,185],[-45,178],[-47,182]],[[113685,69658],[138,-27],[113,-22],[166,-32],[171,-34],[100,-19],[35,8],[138,128],[125,115],[75,141],[72,137],[33,28],[111,26],[176,40],[175,40],[13,14],[41,110],[52,139],[10,14],[13,15],[125,78],[76,47],[-108,139],[-102,132],[-114,148],[-97,114],[-145,172],[-94,113],[166,53],[179,57],[181,58],[219,70],[170,55],[255,82],[124,40],[23,10],[96,97]],[[121168,69446],[-113,-27],[-263,27],[-291,29],[-290,30],[-216,21],[-16,8],[-214,192],[-168,152],[-211,189],[-215,194],[-218,196],[-159,143],[-192,183],[-176,168],[-138,131],[-177,116],[-139,90],[-202,131],[-162,105],[-138,90],[-213,139],[-71,38],[-220,46],[-209,39],[-217,41],[-144,27]],[[130896,66235],[18,69],[16,246],[20,89],[-6,49],[4,14],[45,43],[11,19],[17,125],[18,140],[21,50],[18,14],[142,62],[24,42],[73,-10],[7,10],[6,48],[34,53],[47,42],[35,15],[127,27],[75,38],[22,4],[198,-10],[42,15],[7,13],[12,142],[35,22],[6,12],[-12,98],[7,66],[41,38],[-3,22],[-29,47],[-39,30],[-19,7],[-162,-28],[-67,9],[-32,17],[-6,13],[6,28],[1,47],[24,72],[7,43],[-19,251],[-28,166],[15,165],[-3,34],[-6,8],[-20,0],[-99,-15],[-84,106],[-53,42],[-143,53],[-63,10],[-93,46],[-85,100],[-87,102],[-35,65],[-39,112],[-111,213],[1,55],[-13,34],[-108,140],[-76,100],[-123,161]],[[130415,70075],[168,222],[147,194],[148,195],[145,192],[17,67],[2,131],[-38,175],[-61,81],[-203,32],[-152,24],[-166,27],[-22,10],[-19,136],[9,61],[-11,118],[1,90],[24,149],[2,68],[-77,289],[-43,160],[-44,165],[-9,53],[-1,65],[102,153],[31,34],[60,76],[37,40],[-6,28],[-65,16],[-98,2],[-52,23],[-41,41],[-16,61],[27,107],[-27,208],[54,103],[47,73],[160,10],[-56,81],[-26,47],[-17,14],[-7,22],[9,21],[40,9],[28,27],[45,38],[24,16],[4,47],[21,33],[32,40],[26,47],[-7,54],[24,66],[11,41],[17,35],[-15,52],[-13,44],[-4,51],[25,14],[32,19],[7,41],[17,52],[13,41],[21,33],[2,32],[-13,55]],[[138742,75872],[24,0],[90,-29],[61,-25],[24,2],[100,59],[153,72],[71,32]],[[130415,70075],[246,-90],[192,-69],[310,-112],[241,-86],[66,-14],[705,74],[261,-56],[82,-32],[13,18],[35,38],[60,39],[83,31],[82,16],[118,3],[80,-3],[59,-9],[114,5],[55,15],[188,61],[126,41],[191,64],[139,47],[35,25],[36,45],[17,40],[-43,61],[-5,55],[28,69],[15,105],[-3,150],[-9,87],[39,161],[32,90],[65,43],[45,26],[19,20],[18,21],[69,123],[63,57],[62,34],[67,-4],[57,-47],[110,-21],[107,14],[93,35],[42,29],[50,26],[-3,29],[-56,25],[-32,36],[-13,44],[32,26],[73,8],[179,107],[73,71],[20,32],[34,4],[69,-33],[79,-11],[50,33],[50,7],[49,-35],[26,-43],[44,-51],[56,-10],[68,28],[71,58],[67,82],[59,82],[-14,258],[-10,151],[31,80],[45,50],[30,76],[-1,67],[32,57],[31,154],[43,36],[88,26],[139,14],[110,71],[111,75],[15,66],[-42,70],[-55,137],[-50,82],[-122,147],[14,90],[68,37],[167,-63],[47,-12],[58,-9],[154,2],[125,24],[132,56],[25,58],[-1,69],[2,58],[2,79],[-47,51],[-28,45],[-9,37],[33,20],[32,37],[30,67],[73,81],[44,73],[42,34],[62,48],[40,69],[19,42],[36,40],[12,27],[-10,24],[-18,29],[-20,34],[0,33],[17,34],[18,31],[-8,44],[-10,71],[-34,42],[-23,96],[-37,98],[-19,39],[-35,48],[-80,51],[-22,34],[31,66],[51,41],[98,100],[53,70],[48,49],[62,-9],[36,5],[32,44],[64,40],[113,82],[40,56],[60,27],[50,7],[67,19],[65,30],[59,23],[92,4],[147,14],[80,14],[190,11],[207,5]],[[136943,80293],[-56,-34],[-62,-11],[-32,-21],[-34,-51],[-32,-43],[-18,-16],[-29,3],[-33,34],[-47,-2],[-56,-41],[-67,-68],[-84,-103],[-88,-55],[-111,-47],[-80,-21],[-64,-35],[-106,-72],[-21,-43],[-77,-25],[-62,-28],[-57,-48],[-14,-85],[-36,-49],[-88,-67],[-74,-68],[-48,-66],[-51,-70],[-16,-39],[-2,-53],[24,-44],[5,-42],[-18,-31],[-50,-12],[-52,9],[-80,30],[-85,54],[-31,27],[-41,46],[6,42],[21,82],[15,57],[-35,26],[-25,29],[-19,28],[-36,55],[-45,-13],[-39,-14],[-45,19],[-134,-8],[-101,-6],[-95,-6],[-120,-8],[-145,-9],[-42,12],[-26,19],[-26,75],[-15,64],[-29,121],[-18,92],[-23,111],[-15,122],[-10,87],[-110,3],[-88,3],[-118,3],[1,69],[1,87],[2,99],[22,130],[8,110],[10,133],[7,88],[7,97],[-61,-30],[-67,-33],[-64,-31],[-43,78],[-42,77],[-65,115],[-48,87],[-84,51],[-62,38],[-64,63],[-56,65],[-52,63],[-64,54],[-60,-17],[-68,-34],[-66,-33],[-70,-34],[-34,-17],[-81,6],[-71,6],[-126,10],[-107,8],[-109,9],[-151,12],[-154,12],[-103,-16],[-130,-20],[-137,-22],[-113,-17],[-143,-22],[-107,-17],[-53,2],[-66,70],[-107,113],[-64,68],[-63,67],[-91,96],[-73,73],[-72,71],[-41,66],[-21,82],[-37,38],[-83,50],[-89,54],[-89,55],[-90,54],[-89,54],[-89,54],[-90,55],[-89,54],[-89,54],[-89,54],[-89,55],[-90,54],[-89,54],[-89,54],[-90,55],[-89,54],[-89,54],[-74,40],[-68,-11],[-102,-27],[-107,-29],[-106,-29],[-191,-51],[-122,-33],[-96,-28],[-101,-30],[-134,-38],[-112,-33],[-131,-38],[-116,-34],[-98,-28],[-102,-30],[-80,-24],[0,-189],[0,-189],[0,-189],[0,-190],[0,-189],[0,-189],[0,-190],[0,-189],[0,-189],[1,-190],[0,-189],[0,-189],[0,-189],[0,-190],[0,-189],[0,-189]],[[99894,56753],[-65,355],[-37,203],[43,61],[83,145],[106,276],[240,428],[123,219],[244,327],[301,402],[169,226],[28,413],[29,436],[22,329],[27,391],[23,327],[16,237],[24,338],[20,64],[118,265],[9,35],[-22,44],[-168,225],[-53,50],[-30,117],[43,66],[-202,377],[-51,46],[-22,46],[-2,68],[-4,261],[-54,409],[-71,477]],[[98836,64846],[336,-96],[320,-91],[322,-92],[75,-50],[171,-179],[218,-230],[10,-3],[10,-1],[210,135],[273,177]],[[91244,57748],[7,43],[37,14],[95,-1],[185,-20],[147,23],[9,4],[104,114],[115,121],[174,12],[188,12],[147,6],[215,10],[174,7],[201,10],[6,55],[13,14],[19,2],[148,-30],[139,-29],[11,105],[122,131],[69,26],[17,23],[22,44],[14,68],[6,49],[25,40],[19,74],[25,130],[69,136],[39,185],[6,178],[8,136],[20,28],[0,241],[-1,242],[0,205],[-1,254],[-1,224],[0,242],[-1,218],[0,144]],[[91059,54618],[-149,42],[-9,-39],[-21,-26],[-32,-2],[-23,7],[-15,-31],[-24,-40],[-35,-20],[-34,-25],[-19,-21],[-14,-1],[-34,52],[-45,5],[-85,-9],[-38,14],[-52,7],[-123,-11],[-197,21],[-32,-11],[-8,-9],[-195,-3],[-214,-2],[-179,-3],[-157,-2],[0,9],[-50,1],[-6,-17],[-44,-206],[-5,-112],[23,-69],[27,-44],[30,-18],[3,-26],[-24,-32],[2,-33],[28,-34],[7,-36],[-14,-37],[3,-91],[21,-143],[1,-92],[-20,-43],[9,-72],[39,-102],[6,-44]],[[82515,52914],[37,17],[37,-8],[31,-10],[34,18],[32,28],[19,35],[25,96],[83,33],[49,58],[46,92],[21,64],[19,32],[12,27],[9,31],[20,28],[22,67],[15,62],[47,30],[97,26],[88,-45],[142,39],[7,58],[130,1],[154,1],[128,1],[44,-15],[16,-44],[42,-67],[44,-47],[55,-103],[63,-120],[69,-108],[44,-59],[5,-20],[-3,-23],[-22,-55],[-18,-60],[1,-22],[13,-11],[72,-19],[7,-66],[0,-92],[35,-86],[33,-62],[-2,-23],[-81,-107],[-32,-107],[-16,-30],[-6,-24],[16,-11],[22,7],[32,-9],[30,-3],[39,38],[66,98],[22,12],[50,-8]],[[94844,86304],[22,-27],[50,-13],[18,-10],[20,-19],[33,-7],[41,7],[29,25],[40,12],[39,-4],[23,-14],[43,-20]],[[127338,66944],[23,5],[33,-17],[3,-84],[-12,-80],[-1,-85],[-5,-45],[25,-38],[43,-16],[18,2],[13,19]],[[110816,44571],[-26,1],[-37,3],[-34,-10],[-25,-32],[-27,-54],[-47,-62],[-36,-55],[-32,-39],[-72,-65],[-39,-19],[-19,3],[-12,12],[-22,82],[-14,14],[-140,-43],[-21,0]],[[110816,44571],[-21,-13],[-5,-40],[25,-63],[80,-132],[51,-24],[33,-51],[33,-86],[9,-108],[-13,-129],[8,-96],[29,-63],[8,-82],[-14,-101],[-17,-60],[-20,-20],[-23,-8],[-31,7],[-37,-8],[-41,-19],[-26,-3]],[[113009,44625],[-71,0],[-115,0],[-115,0],[-115,0],[-114,0],[-115,0],[-115,0],[-115,0],[-115,0],[-115,0],[-115,0],[-114,0],[-115,0],[-115,0],[-115,0],[-115,0],[-115,0],[-68,0],[-13,2],[-10,4],[-43,-11],[-45,-36],[-48,-15],[-50,6],[-7,-4]],[[113453,35579],[-24,-9],[-8,-30],[25,-39],[27,-1],[13,44],[-12,24],[-21,11]],[[147524,85931],[60,-7],[39,12],[25,25],[40,8],[59,13],[61,15],[36,-3]],[[120504,78987],[-16,-14],[0,-34],[23,-6],[24,13],[7,28],[-19,12],[-19,1]],[[120175,79334],[-22,-6],[-1,-22],[6,-21],[22,-9],[14,9],[3,22],[-5,20],[-17,7]],[[99142,81722],[-29,-39],[19,-33],[38,6],[19,42],[-7,31],[-40,-7]],[[136701,79283],[-15,-8],[13,-27],[34,-39],[20,2],[-2,20],[-20,33],[-30,19]],[[15425,72281],[185,17],[185,18],[185,18],[185,17],[185,18],[185,18],[184,17],[185,18],[74,9],[-41,-124],[-31,-47],[307,-122],[306,-122],[307,-122],[306,-122],[306,-122],[307,-122],[306,-122],[307,-122],[228,0],[228,1],[229,0],[228,1],[228,0],[147,1],[82,0],[228,0],[229,1],[0,93],[0,92],[1,93],[0,93],[142,-1],[142,-1],[142,-1],[142,-1],[142,-1],[142,-1],[142,-1],[142,-1],[6,-1],[6,-3],[57,-71],[59,-111],[70,-77],[80,-44],[136,-129],[193,-215],[154,-143],[115,-71],[77,-62],[40,-51],[52,-112],[100,-259],[0,-118],[39,-113],[76,-145],[67,-86],[57,-26],[62,-51],[68,-78],[78,-52],[89,-26],[122,-70],[155,-112],[107,-57],[58,-3],[50,36],[44,75],[43,48],[41,21],[17,35],[-7,47],[28,106],[64,165],[77,89],[90,14],[59,31],[27,48],[48,5],[68,-38],[112,-24],[154,-11],[91,4],[27,18],[15,-1],[1,-20],[23,-9],[44,3],[39,-28],[50,-89],[171,-144],[0,0],[14,-49],[60,-71],[109,-109],[62,-94],[15,-79],[56,-125],[97,-170],[44,-92],[-11,-14],[8,-48],[26,-83],[48,-70],[71,-57],[71,-103],[72,-149],[88,-114],[102,-77],[59,-72],[13,-67],[-1,-57],[-15,-48],[6,-45],[29,-43],[10,-52],[-12,-73],[1,-21],[0,0],[9,-16],[91,-126],[47,-101],[37,-162],[0,-1],[41,-97],[60,-39],[92,-15],[70,-33],[47,-53],[61,-32],[72,-11],[70,-35],[67,-59],[124,-38],[182,-19],[138,-47],[95,-77],[42,-16],[11,-1],[5,12],[8,22],[36,25],[88,16]],[[31509,57446],[17,22],[14,48],[18,51],[-11,58],[-7,47],[20,68],[-2,51],[10,32],[29,20],[16,40],[-84,134],[0,31],[11,38],[68,144],[81,171],[89,189],[53,114],[196,0],[129,0],[164,0],[179,1],[117,0],[48,1],[-8,74],[6,82],[22,74],[0,32],[-35,41],[-68,23],[-38,35],[0,45],[-16,54],[-33,64],[-68,65],[-103,67],[-88,89],[-73,112],[-61,72],[-47,31],[-12,16],[139,-2],[131,-1],[0,161],[1,143],[1,161],[237,0],[283,-1],[294,0],[231,0],[136,0]],[[33495,60143],[-1,72],[19,56],[54,24],[69,-49],[29,-21],[26,12],[33,30],[41,87],[102,181],[40,128],[40,26],[58,4],[49,-8],[31,-49],[135,3],[-2,-182],[140,-12]],[[55815,24359],[4,118],[88,176],[24,81],[-11,46],[26,164],[65,279],[21,184],[-24,86],[0,60],[33,52],[16,15],[-83,63],[-45,57],[-58,41],[-62,33],[-30,-14],[-32,-19],[-62,-30],[-70,-52],[-37,-19],[-64,-19],[-73,-16],[-59,10],[-52,11],[-32,33],[-17,71],[0,60],[-10,87],[-39,49],[-13,39],[-2,46],[4,52],[11,38],[-6,46],[-17,33],[4,57],[-9,79],[-25,50],[-13,57],[0,57],[-19,57],[-3,63],[18,57],[6,58],[-19,41],[-37,24],[-27,66],[-5,84],[-30,46],[-32,39],[-36,0],[-55,21],[-50,-2],[-79,2],[-36,14],[-19,30],[-49,41],[-28,71],[-34,14],[-50,-22],[-17,-28],[-19,-38],[-34,-43],[-45,2],[-47,-24],[-45,-3],[-60,-5],[-59,21],[-73,25],[-62,16],[-60,-16],[-41,14],[-53,8],[-60,5],[-47,44],[-51,24],[-28,-8],[-36,-27],[-39,5],[-49,22],[-19,52],[4,33],[11,33],[19,46],[-11,49],[5,44],[8,38],[9,43],[-7,41],[-2,44],[-4,41],[-6,44],[25,62],[22,52],[-13,44],[4,30],[17,49],[22,60],[-3,112],[-19,65],[-21,18],[-5,20],[10,26],[-11,26],[-4,27],[11,24],[-15,47],[-31,14],[-11,14],[-10,51],[-9,60],[4,47],[-15,41],[-21,24],[-21,44],[-22,33],[-8,46],[-15,60]],[[50624,27116],[16,-23],[0,-24],[54,-49],[110,-74],[102,-143],[95,-212],[90,-156],[83,-101],[77,-72],[70,-42],[38,-34],[5,-26],[65,-54],[127,-82],[80,-82],[33,-82],[125,-84],[216,-87],[157,-42],[98,4],[141,-69],[183,-143],[112,-99],[41,-55],[120,-90],[299,-185],[132,-46],[63,-42],[37,-54],[36,-17],[36,21],[76,-19],[114,-59],[89,-72],[115,-159],[36,-63],[16,-56],[-6,-50],[-35,-53],[-64,-57],[-19,-25],[-1,-23],[-17,-48],[-53,-102],[-14,-47],[-3,-35],[-34,-38],[-90,-71],[-18,-34],[-5,-37],[-11,-22],[-12,-9],[-18,-37],[-13,-61],[-2,-78],[11,-96],[-2,-31],[-20,-16],[-11,-23],[-4,-44],[-17,-33],[-30,-21],[-11,-24],[8,-27],[-22,-26],[-51,-27],[-32,-38],[-11,-50],[-29,-45],[-46,-40],[-15,-53],[24,-97],[282,33],[230,-35],[272,-94],[181,-33],[89,29],[66,-4],[43,-37],[58,-7],[72,21],[60,-16],[47,-55],[44,14],[38,81],[45,59],[50,38],[62,11],[75,-15],[60,-30],[45,-44],[48,1],[53,47],[25,57],[-2,67],[21,47],[44,29],[30,39],[15,48],[53,30],[89,11],[46,24],[4,37],[27,34],[48,31],[34,39],[17,47],[30,30],[41,12],[45,98],[50,185],[30,250],[10,354]],[[50624,27116],[-10,13],[-51,48],[-45,90],[-13,42],[-6,2],[-273,-3],[-264,-3],[-27,-19],[-38,0],[-28,18],[-27,-2],[-39,-17],[-36,-37],[-100,-241],[-50,-104],[-37,-92],[-27,-159],[-11,-26],[-32,55],[-46,145],[-21,82],[-29,94],[-53,118],[-61,35],[-38,12],[-55,23],[-96,28],[-42,6],[-276,3],[-22,3],[-108,-13],[-55,9],[-58,66],[-128,116],[-26,36],[-49,25],[-29,2],[-18,-23],[-22,-96],[-27,-87],[-27,-50],[-92,-37],[-85,-39],[-47,-9],[-25,-44],[-11,-61],[-21,-54],[-124,-83],[-27,-35],[-14,-81],[-69,-102],[-21,-39]],[[108302,85250],[14,28],[133,77],[35,-13],[70,-3],[142,3],[70,51],[43,-15],[35,23],[59,29],[9,-6],[7,-5],[91,-13],[68,-27],[46,-42],[47,-26],[48,-10],[27,-21],[6,-32],[45,-16],[85,0],[37,-21],[-13,-42],[8,-14],[31,14],[23,-12],[12,-32],[14,-15],[43,50],[46,-5],[111,-21],[60,-102],[37,-37],[32,-15],[41,16],[37,19],[21,-9],[44,-67],[11,-89],[0,-36],[-16,-60],[-23,-64],[-18,-42],[8,-33],[16,-28],[26,-9],[86,-57],[32,-39],[47,-30],[35,-1],[19,-17],[6,-19],[-4,-51],[-20,-47],[2,-31],[32,-36],[3,-42],[2,-27],[17,-20],[79,-47],[102,-44],[26,-38],[15,-49],[-5,-81],[-6,-71],[133,-96],[-15,-18],[-20,-19],[-128,-15],[-26,-8],[-56,72],[-29,9],[-27,-26],[-32,-15],[-39,8],[-41,22],[-21,16],[-17,1],[-26,-15],[-34,6],[-23,18],[-32,-61],[-20,-13],[-12,2],[-3,104],[-9,15],[-26,3],[-62,-25],[-59,-32],[-20,-28],[2,-51],[8,-61],[41,-92],[-23,-40],[-15,-65],[-64,-58],[-71,-35],[-6,-70],[-40,-48],[-68,-48],[-46,-57],[12,-40],[2,-37],[-7,-26],[-2,-19],[-18,-9],[-104,-7],[-29,-12],[-34,-28]],[[134883,76106],[5,-26],[44,-63],[80,-76],[71,-18],[93,59],[32,-7],[15,19],[9,43],[57,41],[103,38],[58,33],[21,28],[35,8],[38,-8],[27,10],[10,27],[11,12],[19,9],[17,5],[31,-8],[58,-48],[84,-89],[55,-41],[25,7],[33,27],[39,48],[10,68],[-20,90],[13,72],[47,54],[86,34],[126,13],[78,-8],[28,-28],[39,-15],[49,-4],[44,33],[41,67],[2,83],[-36,100],[10,32],[15,13],[49,36],[67,75],[65,96],[63,118],[78,72],[92,28],[112,-31],[132,-92],[49,-113],[-32,-134],[-3,-73],[27,-14],[45,4],[63,21],[42,1],[19,-19],[-1,-38],[-22,-57],[-26,-159],[-17,-137],[-16,-136],[-14,-119],[25,-92],[38,-141],[43,-92],[44,-30],[44,-10],[44,8],[91,60],[137,110],[132,68],[193,38],[65,119],[89,78],[204,116],[111,44],[63,8],[80,-21],[18,-7],[16,-6],[41,-9],[9,-36],[-11,-38],[-44,-32],[-14,-24],[17,-18],[62,-7],[128,43],[84,27],[58,11],[23,35],[36,36],[58,3],[62,-20],[51,-10],[88,10],[46,-31],[64,-59],[29,-36],[10,-9]],[[134084,76252],[197,18],[156,-30],[82,-82],[80,-21],[79,40],[49,7],[19,-25],[39,-11],[60,4],[34,-23],[4,-23]],[[130685,74826],[54,8],[21,-30],[29,-39],[78,-73],[50,-21],[64,-10],[78,10],[63,13],[30,-3],[68,-53],[80,-74],[26,-33],[11,-50],[24,-15],[51,50],[49,16],[46,-9],[50,-6],[50,18],[22,14],[88,64],[79,49],[49,31],[18,100],[22,58],[33,33],[-12,41],[-14,32],[-14,43],[14,23],[32,10],[79,0],[139,45],[116,45],[108,37],[48,6],[47,-6],[21,10],[6,35],[26,37],[60,30],[112,64],[99,95],[35,71],[24,105],[46,161],[51,177],[19,78],[22,60],[87,51],[90,36],[138,8],[162,3],[34,97],[22,82],[27,42],[39,35],[14,7],[88,-51],[134,-77],[156,-38],[79,-19],[32,3]],[[150917,63576],[-9,58],[-19,298],[-14,96],[-12,131],[-17,41],[-22,72],[-24,62],[-21,26],[-13,116],[-5,143],[1,67],[-29,139],[-28,158],[-39,-7],[-22,38],[-16,-1],[-54,-35],[-42,11],[-32,-5],[0,-72],[5,-77],[-12,-28],[-83,-91],[-23,-60],[2,-64],[10,-86],[-14,-43],[-37,-40],[-48,-21],[-43,10],[-27,35],[-26,88],[-23,49],[-23,11],[-19,-13],[-3,-56],[2,-46],[-6,-5],[-14,7],[-15,23],[-40,222],[-57,171],[-3,66],[21,84],[25,130],[68,81],[9,34],[11,28],[16,5],[87,-8],[29,13],[25,38],[38,31],[37,13],[30,4],[47,-29],[20,17],[14,53],[21,54],[13,26],[32,11],[41,3],[14,10],[10,18],[11,71],[52,158],[18,70],[3,13],[-2,78],[15,12],[86,-39],[38,1],[21,16],[6,28],[-11,34],[-61,59],[-109,79],[-100,48],[-185,-7],[-184,-16],[-53,8],[-67,22],[-165,-3],[-199,-12],[-76,6],[-37,-1],[-75,-7],[-122,23],[-84,29],[-75,31],[-89,29],[-21,0],[-13,10],[-8,25],[-3,33],[18,152],[-16,231],[15,83],[-73,190],[-25,35],[-34,2],[-21,-25],[-9,-44],[12,-49],[-26,-56],[-54,-18],[-63,19],[-52,26],[-66,56],[-51,80],[-4,87],[-23,57],[-31,27],[-22,8],[-21,-6],[-18,-31],[16,-30],[21,-43],[-7,-29],[-19,-5],[-29,13],[-44,-7],[-43,22],[-25,2],[-26,8],[-1,51],[-39,64],[-66,72],[-65,44],[-31,-6],[-15,-49],[3,-18],[23,-9],[32,-29],[7,-29],[-4,-26],[-41,-48],[-28,-45],[-64,-65],[-54,-75],[-15,-57],[-20,-51],[-8,-56],[14,-39],[26,-25],[69,-18],[71,-75],[57,-102],[33,-31],[59,-34],[113,-4],[17,-29],[16,-74],[22,-27],[58,-35],[5,-26],[-14,-30],[-26,-24],[-47,-15],[-45,-6],[-45,10],[-67,6],[-76,1],[-54,-188],[-38,-65],[-22,0],[-59,32],[-25,-5],[-68,-167],[-9,-40],[-5,-30],[36,-64],[43,-53],[52,-21],[40,16],[32,-21],[39,-54],[65,-35],[93,-17],[53,-42],[6,-36],[-4,-37],[-9,-96],[-9,-55],[-50,-146],[-35,-125],[18,-60],[13,-24],[13,-19],[40,-47],[28,-46],[-24,-119],[13,-31],[54,-21],[58,-16],[20,-19],[-50,-121],[10,-84],[21,-78],[16,-129],[2,-13],[-4,-33],[33,-100],[51,-194],[3,-73],[-3,-77]],[[92647,55262],[15,85],[-32,156],[2,27],[67,34],[83,26],[32,2],[22,13],[30,34],[50,25],[29,-9],[18,-4],[175,-206],[76,-104],[21,-54],[39,-38],[58,-24],[53,-53],[41,-75]],[[103128,48320],[7,-144],[-48,-179],[-37,-134],[-95,-222],[-85,-198],[-90,-332],[0,-242],[-9,-152],[-30,-93],[-71,-251],[-11,-215],[26,-264],[-24,-250],[-74,-236],[-32,-186],[19,-224],[-136,-186],[-171,-185],[-110,-54],[-86,-62],[-61,-71],[-20,-38],[-45,-86],[-102,-266],[-53,-116],[-69,-100],[-103,-121],[-38,-58],[-15,-83],[6,-153],[10,-467],[-17,-135],[-28,-223],[-101,-249],[-76,-138],[-77,-43],[-99,-37],[-48,-47],[-29,-69],[-56,-61],[-82,-51],[-104,-127],[-126,-201],[-86,-116],[-46,-30],[-48,-2],[-49,24],[-41,3],[-21,-11],[-13,9],[-20,19],[1,46],[-6,77],[-24,80],[29,63],[25,49],[-4,25],[-26,41],[-29,58],[-27,-4],[-58,-45],[-60,-34],[-56,-15],[-44,-36],[-24,-19],[-38,0],[-21,21],[-47,21],[-25,-7],[-14,-10],[-6,-74],[-5,-61],[-9,-58],[-17,-28],[-70,-29],[-47,-39],[-41,-27],[-25,6],[-51,53],[-50,49],[-28,42],[-16,29],[-10,13],[-32,2],[-9,-27]],[[109825,20711],[34,27],[45,40],[15,97],[13,83],[35,40],[35,27],[28,43],[36,103],[24,101],[3,41],[-13,42],[-22,46],[-23,60],[-27,10],[-52,34],[-78,69],[-67,59],[-63,87],[-26,14],[-61,59],[-26,34],[-19,40],[-17,14],[-28,-11],[-72,-18],[-154,-70],[-96,-65],[-81,-77],[-83,-29],[-61,-26],[-49,-88],[-45,-82],[-41,-74],[-23,-34],[-22,-21],[-21,-47],[-44,-79],[-40,-53],[-57,-28],[-72,-38],[-25,-21],[-3,-32],[26,-74],[25,-71],[40,-84],[30,-61],[47,-74],[28,-44],[-4,-73],[9,-26],[16,-31],[13,-7],[15,-11],[39,-21],[10,-14],[27,-25],[26,-46],[50,-62],[56,-48],[96,-20],[75,-15],[25,10],[26,38],[21,49],[6,62],[24,33],[90,158],[50,58],[30,4],[39,12],[50,4],[37,-4],[8,2],[58,20],[107,52],[48,32]],[[110076,27148],[8,1],[185,39],[155,-32],[186,-88],[174,-31],[162,26],[133,6],[101,-14],[80,-31],[59,-47]],[[104013,25018],[31,-25],[205,-183],[55,-97],[27,-61],[88,-223],[66,-199],[53,-151],[4,-69],[7,-67],[8,-33],[-5,-36],[-37,-82],[-39,-63],[-46,-85],[-4,-113],[14,-133],[28,-67],[36,-21],[84,33],[54,-11],[75,-25],[249,16],[30,-8],[93,-10],[31,11],[28,28],[33,80],[29,26],[53,14],[62,21],[51,46],[82,158],[164,140],[50,34],[32,37],[27,51],[58,176],[43,147],[15,70],[39,113],[46,72],[46,38],[23,10],[59,19],[76,18],[79,-20],[86,-44],[96,-74],[99,-91],[45,-46],[49,-21],[87,-7],[58,1],[89,-90],[45,-6],[100,-27],[124,-29],[79,3],[83,49],[61,3],[78,-4],[86,13],[63,21],[48,43],[42,46],[49,139],[28,112],[43,128],[54,175],[19,121],[19,34],[78,37],[64,25],[172,48],[35,25],[32,58],[75,97],[93,81],[48,46],[87,394],[11,49],[64,104],[39,44],[25,1],[36,28],[47,54],[55,33],[65,13],[41,36],[19,59],[33,29],[47,-1],[27,18],[7,40],[28,34],[51,28],[26,33],[2,38],[60,94],[118,148],[111,83],[104,17],[99,31],[93,45],[68,70],[44,97],[75,53],[152,16]],[[113691,35903],[144,3],[152,-7],[22,-5],[34,-13],[39,2],[43,17],[48,41],[52,65],[81,-1],[110,-68],[61,-60],[10,-50],[74,-30],[137,-8],[101,26],[62,61],[66,33],[69,3],[52,-21],[35,-45],[67,-32],[100,-20],[109,29],[119,78],[67,81],[17,85],[19,52],[23,18],[63,10],[103,3],[89,-27],[114,-84],[72,56],[124,96],[125,51],[118,0],[97,37],[76,72],[81,46],[84,20],[80,35],[110,76],[115,110],[117,112],[75,72]],[[36605,54506],[60,-65],[32,-49],[6,-33],[18,-17],[47,-4],[114,-34],[70,7],[63,35],[35,42],[11,66]],[[109290,91751],[-19,2],[-56,-10],[-88,-47],[-130,-111],[-34,-25],[-34,-84],[-8,-9],[-76,4],[-21,2],[-76,-2],[-166,22],[-64,-14],[-84,-86],[-33,-12],[-98,-12],[-17,-10]],[[109332,82933],[68,-85],[86,-45],[200,-48],[18,5],[2,9],[-14,13],[-2,16],[9,19],[28,1],[45,-17],[86,25],[127,68],[116,14],[106,-41],[55,-46],[35,-45]],[[104904,82419],[106,-30],[47,-29],[26,-37],[67,-25],[109,-12],[76,-38],[43,-64],[70,15],[96,96],[95,24],[94,-45],[51,-38],[8,-29],[-22,-12],[-52,6],[-42,-18],[-34,-42],[-5,-45],[24,-47],[33,-33],[42,-18],[23,-25],[3,-31],[11,-9]],[[127437,66319],[-12,-31],[-3,-44],[19,-4],[27,22],[3,36],[-6,18],[-28,3]],[[111852,23317],[56,5],[99,-23],[81,3],[71,2],[122,4],[70,1]],[[137453,78423],[-36,-11],[-8,-18],[24,-24],[31,-8],[17,35],[7,37],[-16,-1],[-19,-10]],[[11834,85855],[276,0],[275,0],[276,0],[275,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[68,0],[208,0],[275,0],[157,0],[119,0],[275,0],[276,0],[275,0],[276,0],[62,0],[213,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[208,0],[68,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[206,0],[70,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[276,0],[275,0],[275,0],[276,0],[275,0],[276,0],[275,0],[153,-1],[2,174],[2,137],[140,-17],[41,-25],[14,-11],[-4,-38],[11,-115],[26,-96],[58,-115],[0,-1],[5,-45],[19,-28],[36,-26],[133,-32],[232,-37],[132,-43],[31,-48],[62,-19],[92,9],[65,21],[56,45],[77,10],[66,-3],[67,-4],[36,-7],[103,-36],[68,-30],[96,-55],[53,-24],[26,-58],[30,-73],[43,0],[32,43],[82,8],[108,-30],[94,-86],[137,-77],[83,-38],[85,0],[107,38],[115,73],[82,13],[49,-7],[28,-57],[34,-22],[89,7],[185,-12],[148,16],[33,-33],[30,-52],[60,-16],[81,16],[145,-12],[34,-2],[28,-1],[118,19],[56,23],[80,38],[106,51],[185,89],[151,33],[141,-64],[111,-57],[44,-22],[114,-57],[161,-82],[185,-93],[185,-94],[161,-81],[114,-58],[44,-22],[125,-66],[125,-66],[126,-66],[125,-66],[126,-66],[125,-66],[125,-66],[126,-66],[31,-109],[31,-107],[74,-78],[67,-71],[39,4],[39,30],[25,15],[42,2],[94,26],[27,-6],[16,-13],[1,-20],[-3,-16],[-14,-32],[22,-61],[5,-68],[13,-51],[38,-65],[33,-52],[42,-10],[97,30],[60,12],[35,-5],[59,-48],[29,-29],[7,-24],[-80,-146],[126,-73],[141,-80],[168,-94],[103,-58],[135,-83],[23,-118],[20,-99],[24,-139],[26,-142],[25,-141],[27,-149],[29,-165],[26,-145],[29,-160],[38,-207],[-34,-80],[-74,-174],[-67,-157],[-6,-45],[-46,-230],[-36,-94],[-65,-55],[-64,-53],[-80,-90],[-87,-44],[-45,-26],[-24,-41],[-26,-89],[5,-137],[13,-22],[60,-96],[105,-66],[114,-64],[162,-1],[146,86],[155,91],[137,81],[164,96],[149,87],[161,31],[223,44],[105,20],[176,34],[137,63],[177,80],[204,93],[176,80],[89,44],[63,51],[15,37],[-4,22],[-16,21],[-22,16],[-20,14],[-10,17],[-1,36],[-13,21],[-11,16],[4,142],[-15,44],[-58,111],[110,50],[101,46],[81,35],[169,5],[158,-1],[216,-1],[183,0],[213,-1],[125,-1],[164,2],[80,128],[71,116],[79,109],[139,130],[41,23],[22,51],[85,48],[93,45],[36,42],[18,24],[253,227],[143,105],[118,58],[90,28],[61,-4],[35,4],[29,0],[151,0],[269,1],[269,0],[158,0],[110,0],[269,1],[269,0],[269,0],[269,1],[64,159],[59,74],[81,-25],[43,2],[33,26],[15,13],[39,23],[26,-4],[22,-35],[18,-23],[21,7],[19,33],[-1,46],[25,31],[30,5],[27,-1],[14,16],[-2,22],[-10,36],[4,43],[68,77],[84,52],[29,25],[9,53],[48,55],[24,31],[6,27],[-13,34],[2,64],[16,76],[20,83],[44,75],[73,82],[19,108],[19,113],[88,110],[100,126],[57,71],[102,130],[73,92],[36,43],[39,50],[62,-15],[62,-15],[-9,-73],[7,-36],[3,-17],[29,-31],[43,-21],[32,-7],[38,1],[104,41],[121,27],[67,25],[12,23],[31,8],[48,-7],[90,-58],[105,-89],[82,-70],[3,-121],[2,-129],[1,-135],[2,-97],[2,-132],[1,-106],[3,-138],[1,-74],[11,-21],[-7,-29],[-3,-14],[1,-12],[5,-15],[-1,-20],[-11,-18],[-5,-22],[-2,-34],[12,-22],[19,-12],[16,0],[20,-13],[27,-22],[40,-19],[41,-7],[29,5],[35,-13],[12,-31],[-7,-29],[-19,-14],[-21,-10],[-4,-22],[10,-24],[16,-20],[16,-36],[-7,-31],[-15,-26],[-7,-27],[13,-23],[34,-31],[22,-30],[33,-16],[16,11],[13,16],[13,11],[24,-7],[27,-8],[30,-11]],[[113691,35904],[-4,27],[-11,67],[-30,57],[-25,35],[-32,9],[-18,-1],[-14,27],[-17,58],[-24,50],[-33,42],[-19,38],[-7,36],[5,39],[31,97],[9,66],[-3,68],[-17,70],[-34,82],[4,24],[-12,57],[-1,39],[7,50],[-7,65],[-29,138],[0,36],[-31,67],[-96,158],[-5,21],[-150,160],[-60,35],[-21,-30],[-9,-28],[7,-51],[-4,-26],[-6,-11],[-36,1]],[[160866,63188],[-42,44],[-69,69],[-27,9],[-77,-34],[-109,-13],[-25,36],[-53,-27],[-51,83],[-60,6],[-76,63],[-27,34],[-9,48],[-22,25],[-30,-3],[-33,26],[-52,25],[-41,15],[-21,-11],[-22,-6],[-4,32],[2,98],[-4,86],[-12,39],[-28,30],[-25,14],[-11,44],[9,88],[20,59],[33,10],[44,43],[23,60],[28,56],[-101,79],[-53,28],[-59,-12],[-72,-25],[-39,-5],[-19,10],[-42,71],[-23,12],[-52,5],[-43,-1],[-25,-31],[-39,-10],[-38,-2],[-39,38],[-59,50],[-93,36],[-11,40],[-23,49],[-36,45],[-57,59],[-49,31],[-24,-19],[-32,-33],[-125,-72],[-55,-28],[-29,-20],[-25,-30],[-8,-73],[-12,-83],[-36,-41],[-34,-32],[-36,-3],[-35,1],[-33,-13],[-100,-82],[-47,6],[-39,47],[-17,34],[-45,-8],[-57,-40],[-27,-70],[-14,-67],[-13,-29],[-19,-9],[-17,-1],[-179,191],[-11,10],[-32,-39],[-30,-102],[-21,-19],[-14,8],[-74,129],[-19,13],[-17,-5],[-22,-41],[-47,-62],[-36,-38],[-1,-42],[-39,-37],[-46,-36],[-15,-4],[-30,15],[-39,48],[-29,51],[-70,51],[-80,43],[-52,33],[-30,8],[-28,-15],[-14,-20],[-20,-51],[-47,-83],[-42,-66],[-40,-42],[-31,-29]],[[95909,81531],[-1,9],[-14,8],[-13,-5],[-9,-10],[-2,-17]],[[99135,80010],[5,0],[0,-6],[-5,-1],[-2,3],[2,4]],[[164468,63778],[-14,19],[-21,-4],[-8,-20],[-2,-18]],[[164770,64016],[2,2],[21,24],[30,7],[16,11],[43,0],[26,-9],[24,-11]],[[136727,78262],[-34,4],[-27,31],[-19,28],[-4,17],[10,-1],[45,-13],[62,-9],[22,-8],[2,-17],[-57,-32]],[[137117,78361],[-7,-11],[-32,-8],[-59,1],[-34,9],[20,67],[1,13],[-2,2],[-17,9],[-26,27],[-9,41],[10,37],[19,16],[12,-3],[36,-57],[32,-17],[64,-9],[-32,-56],[24,-61]],[[185397,80994],[-24,134],[-26,90],[-15,38],[-39,52],[-60,54],[-96,-27],[-72,103],[-106,78],[-14,41],[7,72],[14,30],[167,196],[58,122],[27,129],[-11,118],[-43,160]],[[90279,71914],[32,15],[0,48],[-23,87],[14,55],[50,51],[63,57],[-30,69],[-49,47],[-70,55],[-36,23],[-64,67],[-38,77],[-27,161],[-48,91],[-35,111],[31,205],[-46,124],[-7,53],[-1,63],[15,109],[-10,153],[-54,159],[25,53],[12,28],[-4,24],[-49,51],[-22,41],[11,39],[26,57],[-2,23],[-81,69],[-136,112],[-38,48],[-19,62]],[[109840,53376],[80,54],[77,35],[149,42],[55,66],[30,60],[1,119],[55,47],[172,105],[30,23],[304,-246],[171,-195],[11,-10],[9,-3],[16,15],[21,9],[73,3],[139,9],[45,23],[278,348],[88,134],[41,79],[51,151],[304,326],[11,26],[3,21],[-46,109],[-10,56],[-2,86],[9,133],[-3,85],[-7,27],[-169,240],[429,2],[1,20],[-10,49],[-5,38],[3,41],[-1,25],[311,-1],[-4,-68],[-38,-160],[1,-96],[-9,-109],[-2,-9],[-16,-37],[-14,-38],[64,-611],[-5,-25],[-17,-39],[-4,-12],[6,-17],[142,-66],[12,-9],[52,-79],[279,-290],[10,-14],[29,-92],[4,-35],[-1,-17],[-7,-55],[3,-24],[4,-17],[4,-29],[-44,-114],[-13,-75],[-4,-63],[2,-36],[13,-37],[120,0]],[[106705,52598],[9,25],[34,59],[56,38],[150,60],[8,23],[3,76],[12,37],[52,105],[7,42],[2,89],[7,42],[15,30],[41,53],[15,31],[6,69],[-5,135],[7,29],[14,25],[95,123],[25,55],[9,49],[-1,50],[5,49],[28,48],[24,15],[70,15],[47,-9],[300,73],[32,11],[39,-12],[17,-50],[-2,-79],[6,-39],[18,-27],[53,-38],[36,-63],[19,-24],[54,-43],[246,-363],[70,-34],[67,12],[134,75],[67,20],[469,-22],[52,11]],[[109117,53369],[75,-183],[34,-42],[514,-2],[-10,52],[7,58],[60,74],[43,50]],[[54609,47053],[-26,27],[-26,25],[-41,9],[-50,17],[-37,64],[-38,92],[-13,42],[-30,40],[-29,58],[-9,50],[-22,47],[-11,15],[-17,64],[-4,23],[-8,3],[-12,21],[-24,67],[-5,17],[-10,6],[-28,48],[-22,16],[-8,25],[2,66],[-12,33],[-3,62],[-1,25],[-11,28],[-19,18],[-3,45],[-5,111],[-8,19],[-79,-1],[-8,-11],[-34,-7],[-38,-1],[-30,13]],[[55815,47370],[7,7],[24,6],[21,1],[32,60],[54,37],[94,208],[40,86],[5,47],[11,98],[-21,119],[10,34],[67,120],[1,2]],[[112999,37476],[-22,6],[-57,43],[-44,11],[-110,-8],[-39,-10],[-30,10],[-58,73],[-68,15],[-62,4],[-101,83],[-24,-3],[-11,-7]]],"transform":{"scale":[0.0015477181598286547,0.0012125970627433556],"translate":[-141.00213640665194,-55.11400074012312]},"objects":{"ne_50m_admin_0_boundary_lines_land":{"type":"GeometryCollection","geometries":[{"type":"LineString","arcs":[0]},{"type":"LineString","arcs":[1]},{"type":"LineString","arcs":[2]},{"type":"LineString","arcs":[3]},{"type":"LineString","arcs":[4]},{"type":"LineString","arcs":[5]},{"type":"LineString","arcs":[6]},{"type":"LineString","arcs":[7]},{"type":"LineString","arcs":[8]},{"type":"LineString","arcs":[9]},{"type":"LineString","arcs":[10]},{"type":"LineString","arcs":[11]},{"type":"LineString","arcs":[12]},{"type":"LineString","arcs":[13]},{"type":"LineString","arcs":[14]},{"type":"LineString","arcs":[15]},{"type":"LineString","arcs":[16]},{"type":"LineString","arcs":[17]},{"type":"LineString","arcs":[18]},{"type":"LineString","arcs":[19]},{"type":"LineString","arcs":[20]},{"type":"LineString","arcs":[21]},{"type":"LineString","arcs":[22]},{"type":"LineString","arcs":[23]},{"type":"LineString","arcs":[24]},{"type":"LineString","arcs":[25]},{"type":"LineString","arcs":[26]},{"type":"LineString","arcs":[27]},{"type":"LineString","arcs":[28]},{"type":"LineString","arcs":[29]},{"type":"LineString","arcs":[30]},{"type":"LineString","arcs":[31]},{"type":"LineString","arcs":[32]},{"type":"LineString","arcs":[33]},{"type":"LineString","arcs":[34]},{"type":"LineString","arcs":[35]},{"type":"LineString","arcs":[36]},{"type":"LineString","arcs":[37]},{"type":"LineString","arcs":[38]},{"type":"LineString","arcs":[39]},{"type":"LineString","arcs":[40]},{"type":"LineString","arcs":[41]},{"type":"LineString","arcs":[42]},{"type":"LineString","arcs":[43]},{"type":"LineString","arcs":[44]},{"type":"LineString","arcs":[45]},{"type":"LineString","arcs":[46]},{"type":"LineString","arcs":[47]},{"type":"LineString","arcs":[48]},{"type":"LineString","arcs":[49]},{"type":"LineString","arcs":[50]},{"type":"LineString","arcs":[51]},{"type":"LineString","arcs":[52]},{"type":"LineString","arcs":[53]},{"type":"LineString","arcs":[54]},{"type":"LineString","arcs":[55]},{"type":"LineString","arcs":[56]},{"type":"LineString","arcs":[57]},{"type":"LineString","arcs":[58]},{"type":"LineString","arcs":[59,60]},{"type":"LineString","arcs":[61]},{"type":"LineString","arcs":[62]},{"type":"LineString","arcs":[63]},{"type":"LineString","arcs":[64]},{"type":"LineString","arcs":[65]},{"type":"LineString","arcs":[66]},{"type":"LineString","arcs":[67]},{"type":"LineString","arcs":[68]},{"type":"LineString","arcs":[69]},{"type":"LineString","arcs":[70]},{"type":"LineString","arcs":[71]},{"type":"LineString","arcs":[72]},{"type":"LineString","arcs":[73]},{"type":"LineString","arcs":[74]},{"type":"LineString","arcs":[75]},{"type":"LineString","arcs":[76]},{"type":"LineString","arcs":[77]},{"type":"LineString","arcs":[78]},{"type":"LineString","arcs":[79]},{"type":"LineString","arcs":[80]},{"type":"LineString","arcs":[81]},{"type":"LineString","arcs":[82]},{"type":"LineString","arcs":[83]},{"type":"LineString","arcs":[84]},{"type":"LineString","arcs":[85]},{"type":"LineString","arcs":[86]},{"type":"LineString","arcs":[87]},{"type":"LineString","arcs":[88]},{"type":"LineString","arcs":[89]},{"type":"LineString","arcs":[90]},{"type":"LineString","arcs":[91]},{"type":"LineString","arcs":[92]},{"type":"LineString","arcs":[93]},{"type":"LineString","arcs":[94]},{"type":"LineString","arcs":[95]},{"type":"LineString","arcs":[96]},{"type":"LineString","arcs":[97]},{"type":"LineString","arcs":[98]},{"type":"LineString","arcs":[99]},{"type":"LineString","arcs":[100]},{"type":"LineString","arcs":[101]},{"type":"LineString","arcs":[102]},{"type":"LineString","arcs":[103]},{"type":"LineString","arcs":[104]},{"type":"LineString","arcs":[105]},{"type":"LineString","arcs":[106]},{"type":"LineString","arcs":[107]},{"type":"LineString","arcs":[108]},{"type":"LineString","arcs":[109]},{"type":"LineString","arcs":[110]},{"type":"LineString","arcs":[111]},{"type":"LineString","arcs":[112]},{"type":"LineString","arcs":[113]},{"type":"LineString","arcs":[114]},{"type":"LineString","arcs":[115]},{"type":"LineString","arcs":[116]},{"type":"LineString","arcs":[117]},{"type":"LineString","arcs":[118]},{"type":"LineString","arcs":[119]},{"type":"LineString","arcs":[120]},{"type":"LineString","arcs":[121]},{"type":"LineString","arcs":[122]},{"type":"LineString","arcs":[123]},{"type":"LineString","arcs":[124]},{"type":"LineString","arcs":[125]},{"type":"LineString","arcs":[126]},{"type":"LineString","arcs":[127]},{"type":"LineString","arcs":[128]},{"type":"LineString","arcs":[129]},{"type":"LineString","arcs":[130]},{"type":"LineString","arcs":[131]},{"type":"LineString","arcs":[132]},{"type":"LineString","arcs":[133]},{"type":"LineString","arcs":[134]},{"type":"LineString","arcs":[135]},{"type":"LineString","arcs":[136]},{"type":"LineString","arcs":[137]},{"type":"LineString","arcs":[138]},{"type":"LineString","arcs":[139]},{"type":"LineString","arcs":[140]},{"type":"LineString","arcs":[141]},{"type":"LineString","arcs":[142]},{"type":"LineString","arcs":[143]},{"type":"LineString","arcs":[144]},{"type":"LineString","arcs":[145]},{"type":"LineString","arcs":[146]},{"type":"LineString","arcs":[147]},{"type":"LineString","arcs":[148]},{"type":"LineString","arcs":[149]},{"type":"LineString","arcs":[150,151]},{"type":"LineString","arcs":[152]},{"type":"LineString","arcs":[153]},{"type":"LineString","arcs":[154]},{"type":"LineString","arcs":[155]},{"type":"LineString","arcs":[156]},{"type":"LineString","arcs":[157]},{"type":"LineString","arcs":[158]},{"type":"LineString","arcs":[159]},{"type":"LineString","arcs":[160,161]},{"type":"LineString","arcs":[162]},{"type":"LineString","arcs":[163]},{"type":"LineString","arcs":[164]},{"type":"LineString","arcs":[165,166]},{"type":"LineString","arcs":[167]},{"type":"LineString","arcs":[168]},{"type":"LineString","arcs":[169]},{"type":"LineString","arcs":[170,171,172,173,174]},{"type":"LineString","arcs":[175]},{"type":"LineString","arcs":[176]},{"type":"LineString","arcs":[177]},{"type":"LineString","arcs":[178]},{"type":"LineString","arcs":[179]},{"type":"LineString","arcs":[180]},{"type":"LineString","arcs":[181]},{"type":"LineString","arcs":[182]},{"type":"LineString","arcs":[183]},{"type":"LineString","arcs":[184,185]},{"type":"LineString","arcs":[186]},{"type":"LineString","arcs":[187]},{"type":"LineString","arcs":[188]},{"type":"LineString","arcs":[189]},{"type":"LineString","arcs":[190]},{"type":"LineString","arcs":[191]},{"type":"LineString","arcs":[192]},{"type":"LineString","arcs":[193]},{"type":"LineString","arcs":[194]},{"type":"LineString","arcs":[195]},{"type":"LineString","arcs":[196]},{"type":"LineString","arcs":[197]},{"type":"LineString","arcs":[198]},{"type":"LineString","arcs":[199]},{"type":"LineString","arcs":[200]},{"type":"LineString","arcs":[201]},{"type":"LineString","arcs":[202]},{"type":"LineString","arcs":[203]},{"type":"LineString","arcs":[204]},{"type":"LineString","arcs":[205]},{"type":"LineString","arcs":[206]},{"type":"LineString","arcs":[207]},{"type":"LineString","arcs":[208]},{"type":"LineString","arcs":[209]},{"type":"LineString","arcs":[210]},{"type":"LineString","arcs":[211]},{"type":"LineString","arcs":[212]},{"type":"LineString","arcs":[213]},{"type":"LineString","arcs":[214]},{"type":"LineString","arcs":[215]},{"type":"LineString","arcs":[216]},{"type":"LineString","arcs":[217]},{"type":"LineString","arcs":[218]},{"type":"LineString","arcs":[219]},{"type":"LineString","arcs":[220]},{"type":"LineString","arcs":[221]},{"type":"LineString","arcs":[222,223]},{"type":"LineString","arcs":[224]},{"type":"LineString","arcs":[225]},{"type":"LineString","arcs":[226]},{"type":"LineString","arcs":[227]},{"type":"LineString","arcs":[228]},{"type":"LineString","arcs":[229]},{"type":"LineString","arcs":[230]},{"type":"LineString","arcs":[231]},{"type":"LineString","arcs":[232]},{"type":"LineString","arcs":[233]},{"type":"LineString","arcs":[234]},{"type":"LineString","arcs":[235,236]},{"type":"LineString","arcs":[237]},{"type":"LineString","arcs":[238]},{"type":"LineString","arcs":[239]},{"type":"LineString","arcs":[240,241]},{"type":"LineString","arcs":[242]},{"type":"LineString","arcs":[243]},{"type":"LineString","arcs":[244]},{"type":"LineString","arcs":[245]},{"type":"LineString","arcs":[246]},{"type":"LineString","arcs":[247]},{"type":"LineString","arcs":[248]},{"type":"LineString","arcs":[249]},{"type":"LineString","arcs":[250]},{"type":"LineString","arcs":[251]},{"type":"LineString","arcs":[252]},{"type":"LineString","arcs":[253]},{"type":"LineString","arcs":[254]},{"type":"LineString","arcs":[255]},{"type":"LineString","arcs":[256]},{"type":"LineString","arcs":[257]},{"type":"LineString","arcs":[258]},{"type":"LineString","arcs":[259]},{"type":"LineString","arcs":[260]},{"type":"LineString","arcs":[261]},{"type":"LineString","arcs":[262]},{"type":"LineString","arcs":[263]},{"type":"LineString","arcs":[264]},{"type":"LineString","arcs":[265]},{"type":"LineString","arcs":[266]},{"type":"LineString","arcs":[267]},{"type":"LineString","arcs":[268]},{"type":"LineString","arcs":[269]},{"type":"LineString","arcs":[270]},{"type":"LineString","arcs":[271]},{"type":"LineString","arcs":[272]},{"type":"LineString","arcs":[273]},{"type":"LineString","arcs":[274]},{"type":"LineString","arcs":[275]},{"type":"LineString","arcs":[276]},{"type":"LineString","arcs":[277]},{"type":"LineString","arcs":[278]},{"type":"LineString","arcs":[279]},{"type":"LineString","arcs":[280]},{"type":"LineString","arcs":[281]},{"type":"LineString","arcs":[282]},{"type":"LineString","arcs":[283]},{"type":"LineString","arcs":[284]},{"type":"LineString","arcs":[285]},{"type":"LineString","arcs":[286]},{"type":"LineString","arcs":[287]},{"type":"LineString","arcs":[288]},{"type":"LineString","arcs":[289]},{"type":"LineString","arcs":[290]},{"type":"LineString","arcs":[291]},{"type":"LineString","arcs":[292]},{"type":"LineString","arcs":[293]},{"type":"LineString","arcs":[294]},{"type":"LineString","arcs":[295]},{"type":"LineString","arcs":[296]},{"type":"LineString","arcs":[297]},{"type":"LineString","arcs":[298]},{"type":"LineString","arcs":[299]},{"type":"LineString","arcs":[300]},{"type":"LineString","arcs":[301]},{"type":"LineString","arcs":[302]},{"type":"LineString","arcs":[303]},{"type":"LineString","arcs":[304]},{"type":"LineString","arcs":[305]},{"type":"LineString","arcs":[306]},{"type":"LineString","arcs":[307]},{"type":"LineString","arcs":[308]},{"type":"LineString","arcs":[309]},{"type":"LineString","arcs":[310]},{"type":"LineString","arcs":[311]},{"type":"LineString","arcs":[312]},{"type":"LineString","arcs":[313]},{"type":"LineString","arcs":[314]},{"type":"LineString","arcs":[315]},{"type":"LineString","arcs":[316]},{"type":"LineString","arcs":[317]},{"type":"LineString","arcs":[318]},{"type":"LineString","arcs":[319]},{"type":"LineString","arcs":[320]},{"type":"LineString","arcs":[321]},{"type":"LineString","arcs":[322]},{"type":"LineString","arcs":[323]},{"type":"LineString","arcs":[324]},{"type":"LineString","arcs":[325]},{"type":"LineString","arcs":[326]},{"type":"LineString","arcs":[327]},{"type":"LineString","arcs":[328]},{"type":"LineString","arcs":[329]},{"type":"LineString","arcs":[330]},{"type":"LineString","arcs":[331]},{"type":"LineString","arcs":[332]},{"type":"LineString","arcs":[333,334]},{"type":"LineString","arcs":[335]},{"type":"LineString","arcs":[336]},{"type":"LineString","arcs":[337]},{"type":"LineString","arcs":[338]},{"type":"LineString","arcs":[339]},{"type":"LineString","arcs":[340]},{"type":"LineString","arcs":[341]},{"type":"LineString","arcs":[342]},{"type":"LineString","arcs":[343]},{"type":"LineString","arcs":[344]},{"type":"LineString","arcs":[345]},{"type":"LineString","arcs":[346]},{"type":"LineString","arcs":[347]},{"type":"LineString","arcs":[348]},{"type":"LineString","arcs":[349]},{"type":"LineString","arcs":[350]},{"type":"LineString","arcs":[351]},{"type":"LineString","arcs":[352]},{"type":"LineString","arcs":[353]},{"type":"LineString","arcs":[354]},{"type":"LineString","arcs":[355]},{"type":"LineString","arcs":[356]},{"type":"LineString","arcs":[357]},{"type":"LineString","arcs":[358]},{"type":"LineString","arcs":[359]},{"type":"LineString","arcs":[360]},{"type":"LineString","arcs":[361]},{"type":"LineString","arcs":[362]},{"type":"LineString","arcs":[363]},{"type":"LineString","arcs":[364]},{"type":"LineString","arcs":[365]},{"type":"LineString","arcs":[366]},{"type":"LineString","arcs":[367]},{"type":"LineString","arcs":[368]},{"type":"LineString","arcs":[369]},{"type":"LineString","arcs":[370]},{"type":"LineString","arcs":[371]},{"type":"LineString","arcs":[372]}]}}};

/***/ },
/* 96 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"Navigation": {
			"live": "Live",
			"stories": "Stories",
			"ambassadors": "Kennenlernen"
		},
		"Search": {
			"placeholder": "Ort finden",
			"errorEmpty": "Bitte geben Sie einen Ort ein.",
			"errorNotFound": "Dieser Ort wurde leider nicht gefunden."
		},
		"IndieButton": {
			"line1": "Jetzt Strom",
			"line2": "für 0 EUR",
			"line3": "sichern!"
		},
		"InfoBox": {
			"sonnenBatterie": "sonnenBatterie",
			"ambassadorSince": "Kunde seit",
			"capacity": "Kapazität",
			"autonomy": "Autarkie",
			"pvSize": "PV-Größe",
			"cta": "Mitmachen",
			"ctaAmbassador": "Termin vereinbaren",
			"disclaimer": "Bei diesem Kunden können Sie sich vor Ort von der Alltagstauglichkeit einer sonnenBatterie überzeugen."
		},
		"MasterForm": {
			"title": "Jetzt unverbindlich informieren",
			"personalInformation": "Persönliche Daten",
			"salutation": "Anrede",
			"male": "Herr",
			"female": "Frau",
			"firstname": "Vorname",
			"lastname": "Nachname",
			"email": "E-Mail",
			"phone": "Telefon",
			"energyConsumption": "Stromverbrauch pro Jahr",
			"ecPlaceholder": "in kWh",
			"subject": "Ich möchte ...",
			"sonnenBatterie": "Informationen zur sonnenBatterie",
			"sonnenCommunity": "Informationen zur sonnenCommunity",
			"pvAnlage": "Informationen zu einer PV-Anlage",
			"sonnenBotschafter": "Einen sonnenBotschafter besuchen",
			"submit": "Absenden",
			"legalNotice": "Die angegebenen Daten werden elektronisch verarbeitet und bei der sonnen GmbH verarbeitet. Die Daten werden für die Kontaktaufnahme sowie für die Zusendung von Informationsmaterial zu Produkten und Services verwendet. Mit der Absendung dieses Formulars erklären Sie sich hiermit ausdrücklich einverstanden. Die mit Sternchen gekennzeichneten Felder sind Pflichtfelder.",
			"requiredFields": "Die mit Sternchen gekennzeichneten Felder sind Pflichtfelder.",
			"gdprHeadline": "Einwilligung",
			"gdprCheckbox": "Ja, ich möchte per E-Mail, telefonisch oder durch Brief regelmäßig auf meine Bedürfnisse zugeschnittene Informationen zu neuen Produkten und Dienstleitungen der sonnen GmbH und der sonnen eServices GmbH (gemeinsam „sonnen”) erhalten. Mir ist bekannt, dass sonnen meine Daten zu diesem Zweck auch an regionale Partner von sonnen weiterleitet, die dann unmittelbar mit mir Kontakt aufnehmen werden. Ich kann diese Einwilligung jederzeit für die Zukunft widerrufen, indem ich die Übermittlung von Informationen über die Website von sonnen abbestelle, oder den Widerruf per E-Mail, per Fax oder postalisch an die im Impressum angegebenen Kontaktdaten sende.",
			"successMessage": "Danke für ihr Interesse. Wir haben Ihnen soeben eine E-Mail zugesandt. Um Ihre Anfrage abzuschließen, klicken Sie bitte auf den Bestätigungslink in der E-Mail.",
			"errorMessage": "Leider konnte ihre Anfrage im Moment nicht verarbeitet werden. Bitte versuchen Sie es später noch einmal."
		},
		"Footer": {
			"imprint": "Impressum",
			"privacy": "Datenschutz"
		}
	};

/***/ },
/* 97 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"Navigation": {
			"live": "Live",
			"stories": "Stories",
			"ambassadors": "Get-to-know"
		},
		"Search": {
			"placeholder": "Find city",
			"errorEmpty": "Please enter a city.",
			"errorNotFound": "The city you were looking for was not found."
		},
		"IndieButton": {
			"line1": "Get",
			"line2": "independent!",
			"line3": ""
		},
		"InfoBox": {
			"sonnenBatterie": "sonnenBatterie",
			"ambassadorSince": "Customer since",
			"capacity": "Capacity",
			"autonomy": "Autonomy",
			"pvSize": "PV size",
			"cta": "Join",
			"ctaAmbassador": "Request an Appointment",
			"disclaimer": "At this customers home you can convince yourself that the sonnenBatterie is suitable for daily use."
		},
		"MasterForm": {
			"title": "Inquire about sonnen products",
			"personalInformation": "Personal information",
			"salutation": "Title",
			"male": "Mr.",
			"female": "Mrs.",
			"firstname": "First Name",
			"lastname": "Last Name",
			"email": "Email",
			"phone": "Phone",
			"energyConsumption": "Energy consumption per year",
			"ecPlaceholder": "kWh",
			"subject": "I'd like…",
			"sonnenBatterie": "to have a sonnenBatterie",
			"sonnenCommunity": "to learn about sonnenCommunity",
			"pvAnlage": "to have information about a PV system",
			"sonnenBotschafter": "to visit a sonnenAmbassador",
			"submit": "Submit",
			"legalNotice": "The data provided will be used exclusively to establish contact with you and to provide you with information about sonnenBatterie. By clicking the submit button you agree to these terms. Fields marked with * are required.",
			"requiredFields": "Fields marked with * are required.",
			"gdprHeadline": "Consent",
			"gdprCheckbox": "I agree to be contacted by e-mail, telephone or post in order to receive relevant information about new products and services from sonnen GmbH and sonnen eServices GmbH (jointly „sonnen”). I am aware that sonnen will forward my contact details to regional partners who will subsequently get in touch for this purpose. My consent can be revoked at any point in time by unsubscribing from the service or by sending an e-mail, fax or letter to the address provided in the contact form on the sonnen website.",
			"successMessage": "Thank you for your interest. Your submission has been received. To complete your request successfully, please click the confirmation link in the e-mail you received.",
			"errorMessage": "Unfortunately your request could not be processed at the moment. Please try again later."
		},
		"Footer": {
			"imprint": "Imprint",
			"privacy": "Privacy Policy"
		}
	};

/***/ },
/* 98 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"Navigation": {
			"live": "",
			"stories": ""
		},
		"Search": {
			"placeholder": "",
			"errorEmpty": "",
			"errorNotFound": ""
		},
		"IndieButton": {
			"line1": "",
			"line2": "",
			"line3": ""
		},
		"InfoBox": {
			"sonnenBatterie": "sonnenBatterie",
			"ambassadorSince": "",
			"capacity": "",
			"autonomy": "",
			"pvSize": "",
			"cta": "",
			"ctaAmbassador": "",
			"disclaimer": ""
		},
		"MasterForm": {
			"title": "",
			"personalInformation": "",
			"salutation": "",
			"male": "",
			"female": "",
			"firstname": "",
			"lastname": "",
			"email": "",
			"phone": "",
			"subject": "",
			"sonnenBatterie": "",
			"sonnenCommunity": "",
			"sonnenBotschafter": "",
			"submit": "",
			"successMessage": "",
			"errorMessage": ""
		}
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ambilight = function (_React$Component) {
	  _inherits(Ambilight, _React$Component);
	
	  function Ambilight(props) {
	    _classCallCheck(this, Ambilight);
	
	    return _possibleConstructorReturn(this, (Ambilight.__proto__ || Object.getPrototypeOf(Ambilight)).call(this, props));
	  }
	
	  _createClass(Ambilight, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "Ambilight" },
	        _react2.default.createElement(
	          "div",
	          { className: "Ambilight-Left" },
	          " "
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "Ambilight-Right" },
	          " "
	        )
	      );
	    }
	  }]);
	
	  return Ambilight;
	}(_react2.default.Component);
	
	exports.default = Ambilight;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactRedux = __webpack_require__(18);
	
	var _union = __webpack_require__(220);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _helpers = __webpack_require__(6);
	
	var _selectors = __webpack_require__(35);
	
	__webpack_require__(119);
	
	var _Cesium = __webpack_require__(29);
	
	var _Cesium2 = _interopRequireDefault(_Cesium);
	
	__webpack_require__(113);
	
	var _icon = __webpack_require__(267);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _iconSw = __webpack_require__(265);
	
	var _iconSw2 = _interopRequireDefault(_iconSw);
	
	var _iconEpark = __webpack_require__(264);
	
	var _iconEpark2 = _interopRequireDefault(_iconEpark);
	
	var _iconVideoPlay = __webpack_require__(266);
	
	var _iconVideoPlay2 = _interopRequireDefault(_iconVideoPlay);
	
	var _ne_50m_admin_0_boundary_lines_land = __webpack_require__(95);
	
	var _ne_50m_admin_0_boundary_lines_land2 = _interopRequireDefault(_ne_50m_admin_0_boundary_lines_land);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Set this global variable so that Cesium generates requests for its
	// own assets properly, with this as a prefix.
	// Note that this corresponds to the static file handling in our dev server,
	// and that the production output should include the Cesium build output
	// in a folder by this name as well.
	window.CESIUM_BASE_URL = '/cesium/';
	// import boundaryLinesLand110m from '../data/ne_110m_admin_0_boundary_lines_land.json'
	
	var CesiumWidgetClass = function (_Component) {
	  _inherits(CesiumWidgetClass, _Component);
	
	  function CesiumWidgetClass(props) {
	    _classCallCheck(this, CesiumWidgetClass);
	
	    var _this = _possibleConstructorReturn(this, (CesiumWidgetClass.__proto__ || Object.getPrototypeOf(CesiumWidgetClass)).call(this, props));
	
	    _this.getImageryProvider = _this.getImageryProvider.bind(_this);
	
	    // this.drawBatteries = this.drawBatteries.bind(this)
	    _this.drawBatteriesPending = _this.drawBatteriesPending.bind(_this);
	    _this.updateBatteriesNet = _this.updateBatteriesNet.bind(_this);
	    _this.drawBatteriesNet = _this.drawBatteriesNet.bind(_this);
	    _this.drawBatteriesNetActive = _this.drawBatteriesNetActive.bind(_this);
	    _this.shouldUpdateBatteriesNet = _this.shouldUpdateBatteriesNet.bind(_this);
	    _this.shouldRemoveBatteriesNet = _this.shouldRemoveBatteriesNet.bind(_this);
	    _this.drawVideos = _this.drawVideos.bind(_this);
	    _this.drawAmbassadors = _this.drawAmbassadors.bind(_this);
	    _this.drawAwards = _this.drawAwards.bind(_this);
	    _this.removeBatteriesNet = _this.removeBatteriesNet.bind(_this);
	
	    _this.setRenderNextFrame = _this.setRenderNextFrame.bind(_this);
	    _this.animateFrame = _this.animateFrame.bind(_this);
	    _this.cameraFlyToBounds = _this.cameraFlyToBounds.bind(_this);
	    _this.cameraFlyToCenterHeight = _this.cameraFlyToCenterHeight.bind(_this);
	    _this.handleCameraFlyTo = _this.handleCameraFlyTo.bind(_this);
	    _this.loadObject = _this.loadObject.bind(_this);
	
	    _this.handlePreRender = _this.handlePreRender.bind(_this);
	
	    _this.handleTimeoutInit = _this.handleTimeoutInit.bind(_this);
	    _this.handleTimeoutStart = _this.handleTimeoutStart.bind(_this);
	
	    _this.handleCanvasClick = _this.handleCanvasClick.bind(_this);
	    _this.handleCanvasLeftDown = _this.handleCanvasLeftDown.bind(_this);
	    _this.handleCanvasLeftUp = _this.handleCanvasLeftUp.bind(_this);
	    _this.handleCanvasMouseMove = _this.handleCanvasMouseMove.bind(_this);
	    _this.handleCanvasPinchMove = _this.handleCanvasPinchMove.bind(_this);
	    _this.handleCanvasWheel = _this.handleCanvasWheel.bind(_this);
	
	    _this.unselectAll = _this.unselectAll.bind(_this);
	
	    // helpers
	    _this.propagateViewport = _this.propagateViewport.bind(_this);
	    _this.getViewMagnitude = _this.getViewMagnitude.bind(_this);
	    _this.getViewHeight = _this.getViewHeight.bind(_this);
	    _this.getViewCenter = _this.getViewCenter.bind(_this);
	    _this.getViewBounds = _this.getViewBounds.bind(_this);
	
	    _this.state = {
	      // isInializing: true,
	      targetFrameRate: 24,
	      renderNextFrame: 0,
	
	      cameraIsFlying: false,
	      isMouseLeftDown: false,
	      isZoomingIn: 0,
	      isZoomingOut: 0,
	      isDragging: 0,
	
	      height: 0,
	      magnitude: 0,
	      pixelSize: 1,
	      bounds: null,
	      center: null,
	
	      pickedObject: null,
	      // selectedObject: null,
	      // selectedPosition: null,
	      // selectedMagnitude: null,
	
	      heightThreshold: 1.0e5
	    };
	    return _this;
	  }
	
	  _createClass(CesiumWidgetClass, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      this.batteriesNetPositions = {};
	      this.batteriesNetLinks = {};
	      // this.batteryIds = {}
	      this.batteriesAll = {};
	      this.batteriesByTiles = {};
	      this.batteryIdsPending = [];
	      this.batteryIdsAdded = [];
	      this.videoIds = [];
	      this.ambassadorIds = [];
	      this.awardIds = [];
	      // this.netPositions = []
	      // this.batteriesNetParticles = []
	
	      // console.log(Cesium.VERSION)
	
	      // Cesium.Camera.DEFAULT_VIEW_RECTANGLE = Cesium.Rectangle.fromDegrees(-10,25,20,55)
	      // Cesium.Camera.DEFAULT_VIEW_RECTANGLE = Cesium.Rectangle.fromDegrees(0,25,30,55) 
	      _Cesium2.default.Camera.DEFAULT_VIEW_RECTANGLE = _Cesium2.default.Rectangle.fromDegrees(-118, 14, -86, 33); // start intro fly from middle-america
	      _Cesium2.default.Camera.DEFAULT_VIEW_FACTOR = 8;
	
	      this.viewer = new _Cesium2.default.Viewer(this.refs.cesiumNode, {
	        imageryProvider: this.getImageryProvider('basemap'),
	        animation: false,
	        baseLayerPicker: false,
	        fullscreenButton: false,
	        geocoder: false,
	        homeButton: false,
	        infoBox: false,
	        sceneModePicker: false,
	        selectionIndicator: true,
	        timeline: false,
	        navigationHelpButton: false,
	        navigationInstructionsInitiallyVisible: false,
	        automaticallyTrackDataSourceClocks: false,
	        // orderIndependentTranslucency: false,
	        useDefaultRenderLoop: false,
	        terrainShadows: 0,
	        targetFrameRate: this.state.targetFrameRate,
	
	        contextOptions: { // Scene
	          contextOptions: { // WebGL creation properties
	            webgl: {
	              alpha: false,
	              depth: true,
	              stencil: false,
	              antialias: false,
	              premultipliedAlpha: true,
	              preserveDrawingBuffer: false,
	              failIfMajorPerformanceCaveat: false
	            },
	            allowTextureFilterAnisotropic: false
	          }
	        }
	      });
	      this.viewer.scene.globe.scene3DOnly = true;
	      this.viewer.scene.globe.enableLighting = false;
	      this.viewer.scene.globe.tileCacheSize = 250;
	      this.viewer.scene.globe.maximumScreenSpaceError = 1;
	      this.viewer.scene.globe.shadows = 0;
	      this.viewer.scene.globe.showWaterEffect = false;
	      this.viewer.scene.debugShowFramesPerSecond = false;
	      this.viewer.scene.fxaa = true;
	      this.viewer.scene.fxaaOrderIndependentTranslucency = false;
	      // this.viewer.scene.farToNearRatio = 1000 ?
	      this.viewer.scene.primitives.destroyPrimitives = false;
	
	      // debugger
	
	      // Gets or sets a scaling factor for rendering resolution. Values less than 1.0 can improve performance on less powerful 
	      // devices while values greater than 1.0 will render at a higher resolution and then scale down, resulting in improved 
	      // visual fidelity. For example, if the widget is laid out at a size of 640x480, setting this value to 0.5 will cause 
	      // the scene to be rendered at 320x240 and then scaled up while setting it to 2.0 will cause the scene to be rendered at 
	      // 1280x960 and then scaled down.
	      // this.viewer.resolutionScale = .5
	
	      // camera
	      this.viewer.scene.screenSpaceCameraController.enableRotate = true;
	      this.viewer.scene.screenSpaceCameraController.enableTranslate = true;
	      this.viewer.scene.screenSpaceCameraController.enableZoom = true;
	      this.viewer.scene.screenSpaceCameraController.enableTilt = false;
	      this.viewer.scene.screenSpaceCameraController.enableLook = false;
	      this.viewer.scene.screenSpaceCameraController.minimumZoomDistance = 4000; // meters
	
	
	      // modify SkyAtmosphere
	      this.viewer.scene.skyAtmosphere.hueShift = -0.06;
	      this.viewer.scene.skyAtmosphere.saturationShift = 0.5;
	      this.viewer.scene.skyAtmosphere.brightnessShift = -0.2;
	
	      var handler = new _Cesium2.default.ScreenSpaceEventHandler(this.viewer.scene.canvas);
	      handler.setInputAction(this.handleCanvasClick, _Cesium2.default.ScreenSpaceEventType.LEFT_CLICK);
	      handler.setInputAction(this.handleCanvasLeftDown, _Cesium2.default.ScreenSpaceEventType.LEFT_DOWN);
	      handler.setInputAction(this.handleCanvasLeftUp, _Cesium2.default.ScreenSpaceEventType.LEFT_UP);
	      handler.setInputAction(this.handleCanvasMouseMove, _Cesium2.default.ScreenSpaceEventType.MOUSE_MOVE);
	      handler.setInputAction(this.handleCanvasPinchMove, _Cesium2.default.ScreenSpaceEventType.PINCH_MOVE);
	      handler.setInputAction(this.handleCanvasWheel, _Cesium2.default.ScreenSpaceEventType.WHEEL);
	
	      this.viewer.screenSpaceEventHandler.removeInputAction(_Cesium2.default.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
	
	      this.batteries = new _Cesium2.default.PointPrimitiveCollection({ blendOption: _Cesium2.default.BlendOption.TRANSLUCENT });
	      this.videos = new _Cesium2.default.BillboardCollection({ blendOption: _Cesium2.default.BlendOption.TRANSLUCENT });
	      this.ambassadors = new _Cesium2.default.PointPrimitiveCollection({ blendOption: _Cesium2.default.BlendOption.TRANSLUCENT });
	      this.awards = new _Cesium2.default.PointPrimitiveCollection({ blendOption: _Cesium2.default.BlendOption.TRANSLUCENT });
	
	      // this.viewer.scene.primitives.add(this.batteriesNet)
	      // this.viewer.scene.primitives.add(this.batteries)
	
	      // load-points-by-mode
	
	      switch (this.props.mode) {
	        case 'live':
	          this.viewer.scene.primitives.add(this.batteries);
	          break;
	
	        case 'stories':
	          this.viewer.scene.primitives.add(this.videos);
	          break;
	
	        case 'ambassadors':
	          this.viewer.scene.primitives.add(this.ambassadors);
	          break;
	      }
	
	      setTimeout(this.handleTimeoutInit, 2500);
	
	      setTimeout(this.handleTimeoutStart, 5000);
	
	      requestAnimationFrame(this.animateFrame);
	
	      this.addBoundaries();
	    }
	  }, {
	    key: 'handleTimeoutInit',
	    value: function handleTimeoutInit() {
	
	      this.loadBatteriesByBounds(5000, 1, // page,
	      true);
	      this.props.loadVideosByBounds();
	      this.props.loadAmbassadorsByBounds();
	      // this.props.loadAwardsByBounds()
	    }
	  }, {
	    key: 'handleTimeoutStart',
	    value: function handleTimeoutStart() {
	      this.viewer.scene.preRender.addEventListener(this.handlePreRender);
	
	      // intro endpoint by url parameter or mode
	      var urlQueryWindow = new URLSearchParams(location.search);
	      // ?w=9.9&s=47.6&e=10.8&n=48
	      if (urlQueryWindow.get('w') != null && urlQueryWindow.get('s') != null && urlQueryWindow.get('e') != null && urlQueryWindow.get('n') != null && urlQueryWindow.get('w') >= -180 && urlQueryWindow.get('w') <= 180 && urlQueryWindow.get('s') >= -90 && urlQueryWindow.get('s') <= 90 && urlQueryWindow.get('e') <= 180 && urlQueryWindow.get('e') >= -180 && urlQueryWindow.get('n') <= 90 && urlQueryWindow.get('n') >= -90) {
	        var paramWindow = new _Cesium2.default.Rectangle(urlQueryWindow.get('w'), urlQueryWindow.get('s'), urlQueryWindow.get('e'), urlQueryWindow.get('n'));
	        this.props.setBounds(paramWindow, 5);
	      } else {
	        switch (this.props.mode) {
	          case 'live':
	            this.cameraFlyToCenterHeight({ lat: 51.2, lng: 10.5 }, 0.4e7, 5);
	            break;
	
	          case 'stories':
	            this.cameraFlyToCenterHeight({ lat: 51.2, lng: 10.5 }, 1.0e7, 5);
	            break;
	
	          case 'ambassadors':
	            this.cameraFlyToCenterHeight({ lat: 51.2, lng: 10.5 }, 0.15e7, 5);
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.mode != this.props.mode) {
	
	        this.unselectAll();
	        this.setRenderNextFrame(true);
	
	        switch (nextProps.mode) {
	          case 'live':
	            this.viewer.scene.primitives.removeAll();
	            // this.viewer.scene.primitives.add(this.batteriesNet)
	            this.viewer.scene.primitives.add(this.batteries);
	            var latlngLive = {
	              lat: 51.2,
	              lng: 10.5
	            };
	            this.cameraFlyToCenterHeight(latlngLive, 0.4e7, 1);
	
	            this.boundaryLinesLand = null;
	            this.boundaryLinesLandType = null;
	            this.addBoundaries();
	            break;
	
	          case 'stories':
	            this.removeBatteriesNet();
	
	            this.boundaryLinesLand = null;
	            this.boundaryLinesLandType = null;
	            this.addBoundaries();
	
	            this.viewer.scene.primitives.removeAll();
	            this.viewer.scene.primitives.add(this.videos);
	            //this.viewer.scene.primitives.add(this.ambassadors)
	
	            // find and fly to closest video
	            // const center = this.getViewCenter()
	            // let closestVideo
	            // let closestDistance
	            // for (let key of Object.keys(this.props.videos)) {
	            //   let video = this.props.videos[key]
	            //   if ( ! video) {
	            //     continue
	            //   }
	            //   let distance = getDistance(video.lng,video.lat,center.lng,center.lat)
	            //   if ( ! closestVideo || distance < closestDistance) {
	            //     closestVideo = video
	            //     closestDistance = distance
	            //     continue
	            //   }
	            // }
	            // closestVideo.type = 'video'
	
	            // height = Math.max(
	            //   this.state.heightThreshold*8,
	            //   Math.min(
	            //     this.getViewHeight(), 
	            //     this.state.heightThreshold*10
	            //   )
	            // )
	            // this.cameraFlyToCenterHeight(closestVideo, 1.0e7, 1)
	
	            // this.props.setEntityIsLoading(closestVideo.type)
	            // setTimeout(this.loadObject, 1000, closestVideo)
	
	            // this.setState({
	            //   pickedObject: closestVideo,
	            // })
	            this.cameraFlyToCenterHeight(this.getViewCenter(), 1.0e7, 1);
	
	            break;
	
	          case 'ambassadors':
	            this.removeBatteriesNet();
	
	            this.boundaryLinesLand = null;
	            this.boundaryLinesLandType = null;
	            this.addBoundaries();
	
	            this.viewer.scene.primitives.removeAll();
	            this.viewer.scene.primitives.add(this.ambassadors);
	            // let boundsDE = {
	            //   west: '5.86',
	            //   south: '47.27',
	            //   east: '15.04',
	            //   north: '55.08'
	            // }
	            var latlngAmbassador = {
	              lat: 51.2,
	              lng: 10.5
	            };
	            this.cameraFlyToCenterHeight(latlngAmbassador, 0.15e7, 1);
	            //this.cameraFlyToBounds(boundsDE)
	            //this.cameraFlyToCenterHeight([52,12], height, 1)
	            break;
	
	          case 'awards':
	            this.viewer.scene.primitives.removeAll();
	            this.viewer.scene.primitives.add(this.awards);
	
	            this.boundaryLinesLand = null;
	            this.boundaryLinesLandType = null;
	            this.addBoundaries();
	            break;
	        }
	      }
	
	      var center = void 0;
	      var height = void 0;
	
	      switch (true) {
	
	        // zoom in
	        case nextProps.zoom > this.props.zoom:
	          center = this.getViewCenter();
	          height = Math.max(4000, this.getViewHeight() / 2);
	          this.props.setCenterHeight(center, height, .5);
	
	          // this.cameraFlyToCenterHeight(center, height, .5)
	          this.unselectAll();
	          // this.setRenderNextFrame(true)
	          break;
	
	        // zoom out
	        case nextProps.zoom < this.props.zoom:
	          center = this.getViewCenter();
	          height = Math.min(100000000, this.getViewHeight() * 2);
	          this.props.setCenterHeight(center, height, .5);
	
	          // this.cameraFlyToCenterHeight(center, height, .5)
	          this.unselectAll();
	          // this.setRenderNextFrame(true)
	          break;
	
	        // explicit center / height
	        case JSON.stringify(nextProps.targetCenter) != JSON.stringify(this.props.targetCenter):
	        case JSON.stringify(nextProps.targetHeight) != JSON.stringify(this.props.targetHeight):
	          // console.log("componentWillReceiveProps.centerHeight",nextProps.targetHeight)
	          height = nextProps.targetHeight == null ? this.state.heightThreshold * 2 : nextProps.targetHeight;
	          // console.log(height)
	          this.cameraFlyToCenterHeight(nextProps.targetCenter, height, nextProps.targetDuration);
	          break;
	
	        // explicit bounds
	        case nextProps.targetBounds && JSON.stringify(nextProps.targetBounds) !== JSON.stringify(this.props.currentBounds):
	          // console.log("componentWillReceiveProps.bounds",nextProps)
	
	          this.removeBatteriesNet();
	          this.cameraFlyToBounds(nextProps.targetBounds, nextProps.targetDuration);
	          // fixed search bug - reset target bounds
	          this.props.setBounds(null);
	          break;
	
	        // case (JSON.stringify(nextProps.selectedEntity) != JSON.stringify(this.props.selectedEntity)) :
	        case JSON.stringify(nextProps.currentBounds) != JSON.stringify(this.props.currentBounds):
	          // console.log(nextProps.selectedEntity,this.shouldUpdateBatteriesNet())
	          if (nextProps.selectedEntity && this.shouldUpdateBatteriesNet()) {
	            var _location = nextProps.selectedEntity.lat + ',' + nextProps.selectedEntity.lng;
	            this.drawBatteriesNetActive(nextProps.selectedEntity, this.batteriesNetPositions[_location], true);
	          }
	          break;
	
	        // selected object
	        // case (! this.state.cameraIsFlying && this.state.pickedObject != null && JSON.stringify(nextProps.selectedEntity) != JSON.stringify(this.props.selectedEntity)) :
	        //   // console.log("componentWillReceiveProps.selectedObject")
	        //   let selectedObject = nextProps.selectedEntity
	
	        //   if (selectedObject) {
	        //     this.setState({
	        //       selectedObject,
	        //     })
	
	        //     if (selectedObject.video || selectedObject.ambassador) {
	        //       height = this.state.heightThreshold*10
	        //     } else if (this.getViewHeight() > this.state.heightThreshold) {
	        //       height = this.state.heightThreshold/3
	        //     } else {
	        //       height = this.getViewHeight()
	        //     }
	
	        //     this.cameraFlyToCenterHeight(selectedObject, height, 1)
	        //   }
	        //   break
	      }
	
	      // fly to bounds, e.g. after search
	      // if (JSON.stringify(nextProps.bounds) !== JSON.stringify(this.getViewBounds()) 
	      //   && JSON.stringify(nextProps.bounds) !== JSON.stringify(this.props.bounds)) {
	      //   this.cameraFlyToBounds(nextProps.bounds, 2)
	      // }
	
	
	      // console.log("pickedObject",this.state.pickedObject, ! this.state.cameraIsFlying,JSON.stringify(nextProps.selectedEntity) != JSON.stringify(this.props.selectedEntity))
	      // if ( ! this.state.cameraIsFlying && this.state.pickedObject != null && JSON.stringify(nextProps.selectedEntity) != JSON.stringify(this.props.selectedEntity)) {
	
	      //   let selectedObject = nextProps.selectedEntity
	
	      //   if (selectedObject) {
	      //     this.setState({
	      //       selectedObject,
	      //     })
	
	      //     this.flyToSelectedObject(selectedObject)
	      //   }
	      // }
	
	
	      // console.log(nextProps.weightBounds)
	      if (nextProps.weightBounds && JSON.stringify(nextProps.weightBounds) !== JSON.stringify(this.props.weightBounds)) {
	        // console.log(JSON.stringify(nextProps.weightBounds),JSON.stringify(this.props.weightBounds))
	        this.loadBatteriesByBounds(5000, 1, true, nextProps.weightBounds);
	      }
	
	      if (Object.keys(nextProps.batteries).length > Object.keys(this.props.batteries).length && Object.keys(nextProps.batteriesByTiles).length > 0) {
	        // this.batteriesIndex = 0
	
	        this.batteriesAll = nextProps.batteries;
	        this.batteriesByTiles = nextProps.batteries;
	
	        var batteryIdsPendingNew = Object.keys(nextProps.batteries).reduce(function (acc, batteryId, index) {
	          if (_this2.batteryIdsPending.indexOf(batteryId) >= 0) {
	            // console.log("delete bc pending",index)
	            return acc;
	          }
	          if (_this2.batteryIdsAdded.indexOf(batteryId) >= 0) {
	            // console.log("delete bc added",index)
	            return acc;
	          }
	          // console.log(Object.keys(acc).length)
	          acc.push(batteryId);
	          return acc;
	        }, []);
	
	        if (batteryIdsPendingNew.length > 0) {
	          // console.log("batteryIdsPendingNew", batteryIdsPendingNew.length)
	          this.batteryIdsPending = (0, _union2.default)(this.batteryIdsPending, batteryIdsPendingNew).sort();
	          // console.log("this.batteryIdsPending", this.batteryIdsPending.length)
	        }
	        if (batteryIdsPendingNew.length === this.batteryIdsPending.length) {
	          this.drawBatteriesPending(50);
	        }
	        // this.drawBatteries(nextProps.batteries, 25, nextProps.batteriesByTiles)
	      }
	
	      // console.log("entityIsLoading",this.props.entityIsLoading,nextProps.entityIsLoading)
	      if (this.props.entityIsLoading == true && nextProps.entityIsLoading == false && nextProps.selectedEntity) {
	        // this.drawBatteriesNet(nextProps.batteriesNetByBounds)
	
	        var _location2 = nextProps.selectedEntity.lat + ',' + nextProps.selectedEntity.lng;
	        this.drawBatteriesNetActive(nextProps.selectedEntity, this.batteriesNetPositions[_location2], true);
	      }
	
	      if (JSON.stringify(Object.keys(this.props.videos)) !== JSON.stringify(Object.keys(nextProps.videos))) {
	        this.videosIndex = 0;
	        this.drawVideos(nextProps.videos);
	      }
	
	      if (JSON.stringify(Object.keys(this.props.ambassadors)) !== JSON.stringify(Object.keys(nextProps.ambassadors))) {
	        this.ambassadorsIndex = 0;
	        this.drawAmbassadors(nextProps.ambassadors);
	      }
	
	      // if (JSON.stringify(Object.keys(this.props.awards)) !== JSON.stringify(Object.keys(nextProps.awards))) {
	      //   this.awardsIndex = 0
	      //   this.drawAwards(nextProps.awards)
	      // }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.viewer) {
	        this.viewer.destroy();
	      }
	    }
	
	    // 1. pick primitive at position
	    // 2. load place with primitive id
	    // 3. when loaded -> center (componentWillReceiveProps)
	    // 4. when centered -> display popup
	    // 5. click or move camera -> unload and hide popup
	
	  }, {
	    key: 'handleCanvasClick',
	    value: function handleCanvasClick(event) {
	
	      var pickedObject = this.viewer.scene.pick({
	        x: event.position ? event.position.x : event.offsetX,
	        y: event.position ? event.position.y : event.offsetY
	      });
	
	      if (pickedObject && pickedObject.id) {
	
	        var object = pickedObject.id;
	        var height = void 0;
	        // console.log(object)
	
	        switch (object.type) {
	          case 'battery':
	            height = this.getViewHeight() > this.state.heightThreshold ? this.state.heightThreshold / 3 : this.getViewHeight();
	            this.cameraFlyToCenterHeight(object, height, 1);
	
	            // this.props.loadBattery(object.id)
	            break;
	
	          case 'video':
	            height = Math.max(this.state.heightThreshold * 8, Math.min(this.getViewHeight(), this.state.heightThreshold * 10));
	            this.cameraFlyToCenterHeight(object, 1.0e7, 1);
	
	            // this.props.loadVideo(object.id)
	            break;
	
	          case 'ambassador':
	            height = Math.max(0.15e7 / 20, Math.min(this.getViewHeight(), 0.15e7 / 3));
	            this.cameraFlyToCenterHeight(object, height, 1);
	
	            // this.props.loadAmbassador(object.id)
	            break;
	
	          // case 'award' :
	          //   this.props.loadAward(object.id)
	          //   break
	        }
	
	        this.setState({
	          pickedObject: object
	        });
	      } else {
	
	        this.unselectAll();
	        this.setRenderNextFrame(true);
	      }
	    }
	  }, {
	    key: 'handleCanvasLeftDown',
	    value: function handleCanvasLeftDown(event) {
	      this.setState({
	        isMouseLeftDown: true
	      });
	      document.getElementById('searchInputField').blur();
	      if (window.innerWidth <= 560) {
	        document.getElementById('searchInputField').style.width = '0px';
	        document.getElementById('searchInputField').style.padding = '11px 0px';
	        document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '3px';
	        document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '3px';
	        document.getElementById('clearanceButton').style.width = '0px';
	        document.getElementById('clearanceButton').style.padding = '0px';
	      }
	    }
	  }, {
	    key: 'handleCanvasLeftUp',
	    value: function handleCanvasLeftUp(event) {
	      this.setState({
	        isMouseLeftDown: false
	      });
	    }
	  }, {
	    key: 'handleCanvasMouseMove',
	    value: function handleCanvasMouseMove(event) {
	      if (this.state.cameraIsFlying) {
	        return;
	      }
	      if (this.state.isMouseLeftDown) {
	        this.unselectAll();
	        this.setRenderNextFrame(true);
	
	        if (JSON.stringify(this.getViewCenter(0)) != JSON.stringify(this.state.center)) {
	          this.setState({
	            isDragging: 6
	          });
	        }
	      }
	    }
	  }, {
	    key: 'handleCanvasPinchMove',
	    value: function handleCanvasPinchMove(event) {
	      if (this.state.cameraIsFlying) {
	        return;
	      }
	
	      this.unselectAll();
	      this.setRenderNextFrame(true);
	
	      if (this.getViewMagnitude(0) < this.props.currentMagnitude * 1000) {
	        this.setState({
	          isZoomingIn: 6,
	          isZoomingOut: 0
	        });
	      } else if (this.getViewMagnitude(0) > this.props.currentMagnitude * 1000) {
	        this.setState({
	          isZoomingIn: 0,
	          isZoomingOut: 6
	        });
	      }
	      document.getElementById('searchInputField').blur();
	      if (window.innerWidth <= 560) {
	        document.getElementById('searchInputField').style.width = '0px';
	        document.getElementById('searchInputField').style.padding = '11px 0px';
	        document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '3px';
	        document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '3px';
	        document.getElementById('clearanceButton').style.width = '0px';
	        document.getElementById('clearanceButton').style.padding = '0px';
	      }
	    }
	  }, {
	    key: 'handleCanvasWheel',
	    value: function handleCanvasWheel(event) {
	      if (this.state.cameraIsFlying) {
	        return;
	      }
	
	      this.unselectAll();
	      this.setRenderNextFrame(true);
	
	      if (this.getViewMagnitude(0) < this.props.currentMagnitude * 1000) {
	        // console.log("zoon in",this.props.currentMagnitude*1000)
	        this.setState({
	          isZoomingIn: 6,
	          isZoomingOut: 0
	        });
	      } else if (this.getViewMagnitude(0) > this.props.currentMagnitude * 1000) {
	        // console.log("zoon out",this.props.currentMagnitude*1000)
	        this.setState({
	          isZoomingIn: 0,
	          isZoomingOut: 6
	        });
	      }
	      document.getElementById('searchInputField').blur();
	      if (window.innerWidth <= 560) {
	        document.getElementById('searchInputField').style.width = '0px';
	        document.getElementById('searchInputField').style.padding = '11px 0px';
	        document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '3px';
	        document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '3px';
	        document.getElementById('clearanceButton').style.width = '0px';
	        document.getElementById('clearanceButton').style.padding = '0px';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: 'CesiumWidget', ref: 'cesiumNode' });
	    }
	  }, {
	    key: 'setRenderNextFrame',
	    value: function setRenderNextFrame(renderNextFrame) {
	      if (renderNextFrame) {
	        this.setState({
	          renderNextFrame: this.state.targetFrameRate * 1 // 1 sec
	        });
	      } else if (this.state.renderNextFrame > 0) {
	        this.setState({
	          renderNextFrame: this.state.renderNextFrame - 1
	        });
	      }
	    }
	  }, {
	    key: 'handlePreRender',
	    value: function handlePreRender() {
	
	      switch (true) {
	        case !this.viewer:
	        case !this.viewer.scene:
	        case !this.viewer.camera:
	        case !this.batteries:
	        case this.state.cameraIsFlying:
	          return;
	      }
	
	      if (this.getViewHeight() > 100000000) {
	        this.cameraFlyToCenterHeight(this.getViewCenter(0), 90000000);
	        return;
	      }
	      // console.log("preRender",this.state.isDragging,this.state.isZoomingIn,this.state.isZoomingOut)
	
	      var propagate = false;
	      var nextState = {};
	
	      if (this.state.isDragging > 0) {
	        nextState.center = this.getViewCenter(0);
	        if (JSON.stringify(this.getViewCenter(0)) == JSON.stringify(this.state.center)) {
	          nextState.isDragging = this.state.isDragging - 1;
	          // console.log("drag",this.state.isDragging)
	          if (nextState.isDragging == 0) {
	            propagate = true;
	          }
	        }
	      }
	      if (this.state.isZoomingIn > 0) {
	        nextState.magnitude = this.getViewMagnitude(0);
	        if (this.getViewMagnitude(0) == this.state.magnitude) {
	          // console.log("zoomIn",this.state.isZoomingIn)
	          nextState.isZoomingIn = this.state.isZoomingIn - 1;
	          if (nextState.isZoomingIn == 0) {
	            propagate = true;
	          }
	        }
	      }
	      if (this.state.isZoomingOut > 0) {
	        nextState.magnitude = this.getViewMagnitude(0);
	        if (this.getViewMagnitude(0) == this.state.magnitude) {
	          // console.log("zoomOut",this.state.isZoomingOut)
	          nextState.isZoomingOut = this.state.isZoomingOut - 1;
	          if (nextState.isZoomingOut == 0) {
	            propagate = true;
	          }
	        }
	      }
	
	      if (Object.keys(nextState).length > 0) {
	        this.setState(nextState);
	      }
	
	      if (propagate) {
	        this.propagateViewport();
	      }
	
	      // always point north
	      var camera = this.viewer.scene.camera;
	      camera.setView({
	        orientation: {
	          heading: 0,
	          pitch: camera.pitch,
	          roll: camera.roll
	        }
	      });
	    }
	  }, {
	    key: 'unselectAll',
	    value: function unselectAll() {
	      if (this.props.entityIsLoading) {
	        this.props.unsetEntityIsLoading();
	      }
	
	      if (this.props.selectedEntity != null) {
	        // this.props.setSelectedObject(null)
	        this.props.unsetSelectedEntity();
	        this.viewer.selectedEntity = null;
	      }
	
	      if (this.batteriesNetActive) {
	        this.viewer.scene.groundPrimitives.remove(this.batteriesNetActive);
	      }
	    }
	  }, {
	    key: 'animateFrame',
	    value: function animateFrame() {
	
	      // constant frame rate
	      var self = this;
	      setTimeout(function () {
	        requestAnimationFrame(self.animateFrame);
	      }, 1000 / this.viewer.targetFrameRate);
	
	      if (_Cesium2.default.Imagery.loadingImageryCount > 0) {
	        this.setRenderNextFrame(true);
	      }
	
	      // timing for smooth animations
	      // this.now = Date.now()
	      // this._delta = (this.now - this._then) / 1000
	      // this._then = this.now
	
	      // // move animations
	      // // let velocity = this.state.velocityEnergyStreamsRatio * this._delta // * this.getZoomRatio()*400
	      // let velocity = 100 * this._delta // * this.getZoomRatio()*400
	
	      // console.log(this.batteriesNetParticles.length)
	      // for (let particle of this.batteriesNetParticles) {
	      //   // let dx = (particle.sourceL-particle.targetL)
	      //   // console.log(dx)
	      //   // let dy = (particle.sourceL-particle.targetL)
	      //   // console.log("-----")
	      //   // console.log(velocity/particle.distance) //,particle.dx,particle.dy)
	      //   let ratio = velocity/particle.distance
	
	      //   particle.currentLat = particle.currentLat - particle.dx * ratio//Math.abs(particle.dx) * velocity
	      //   particle.currentLng = particle.currentLng - particle.dy * ratio//Math.abs(particle.dy) * velocity
	
	      //   let dx = particle.currentLat - particle.targetLat
	      //   let dy = particle.currentLng - particle.targetLng
	
	      //   // console.log("--")
	      //   // console.log(particle.currentLat)
	      //   // console.log(particle.currentLng)
	      //   // console.log(dx/Math.abs(dx),particle.dx/Math.abs(particle.dx))
	      //   // console.log(dy/Math.abs(dy),particle.dy/Math.abs(particle.dy))
	      //   // console.log(dx/Math.abs(dx)!=particle.dx/Math.abs(particle.dx),dy/Math.abs(dy)!=particle.dy/Math.abs(particle.dy))
	      //   if (dx/Math.abs(dx) != particle.dx/Math.abs(particle.dx) 
	      //     && dy/Math.abs(dy) != particle.dy/Math.abs(particle.dy)) {
	      //     particle = Object.assign({}, particle, {
	      //       currentLng: particle.sourceLng,
	      //       currentLat: particle.sourceLat,
	      //     })
	      //     // console.log(particle.currentVertex == particle.sourceVertex)
	      //   }
	      //   // console.log({x:particle.currentLat,y:particle.currentLng})
	      //   // debugger
	      //   // let vertex = new THREE.Vector3(
	      //   //   particle.currentLat, // - this.state.frame/this.state.frameRate*dx, 
	      //   //   particle.currentLng, // - this.state.frame/this.state.frameRate*dy, 
	      //   //   0
	      //   // )
	      //   // console.log(particle.sourceLat,particle.sourceLng)
	      //   // console.log(particle.sourceLat,particle.sourceLng)
	      //   // console.log(vertex.lat,vertex.lng)
	      //   // console.log(particle.targetLat,particle.targetLng)
	      //   particle.primitive.position = Cesium.Cartesian3.fromDegrees(particle.currentLat,particle.currentLng,0)
	      //   // break
	      // }
	
	
	      switch (true) {
	        // case this.state.isInializing :
	        // case this.batteriesNetParticles.length > 0 :
	        case this.state.cameraIsFlying:
	        case this.state.renderNextFrame > 0:
	          this.setRenderNextFrame(false);
	          this.viewer.render();
	          break;
	      }
	    }
	  }, {
	    key: 'addBoundaries',
	    value: function addBoundaries() {
	      var _this3 = this;
	
	      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '50m';
	
	      if (type === this.boundaryLinesLandType) {
	        return;
	      }
	      // this.viewer.dataSources.add(Cesium.GeoJsonDataSource.load(boundaryLinesLand50m, {
	      var boundaryLinesLand = void 0;
	      switch (type) {
	        case '50m':
	          boundaryLinesLand = _ne_50m_admin_0_boundary_lines_land2.default;
	          break;
	        case '110m':
	        default:
	          boundaryLinesLand = boundaryLinesLand110m;
	          break;
	      }
	
	      if (this.boundaryLinesLand) {
	        console.log("remove", this.boundaryLinesLandType);
	        this.viewer.dataSources.remove(this.boundaryLinesLand);
	      }
	
	      _Cesium2.default.GeoJsonDataSource.load(boundaryLinesLand, {
	        stroke: _Cesium2.default.Color.WHITE.withAlpha(0.3),
	        fill: _Cesium2.default.Color.PINK.withAlpha(0.0),
	        strokeWidth: 1
	      }).then(function (dataSource) {
	        // Add it to the viewer
	        console.log("add", type);
	        _this3.viewer.dataSources.add(dataSource);
	        // Remember the data source by ID so we can delete later
	        _this3.boundaryLinesLand = dataSource;
	        _this3.boundaryLinesLandType = type;
	      });
	    }
	  }, {
	    key: 'shouldUpdateBatteriesNet',
	    value: function shouldUpdateBatteriesNet() {
	
	      // console.log(this.batteryIdsPending.length)
	      if (this.weightBounds) {
	        return false;
	      }
	
	      if (this.batteryIdsPending.length > 0) {
	        return false;
	      }
	
	      if (this.props.mode != 'live') {
	        return false;
	      }
	
	      var bounds = this.getViewBounds();
	      var deltaLat = bounds ? bounds.east - bounds.west : 10;
	      var deltaLng = bounds ? bounds.north - bounds.south : 10;
	      var magnitude = this.getViewMagnitude();
	
	      switch (true) {
	        case deltaLat > 1.5:
	        case deltaLng > 1.5: // && deltaCurrentLat > 1.5 && deltaCurrentLng > 1.5 :
	        case magnitude - _helpers.earthRadiusKm > 75:
	          // && this.props.currentMagnitude-earthRadiusKm > 75 :
	          return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'shouldRemoveBatteriesNet',
	    value: function shouldRemoveBatteriesNet() {
	      // console.log(this.viewer.scene.groundPrimitives.length)
	      if (this.viewer.scene.groundPrimitives.length == 0) {
	        return false;
	      }
	
	      if (this.props.mode != 'live') {
	        return true;
	      }
	
	      var deltaCurrentLat = this.props.currentBounds.east - this.props.currentBounds.west;
	      var deltaCurrentLng = this.props.currentBounds.north - this.props.currentBounds.south;
	
	      var bounds = this.getViewBounds();
	      var deltaLat = bounds ? bounds.east - bounds.west : 10;
	      var deltaLng = bounds ? bounds.north - bounds.south : 10;
	
	      // console.log(deltaLat, deltaCurrentLat)
	      // console.log(deltaLng, deltaCurrentLng)
	      // console.log(this.getViewMagnitude()-earthRadiusKm, this.props.currentMagnitude-earthRadiusKm)
	      switch (true) {
	        case deltaLat > 1.5 && deltaCurrentLat <= 1.5:
	        case deltaLng > 1.5 && deltaCurrentLng <= 1.5:
	        case this.getViewMagnitude() - _helpers.earthRadiusKm > 75:
	          // && this.props.currentMagnitude-earthRadiusKm <= 75 :
	          return true;
	      }
	      return false;
	    }
	
	    // deprectaced method + signatute
	    // drawBatteries(batteries, n = 25, batteriesByTiles = {}) {
	    //   if ( ! batteries) {
	    //     return
	    //   }
	
	    //   let keys = Object.keys(batteries)
	    //   // console.log("drawBatteries:",keys.length)
	    //   if (keys.length <= this.batteriesIndex) {
	    //     return
	    //   }
	    //   // console.log(keys)
	    //   let max = n+this.batteriesIndex
	    //   // console.log("drawBatteries",n,this.batteriesIndex,max)
	
	    //   for (let i=this.batteriesIndex; i<max; i++) {
	
	    //     if (batteries.length <= this.batteriesIndex) {
	    //       return
	    //     }
	
	    //     let battery = batteries[keys[i]]
	
	    //     if ( ! battery) {
	    //       // console.log("skip")
	    //       // console.log("skip1",battery)
	    //       this.batteriesIndex++
	    //       continue
	    //     }
	
	    //     if (this.batteryIds[battery.id] === true) {
	    //       // console.log("skip2",battery.id)
	    //       this.batteriesIndex++
	    //       continue
	    //     }
	
	    //     this.batteryIds[battery.id] = true
	
	    //     let pixelSize = this.state.pixelSize
	
	    //     let key
	    //     let len
	
	    //     if (battery.lng != undefined && battery.lat != undefined) {
	
	    //       key = '_'+lng2tileX(battery.lng)+'_'+lat2tileY(battery.lat)
	    //       // console.log(key)
	    //       if (batteriesByTiles[key]) {
	    //         // console.log(batteriesByTiles[key].batteries.length)
	    //         len = batteriesByTiles[key].batteries.length
	    //         pixelSize = this.state.pixelSize * 1/(len/(len+2))
	    //       }
	
	    //       // console.log(key)
	
	    //       this.batteries.add({
	    //         position: Cesium.Cartesian3.fromDegrees(battery.lng, battery.lat, 0),
	    //         pixelSize: pixelSize, // * Math.min(5, ((battery.weight || 1)+6)/7),
	    //         color: lightblue.fill,
	    //         outlineColor: cdblue.outline,
	    //         outlineWidth: 0.5,
	    //         // color: new Cesium.Color(255/255,0/255,0/255,1.0),
	    //         id: Object.assign({}, battery, {type: 'battery'}),
	    //         scaleByDistance: new Cesium.NearFarScalar(1.0e1, 7.0, 0.6e6, 1.2),
	    //         // scaleByDistance: new Cesium.NearFarScalar(1e5, 3.0, 3e6, 1.2),
	    //         // translucencyByDistance: new Cesium.NearFarScalar(0.75e5, 0.0, 1.25e5, 1.0),
	    //       })
	    //       // console.log(this.allBatteries._pointPrimitives.length)
	
	    //       this.batteriesIndex++
	    //     }
	    //   }
	
	    //   if (n == 25) {
	    //     setTimeout(this.drawBatteries, 1, batteries, n, batteriesByTiles)
	    //   }
	    // }
	
	
	  }, {
	    key: 'drawBatteriesPending',
	    value: function drawBatteriesPending() {
	      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 25;
	
	
	      var max = n;
	      while (max-- > 0 && this.batteryIdsPending.length > 0) {
	
	        var batteryId = this.batteryIdsPending.shift();
	        if (this.batteryIdsAdded.indexOf(batteryId) >= 0) {
	          continue;
	        }
	
	        var battery = this.batteriesAll[batteryId];
	        if (!battery) {
	          continue;
	        }
	
	        var pixelSize = this.state.pixelSize;
	
	        var key = void 0;
	        var len = void 0;
	
	        if (battery.lng != undefined && battery.lat != undefined) {
	
	          key = '_' + (0, _helpers.lng2tileX)(battery.lng) + '_' + (0, _helpers.lat2tileY)(battery.lat);
	          // console.log(key)
	          if (this.batteriesByTiles[key]) {
	            // console.log(this.batteriesByTiles[key].batteries.length)
	            len = this.batteriesByTiles[key].batteries.length;
	            pixelSize = this.state.pixelSize * 1 / (len / (len + 2));
	          }
	
	          this.batteries.add({
	            position: _Cesium2.default.Cartesian3.fromDegrees(battery.lng, battery.lat, 0),
	            pixelSize: pixelSize,
	            color: _helpers.lightblue.fill,
	            outlineColor: _helpers.cdblue.outline,
	            outlineWidth: 0.5,
	            // color: new Cesium.Color(255/255,0/255,0/255,1.0),
	            id: Object.assign({}, battery, { type: 'battery' }),
	            scaleByDistance: new _Cesium2.default.NearFarScalar(1.0e1, 7.0, 0.6e6, 1.2)
	          });
	
	          this.batteryIdsAdded.push(batteryId);
	        }
	      }
	
	      // console.log(this.batteryIdsPending.length+this.batteryIdsAdded.length,this.batteryIdsPending.length,this.batteryIdsAdded.length)
	      if (this.batteryIdsPending.length > 0) {
	        setTimeout(this.drawBatteriesPending, 1, n);
	        this.setRenderNextFrame(true);
	      } else {
	        this.updateBatteriesNet(true);
	      }
	    }
	  }, {
	    key: 'drawBatteriesNet',
	    value: function drawBatteriesNet(links) {
	
	      // console.log("drawBatteriesNet",this.props.weightBounds)
	
	      // if ( ! this.shouldUpdateBatteriesNet()) {
	      // this.removeBatteriesNet()
	      // return
	      // }
	
	      // if ( ! this.groundPrimitives) {
	      //   this.groundPrimitives = []
	      // }
	
	      var geometryInstances = [];
	      var maxDistance = 100;
	      for (var i = 0; i < links.length; i++) {
	
	        var link = links[i];
	        var linkString = JSON.stringify(link);
	        // console.log(link,this.batteriesNetLinks[linkString])
	        if (this.batteriesNetLinks[linkString] === true) {
	          //.indexOf(JSON.stringify(link)) >= 0) {
	          continue;
	        }
	
	        var sourceKey = link.source[0] + ',' + link.source[1];
	        if (this.batteriesNetPositions[sourceKey] === undefined) {
	          this.batteriesNetPositions[sourceKey] = [];
	        }
	        var targetKey = link.target[0] + ',' + link.target[1];
	        if (this.batteriesNetPositions[targetKey] === undefined) {
	          this.batteriesNetPositions[targetKey] = [];
	        }
	
	        this.batteriesNetPositions[sourceKey].push(link.target);
	        this.batteriesNetPositions[targetKey].push(link.source);
	        this.batteriesNetLinks[linkString] = true; // .push(JSON.stringify(link))
	
	
	        var linkPositions = [link.source[1], link.source[0], link.target[1], link.target[0]];
	
	        var positions = _Cesium2.default.Cartesian3.fromDegreesArray(linkPositions);
	
	        geometryInstances.push(new _Cesium2.default.GeometryInstance({
	          geometry: new _Cesium2.default.CorridorGeometry({
	            positions: positions,
	            width: 70
	          }),
	          attributes: {
	            color: new _Cesium2.default.ColorGeometryInstanceAttribute(1.0, 1.0, 1.0, 0.5)
	          }
	        }));
	      }
	
	      // console.log("lines",geometryInstances.length)
	      if (geometryInstances.length > 0) {
	
	        // this.removeBatteriesNet()
	
	        var groundPrimitive = new _Cesium2.default.GroundPrimitive({
	          geometryInstances: geometryInstances,
	          allowPicking: false,
	          show: true,
	          releaseGeometryInstances: false
	        });
	
	        this.viewer.scene.groundPrimitives.add(groundPrimitive);
	
	        // this.groundPrimitives.push(groundPrimitive)
	
	        // console.log(this.groundPrimitives.length)
	        // if (this.groundPrimitives.length > 1) {
	        //   setTimeout(function() {
	        //     groundPrimitive = this.groundPrimitives.shift()
	        //     this.viewer.scene.groundPrimitives.remove(groundPrimitive)
	        //     if (groundPrimitive && ! groundPrimitive.isDestroyed) {
	        //       groundPrimitive.destroy()
	        //     }
	        //   }.bind(this),250)
	        // }
	      }
	
	      // console.log('drawBatteriesNet', this.viewer.scene.groundPrimitives.length)
	
	      if (this.props.entityIsLoading && this.props.selectedEntity) {
	        var _location3 = this.props.selectedEntity.lat + ',' + this.props.selectedEntity.lng;
	        this.drawBatteriesNetActive(this.props.selectedEntity, this.batteriesNetPositions[_location3], true);
	      }
	    }
	  }, {
	    key: 'drawBatteriesNetActive',
	    value: function drawBatteriesNetActive(object) {
	      var leafs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	
	      // if (this.props.selectedObject && ! forceUpdate) {
	      //   return
	      // }
	      // console.log('drawBatteriesNetActive',object,leafs)
	      if (this.batteriesNetActive) {
	        this.viewer.scene.groundPrimitives.remove(this.batteriesNetActive);
	      }
	
	      if (object) {
	
	        // this.batteriesNetStreams = new Cesium.PointPrimitiveCollection()
	
	        var geometryInstances = [];
	        for (var i = 0; i < leafs.length; i++) {
	
	          var leaf = leafs[i];
	
	          var leafPositions = [object.lng, object.lat, leaf[1], leaf[0]];
	
	          var positions = _Cesium2.default.Cartesian3.fromDegreesArray(leafPositions);
	
	          geometryInstances.push(new _Cesium2.default.GeometryInstance({
	            geometry: new _Cesium2.default.CorridorGeometry({
	              positions: positions,
	              width: 75
	            }),
	            attributes: {
	              color: new _Cesium2.default.ColorGeometryInstanceAttribute(76 / 255, 207 / 255, 239 / 255, 1.0)
	            }
	          }));
	
	          // let currentLng = object.lng + (leaf[1]-object.lng)
	          // let currentLat = object.lat + (leaf[0]-object.lat)
	
	          // let primitive = this.batteriesNetStreams.add({
	          //   position: Cesium.Cartesian3.fromDegrees(currentLng, currentLat, 0),
	          //   pixelSize: 20,
	          //   color: new Cesium.Color(255/255,255/255,255/255,0.75),
	          // })
	
	          // const distance = getDistance(object.lng, object.lat, leaf[1], leaf[0])
	          // this.batteriesNetParticles.push({
	          //   primitive,
	          //   currentLng,
	          //   currentLat,
	          //   sourceLng: object.lng,
	          //   sourceLat: object.lat,
	          //   targetLng: leaf[1],
	          //   targetLat: leaf[0],
	          //   deltaLng: (leaf[1]-object.lng), 
	          //   deltaLat: (leaf[0]-object.lat),
	          //   distance
	          // })
	        }
	
	        // console.log(geometryInstances)
	        if (geometryInstances.length > 0) {
	          this.batteriesNetActive = new _Cesium2.default.GroundPrimitive({
	            geometryInstances: geometryInstances,
	            allowPicking: false,
	            show: true
	          });
	          this.viewer.scene.groundPrimitives.add(this.batteriesNetActive);
	        }
	
	        // this.viewer.scene.primitives.add(this.batteriesNetStreams)
	      }
	
	      this.setRenderNextFrame(true);
	    }
	  }, {
	    key: 'removeBatteriesNet',
	    value: function removeBatteriesNet() {
	      // keepLatest = false) {
	
	      // console.log("removeBatteriesNet")
	      var len = this.viewer.scene.groundPrimitives.length;
	      // console.log("removeBatteriesNet",len)
	      // if (keepLatest) {
	      //   len--
	      // }
	      for (var i = 0; i < len; i++) {
	        // console.log("remove",i)
	        var geometry = this.viewer.scene.groundPrimitives.get(i);
	        this.viewer.scene.groundPrimitives.remove(geometry);
	        if (geometry && !geometry.isDestroyed) {
	          geometry.destroy();
	        }
	      }
	
	      this.batteriesNetLinks = {};
	      this.batteriesNetPositions = {};
	      this.batteriesNetActive = null;
	      // this.batteriesNetParticles = []
	    }
	  }, {
	    key: 'drawVideos',
	    value: function drawVideos(videos) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.keys(videos)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	
	          var video = videos[key];
	          if (!video || this.videoIds.indexOf(video.id) >= 0) {
	            continue;
	          }
	          this.videoIds.push(video.id);
	
	          // this.videos.add({
	          //   position: Cesium.Cartesian3.fromDegrees(video.lng, video.lat, 0),
	          //   pixelSize: 30,
	          //   color: new Cesium.Color(215/255,238/255,251/255,1.0),
	          //   outlineColor: new Cesium.Color(215/255,238/255,251/255,0.15),
	          //   outlineWidth: 0.5,
	          //   id: Object.assign({}, video, {type: 'video'}),
	          // })
	
	          this.videos.add({
	            position: _Cesium2.default.Cartesian3.fromDegrees(video.lng, video.lat, 0),
	            image: _iconVideoPlay2.default,
	            id: Object.assign({}, video, { type: 'video' }),
	            width: 40,
	            height: 40
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'drawAmbassadors',
	    value: function drawAmbassadors(ambassadors) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = Object.keys(ambassadors)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var key = _step2.value;
	
	
	          var ambassador = ambassadors[key];
	          if (!ambassador || this.ambassadorIds.indexOf(ambassador.id) >= 0) {
	            continue;
	          }
	          this.ambassadorIds.push(ambassador.id);
	
	          this.ambassadors.add({
	            position: _Cesium2.default.Cartesian3.fromDegrees(ambassador.lng, ambassador.lat, 0),
	            pixelSize: 8,
	            color: new _Cesium2.default.Color(215 / 255, 238 / 255, 251 / 255, 1.0),
	            outlineColor: new _Cesium2.default.Color(76 / 255, 207 / 255, 239 / 255, 0.15),
	            outlineWidth: 2,
	            id: Object.assign({}, ambassador, { type: 'ambassador' }),
	            scaleByDistance: new _Cesium2.default.NearFarScalar(1.8e6, 1.0, 1.8e7, 0.3)
	          });
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'drawAwards',
	    value: function drawAwards(awards) {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = Object.keys(awards)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var key = _step3.value;
	
	
	          var award = awards[key];
	          if (!award || this.awardIds.indexOf(award.id) >= 0) {
	            continue;
	          }
	          this.awardIds.push(award.id);
	
	          this.awards.add({
	            position: _Cesium2.default.Cartesian3.fromDegrees(award.lng, award.lat, 0),
	            pixelSize: 15,
	            color: new _Cesium2.default.Color(215 / 255, 238 / 255, 251 / 255, 1.0),
	            outlineColor: new _Cesium2.default.Color(215 / 255, 238 / 255, 251 / 255, 0.15),
	            outlineWidth: 0.5,
	            id: Object.assign({}, award, { type: 'award' })
	          });
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'cameraFlyToCenterHeight',
	    value: function cameraFlyToCenterHeight(center) {
	      var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var complete = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.handleCameraFlyTo;
	
	      // console.log("cameraFlyToCenterHeight",{center,height})
	      if (!this.state.cameraIsFlying) {
	
	        this.setState({
	          cameraIsFlying: true
	        });
	        this.props.setCameraIsFlying(true);
	
	        this.viewer.camera.flyTo({
	          destination: _Cesium2.default.Cartesian3.fromDegrees(center.lng, center.lat, height),
	          duration: duration,
	          easingFunction: _Cesium2.default.EasingFunction.QUADRACTIC_IN_OUT,
	          complete: complete
	        });
	      }
	    }
	  }, {
	    key: 'cameraFlyToBounds',
	    value: function cameraFlyToBounds(bounds) {
	      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var complete = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.handleCameraFlyTo;
	
	      // console.log("cameraFlyToBounds",{bounds})
	      if (!this.state.cameraIsFlying) {
	
	        this.setState({
	          cameraIsFlying: true
	        });
	        this.props.setCameraIsFlying(true);
	
	        this.viewer.camera.flyTo({
	          destination: _Cesium2.default.Rectangle.fromDegrees(bounds.west, bounds.south, bounds.east, bounds.north),
	          duration: duration,
	          easingFunction: _Cesium2.default.EasingFunction.QUADRACTIC_IN_OUT,
	          complete: complete
	        });
	      }
	    }
	  }, {
	    key: 'handleCameraFlyTo',
	    value: function handleCameraFlyTo() {
	      // console.log('handleCameraFlyTo')
	
	      this.propagateViewport();
	
	      // if (this.props.selectedEntity) {
	
	      //   if (this.props.mode == 'live') {
	      //     let location = this.props.selectedEntity.lat+','+this.props.selectedEntity.lng
	      //     this.drawBatteriesNetActive(this.props.selectedEntity, this.batteriesNetPositions[location], true)
	      //   }
	
	      //   this.props.setSelectedObject(this.props.selectedEntity)
	      //   this.props.setSelectedEntity(null)
	      //   this.setState({
	      //     pickedObject: null,
	      //     cameraIsFlying: false,
	      //     selectedObject: null,
	      //     // selectedPosition: this.getViewCenter(),
	      //     // selectedMagnitude: this.getViewMagnitude(),
	      //   })
	      // } else {
	      this.setState({
	        cameraIsFlying: false
	      });
	      this.props.setCameraIsFlying(false);
	      // }
	
	      if (this.state.pickedObject) {
	        this.props.setEntityIsLoading(this.state.pickedObject.type);
	        setTimeout(this.loadObject, 500, this.state.pickedObject);
	      }
	    }
	  }, {
	    key: 'loadObject',
	    value: function loadObject(object) {
	      switch (object.type) {
	        case 'battery':
	          this.props.loadBattery(object.id);
	          break;
	
	        case 'video':
	          this.props.loadVideo(object.id);
	          break;
	
	        case 'ambassador':
	          this.props.loadAmbassador(object.id);
	          break;
	      }
	      this.setState({
	        pickedObject: null
	      });
	    }
	
	    // 1. load world -> places have weight
	    // 2. on zoom out no place loading
	    // 3. on zoom in check max weight in bounds
	    // 4. on move check max weight in bounds
	    // - if max weight == 1 no places loading
	    // - if max weight > 1 load places for bounds
	    // - set height thresholds
	    // always round bounds (depending on height)
	
	    // load helper
	
	  }, {
	    key: 'loadBatteriesByBounds',
	    value: function loadBatteriesByBounds() {
	      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var forceLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var forceBounds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	
	      var bounds = forceBounds ? forceBounds : this.getViewBounds();
	      // console.log({bounds})
	
	      if (bounds.south <= -90 && bounds.north >= 90 && bounds.west <= -180 && bounds.east >= 180) {
	        if (!forceLoad && this.globeLoaded) {
	          return;
	        }
	        this.globeLoaded = true;
	      }
	
	      if (forceLoad) {
	        // console.log("LOAD force",bounds)
	        this.props.loadBatteriesByBounds(bounds.south.toFixed(2), bounds.west.toFixed(2), bounds.north.toFixed(2), bounds.east.toFixed(2), limit, page);
	        return;
	      }
	    }
	
	    // propagate viewport values to props + selectors
	
	  }, {
	    key: 'propagateViewport',
	    value: function propagateViewport() {
	      // console.log('propagateViewport',this.getViewBounds())
	      // this.addBoundaries(this.getViewMagnitude() <= 7500 ? '50m' : '110m')
	      this.props.setViewport(this.getViewBounds(), this.getViewCenter(), this.getViewHeight(), this.getViewMagnitude());
	
	      // console.log("propagateViewport",this.shouldUpdateBatteriesNet(),this.shouldRemoveBatteriesNet())
	      this.updateBatteriesNet();
	    }
	  }, {
	    key: 'updateBatteriesNet',
	    value: function updateBatteriesNet() {
	      var forceRedraw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.shouldUpdateBatteriesNet()) {
	
	        this.setState({
	          center: this.getViewCenter(0),
	          height: this.getViewHeight(0),
	          magnitude: this.getViewMagnitude(0)
	        });
	
	        // console.log("propagateViewport")
	        if (forceRedraw) {
	          this.removeBatteriesNet();
	        }
	        this.drawBatteriesNet(this.props.batteriesNetByBounds);
	      } else if (this.shouldRemoveBatteriesNet()) {
	
	        this.removeBatteriesNet();
	      }
	    }
	
	    // magnitude helper
	
	  }, {
	    key: 'getViewMagnitude',
	    value: function getViewMagnitude() {
	      var round = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	
	      // distance to globe center
	      if (round > 0) {
	        return Math.round(this.viewer.camera.getMagnitude() / round);
	      } else {
	        return this.viewer.camera.getMagnitude();
	      }
	    }
	
	    // height helper
	
	  }, {
	    key: 'getViewHeight',
	    value: function getViewHeight() {
	      var round = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	      // height from surface
	      if (round > 0) {
	        return Math.round(this.viewer.camera.positionCartographic.height);
	      } else {
	        return this.viewer.camera.positionCartographic.height;
	      }
	    }
	
	    // center helper
	
	  }, {
	    key: 'getViewCenter',
	    value: function getViewCenter() {
	      var round = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	
	      switch (true) {
	        case !this.viewer:
	        case !this.viewer.camera:
	        case !this.viewer.scene:
	        case !this.viewer.scene.globe:
	        case !this.viewer.scene.globe.ellipsoid:
	        case !this.viewer.container.clientWidth:
	        case !this.viewer.container.clientHeight:
	          return { lng: 0, lat: 0 };
	      }
	      var windowPosition = new _Cesium2.default.Cartesian2(this.viewer.container.clientWidth / 2, this.viewer.container.clientHeight / 2);
	      var pickRay = this.viewer.camera.getPickRay(windowPosition);
	      var pickPosition = this.viewer.scene.globe.pick(pickRay, this.viewer.scene);
	      if (!pickPosition) {
	        return { lng: 0, lat: 0 };
	      }
	      var pickPositionCartographic = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(pickPosition);
	
	      if (round > 0) {
	        return {
	          lng: Math.round(pickPositionCartographic.longitude * (180 / Math.PI) * round) / round,
	          lat: Math.round(pickPositionCartographic.latitude * (180 / Math.PI) * round) / round
	        };
	      } else {
	        return {
	          lng: pickPositionCartographic.longitude * (180 / Math.PI),
	          lat: pickPositionCartographic.latitude * (180 / Math.PI)
	        };
	      }
	    }
	
	    // bounds helper
	
	  }, {
	    key: 'getViewBounds',
	    value: function getViewBounds() {
	      switch (true) {
	        case !this.viewer:
	        case !this.viewer.scene:
	        case !this.viewer.camera:
	          return { west: -180, south: -90, east: 180, north: 90 };
	      }
	
	      var rect = this.viewer.camera.computeViewRectangle();
	      var bounds = {};
	      // let padding = .1
	
	      bounds.west = Math.floor(_Cesium2.default.Math.toDegrees(rect.west) * 10) / 10;
	      bounds.south = Math.floor(_Cesium2.default.Math.toDegrees(rect.south) * 10) / 10;
	      bounds.east = Math.ceil(_Cesium2.default.Math.toDegrees(rect.east) * 10) / 10;
	      bounds.north = Math.ceil(_Cesium2.default.Math.toDegrees(rect.north) * 10) / 10;
	
	      // console.log(bounds.west+bounds.east,bounds.south+bounds.north)
	
	      return bounds;
	    }
	
	    // image provider helper
	
	  }, {
	    key: 'getImageryProvider',
	    value: function getImageryProvider(type) {
	
	      var imageryProvider = void 0;
	
	      switch (type) {
	        case 'mapbox':
	          var MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoibmJhdSIsImEiOiJjajFjNmtmcmQwMDhtMndydWZoNndlNjZmIn0.7rc2bp0qsTwbeQ2vL1oZqw';
	          var MAPBOX_STYLE_ID = 'cj1eskg5p00i82rqszyr2ejrp'; // 'cj06tsqdu00he2rmvkjysgfvw' // 'satellite-v9'
	          var MAPBOX_USERNAME = 'nbau'; // 'mapbox'
	          var MAPBOX_TILE_SIZE = '512'; // '256' or '512'
	
	          // defaults
	          // mapbox://styles/mapbox/streets-v9
	          // mapbox://styles/mapbox/outdoors-v9
	          // mapbox://styles/mapbox/light-v9
	          // mapbox://styles/mapbox/dark-v9
	          // mapbox://styles/mapbox/satellite-v9
	          // mapbox://styles/mapbox/satellite-streets-v9
	
	          var mapboxUrl = 'https://api.mapbox.com/styles/v1/' + MAPBOX_USERNAME + '/' + MAPBOX_STYLE_ID + '/tiles/' + MAPBOX_TILE_SIZE + '/{z}/{x}/{y}?access_token=' + MAPBOX_ACCESS_TOKEN;
	          imageryProvider = new _Cesium2.default.UrlTemplateImageryProvider({
	            url: mapboxUrl,
	            tileWidth: MAPBOX_TILE_SIZE,
	            tileHeight: MAPBOX_TILE_SIZE,
	            enablePickFeatures: false
	          });
	          break;
	
	        case 'bing':
	          imageryProvider = new _Cesium2.default.BingMapsImageryProvider({
	            url: 'https://dev.virtualearth.net',
	            key: 'AnNNVBbVn4tyPlGfi-oruHoZi1Mffv3HXel_t78xjF8bBW837HXiuAgnHXGKmVpO',
	            mapStyle: _Cesium2.default.BingMapsStyle.ROAD
	          });
	          break;
	
	        case 'osm':
	          imageryProvider = new _Cesium2.default.createOpenStreetMapImageryProvider({
	            url: 'https://a.tile.openstreetmap.org/'
	          });
	          break;
	
	        case 'arcgis':
	          imageryProvider = new _Cesium2.default.WebMapServiceImageryProvider({
	            url: 'https://sampleserver1.arcgisonline.com/ArcGIS/services/Specialty/ESRI_StatesCitiesRivers_USA/MapServer/WMSServer',
	            layers: '0',
	            proxy: new _Cesium2.default.DefaultProxy('/proxy/')
	          });
	          break;
	
	        case 'basemap':
	        default:
	          imageryProvider = new _Cesium2.default.ArcGisMapServerImageryProvider({
	            url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
	            tileWidth: 256,
	            tileHeight: 256,
	            enablePickFeatures: false,
	            usePreCachedTilesIfAvailable: true
	          });
	          break;
	      }
	      return imageryProvider;
	    }
	  }]);
	
	  return CesiumWidgetClass;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    selectedEntity: (0, _selectors.getSelectedEntity)(state),
	    batteriesNetByBounds: (0, _selectors.getBatteriesNetByBounds)(state),
	    batteriesByTiles: (0, _selectors.getBatteriesByTiles)(state),
	    weightBounds: (0, _selectors.getWeightBounds)(state),
	
	    batteries: (0, _selectors.getBatteries)(state),
	    videos: (0, _selectors.getVideos)(state),
	    ambassadors: (0, _selectors.getAmbassadors)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var CesiumWidget = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CesiumWidgetClass);
	
	exports.default = CesiumWidget;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(53);
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(33);
	
	var actionCreators = _interopRequireWildcard(_actions);
	
	var _Header = __webpack_require__(104);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Logo = __webpack_require__(54);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _IndieButton = __webpack_require__(105);
	
	var _IndieButton2 = _interopRequireDefault(_IndieButton);
	
	var _CesiumWidget = __webpack_require__(100);
	
	var _CesiumWidget2 = _interopRequireDefault(_CesiumWidget);
	
	var _InfoBox = __webpack_require__(106);
	
	var _InfoBox2 = _interopRequireDefault(_InfoBox);
	
	var _GeoMarker = __webpack_require__(103);
	
	var _GeoMarker2 = _interopRequireDefault(_GeoMarker);
	
	var _MasterForm = __webpack_require__(109);
	
	var _MasterForm2 = _interopRequireDefault(_MasterForm);
	
	var _Intro = __webpack_require__(107);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _Zoom = __webpack_require__(112);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	var _Ambilight = __webpack_require__(99);
	
	var _Ambilight2 = _interopRequireDefault(_Ambilight);
	
	var _Localizer = __webpack_require__(108);
	
	var _Localizer2 = _interopRequireDefault(_Localizer);
	
	var _Footer = __webpack_require__(102);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CoreLayout = function (_React$Component) {
	  _inherits(CoreLayout, _React$Component);
	
	  function CoreLayout(props) {
	    _classCallCheck(this, CoreLayout);
	
	    return _possibleConstructorReturn(this, (CoreLayout.__proto__ || Object.getPrototypeOf(CoreLayout)).call(this, props));
	  }
	
	  _createClass(CoreLayout, [{
	    key: 'render',
	    value: function render() {
	      var _React$createElement;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Header2.default, {
	          style: { position: 'absolute', top: 0, left: 0, right: 0 },
	          mode: this.props.map.mode,
	          setMode: this.props.setMode,
	          setBounds: this.props.setBounds,
	          unsetSelectedEntity: this.props.unsetSelectedEntity
	        }),
	        _react2.default.createElement(_Logo2.default, null),
	        _react2.default.createElement(_IndieButton2.default, {
	          showForm: this.props.map.showForm,
	          setShowForm: this.props.setShowForm
	        }),
	        _react2.default.createElement(_CesiumWidget2.default, (_React$createElement = {
	          mode: this.props.map.mode,
	          zoom: this.props.map.zoom,
	          setCameraIsFlying: this.props.setCameraIsFlying,
	          entityIsLoading: this.props.entityIsLoading,
	
	          targetBounds: this.props.map.targetBounds,
	          targetCenter: this.props.map.targetCenter,
	          targetHeight: this.props.map.targetHeight,
	          targetDuration: this.props.map.targetDuration,
	
	          setBounds: this.props.setBounds,
	          setCenterHeight: this.props.setCenterHeight,
	          setViewport: this.props.setViewport,
	
	          currentBounds: this.props.map.currentBounds,
	          currentCenter: this.props.map.currentCenter,
	          currentHeight: this.props.map.currentHeight,
	          currentMagnitude: this.props.map.currentMagnitude
	
	        }, _defineProperty(_React$createElement, 'entityIsLoading', this.props.entityIsLoading), _defineProperty(_React$createElement, 'setEntityIsLoading', this.props.setEntityIsLoading), _defineProperty(_React$createElement, 'unsetEntityIsLoading', this.props.unsetEntityIsLoading), _defineProperty(_React$createElement, 'selectedEntity', this.props.selectedEntity), _defineProperty(_React$createElement, 'unsetSelectedEntity', this.props.unsetSelectedEntity), _defineProperty(_React$createElement, 'loadBatteriesByBounds', this.props.loadBatteriesByBounds), _defineProperty(_React$createElement, 'loadBattery', this.props.loadBattery), _defineProperty(_React$createElement, 'loadVideosByBounds', this.props.loadVideosByBounds), _defineProperty(_React$createElement, 'loadVideo', this.props.loadVideo), _defineProperty(_React$createElement, 'loadAmbassadorsByBounds', this.props.loadAmbassadorsByBounds), _defineProperty(_React$createElement, 'loadAmbassador', this.props.loadAmbassador), _defineProperty(_React$createElement, 'loadAwardsByBounds', this.props.loadAwardsByBounds), _defineProperty(_React$createElement, 'loadAward', this.props.loadAward), _React$createElement)),
	        _react2.default.createElement(_InfoBox2.default, {
	          entityIsLoading: this.props.entityIsLoading,
	          entityType: this.props.entityType,
	          selectedEntity: this.props.selectedEntity,
	          showForm: this.props.map.showForm,
	          setShowForm: this.props.setShowForm,
	          cameraIsFlying: this.props.map.cameraIsFlying
	        }),
	        _react2.default.createElement(_GeoMarker2.default, {
	          entityIsLoading: this.props.entityIsLoading,
	          selectedEntity: this.props.selectedEntity,
	          cameraIsFlying: this.props.map.cameraIsFlying
	        }),
	        _react2.default.createElement(_MasterForm2.default, {
	          mode: this.props.map.mode,
	          showForm: this.props.map.showForm,
	          setShowForm: this.props.setShowForm,
	          selectedEntity: this.props.selectedEntity
	        }),
	        _react2.default.createElement(_Intro2.default, null),
	        _react2.default.createElement(_Zoom2.default, {
	          zoomIncrement: this.props.zoomIncrement,
	          zoomDecrement: this.props.zoomDecrement,
	          unsetSelectedEntity: this.props.unsetSelectedEntity
	        }),
	        _react2.default.createElement(_Ambilight2.default, null),
	        _react2.default.createElement(_Localizer2.default, {
	          unsetSelectedEntity: this.props.unsetSelectedEntity,
	          setCenterHeight: this.props.setCenterHeight
	        }),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return CoreLayout;
	}(_react2.default.Component);
	
	function mapStateToProps(state, ownProps) {
	  return {
	    map: state.map,
	    selectedEntity: state.entities.selected,
	    entityIsLoading: state.entities.entity_is_loading,
	    entityType: state.entities.entity_type
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CoreLayout);

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	
	      var linkImprint = void 0,
	          linkPrivacy = void 0;
	      var location = (0, _helpers.getLanguage)().toUpperCase();
	      switch (location) {
	        case 'DE':
	          linkImprint = 'https://sonnenbatterie.de/de/impressum';
	          linkPrivacy = 'https://sonnenbatterie.de/de/datenschutz';
	          break;
	        case 'EN':
	          linkImprint = 'https://sonnenbatterie.de/en/imprint-0';
	          linkPrivacy = 'https://sonnenbatterie.de/en/privacy-policy';
	          break;
	        case 'IT':
	          linkImprint = 'https://www.sonnenbatterie.de/it/node/972';
	          linkPrivacy = 'https://sonnenbatterie.de/it/privacy';
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Footer' },
	        _react2.default.createElement(
	          'a',
	          { href: linkImprint, target: '_blank' },
	          (0, _helpers.__)('Footer.imprint')
	        ),
	        '\xA0|\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: linkPrivacy, target: '_blank' },
	          (0, _helpers.__)('Footer.privacy')
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _geomarker = __webpack_require__(263);
	
	var _geomarker2 = _interopRequireDefault(_geomarker);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactRedux = __webpack_require__(18);
	
	var _selectors = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  entityIsLoading: _react2.default.PropTypes.bool.isRequired,
	  cameraIsFlying: _react2.default.PropTypes.bool.isRequired,
	  selectedEntity: _react2.default.PropTypes.object
	};
	
	var GeoMarkerClass = function (_React$Component) {
	  _inherits(GeoMarkerClass, _React$Component);
	
	  function GeoMarkerClass(props) {
	    _classCallCheck(this, GeoMarkerClass);
	
	    return _possibleConstructorReturn(this, (GeoMarkerClass.__proto__ || Object.getPrototypeOf(GeoMarkerClass)).call(this, props));
	  }
	
	  _createClass(GeoMarkerClass, [{
	    key: 'render',
	    value: function render() {
	      if (!this.props.entityIsLoading && (!this.props.selectedEntity || this.props.cameraIsFlying)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'GeoMarker' },
	          _react2.default.createElement('img', { className: 'GeoMarker-image GeoMarker-image--hidden', src: _geomarker2.default })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'GeoMarker' },
	        _react2.default.createElement('img', { className: 'GeoMarker-image GeoMarker-image--visible', src: _geomarker2.default })
	      );
	    }
	  }]);
	
	  return GeoMarkerClass;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	GeoMarkerClass.propTypes = propTypes;
	
	var GeoMarker = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GeoMarkerClass);
	
	exports.default = GeoMarker;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _Navigation = __webpack_require__(110);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Logo = __webpack_require__(54);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Search = __webpack_require__(111);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  mode: _react2.default.PropTypes.string.isRequired,
	  setMode: _react2.default.PropTypes.func.isRequired,
	  setCenter: _react2.default.PropTypes.func.isRequired,
	  setBounds: _react2.default.PropTypes.func.isRequired,
	  setSelectedObject: _react2.default.PropTypes.func.isRequired
	};
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	  }
	
	  _createClass(Header, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Header' },
	        _react2.default.createElement(_Navigation2.default, {
	          mode: this.props.mode,
	          setMode: this.props.setMode
	        }),
	        _react2.default.createElement(_Search2.default, {
	          setBounds: this.props.setBounds,
	          unsetSelectedEntity: this.props.unsetSelectedEntity
	        })
	      );
	    }
	  }]);
	
	  return Header;
	}(_react2.default.Component);
	
	Header.propTypes = propTypes;
	
	exports.default = Header;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  showForm: _react2.default.PropTypes.string.isRequired,
	  setShowForm: _react2.default.PropTypes.func.isRequired
	};
	
	var IndieButton = function (_React$Component) {
	  _inherits(IndieButton, _React$Component);
	
	  function IndieButton(props) {
	    _classCallCheck(this, IndieButton);
	
	    var _this = _possibleConstructorReturn(this, (IndieButton.__proto__ || Object.getPrototypeOf(IndieButton)).call(this, props));
	
	    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(IndieButton, [{
	    key: 'handleButtonClick',
	    value: function handleButtonClick(event) {
	      this.props.setShowForm(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        { className: 'IndieButton', ref: 'btn', onClick: this.handleButtonClick },
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.__)('IndieButton.line1')
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            (0, _helpers.__)('IndieButton.line2')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.__)('IndieButton.line3')
	        )
	      );
	    }
	  }]);
	
	  return IndieButton;
	}(_react2.default.Component);
	
	exports.default = IndieButton;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactPlayer = __webpack_require__(82);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _selectors = __webpack_require__(35);
	
	var _helpers = __webpack_require__(6);
	
	var _Avatar_Eco8_grau2x = __webpack_require__(257);
	
	var _Avatar_Eco8_grau2x2 = _interopRequireDefault(_Avatar_Eco8_grau2x);
	
	var _Avatar_Eco8_grau_display2x = __webpack_require__(258);
	
	var _Avatar_Eco8_grau_display2x2 = _interopRequireDefault(_Avatar_Eco8_grau_display2x);
	
	var _Avatar_Eco8_schwarz2x = __webpack_require__(259);
	
	var _Avatar_Eco8_schwarz2x2 = _interopRequireDefault(_Avatar_Eco8_schwarz2x);
	
	var _Avatar_Eco8_schwarz_display2x = __webpack_require__(260);
	
	var _Avatar_Eco8_schwarz_display2x2 = _interopRequireDefault(_Avatar_Eco8_schwarz_display2x);
	
	var _Avatar_Eco8_weiss2x = __webpack_require__(261);
	
	var _Avatar_Eco8_weiss2x2 = _interopRequireDefault(_Avatar_Eco8_weiss2x);
	
	var _Avatar_Eco8_weiss_display2x = __webpack_require__(262);
	
	var _Avatar_Eco8_weiss_display2x2 = _interopRequireDefault(_Avatar_Eco8_weiss_display2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  mode: _react2.default.PropTypes.string.isRequired,
	  setMode: _react2.default.PropTypes.func.isRequired,
	  entityIsLoading: _react2.default.PropTypes.bool.isRequired,
	  cameraIsFlying: _react2.default.PropTypes.bool.isRequired,
	  selectedEntity: _react2.default.PropTypes.object
	};
	
	var InfoBoxClass = function (_React$Component) {
	  _inherits(InfoBoxClass, _React$Component);
	
	  function InfoBoxClass(props) {
	    _classCallCheck(this, InfoBoxClass);
	
	    var _this = _possibleConstructorReturn(this, (InfoBoxClass.__proto__ || Object.getPrototypeOf(InfoBoxClass)).call(this, props));
	
	    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	    _this.handleVideo = _this.handleVideo.bind(_this);
	    return _this;
	  }
	
	  _createClass(InfoBoxClass, [{
	    key: 'handleButtonClick',
	    value: function handleButtonClick(event) {
	      this.props.setShowForm(true);
	    }
	  }, {
	    key: 'handleVideo',
	    value: function handleVideo(event) {
	      this.video.player.player.playVideo();
	      this.video.player.player.pauseVideo();
	      this.video.player.player.playVideo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var className = void 0;
	      if (this.props.entityIsLoading) {
	        className = 'InfoBox InfoBox--loading InfoBox--' + this.props.entityType;
	        return _react2.default.createElement(
	          'div',
	          { className: className },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      if (!this.props.selectedEntity || this.props.cameraIsFlying) {
	        className = 'InfoBox InfoBox--hidden InfoBox--' + this.props.entityType;
	        return _react2.default.createElement('div', { className: className });
	      }
	
	      var _props$selectedEntity = this.props.selectedEntity,
	          id = _props$selectedEntity.id,
	          type = _props$selectedEntity.type,
	          location = _props$selectedEntity.location,
	          battery = _props$selectedEntity.battery,
	          video = _props$selectedEntity.video,
	          ambassador = _props$selectedEntity.ambassador,
	          award = _props$selectedEntity.award;
	
	      // if no photo provided
	
	      var imageSource = void 0;
	      if (battery && battery.photos && battery.photos.length > 0) {
	        imageSource = battery.photos[0];
	      } else if (ambassador && ambassador.photos && ambassador.photos.length > 0) {
	        imageSource = ambassador.photos[0].url;
	      } else if (id) {
	        switch (parseInt(id, 36).toString().slice(-1)) {
	          case "4": // 20%
	          case "5":
	            imageSource = _Avatar_Eco8_weiss_display2x2.default;
	            break;
	          case "6":
	            // 10%
	            imageSource = _Avatar_Eco8_grau2x2.default;
	            break;
	          case "7":
	            // 10%
	            imageSource = _Avatar_Eco8_grau_display2x2.default;
	            break;
	          case "8":
	            // 10%
	            imageSource = _Avatar_Eco8_schwarz2x2.default;
	            break;
	          case "9":
	            // 10%
	            imageSource = _Avatar_Eco8_schwarz_display2x2.default;
	            break;
	          case "0": // 40%
	          case "1":
	          case "2":
	          case "3":
	          default:
	            imageSource = _Avatar_Eco8_weiss2x2.default;
	            break;
	        }
	      } else {
	        imageSource = _Avatar_Eco8_weiss2x2.default;
	      }
	
	      var i = _react2.default.createElement('div', { className: 'InfoBox-imageContainer', style: { backgroundImage: 'url(' + imageSource + ')' } });
	      var title = (0, _helpers.__)('InfoBox.sonnenBatterie');
	      var displayName = void 0;
	      var statement = void 0;
	      var ambassadorSince = void 0;
	      var ambassadorSinceYear = void 0;
	      var monthNumber = void 0;
	      var monthName = void 0;
	      var capacity = void 0;
	      var autonomy7d = void 0;
	      var pvsize = void 0;
	      var cta = (0, _helpers.__)('InfoBox.cta');
	      var disclaimer = void 0;
	      switch (true) {
	
	        case ambassador != null:
	          title = ambassador.name;
	          if (battery) {
	            displayName = _react2.default.createElement(
	              'p',
	              null,
	              battery.address
	            );
	          }
	          statement = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'em',
	              null,
	              ambassador.statement
	            ),
	            _react2.default.createElement('br', null)
	          );
	          // ambassador.since date formatting
	          if (ambassador.since) {
	            ambassadorSinceYear = ambassador.since.split('-')[0];
	            monthNumber = ambassador.since.split('-')[1];
	            switch (monthNumber) {
	              case '01':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'Januar';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'January';
	                }
	                break;
	              case '02':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'Februar';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'February';
	                }
	                break;
	              case '03':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'März';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'March';
	                }
	                break;
	              case '04':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'April';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'April';
	                }
	                break;
	              case '05':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'Mai';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'May';
	                }
	                break;
	              case '06':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'Juni';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'June';
	                }
	                break;
	              case '07':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'Juli';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'July';
	                }
	                break;
	              case '08':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'August';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'August';
	                }
	                break;
	              case '09':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'September';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'September';
	                }
	                break;
	              case '10':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'Oktober';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'October';
	                }
	                break;
	              case '11':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'November';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'November';
	                }
	                break;
	              case '12':
	                if ((0, _helpers.getLanguage)().toUpperCase() == 'DE') {
	                  monthName = 'Dezember';
	                } else if ((0, _helpers.getLanguage)().toUpperCase() == 'EN') {
	                  monthName = 'December';
	                }
	                break;
	            }
	            ambassadorSince = _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'strong',
	                null,
	                (0, _helpers.__)('InfoBox.ambassadorSince'),
	                ':'
	              ),
	              ' ',
	              monthName,
	              ' ',
	              ambassadorSinceYear
	            );
	          }
	          if (battery) {
	            if (battery.capacity != 0 && battery.capacity != null) {
	              capacity = _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  (0, _helpers.__)('InfoBox.capacity'),
	                  ':'
	                ),
	                ' ',
	                battery.capacity,
	                ' kWh'
	              );
	            }
	          }
	          // autonomy7d = <span><br /><strong>{__('InfoBox.autonomy')}:</strong> {battery.autonomy7d} %</span>
	          // pvsize = <span><br /><strong>{__('InfoBox.pvSize')}:</strong> {battery.pvsize} kWp</span>
	          cta = (0, _helpers.__)('InfoBox.ctaAmbassador');
	          disclaimer = _react2.default.createElement(
	            'span',
	            { style: { display: 'block', marginTop: '20px' } },
	            (0, _helpers.__)('InfoBox.disclaimer')
	          );
	          break;
	
	        case award != null:
	          statement = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'em',
	              null,
	              award.statement
	            ),
	            _react2.default.createElement('br', null)
	          );
	          break;
	
	        case video != null:
	          i = _react2.default.createElement(_reactPlayer2.default, {
	            url: video.url,
	            playing: false,
	            volume: 0.75,
	            youtubeConfig: { playerVars: { autoplay: 1, preload: true } },
	            className: 'Story-video',
	            onReady: this.handleVideo,
	            ref: function ref(video) {
	              _this2.video = video;
	            },
	            playsinline: true,
	            controls: true
	          });
	          title = video.title;
	          break;
	
	        case battery != null:
	          displayName = _react2.default.createElement(
	            'p',
	            null,
	            battery.address
	          );
	          if (battery.capacity != 0 && battery.capacity != null) {
	            capacity = _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'strong',
	                null,
	                (0, _helpers.__)('InfoBox.capacity'),
	                ':'
	              ),
	              ' ',
	              battery.capacity,
	              ' kWh'
	            );
	          }
	          if (battery.autonomy7d != 0 && battery.autonomy7d != null) {
	            autonomy7d = _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'strong',
	                null,
	                (0, _helpers.__)('InfoBox.autonomy'),
	                ':'
	              ),
	              ' ',
	              battery.autonomy7d,
	              ' %'
	            );
	          }
	          if (battery.pvsize != 0 && battery.pvsize != null) {
	            pvsize = _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'strong',
	                null,
	                (0, _helpers.__)('InfoBox.pvSize'),
	                ':'
	              ),
	              ' ',
	              battery.pvsize,
	              ' kWp'
	            );
	          }
	          break;
	      }
	
	      var infos = void 0;
	      if (id) {
	        infos = _react2.default.createElement(
	          'div',
	          null,
	          i,
	          _react2.default.createElement(
	            'div',
	            { className: 'InfoBox-Innertext' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              title
	            ),
	            displayName,
	            _react2.default.createElement(
	              'div',
	              { className: 'InfoBox-Statement' },
	              statement
	            ),
	            ambassadorSince,
	            capacity,
	            autonomy7d,
	            pvsize
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'InfoBox-Button' },
	            _react2.default.createElement(
	              'a',
	              { ref: 'btn', onClick: this.handleButtonClick },
	              _react2.default.createElement(
	                'div',
	                { className: 'btn' },
	                cta
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'InfoBox-Disclaimer' },
	            disclaimer
	          )
	        );
	      }
	
	      className = id ? 'InfoBox InfoBox--visible' : 'InfoBox InfoBox--hidden';
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        infos
	      );
	    }
	  }]);
	
	  return InfoBoxClass;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	InfoBoxClass.propTypes = propTypes;
	
	var InfoBox = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InfoBoxClass);
	
	exports.default = InfoBox;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlayer = __webpack_require__(82);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _sonnen = __webpack_require__(256);
	
	var _sonnen2 = _interopRequireDefault(_sonnen);
	
	var _sonnen3 = __webpack_require__(255);
	
	var _sonnen4 = _interopRequireDefault(_sonnen3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Intro = function (_React$Component) {
	  _inherits(Intro, _React$Component);
	
	  function Intro(props) {
	    _classCallCheck(this, Intro);
	
	    var _this = _possibleConstructorReturn(this, (Intro.__proto__ || Object.getPrototypeOf(Intro)).call(this, props));
	
	    _this.handleVideoFadeout = _this.handleVideoFadeout.bind(_this);
	    _this.handleVideoEnd = _this.handleVideoEnd.bind(_this);
	    _this.handleAudio = _this.handleAudio.bind(_this);
	    return _this;
	  }
	
	  _createClass(Intro, [{
	    key: 'handleVideoFadeout',
	    value: function handleVideoFadeout(event) {
	      setTimeout(function () {
	        if (document.getElementById('videoFade')) {
	          document.getElementById('videoFade').style.opacity = 0;
	        }
	      }.bind(this), 6000);
	    }
	  }, {
	    key: 'handleVideoEnd',
	    value: function handleVideoEnd(event) {
	      var el = document.getElementById('videoFade');
	      el.parentNode.removeChild(el);
	      // el.style.display = 'none'
	    }
	  }, {
	    key: 'handleAudio',
	    value: function handleAudio(event) {
	      this.introAudio.player.player.autoplay = true;
	      // console.log(this.introAudio)
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Intro-Container', id: 'videoFade' },
	        _react2.default.createElement(_reactPlayer2.default, {
	          url: _sonnen2.default,
	          className: 'Intro-Video',
	          width: '100%',
	          height: 'auto',
	          playing: true,
	          playsinline: true
	          //fileConfig={{ attributes: { autoPlay:true }}}
	          , onReady: this.handleVideoFadeout,
	          onEnded: this.handleVideoEnd,
	          ref: function ref(introVideo) {
	            _this2.introVideo = introVideo;
	          }
	        }),
	        _react2.default.createElement(_reactPlayer2.default, {
	          url: _sonnen4.default,
	          className: 'Intro-Sound',
	          playing: true,
	          playsinline: true,
	          volume: 1.0,
	          hidden: true,
	          onReady: this.handleAudio,
	          ref: function ref(introAudio) {
	            _this2.introAudio = introAudio;
	          }
	        })
	      );
	    }
	  }]);
	
	  return Intro;
	}(_react2.default.Component);
	
	exports.default = Intro;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  unsetSelectedEntity: _react2.default.PropTypes.func.isRequired,
	  setCenterHeight: _react2.default.PropTypes.func.isRequired
	};
	
	var Localizer = function (_React$Component) {
	  _inherits(Localizer, _React$Component);
	
	  function Localizer(props) {
	    _classCallCheck(this, Localizer);
	
	    var _this = _possibleConstructorReturn(this, (Localizer.__proto__ || Object.getPrototypeOf(Localizer)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.gotoUserPosition = _this.gotoUserPosition.bind(_this);
	    return _this;
	  }
	
	  _createClass(Localizer, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var _this2 = this;
	
	      this.props.unsetSelectedEntity();
	
	      fetch('https://geoip.nekudo.com/api/').then(function (response) {
	        return response.json();
	      }).then(function (position) {
	        _this2.gotoUserPosition(position.location.latitude, position.location.longitude);
	      });
	    }
	  }, {
	    key: 'gotoUserPosition',
	    value: function gotoUserPosition(lat, lng) {
	      this.props.setCenterHeight({ lat: lat, lng: lng }, null, 2);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Localizer' },
	        _react2.default.createElement('button', { onClick: this.handleClick })
	      );
	    }
	  }]);
	
	  return Localizer;
	}(_react2.default.Component);
	
	Localizer.propTypes = propTypes;
	
	exports.default = Localizer;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(6);
	
	__webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  showForm: _react2.default.PropTypes.string.isRequired,
	  setShowForm: _react2.default.PropTypes.func.isRequired,
	  mode: _react2.default.PropTypes.string.isRequired,
	  selectedEntity: _react2.default.PropTypes.object
	};
	
	var MasterForm = function (_React$Component) {
	  _inherits(MasterForm, _React$Component);
	
	  function MasterForm(props) {
	    _classCallCheck(this, MasterForm);
	
	    var _this2 = _possibleConstructorReturn(this, (MasterForm.__proto__ || Object.getPrototypeOf(MasterForm)).call(this, props));
	
	    _this2.handleSubmit = function (e) {
	      e.preventDefault();
	
	      _this2.setState({
	        isSending: true
	      });
	
	      var serialize = __webpack_require__(269);
	      var form = document.querySelector('.MasterFormElements');
	      var postData = serialize(form);
	
	      var productInterest__c = [];
	      if (_this2.eco.checked) {
	        productInterest__c.push('eco');
	      }
	      if (_this2.photovoltaics.checked) {
	        productInterest__c.push('Photovoltaics');
	      }
	
	      if (productInterest__c != '') {
	        postData += '&productInterest__c=' + productInterest__c.join('%3B');
	      }
	
	      postData += '&LeadType__c=Customer';
	      postData += '&ApiCampaign__c=70124000000OAvl';
	      postData += '&leadsource=Web';
	      postData += '&awarenessSource__c=sonnenCommunity%20live';
	      postData += '&language__c=' + (0, _helpers.getLanguage)().toUpperCase();
	      postData += '&awarenessSourceDetails__c=' + _this2.props.mode;
	
	      var clickedAmbassador = '';
	      if (_this2.props.selectedEntity) {
	        if (_this2.props.selectedEntity.ambassador) {
	          // clickedAmbassador = 'Preferred sonnenAmbassador: ' + this.props.selectedEntity.ambassador.name
	
	          var today = new Date();
	          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
	
	          clickedAmbassador = '-%20m%C3%B6chte%20Kontakt%20zu%20einem%20sonnenBotschafter%20%0D%0A-%20gew%C3%BCnschter%20sonnenBotschafter%3A%20' + _this2.props.selectedEntity.ambassador.name + '%20%0D%0A-%20bitte%20sonnenBotschafter%20Interesse%20nochmal%20best%C3%A4tigen%20lassen%0D%0A-%20Formular%20abgesendet%20am%3A%20' + date;
	        }
	      }
	
	      if (clickedAmbassador != '') {
	        postData += '&message__c=' + clickedAmbassador;
	      } else {
	        postData += '&message__c=null';
	      }
	
	      // console.log( postData )
	
	      var _this = _this2;
	
	      fetch('https://go.pardot.com/l/317971/2017-07-04/8dds', {
	        method: 'POST',
	        mode: 'no-cors',
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
	          'Accept': '*/*'
	        },
	        body: postData
	      }).then(function (result) {
	        //console.log( 'Result: ', result )
	
	        _this.setState({
	          isSending: false
	        });
	
	        document.getElementById('MasterFormSuccess').style.opacity = 1;
	        setTimeout(function () {
	          document.getElementById('MasterFormSuccess').style.opacity = 0;
	        }.bind(this), 5000);
	        setTimeout(function () {
	          _this.props.setShowForm(false);
	        }.bind(this), 5000);
	        setTimeout(function () {
	          _this.resetInput();
	        }, 5000);
	      }).catch(function (error) {
	        //console.log('Request failed:', error)
	        _this.setState({
	          isSending: false
	        });
	        document.getElementById('MasterFormError').style.opacity = 1;
	        setTimeout(function () {
	          document.getElementById('MasterFormError').style.opacity = 0;
	        }.bind(this), 5000);
	      });
	    };
	
	    _this2.handleCloseClick = _this2.handleCloseClick.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	
	    _this2.state = {
	      isSending: false
	    };
	
	    return _this2;
	  }
	
	  _createClass(MasterForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.eco.checked = 'checked';
	      this.photovoltaics.checked = 'checked';
	    }
	  }, {
	    key: 'handleCloseClick',
	    value: function handleCloseClick(event) {
	      this.props.setShowForm(false);
	    }
	  }, {
	    key: 'resetInput',
	    value: function resetInput() {
	      this.salutation.value = '';
	      this.firstname.value = '';
	      this.lastname.value = '';
	      this.email.value = '';
	      this.phone.value = '';
	      this.energy.value = '';
	      this.eco.checked = 'checked';
	      this.photovoltaics.checked = 'checked';
	      this.gdpr.checked = false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var classMasterForm = this.props.showForm == true ? 'MasterForm MasterForm--visible' : 'MasterForm MasterForm--hidden';
	
	      var buttonSubmit = this.state.isSending ? _react2.default.createElement(
	        'button',
	        { id: 'formButton', type: 'submit', tabindex: '11', disabled: true },
	        (0, _helpers.__)('MasterForm.submit')
	      ) : _react2.default.createElement(
	        'button',
	        { id: 'formButton', type: 'submit', tabindex: '11' },
	        (0, _helpers.__)('MasterForm.submit')
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: classMasterForm },
	        _react2.default.createElement(
	          'div',
	          { className: 'MasterFormContainer' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.__)('MasterForm.title')
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.handleCloseClick, className: 'MasterFormClose' },
	            _react2.default.createElement('img', { src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMxODFhMjc7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5zb25uZW5fdWlfY2xvc2Vmb3JtPC90aXRsZT48ZyBpZD0iRWJlbmVfMiIgZGF0YS1uYW1lPSJFYmVuZSAyIj48ZyBpZD0iRWJlbmVfMS0yIiBkYXRhLW5hbWU9IkViZW5lIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEyLjQxLDExbDkuMjktOS4yOUExLDEsMCwwLDAsMjAuMjkuMjlMMTEsOS41OSwxLjcxLjI5QTEsMSwwLDAsMCwuMjksMS43MUw5LjU5LDExLC4yOSwyMC4yOWExLDEsMCwxLDAsMS40MSwxLjQxTDExLDEyLjQxbDkuMjksOS4yOWExLDEsMCwwLDAsMS40MS0xLjQxWiIvPjwvZz48L2c+PC9zdmc+' })
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.handleSubmit, className: 'MasterFormElements' },
	            _react2.default.createElement(
	              'span',
	              { id: 'personalInformation' },
	              (0, _helpers.__)('MasterForm.personalInformation')
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'fieldSetName' },
	              _react2.default.createElement(
	                'label',
	                { className: 'MasterForm-Sets MasterForm-Salutation' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'MasterForm-Label' },
	                  (0, _helpers.__)('MasterForm.salutation'),
	                  '*'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'select',
	                  { id: 'salutation', name: 'salutation', tabindex: '1', required: true, autofocus: true, ref: function ref(salutation) {
	                      return _this3.salutation = salutation;
	                    } },
	                  _react2.default.createElement('option', { value: '', disabled: true, selected: true }),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'Mr.' },
	                    (0, _helpers.__)('MasterForm.male')
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'Ms.' },
	                    (0, _helpers.__)('MasterForm.female')
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'MasterForm-Sets MasterForm-Firstname' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'MasterForm-Label' },
	                  (0, _helpers.__)('MasterForm.firstname'),
	                  '*'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', { id: 'firstname', name: 'firstname', type: 'text', placeholder: '', tabindex: '2', required: true, ref: function ref(firstname) {
	                    return _this3.firstname = firstname;
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'MasterForm-Sets MasterForm-Lastname' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'MasterForm-Label' },
	                  (0, _helpers.__)('MasterForm.lastname'),
	                  '*'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', { id: 'lastname', name: 'lastname', type: 'text', placeholder: '', tabindex: '3', required: true, ref: function ref(lastname) {
	                    return _this3.lastname = lastname;
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'mailPhoneEnergy' },
	              _react2.default.createElement(
	                'label',
	                { className: 'MasterForm-Sets MasterForm-Email' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'MasterForm-Label' },
	                  (0, _helpers.__)('MasterForm.email'),
	                  '*'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', { id: 'email', name: 'email', type: 'email', placeholder: '', tabindex: '4', required: true, pattern: '[A-Za-z0-9._%+-]{2,}@[a-zA-Z]{1,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,4})', ref: function ref(email) {
	                    return _this3.email = email;
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'MasterForm-Sets MasterForm-Phone' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'MasterForm-Label' },
	                  (0, _helpers.__)('MasterForm.phone'),
	                  '*'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', { id: 'phone', name: 'phone', type: 'tel', placeholder: '', tabindex: '5', required: true, ref: function ref(phone) {
	                    return _this3.phone = phone;
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'checkBoxes' },
	              _react2.default.createElement(
	                'label',
	                { className: 'energyConsumption' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'MasterForm-Label' },
	                  (0, _helpers.__)('MasterForm.energyConsumption')
	                ),
	                _react2.default.createElement('input', { id: 'energy', name: 'EnergyConsumption__c', type: 'number', placeholder: (0, _helpers.__)('MasterForm.ecPlaceholder'), tabindex: '6', min: '0', max: '50000', step: '100', ref: function ref(energy) {
	                    return _this3.energy = energy;
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'infoCheckboxFirst' },
	                _react2.default.createElement('input', { type: 'checkbox', tabindex: '7', ref: function ref(eco) {
	                    return _this3.eco = eco;
	                  } }),
	                _react2.default.createElement(
	                  'span',
	                  { id: 'checkBoxCorrection' },
	                  (0, _helpers.__)('MasterForm.sonnenBatterie')
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement('input', { type: 'checkbox', tabindex: '8', ref: function ref(photovoltaics) {
	                    return _this3.photovoltaics = photovoltaics;
	                  } }),
	                _react2.default.createElement(
	                  'span',
	                  { id: 'checkBoxCorrection' },
	                  (0, _helpers.__)('MasterForm.pvAnlage')
	                )
	              ),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'gdprCheckbox' },
	              _react2.default.createElement(
	                'span',
	                { className: 'MasterForm-Label gdprHeadline' },
	                (0, _helpers.__)('MasterForm.gdprHeadline')
	              ),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement('input', { type: 'checkbox', tabindex: '9', required: true, ref: function ref(gdpr) {
	                    return _this3.gdpr = gdpr;
	                  } }),
	                _react2.default.createElement(
	                  'span',
	                  { id: 'gdprText' },
	                  (0, _helpers.__)('MasterForm.gdprCheckbox')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'buttonField' },
	              buttonSubmit
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'MasterForm-Legal' },
	            (0, _helpers.__)('MasterForm.requiredFields')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'MasterFormSuccess', id: 'MasterFormSuccess' },
	            (0, _helpers.__)('MasterForm.successMessage')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'MasterFormError', id: 'MasterFormError' },
	            (0, _helpers.__)('MasterForm.errorMessage')
	          )
	        )
	      );
	    }
	  }]);
	
	  return MasterForm;
	}(_react2.default.Component);
	
	MasterForm.propTypes = propTypes;
	
	exports.default = MasterForm;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _helpers = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  mode: _react2.default.PropTypes.string.isRequired,
	  setMode: _react2.default.PropTypes.func.isRequired
	};
	
	var Navigation = function (_React$Component) {
	  _inherits(Navigation, _React$Component);
	
	  function Navigation(props) {
	    _classCallCheck(this, Navigation);
	
	    var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));
	
	    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Navigation, [{
	    key: 'handleButtonClick',
	    value: function handleButtonClick(event) {
	      this.props.setMode(event.target.dataset.mode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classLive = this.props.mode == 'live' ? 'Navigation-button Navigation-button--live Navigation-button--active' : 'Navigation-button Navigation-button--live';
	
	      var classStories = this.props.mode == 'stories' ? 'Navigation-button Navigation-button--stories Navigation-button--active' : 'Navigation-button Navigation-button--stories';
	
	      var classAmbassadors = this.props.mode == 'ambassadors' ? 'Navigation-button Navigation-button--ambassadors Navigation-button--active' : 'Navigation-button Navigation-button--ambassadors';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Navigation' },
	        _react2.default.createElement(
	          'button',
	          { onClick: this.handleButtonClick, 'data-mode': 'live', className: classLive },
	          (0, _helpers.__)('Navigation.live')
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.handleButtonClick, 'data-mode': 'stories', className: classStories },
	          (0, _helpers.__)('Navigation.stories')
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.handleButtonClick, 'data-mode': 'ambassadors', className: classAmbassadors },
	          (0, _helpers.__)('Navigation.ambassadors')
	        )
	      );
	    }
	  }]);
	
	  return Navigation;
	}(_react2.default.Component);
	
	Navigation.propTypes = propTypes;
	
	exports.default = Navigation;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _map = __webpack_require__(34);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _helpers = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  unsetSelectedEntity: _react2.default.PropTypes.func.isRequired
	};
	
	var Search = function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.geocodeAddress = _this.geocodeAddress.bind(_this);
	    _this.handleGeocodeAddress = _this.handleGeocodeAddress.bind(_this);
	    _this.autoHideError = _this.autoHideError.bind(_this);
	    _this.initAutocomplete = _this.initAutocomplete.bind(_this);
	    _this.handleClearance = _this.handleClearance.bind(_this);
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	
	    _this.state = {
	      errorMessage: null,
	      acBounds: null,
	      classClearance: 'Searchfield-cleaner--hide'
	    };
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.geocoder = new google.maps.Geocoder();
	
	      if (window.innerWidth <= 560) {
	        document.getElementById('clearanceButton').style.width = '0px';
	        document.getElementById('clearanceButton').style.padding = '0px';
	        document.getElementById('searchInputField').style.width = '0px';
	      }
	
	      this.initAutocomplete();
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown() {
	      if (this.state.errorMessage) {
	        this.setState({
	          errorMessage: null
	        });
	      }
	    }
	  }, {
	    key: 'handleClearance',
	    value: function handleClearance() {
	      this.address.value = "";
	      this.setState({
	        classClearance: 'Searchfield-cleaner--hide'
	      });
	      document.getElementById('searchInputField').focus();
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus() {
	      setTimeout(function () {
	        this.address.setSelectionRange(0, this.address.value.length);
	      }.bind(this), 50);
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      if (this.address.value.length == 0) {
	        this.setState({
	          classClearance: 'Searchfield-cleaner--hide'
	        });
	      } else {
	        this.setState({
	          classClearance: 'Searchfield-cleaner'
	        });
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      if (event) {
	        event.preventDefault();
	      }
	
	      this.props.unsetSelectedEntity();
	
	      var address = this.address.value.trim();
	
	      if (window.innerWidth > 560) {
	        this.geocodeAddress(address);
	        document.getElementById('searchInputField').blur();
	      } else if (document.getElementById('searchInputField').style.width == '0px') {
	        document.getElementById('searchInputField').style.width = '260px';
	        document.getElementById('searchInputField').style.padding = '11px 5%';
	        document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '0px';
	        document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '0px';
	        document.getElementById('clearanceButton').style.width = '32px';
	        document.getElementById('clearanceButton').style.padding = '8px';
	        document.getElementById('searchInputField').focus();
	      } else if (address.trim() == '') {
	        this.setState({
	          errorMessage: (0, _helpers.__)('Search.errorEmpty')
	        });
	        return;
	      } else {
	        this.geocodeAddress(address);
	        document.getElementById('searchInputField').blur();
	        document.getElementById('searchInputField').style.width = '0px';
	        document.getElementById('searchInputField').style.padding = '11px 0px';
	        document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '3px';
	        document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '3px';
	        document.getElementById('clearanceButton').style.width = '0px';
	        document.getElementById('clearanceButton').style.padding = '0px';
	      }
	    }
	  }, {
	    key: 'autoHideError',
	    value: function autoHideError() {
	      setTimeout(function () {
	        this.setState({
	          errorMessage: null
	        });
	      }.bind(this), 3000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var label = void 0;
	      if (this.props.label) {
	        label = _react2.default.createElement(
	          'label',
	          { className: 'Search-label' },
	          this.props.label
	        );
	      }
	
	      var placeholder = (0, _helpers.__)('Search.placeholder');
	
	      var error = void 0;
	      if (this.state.errorMessage) {
	        error = _react2.default.createElement(
	          'div',
	          { className: 'Search-error' },
	          this.state.errorMessage
	        );
	        this.autoHideError();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Search Search--inline' },
	        _react2.default.createElement(
	          'form',
	          { className: 'Search-form', onSubmit: this.handleSubmit },
	          label,
	          _react2.default.createElement('input', {
	            className: 'Search-input',
	            id: 'searchInputField',
	            ref: function ref(address) {
	              return _this2.address = address;
	            },
	            type: 'text',
	            name: 'postal-code',
	            autoComplete: 'off',
	            placeholder: (0, _helpers.__)('Search.placeholder'),
	            onKeyDown: this.handleKeyDown,
	            onInput: this.handleInput,
	            onFocus: this.handleFocus
	          }),
	          _react2.default.createElement('a', {
	            className: this.state.classClearance,
	            id: 'clearanceButton',
	            onClick: this.handleClearance
	          }),
	          _react2.default.createElement('input', {
	            className: 'Search-submit',
	            id: 'searchSubmitButton',
	            type: 'submit',
	            name: 'submit',
	            value: ''
	          })
	        ),
	        error
	      );
	    }
	  }, {
	    key: 'initAutocomplete',
	    value: function initAutocomplete() {
	      var _this3 = this;
	
	      this.autocompleteFormField = document.getElementById('searchInputField');
	      var autocomplete = new google.maps.places.Autocomplete(this.autocompleteFormField, {
	        types: ['(regions)']
	      });
	
	      this.autocompleteListener = google.maps.event.addListener(autocomplete, 'place_changed', function () {
	        var place = autocomplete.getPlace();
	        if (place.geometry) {
	          _this3.setState({
	            acBounds: place.geometry.viewport
	          });
	        }
	        _this3.handleSubmit();
	      });
	    }
	  }, {
	    key: 'geocodeAddress',
	    value: function geocodeAddress(address) {
	      if (address.trim() == '') {
	        this.setState({
	          errorMessage: (0, _helpers.__)('Search.errorEmpty')
	        });
	        return;
	      }
	
	      this.setState({
	        errorMessage: null
	      });
	      //console.log('address: ', address)
	      this.geocoder.geocode({ 'address': address }, this.handleGeocodeAddress);
	    }
	  }, {
	    key: 'handleGeocodeAddress',
	    value: function handleGeocodeAddress(results, status) {
	      //console.log('results: ', results)
	      //console.log('status: ', status)
	      if (status === google.maps.GeocoderStatus.OK && results[0].geometry.bounds) {
	        //console.log('USED SEARCH-BOUNDS')
	        window.scrollTo(0, 0);
	
	        var bounds = {
	          west: results[0].geometry.bounds.getSouthWest().lng(),
	          south: results[0].geometry.bounds.getSouthWest().lat(),
	          east: results[0].geometry.bounds.getNorthEast().lng(),
	          north: results[0].geometry.bounds.getNorthEast().lat()
	        };
	
	        if (bounds.east - bounds.west < 0.07 && bounds.north - bounds.south < 0.03) {
	          var deltaLatCorrection = (0.07 - (bounds.east - bounds.west)) / 2;
	          var deltaLngCorrection = (0.03 - (bounds.north - bounds.south)) / 2;
	          var boundsCorrection = {
	            west: bounds.west - deltaLatCorrection,
	            south: bounds.south - deltaLngCorrection,
	            east: bounds.east + deltaLatCorrection,
	            north: bounds.north + deltaLngCorrection
	          };
	
	          this.props.setBounds(boundsCorrection);
	        } else {
	
	          this.props.setBounds(bounds);
	        }
	      } else if (status === google.maps.GeocoderStatus.OK && !results[0].geometry.bounds && results[0].geometry.viewport) {
	        //console.log('ONLY VIEWPORT!')
	        window.scrollTo(0, 0);
	
	        var viewportBounds = {
	          west: results[0].geometry.viewport.getSouthWest().lng(),
	          south: results[0].geometry.viewport.getSouthWest().lat(),
	          east: results[0].geometry.viewport.getNorthEast().lng(),
	          north: results[0].geometry.viewport.getNorthEast().lat()
	        };
	
	        if (viewportBounds.east - viewportBounds.west < 0.07 && viewportBounds.north - viewportBounds.south < 0.03) {
	          var deltaLatCorrectionVP = (0.07 - (viewportBounds.east - viewportBounds.west)) / 2;
	          var deltaLngCorrectionVP = (0.03 - (viewportBounds.north - viewportBounds.south)) / 2;
	          var viewportBoundsCorrection = {
	            west: viewportBounds.west - deltaLatCorrectionVP,
	            south: viewportBounds.south - deltaLngCorrectionVP,
	            east: viewportBounds.east + deltaLatCorrectionVP,
	            north: viewportBounds.north + deltaLngCorrectionVP
	          };
	
	          this.props.setBounds(viewportBoundsCorrection);
	        } else {
	
	          this.props.setBounds(viewportBounds);
	        }
	      } else if (this.state.acBounds !== null) {
	        //console.log('USED AUTOCOMPLETE-BOUNDS')
	        var acBounds = {
	          west: this.state.acBounds.getSouthWest().lng(),
	          south: this.state.acBounds.getSouthWest().lat(),
	          east: this.state.acBounds.getNorthEast().lng(),
	          north: this.state.acBounds.getNorthEast().lat()
	        };
	        this.setState({
	          acBounds: null
	        });
	        this.props.setBounds(acBounds);
	      } else {
	        // console.log('Geocode was not successful for the following reason: ' + status)
	
	        this.setState({
	          errorMessage: (0, _helpers.__)('Search.errorNotFound')
	        });
	      }
	    }
	  }]);
	
	  return Search;
	}(_react2.default.Component);
	
	Search.propTypes = propTypes;
	
	exports.default = Search;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  zoomIncrement: _react2.default.PropTypes.func.required,
	  zoomDecrement: _react2.default.PropTypes.func.required,
	  unsetSelectedEntity: _react2.default.PropTypes.func.isRequired
	};
	
	var Zoom = function (_React$Component) {
	  _inherits(Zoom, _React$Component);
	
	  function Zoom(props) {
	    _classCallCheck(this, Zoom);
	
	    var _this = _possibleConstructorReturn(this, (Zoom.__proto__ || Object.getPrototypeOf(Zoom)).call(this, props));
	
	    _this.handleZoomIn = _this.handleZoomIn.bind(_this);
	    _this.handleZoomOut = _this.handleZoomOut.bind(_this);
	    return _this;
	  }
	
	  _createClass(Zoom, [{
	    key: "handleZoomIn",
	    value: function handleZoomIn(event) {
	      this.props.unsetSelectedEntity();
	      this.props.zoomIncrement();
	    }
	  }, {
	    key: "handleZoomOut",
	    value: function handleZoomOut(event) {
	      this.props.unsetSelectedEntity();
	      this.props.zoomDecrement();
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "Zoom" },
	        _react2.default.createElement("button", { onClick: this.handleZoomIn, className: "Zoom-in" }),
	        _react2.default.createElement("button", { onClick: this.handleZoomOut, className: "Zoom-out" })
	      );
	    }
	  }]);
	
	  return Zoom;
	}(_react2.default.Component);
	
	Zoom.propTypes = propTypes;
	
	exports.default = Zoom;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Cesium = __webpack_require__(29);
	
	var _Cesium2 = _interopRequireDefault(_Cesium);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Cesium2.default.Imagery.loadingImageryCount = 0;
	
	_Cesium2.default.Imagery.prototype.__defineSetter__('state', function (value) {
	  if (value === _Cesium2.default.ImageryState.TRANSITIONING && this._state !== _Cesium2.default.ImageryState.TRANSITIONING) {
	    // Starting to transition.
	    _Cesium2.default.Imagery.loadingImageryCount++;
	  } else if (value !== _Cesium2.default.ImageryState.TRANSITIONING && this._state === _Cesium2.default.ImageryState.TRANSITIONING) {
	    // Finishing transition to transition.
	    _Cesium2.default.Imagery.loadingImageryCount--;
	    // if (Cesium.Imagery.loadingImageryCount === 0) {
	    //   // Done loading all imagery.
	    // }
	  }
	  this._state = value;
	});
	_Cesium2.default.Imagery.prototype.__defineGetter__('state', function () {
	  return this._state;
	});

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge = __webpack_require__(215);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _entities = __webpack_require__(55);
	
	var _entities2 = _interopRequireDefault(_entities);
	
	var _actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var spreadLatLng = function spreadLatLng(object) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var multiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	
	  var r = 100000;
	
	  if (object && object.lat && object.lng) {
	
	    var latRemainder = object.lat * r % Math.floor(object.lat * r);
	    var lngRemainder = object.lng * r % Math.floor(object.lng * r);
	
	    if (latRemainder == 0 || lngRemainder == 0) {
	      var lat = object.lat;
	      var lng = object.lng;
	
	      var angle = Math.sqrt(offset) * 887; // object.id
	
	      var x = angle * Math.cos(angle);
	      var y = angle * Math.sin(angle);
	
	      lat += y / 1000000 * multiplier;
	      lng += x / 1000000 * multiplier;
	
	      object.lat = lat; // +offset
	      object.lng = lng; // +offset
	    }
	  }
	
	  return object;
	};
	
	// Updates an entity cache in response to any action with response.entities.
	function entities() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _entities2.default;
	  var action = arguments[1];
	
	
	  var newState = Object.assign({}, state);
	
	  switch (action.type) {
	    case _actions.SET_ENTITY_IS_LOADING:
	      return Object.assign({}, state, {
	        entity_is_loading: true,
	        entity_type: action.entityType
	      });
	    case _actions.UNSET_ENTITY_IS_LOADING:
	      return Object.assign({}, state, {
	        entity_is_loading: false,
	        selected: null
	      });
	    case _actions.UNSET_SELECTED_ENTITY:
	      return Object.assign({}, state, {
	        selected: null,
	        entity_is_loading: false
	      });
	  }
	  if (action.response && action.response.entities) {
	
	    var newEntities = action.response.entities;
	    // console.log(newEntities)
	    if (newEntities.hasOwnProperty('batteries')) {
	      newEntities.batteryLocations = newState.batteryLocations;
	      newEntities = Object.keys(newEntities.batteries).reduce(function (acc, batteryId, index) {
	        var battery = acc.batteries[batteryId];
	        if (!battery.weight) {
	          battery.weight = 1;
	        }
	        if (newState.batteries.hasOwnProperty(batteryId)) {
	          battery.lat = newState.batteries[batteryId].lat;
	          battery.lng = newState.batteries[batteryId].lng;
	          // battery.weight = newState.batteries[batteryId].weight
	          // if (batteryId == 33 || batteryId == 442) {
	          //   console.log(newState.batteries[batteryId].weight)
	          // }
	        } else {
	          var location = battery.lng + '|' + battery.lat;
	          if (newState.batteryLocations[location] && newState.batteryLocations[location] >= 1) {
	            newState.batteryLocations[location] += 1;
	            battery = spreadLatLng(battery, newState.batteryLocations[location]);
	            // console.log('spreadLatLng',battery)
	          } else {
	            newState.batteryLocations[location] = 1;
	          }
	        }
	        acc.batteries[batteryId] = battery;
	        return acc;
	      }, newEntities);
	    }
	    // console.log(newEntities)
	    newState = (0, _merge2.default)({}, newState, newEntities);
	    // console.log(newState)
	
	    var key = Object.keys(action.response.entities)[0];
	    if (newState.entity_is_loading && typeof action.response.result === 'number' && action.response.entities[key][action.response.result]) {
	      newState['selected'] = Object.assign({}, action.response.entities[key][action.response.result], {
	        lat: newState[key][action.response.result].lat,
	        lng: newState[key][action.response.result].lng
	      }) || {};
	      newState['entity_is_loading'] = false;
	    }
	  }
	
	  return newState;
	}
	
	exports.default = entities;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(53);
	
	var _reactRouterRedux = __webpack_require__(84);
	
	var _entities = __webpack_require__(114);
	
	var _entities2 = _interopRequireDefault(_entities);
	
	var _map = __webpack_require__(116);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Combine all our reducers togeher
	// we need this for react-router
	var rootReducer = (0, _redux.combineReducers)({
	  entities: _entities2.default,
	  map: _map2.default,
	  routing: _reactRouterRedux.routerReducer
	});
	
	/*
	  Reducers
	
	  Reducers match up the dispatched (fired) action with a function that should be called.
	
	  It takes in a copy of state, modifies it, and returns the new state
	  When state gets large, it makes sense to have multiple reducers that only deal with a piece of the state
	
	*/
	
	exports.default = rootReducer;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(34);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function map() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _map2.default;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions.ZOOM_INCREMENT:
	      return Object.assign({}, state, {
	        zoom: state.zoom + 1
	      });
	    case _actions.ZOOM_DECREMENT:
	      return Object.assign({}, state, {
	        zoom: state.zoom - 1
	      });
	    case _actions.SET_BOUNDS:
	      return Object.assign({}, state, {
	        targetBounds: action.bounds,
	        targetDuration: action.duration
	      });
	    case _actions.SET_CENTER_HEIGHT:
	      return Object.assign({}, state, {
	        targetCenter: action.center,
	        targetHeight: action.height,
	        targetDuration: action.duration
	      });
	    case _actions.SET_VIEWPORT:
	      return Object.assign({}, state, {
	        currentBounds: action.bounds,
	        currentCenter: action.center,
	        currentHeight: action.height,
	        currentMagnitude: action.magnitude
	      });
	    case _actions.SET_SELECTED_OBJECT:
	      return Object.assign({}, state, {
	        selectedObject: action.selectedObject
	      });
	    case _actions.SET_MODE:
	      return Object.assign({}, state, {
	        mode: action.mode
	      });
	    case _actions.SET_SHOW_FORM:
	      return Object.assign({}, state, {
	        showForm: action.showForm
	      });
	    case _actions.SET_CAMERA_IS_FLYING:
	      return Object.assign({}, state, {
	        cameraIsFlying: action.cameraIsFlying
	      });
	    default:
	      return state;
	  }
	}
	
	exports.default = map;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.history = undefined;
	
	var _redux = __webpack_require__(53);
	
	var _reactRouterRedux = __webpack_require__(84);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reduxThunk = __webpack_require__(275);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _index = __webpack_require__(115);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _entities = __webpack_require__(55);
	
	var _entities2 = _interopRequireDefault(_entities);
	
	var _map = __webpack_require__(34);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _api = __webpack_require__(56);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	  Store
	
	  Redux apps have a single store which takes
	  1. All Reducers which we combined into `rootReducer`
	  2. An optional starting state - similar to React's getInitialState
	*/
	
	var defaultState = {
	  entities: _entities2.default,
	  map: _map2.default
	};
	
	var enhancers = (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default, _api2.default), window.devToolsExtension ? window.devToolsExtension() : function (f) {
	  return f;
	});
	
	var store = (0, _redux.createStore)(_index2.default, defaultState, enhancers);
	
	// we export history because we need it in `sonnencommunity.js` to feed into <Router>
	var history = exports.history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	/*
	  Enable Hot Reloading for the reducers
	  We re-require() the reducers whenever any new code has been written.
	  Webpack will handle the rest
	*/
	
	if (false) {
	  module.hot.accept('./reducers/', function () {
	    var nextRootReducer = require('./reducers/index').default;
	    store.replaceReducer(nextRootReducer);
	  });
	}
	
	exports.default = store;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-voronoi/ Version 1.1.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function x(d) {
	  return d[0];
	}
	
	function y(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon || Math.abs(endY - startY) > epsilon) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon && y1 - endY > epsilon ? [x0, Math.abs(startX - x0) < epsilon ? startY : y1]
	              : Math.abs(endY - y1) < epsilon && x1 - endX > epsilon ? [Math.abs(startY - y1) < epsilon ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon && endY - y0 > epsilon ? [x1, Math.abs(startX - x1) < epsilon ? startY : y0]
	              : Math.abs(endY - y0) < epsilon && endX - x0 > epsilon ? [Math.abs(startY - y0) < epsilon ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon
	      && Math.abs(y - lArc.circle.cy) < epsilon) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon
	      && Math.abs(y - rArc.circle.cy) < epsilon) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      if (!(m = (halfedges = cell.halfedges).length)) return;
	      var site = cell.site,
	          halfedges,
	          j = -1,
	          m,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
	
	    // Use the previously-found cell, or start with an arbitrary one.
	    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
	    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
	
	    // Traverse the half-edges to find a closer cell, if any.
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	var voronoi = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon) * epsilon, Math.round(y$$1(d, i, data) / epsilon) * epsilon];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	exports.voronoi = voronoi;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 119 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 120 */
119,
/* 121 */
119,
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	    factory(exports, module);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, mod);
	    global.fetchJsonp = mod.exports;
	  }
	})(this, function (exports, module) {
	  'use strict';
	
	  var defaultOptions = {
	    timeout: 5000,
	    jsonpCallback: 'callback',
	    jsonpCallbackFunction: null
	  };
	
	  function generateCallbackFunction() {
	    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
	  }
	
	  // Known issue: Will throw 'Uncaught ReferenceError: callback_*** is not defined'
	  // error if request timeout
	  function clearFunction(functionName) {
	    // IE8 throws an exception when you try to delete a property on window
	    // http://stackoverflow.com/a/1824228/751089
	    try {
	      delete window[functionName];
	    } catch (e) {
	      window[functionName] = undefined;
	    }
	  }
	
	  function removeScript(scriptId) {
	    var script = document.getElementById(scriptId);
	    document.getElementsByTagName('head')[0].removeChild(script);
	  }
	
	  function fetchJsonp(_url) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    // to avoid param reassign
	    var url = _url;
	    var timeout = options.timeout || defaultOptions.timeout;
	    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
	
	    var timeoutId = undefined;
	
	    return new Promise(function (resolve, reject) {
	      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
	      var scriptId = jsonpCallback + '_' + callbackFunction;
	
	      window[callbackFunction] = function (response) {
	        resolve({
	          ok: true,
	          // keep consistent with fetch API
	          json: function json() {
	            return Promise.resolve(response);
	          }
	        });
	
	        if (timeoutId) clearTimeout(timeoutId);
	
	        removeScript(scriptId);
	
	        clearFunction(callbackFunction);
	      };
	
	      // Check if the user set their own params, and if not add a ? to start a list of params
	      url += url.indexOf('?') === -1 ? '?' : '&';
	
	      var jsonpScript = document.createElement('script');
	      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
	      jsonpScript.id = scriptId;
	      document.getElementsByTagName('head')[0].appendChild(jsonpScript);
	
	      timeoutId = setTimeout(function () {
	        reject(new Error('JSONP request to ' + _url + ' timed out'));
	
	        clearFunction(callbackFunction);
	        removeScript(scriptId);
	      }, timeout);
	    });
	  }
	
	  // export as global function
	  /*
	  let local;
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	  local.fetchJsonp = fetchJsonp;
	  */
	
	  module.exports = fetchJsonp;
	});

/***/ },
/* 123 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(36);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(11);
	
	var _DOMUtils = __webpack_require__(21);
	
	var _DOMStateStorage = __webpack_require__(57);
	
	var _PathUtils = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(36);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(11);
	
	var _PathUtils = __webpack_require__(7);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(37);
	
	var _BrowserProtocol = __webpack_require__(36);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(125);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(21);
	
	var _createHistory = __webpack_require__(38);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(37);
	
	var _DOMUtils = __webpack_require__(21);
	
	var _HashProtocol = __webpack_require__(124);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(38);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(11);
	
	var _PathUtils = __webpack_require__(7);
	
	var _createHistory = __webpack_require__(38);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// =========
	// = humps =
	// =========
	// Underscore-to-camelCase converter (and vice versa)
	// for strings and object keys
	
	// humps is copyright © 2012+ Dom Christie
	// Released under the MIT license.
	
	
	;(function(global) {
	
	  var _processKeys = function(convert, obj, options) {
	    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
	      return obj;
	    }
	
	    var output,
	        i = 0,
	        l = 0;
	
	    if(_isArray(obj)) {
	      output = [];
	      for(l=obj.length; i<l; i++) {
	        output.push(_processKeys(convert, obj[i], options));
	      }
	    }
	    else {
	      output = {};
	      for(var key in obj) {
	        if(obj.hasOwnProperty(key)) {
	          output[convert(key, options)] = _processKeys(convert, obj[key], options);
	        }
	      }
	    }
	    return output;
	  };
	
	  // String conversion methods
	
	  var separateWords = function(string, options) {
	    options = options || {};
	    var separator = options.separator || '_';
	    var split = options.split || /(?=[A-Z])/;
	
	    return string.split(split).join(separator);
	  };
	
	  var camelize = function(string) {
	    if (_isNumerical(string)) {
	      return string;
	    }
	    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    });
	    // Ensure 1st char is always lowercase
	    return string.substr(0, 1).toLowerCase() + string.substr(1);
	  };
	
	  var pascalize = function(string) {
	    var camelized = camelize(string);
	    // Ensure 1st char is always uppercase
	    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
	  };
	
	  var decamelize = function(string, options) {
	    return separateWords(string, options).toLowerCase();
	  };
	
	  // Utilities
	  // Taken from Underscore.js
	
	  var toString = Object.prototype.toString;
	
	  var _isFunction = function(obj) {
	    return typeof(obj) === 'function';
	  };
	  var _isObject = function(obj) {
	    return obj === Object(obj);
	  };
	  var _isArray = function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	  var _isDate = function(obj) {
	    return toString.call(obj) == '[object Date]';
	  };
	  var _isRegExp = function(obj) {
	    return toString.call(obj) == '[object RegExp]';
	  };
	  var _isBoolean = function(obj) {
	    return toString.call(obj) == '[object Boolean]';
	  };
	
	  // Performant way to determine if obj coerces to a number
	  var _isNumerical = function(obj) {
	    obj = obj - 0;
	    return obj === obj;
	  };
	
	  // Sets up function which handles processing keys
	  // allowing the convert function to be modified by a callback
	  var _processor = function(convert, options) {
	    var callback = options && 'process' in options ? options.process : options;
	
	    if(typeof(callback) !== 'function') {
	      return convert;
	    }
	
	    return function(string, options) {
	      return callback(string, convert, options);
	    }
	  };
	
	  var humps = {
	    camelize: camelize,
	    decamelize: decamelize,
	    pascalize: pascalize,
	    depascalize: decamelize,
	    camelizeKeys: function(object, options) {
	      return _processKeys(_processor(camelize, options), object);
	    },
	    decamelizeKeys: function(object, options) {
	      return _processKeys(_processor(decamelize, options), object, options);
	    },
	    pascalizeKeys: function(object, options) {
	      return _processKeys(_processor(pascalize, options), object);
	    },
	    depascalizeKeys: function () {
	      return this.decamelizeKeys.apply(this, arguments);
	    }
	  };
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (humps), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module.exports) {
	    module.exports = humps;
	  } else {
	    global.humps = humps;
	  }
	
	})(this);


/***/ },
/* 130 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(10),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(176),
	    hashDelete = __webpack_require__(177),
	    hashGet = __webpack_require__(178),
	    hashHas = __webpack_require__(179),
	    hashSet = __webpack_require__(180);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(10),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(10),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 135 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(146);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 139 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(41),
	    eq = __webpack_require__(14);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 142 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(68),
	    isFlattenable = __webpack_require__(182);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(168);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(68),
	    isArray = __webpack_require__(15);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(142),
	    baseIsNaN = __webpack_require__(150),
	    strictIndexOf = __webpack_require__(210);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(31),
	    isObjectLike = __webpack_require__(19);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(149),
	    isObjectLike = __webpack_require__(19);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(65),
	    equalArrays = __webpack_require__(73),
	    equalByTag = __webpack_require__(170),
	    equalObjects = __webpack_require__(171),
	    getTag = __webpack_require__(174),
	    isArray = __webpack_require__(15),
	    isBuffer = __webpack_require__(45),
	    isTypedArray = __webpack_require__(47);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 150 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(46),
	    isMasked = __webpack_require__(185),
	    isObject = __webpack_require__(4),
	    toSource = __webpack_require__(75);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(31),
	    isLength = __webpack_require__(78),
	    isObjectLike = __webpack_require__(19);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(42),
	    nativeKeys = __webpack_require__(197);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4),
	    isPrototype = __webpack_require__(42),
	    nativeKeysIn = __webpack_require__(198);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(65),
	    assignMergeValue = __webpack_require__(69),
	    baseFor = __webpack_require__(144),
	    baseMergeDeep = __webpack_require__(156),
	    isObject = __webpack_require__(4),
	    keysIn = __webpack_require__(79);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(69),
	    cloneBuffer = __webpack_require__(162),
	    cloneTypedArray = __webpack_require__(163),
	    copyArray = __webpack_require__(164),
	    initCloneObject = __webpack_require__(181),
	    isArguments = __webpack_require__(44),
	    isArray = __webpack_require__(15),
	    isArrayLikeObject = __webpack_require__(77),
	    isBuffer = __webpack_require__(45),
	    isFunction = __webpack_require__(46),
	    isObject = __webpack_require__(4),
	    isPlainObject = __webpack_require__(270),
	    isTypedArray = __webpack_require__(47),
	    toPlainObject = __webpack_require__(219);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(211),
	    defineProperty = __webpack_require__(72),
	    identity = __webpack_require__(76);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 159 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(64),
	    arrayIncludes = __webpack_require__(137),
	    arrayIncludesWith = __webpack_require__(138),
	    cacheHas = __webpack_require__(71),
	    createSet = __webpack_require__(169),
	    setToArray = __webpack_require__(43);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(66);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(5);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)(module)))

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(161);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 164 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(140),
	    baseAssignValue = __webpack_require__(41);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(5);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(70),
	    isIterateeCall = __webpack_require__(183);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 168 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(63),
	    noop = __webpack_require__(216),
	    setToArray = __webpack_require__(43);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(94),
	    Uint8Array = __webpack_require__(66),
	    eq = __webpack_require__(14),
	    equalArrays = __webpack_require__(73),
	    mapToArray = __webpack_require__(196),
	    setToArray = __webpack_require__(43);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(172);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(145),
	    getSymbols = __webpack_require__(173),
	    keys = __webpack_require__(213);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(136),
	    stubArray = __webpack_require__(217);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(131),
	    Map = __webpack_require__(40),
	    Promise = __webpack_require__(133),
	    Set = __webpack_require__(63),
	    WeakMap = __webpack_require__(134),
	    baseGetTag = __webpack_require__(31),
	    toSource = __webpack_require__(75);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 175 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(25);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(25);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(25);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(25);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(141),
	    getPrototype = __webpack_require__(272),
	    isPrototype = __webpack_require__(42);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(94),
	    isArguments = __webpack_require__(44),
	    isArray = __webpack_require__(15);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(14),
	    isArrayLike = __webpack_require__(26),
	    isIndex = __webpack_require__(74),
	    isObject = __webpack_require__(4);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 184 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(166);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 186 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(23);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(23);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(23);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(23);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(132),
	    ListCache = __webpack_require__(22),
	    Map = __webpack_require__(40);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(24);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(24);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(24);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(24);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 196 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(273);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(271);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)(module)))

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(135);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 201 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 202 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(157),
	    shortOut = __webpack_require__(204);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 204 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(22);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 206 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 207 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(22),
	    Map = __webpack_require__(40),
	    MapCache = __webpack_require__(62);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 210 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 211 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(148);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(67),
	    baseKeys = __webpack_require__(153),
	    isArrayLike = __webpack_require__(26);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(32)(module)))

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(155),
	    createAssigner = __webpack_require__(167);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 216 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 217 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 218 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(165),
	    keysIn = __webpack_require__(79);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(143),
	    baseRest = __webpack_require__(70),
	    baseUniq = __webpack_require__(160),
	    isArrayLikeObject = __webpack_require__(77);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EntitySchema = function () {
	  function EntitySchema(key) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, EntitySchema);
	
	    if (!key || typeof key !== 'string') {
	      throw new Error('A string non-empty key is required');
	    }
	
	    this._key = key;
	    this._assignEntity = options.assignEntity;
	
	    var idAttribute = options.idAttribute || 'id';
	    this._getId = typeof idAttribute === 'function' ? idAttribute : function (x) {
	      return x[idAttribute];
	    };
	    this._idAttribute = idAttribute;
	    this._meta = options.meta;
	    this._defaults = options.defaults;
	  }
	
	  _createClass(EntitySchema, [{
	    key: 'getAssignEntity',
	    value: function getAssignEntity() {
	      return this._assignEntity;
	    }
	  }, {
	    key: 'getKey',
	    value: function getKey() {
	      return this._key;
	    }
	  }, {
	    key: 'getId',
	    value: function getId(entity, key) {
	      return this._getId(entity, key);
	    }
	  }, {
	    key: 'getIdAttribute',
	    value: function getIdAttribute() {
	      return this._idAttribute;
	    }
	  }, {
	    key: 'getMeta',
	    value: function getMeta(prop) {
	      if (!prop || typeof prop !== 'string') {
	        throw new Error('A string non-empty property name is required');
	      }
	      return this._meta && this._meta[prop];
	    }
	  }, {
	    key: 'getDefaults',
	    value: function getDefaults() {
	      return this._defaults;
	    }
	  }, {
	    key: 'define',
	    value: function define(nestedSchema) {
	      for (var key in nestedSchema) {
	        if (nestedSchema.hasOwnProperty(key)) {
	          this[key] = nestedSchema[key];
	        }
	      }
	    }
	  }]);
	
	  return EntitySchema;
	}();
	
	exports.default = EntitySchema;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isObject = __webpack_require__(4);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _UnionSchema = __webpack_require__(80);
	
	var _UnionSchema2 = _interopRequireDefault(_UnionSchema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArraySchema = function () {
	  function ArraySchema(itemSchema) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, ArraySchema);
	
	    if (!(0, _isObject2.default)(itemSchema)) {
	      throw new Error('ArraySchema requires item schema to be an object.');
	    }
	
	    if (options.schemaAttribute) {
	      var schemaAttribute = options.schemaAttribute;
	      this._itemSchema = new _UnionSchema2.default(itemSchema, { schemaAttribute: schemaAttribute });
	    } else {
	      this._itemSchema = itemSchema;
	    }
	  }
	
	  _createClass(ArraySchema, [{
	    key: 'getItemSchema',
	    value: function getItemSchema() {
	      return this._itemSchema;
	    }
	  }]);
	
	  return ArraySchema;
	}();
	
	exports.default = ArraySchema;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.arrayOf = arrayOf;
	exports.valuesOf = valuesOf;
	exports.unionOf = unionOf;
	exports.normalize = normalize;
	
	var _EntitySchema = __webpack_require__(221);
	
	var _EntitySchema2 = _interopRequireDefault(_EntitySchema);
	
	var _IterableSchema = __webpack_require__(222);
	
	var _IterableSchema2 = _interopRequireDefault(_IterableSchema);
	
	var _UnionSchema = __webpack_require__(80);
	
	var _UnionSchema2 = _interopRequireDefault(_UnionSchema);
	
	var _isEqual = __webpack_require__(212);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _isObject = __webpack_require__(4);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultAssignEntity(normalized, key, entity) {
	  normalized[key] = entity;
	}
	
	function visitObject(obj, schema, bag, options, collectionKey) {
	  var _options$assignEntity = options.assignEntity,
	      assignEntity = _options$assignEntity === undefined ? defaultAssignEntity : _options$assignEntity;
	
	
	  var defaults = schema && schema.getDefaults && schema.getDefaults();
	  var schemaAssignEntity = schema && schema.getAssignEntity && schema.getAssignEntity();
	  var normalized = (0, _isObject2.default)(defaults) ? _extends({}, defaults) : {};
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      var resolvedSchema = typeof schema[key] === 'function' ? schema[key].call(null, obj) : schema[key];
	      var entity = visit(obj[key], resolvedSchema, bag, options, collectionKey);
	      assignEntity.call(null, normalized, key, entity, obj, schema);
	      if (schemaAssignEntity) {
	        schemaAssignEntity.call(null, normalized, key, entity, obj, schema);
	      }
	    }
	  }
	  return normalized;
	}
	
	function defaultMapper(iterableSchema, itemSchema, bag, options) {
	  return function (obj, key) {
	    return visit(obj, itemSchema, bag, options, key);
	  };
	}
	
	function polymorphicMapper(iterableSchema, itemSchema, bag, options) {
	  return function (obj, key) {
	    var schemaKey = iterableSchema.getSchemaKey(obj);
	    var result = visit(obj, itemSchema[schemaKey], bag, options, key);
	    return { id: result, schema: schemaKey };
	  };
	}
	
	function visitIterable(obj, iterableSchema, bag, options) {
	  var itemSchema = iterableSchema.getItemSchema();
	  var curriedItemMapper = defaultMapper(iterableSchema, itemSchema, bag, options);
	
	  if (Array.isArray(obj)) {
	    return obj.map(curriedItemMapper);
	  } else {
	    return Object.keys(obj).reduce(function (objMap, key) {
	      objMap[key] = curriedItemMapper(obj[key], key);
	      return objMap;
	    }, {});
	  }
	}
	
	function visitUnion(obj, unionSchema, bag, options) {
	  var itemSchema = unionSchema.getItemSchema();
	  return polymorphicMapper(unionSchema, itemSchema, bag, options)(obj);
	}
	
	function defaultMergeIntoEntity(entityA, entityB, entityKey) {
	  for (var key in entityB) {
	    if (!entityB.hasOwnProperty(key)) {
	      continue;
	    }
	
	    if (!entityA.hasOwnProperty(key) || (0, _isEqual2.default)(entityA[key], entityB[key])) {
	      entityA[key] = entityB[key];
	      continue;
	    }
	
	    console.warn('When merging two ' + entityKey + ', found unequal data in their "' + key + '" values. Using the earlier value.', entityA[key], entityB[key]);
	  }
	}
	
	function visitEntity(entity, entitySchema, bag, options, collectionKey) {
	  var _options$mergeIntoEnt = options.mergeIntoEntity,
	      mergeIntoEntity = _options$mergeIntoEnt === undefined ? defaultMergeIntoEntity : _options$mergeIntoEnt;
	
	
	  var entityKey = entitySchema.getKey();
	  var id = entitySchema.getId(entity, collectionKey);
	
	  if (!bag.hasOwnProperty(entityKey)) {
	    bag[entityKey] = {};
	  }
	
	  if (!bag[entityKey].hasOwnProperty(id)) {
	    bag[entityKey][id] = {};
	  }
	
	  var stored = bag[entityKey][id];
	  var normalized = visitObject(entity, entitySchema, bag, options, collectionKey);
	  mergeIntoEntity(stored, normalized, entityKey);
	
	  return id;
	}
	
	function visit(obj, schema, bag, options, collectionKey) {
	  if (!(0, _isObject2.default)(obj) || !(0, _isObject2.default)(schema)) {
	    return obj;
	  }
	
	  if (schema instanceof _EntitySchema2.default) {
	    return visitEntity(obj, schema, bag, options, collectionKey);
	  } else if (schema instanceof _IterableSchema2.default) {
	    return visitIterable(obj, schema, bag, options);
	  } else if (schema instanceof _UnionSchema2.default) {
	    return visitUnion(obj, schema, bag, options);
	  } else {
	    return visitObject(obj, schema, bag, options, collectionKey);
	  }
	}
	
	function normalizeResult(result) {
	  if ((0, _isObject2.default)(result) && (0, _isEqual2.default)(Object.keys(result), Object.keys(result).map(function (key) {
	    return result[key];
	  }))) {
	    return Object.keys(result);
	  }
	  return result;
	}
	
	function arrayOf(schema, options) {
	  return new _IterableSchema2.default(schema, options);
	}
	
	function valuesOf(schema, options) {
	  return new _IterableSchema2.default(schema, options);
	}
	
	function unionOf(schema, options) {
	  return new _UnionSchema2.default(schema, options);
	}
	
	exports.Schema = _EntitySchema2.default;
	function normalize(obj, schema) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!(0, _isObject2.default)(obj)) {
	    throw new Error('Normalize accepts an object or an array as its input.');
	  }
	
	  if (!(0, _isObject2.default)(schema) || Array.isArray(schema)) {
	    throw new Error('Normalize accepts an object for schema.');
	  }
	
	  var bag = {};
	  var result = visit(obj, schema, bag, options);
	
	  return {
	    entities: bag,
	    result: normalizeResult(result)
	  };
	}

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(226);
	var invariant = __webpack_require__(227);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(224)();
	}


/***/ },
/* 226 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 228 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchJsonp = __webpack_require__(122);
	
	var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);
	
	var _FilePlayer2 = __webpack_require__(28);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	var _props3 = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = '//api.soundcloud.com/resolve.json';
	var MATCH_URL = /^https?:\/\/(soundcloud.com|snd.sc)\/([a-z0-9-_]+\/[a-z0-9-_]+)$/;
	
	var songData = {}; // Cache song data requests
	
	var SoundCloud = function (_FilePlayer) {
	  _inherits(SoundCloud, _FilePlayer);
	
	  function SoundCloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      image: null
	    }, _this.clientId = _this.props.soundcloudConfig.clientId || _props3.defaultProps.soundcloudConfig.clientId, _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SoundCloud, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return _get(SoundCloud.prototype.__proto__ || Object.getPrototypeOf(SoundCloud.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState) || this.state.image !== nextState.image;
	    }
	  }, {
	    key: 'getSongData',
	    value: function getSongData(url) {
	      var _this2 = this;
	
	      if (songData[url]) {
	        return Promise.resolve(songData[url]);
	      }
	      return (0, _fetchJsonp2['default'])(RESOLVE_URL + '?url=' + url + '&client_id=' + this.clientId).then(function (response) {
	        if (response.ok) {
	          songData[url] = response.json();
	          return songData[url];
	        } else {
	          _this2.props.onError(new Error('SoundCloud track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this3 = this;
	
	      var _props = this.props,
	          soundcloudConfig = _props.soundcloudConfig,
	          onError = _props.onError;
	
	      this.stop();
	      this.getSongData(url).then(function (data) {
	        if (!_this3.mounted) return;
	        if (!data.streamable) {
	          onError(new Error('SoundCloud track is not streamable'));
	          return;
	        }
	        var image = data.artwork_url || data.user.avatar_url;
	        if (image && soundcloudConfig.showArtwork) {
	          _this3.setState({ image: image.replace('-large', '-t500x500') });
	        }
	        _this3.player.src = data.stream_url + '?client_id=' + _this3.clientId;
	      }, onError);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          url = _props2.url,
	          loop = _props2.loop,
	          controls = _props2.controls;
	
	      var style = {
	        display: url ? 'block' : 'none',
	        height: '100%',
	        backgroundImage: this.state.image ? 'url(' + this.state.image + ')' : null,
	        backgroundSize: 'cover',
	        backgroundPosition: 'center'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('audio', {
	          ref: this.ref,
	          type: 'audio/mpeg',
	          preload: 'auto',
	          style: {
	            width: '100%',
	            height: '100%'
	          },
	          controls: controls,
	          loop: loop
	        })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return SoundCloud;
	}(_FilePlayer3['default']);
	
	SoundCloud.displayName = 'SoundCloud';
	exports['default'] = SoundCloud;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FilePlayer2 = __webpack_require__(28);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = 'https://api.streamable.com/videos/';
	var MATCH_URL = /^https?:\/\/streamable.com\/([a-z0-9]+)$/;
	
	var cache = {}; // Cache song data requests
	
	var Streamable = function (_FilePlayer) {
	  _inherits(Streamable, _FilePlayer);
	
	  function Streamable() {
	    _classCallCheck(this, Streamable);
	
	    return _possibleConstructorReturn(this, (Streamable.__proto__ || Object.getPrototypeOf(Streamable)).apply(this, arguments));
	  }
	
	  _createClass(Streamable, [{
	    key: 'getData',
	    value: function getData(url) {
	      var onError = this.props.onError;
	
	      var id = url.match(MATCH_URL)[1];
	      if (cache[id]) {
	        return Promise.resolve(cache[id]);
	      }
	      return window.fetch(RESOLVE_URL + id).then(function (response) {
	        if (response.status === 200) {
	          cache[id] = response.json();
	          return cache[id];
	        } else {
	          onError(new Error('Streamable track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var onError = this.props.onError;
	
	      this.stop();
	      this.getData(url).then(function (data) {
	        if (!_this2.mounted) return;
	        _this2.player.src = data.files.mp4.url;
	      }, onError);
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Streamable;
	}(_FilePlayer3['default']);
	
	Streamable.displayName = 'Streamable';
	exports['default'] = Streamable;
	module.exports = exports['default'];

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FilePlayer2 = __webpack_require__(28);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = 'https://api.vid.me/videoByUrl/';
	var MATCH_URL = /^https?:\/\/vid.me\/([a-z0-9]+)$/i;
	
	var cache = {}; // Cache song data requests
	
	var Vidme = function (_FilePlayer) {
	  _inherits(Vidme, _FilePlayer);
	
	  function Vidme() {
	    _classCallCheck(this, Vidme);
	
	    return _possibleConstructorReturn(this, (Vidme.__proto__ || Object.getPrototypeOf(Vidme)).apply(this, arguments));
	  }
	
	  _createClass(Vidme, [{
	    key: 'getData',
	    value: function getData(url) {
	      var onError = this.props.onError;
	
	      var id = url.match(MATCH_URL)[1];
	      if (cache[id]) {
	        return Promise.resolve(cache[id]);
	      }
	      return window.fetch(RESOLVE_URL + id).then(function (response) {
	        if (response.status === 200) {
	          cache[id] = response.json();
	          return cache[id];
	        } else {
	          onError(new Error('Vidme track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'getURL',
	    value: function getURL(_ref) {
	      var video = _ref.video;
	      var vidmeConfig = this.props.vidmeConfig;
	
	      if (vidmeConfig.format && video.formats && video.formats.length !== 0) {
	        var index = video.formats.findIndex(function (f) {
	          return f.type === vidmeConfig.format;
	        });
	        if (index !== -1) {
	          return video.formats[index].uri;
	        } else {
	          console.warn('Vidme format "' + vidmeConfig.format + '" was not found for ' + video.full_url);
	        }
	      }
	      return video.complete_url;
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var onError = this.props.onError;
	
	      this.stop();
	      this.getData(url).then(function (data) {
	        if (!_this2.mounted) return;
	        _this2.player.src = _this2.getURL(data);
	      }, onError);
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Vidme;
	}(_FilePlayer3['default']);
	
	Vidme.displayName = 'Vidme';
	exports['default'] = Vidme;
	module.exports = exports['default'];

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(81);
	
	var _Base2 = __webpack_require__(27);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IFRAME_SRC = 'https://player.vimeo.com/video/';
	var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
	var MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;
	var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';
	var DEFAULT_IFRAME_PARAMS = {
	  api: 1,
	  autoplay: 0,
	  badge: 0,
	  byline: 0,
	  fullscreen: 1,
	  portrait: 0,
	  title: 0
	};
	
	var Vimeo = function (_Base) {
	  _inherits(Vimeo, _Base);
	
	  function Vimeo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.onMessage = function (e) {
	      if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
	      _this.origin = _this.origin || e.origin;
	      var data = JSON.parse(e.data);
	      if (data.event === 'ready') {
	        _this.postMessage('getDuration');
	        _this.postMessage('addEventListener', 'playProgress');
	        _this.postMessage('addEventListener', 'loadProgress');
	        _this.postMessage('addEventListener', 'play');
	        _this.postMessage('addEventListener', 'pause');
	        _this.postMessage('addEventListener', 'finish');
	      }
	      if (data.event === 'playProgress') _this.fractionPlayed = data.data.percent;
	      if (data.event === 'loadProgress') _this.fractionLoaded = data.data.percent;
	      if (data.event === 'play') _this.onPlay();
	      if (data.event === 'pause') _this.props.onPause();
	      if (data.event === 'finish') _this.onEnded();
	      if (data.method === 'getDuration') {
	        _this.duration = data.value; // Store for use later
	        _this.onReady();
	      }
	    }, _this.onEnded = function () {
	      var _this$props = _this.props,
	          loop = _this$props.loop,
	          onEnded = _this$props.onEnded;
	
	      if (loop) {
	        _this.seekTo(0);
	      }
	      onEnded();
	    }, _this.postMessage = function (method, value) {
	      if (!_this.origin) return;
	      var data = JSON.stringify({ method: method, value: value });
	      return _this.iframe.contentWindow && _this.iframe.contentWindow.postMessage(data, _this.origin);
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Vimeo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          url = _props.url,
	          vimeoConfig = _props.vimeoConfig;
	
	      window.addEventListener('message', this.onMessage, false);
	
	      if (!url && vimeoConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', this.onMessage, false);
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'getIframeParams',
	    value: function getIframeParams() {
	      return _extends({}, DEFAULT_IFRAME_PARAMS, this.props.vimeoConfig.iframeParams);
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var id = url.match(MATCH_URL)[3];
	      this.iframe.src = IFRAME_SRC + id + '?' + (0, _queryString.stringify)(this.getIframeParams());
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.postMessage('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.postMessage('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.iframe.src = '';
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'seekTo', this).call(this, fraction);
	      this.postMessage('seekTo', this.duration * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.postMessage('setVolume', fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.postMessage('setPlaybackRate', rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      return this.fractionPlayed || null;
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      return this.fractionLoaded || null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _getIframeParams = this.getIframeParams(),
	          fullscreen = _getIframeParams.fullscreen;
	
	      var style = {
	        display: this.props.url ? 'block' : 'none',
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('iframe', {
	        ref: this.ref,
	        frameBorder: '0',
	        style: style,
	        allowFullScreen: fullscreen
	      });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Vimeo;
	}(_Base3['default']);
	
	Vimeo.displayName = 'Vimeo';
	exports['default'] = Vimeo;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(61);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(27);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
	var SDK_GLOBAL = 'Wistia';
	var MATCH_URL = /^https?:\/\/(.+)?(wistia.com|wi.st)\/(medias|embed)\/(.*)$/;
	
	var Wistia = function (_Base) {
	  _inherits(Wistia, _Base);
	
	  function Wistia() {
	    _classCallCheck(this, Wistia);
	
	    return _possibleConstructorReturn(this, (Wistia.__proto__ || Object.getPrototypeOf(Wistia)).apply(this, arguments));
	  }
	
	  _createClass(Wistia, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onStart = _props.onStart,
	          onPause = _props.onPause,
	          onEnded = _props.onEnded;
	
	      this.loadingSDK = true;
	      this.getSDK().then(function () {
	        window._wq = window._wq || [];
	        window._wq.push({
	          id: _this2.getID(_this2.props.url),
	          onReady: function onReady(player) {
	            _this2.loadingSDK = false;
	            _this2.player = player;
	            _this2.player.bind('start', onStart);
	            _this2.player.bind('play', _this2.onPlay);
	            _this2.player.bind('pause', onPause);
	            _this2.player.bind('end', onEnded);
	            _this2.onReady();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      return new Promise(function (resolve, reject) {
	        if (window[SDK_GLOBAL]) {
	          resolve();
	        } else {
	          (0, _loadScript2['default'])(SDK_URL, function (err, script) {
	            if (err) reject(err);
	            resolve(script);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getID',
	    value: function getID(url) {
	      return url && url.match(MATCH_URL)[4];
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var id = this.getID(url);
	      if (this.isReady) {
	        this.player.replaceWith(id);
	        this.props.onReady();
	        this.onReady();
	      }
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady || !this.player) return;
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady || !this.player) return;
	      this.player && this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady || !this.player) return;
	      this.player.pause();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Wistia.prototype.__proto__ || Object.getPrototypeOf(Wistia.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player) return;
	      this.player.time(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady || !this.player || !this.player.volume) return;
	      this.player.volume(fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      if (!this.isReady || !this.player || !this.player.playbackRate) return;
	      this.player.playbackRate(rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady || !this.player || !this.player.duration) return;
	      return this.player.duration();
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.player || !this.player.percentWatched) return null;
	      return this.player.percentWatched();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.getID(this.props.url);
	      var className = 'wistia_embed wistia_async_' + id;
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement('div', { className: className, style: style });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Wistia;
	}(_Base3['default']);
	
	Wistia.displayName = 'Wistia';
	exports['default'] = Wistia;
	module.exports = exports['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(61);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(27);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _utils = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
	var BLANK_VIDEO_URL = 'https://www.youtube.com/watch?v=GlCmAC4MHek';
	var DEFAULT_PLAYER_VARS = {
	  autoplay: 0,
	  playsinline: 1,
	  showinfo: 0,
	  rel: 0,
	  iv_load_policy: 3
	};
	
	var YouTube = function (_Base) {
	  _inherits(YouTube, _Base);
	
	  function YouTube() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.onStateChange = function (_ref2) {
	      var data = _ref2.data;
	      var _this$props = _this.props,
	          onPause = _this$props.onPause,
	          onBuffer = _this$props.onBuffer;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
	          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
	          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
	          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
	          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
	          CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) _this.onPlay();
	      if (data === PAUSED) onPause();
	      if (data === BUFFERING) onBuffer();
	      if (data === ENDED) _this.onEnded();
	      if (data === CUED) _this.onReady();
	    }, _this.onEnded = function () {
	      var _this$props2 = _this.props,
	          loop = _this$props2.loop,
	          onEnded = _this$props2.onEnded;
	
	      if (loop) {
	        _this.seekTo(0);
	      }
	      onEnded();
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YouTube, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          url = _props.url,
	          youtubeConfig = _props.youtubeConfig;
	
	      if (!url && youtubeConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      if (window[SDK_GLOBAL] && window[SDK_GLOBAL].loaded) {
	        return Promise.resolve(window[SDK_GLOBAL]);
	      }
	      return new Promise(function (resolve, reject) {
	        var previousOnReady = window[SDK_GLOBAL_READY];
	        window[SDK_GLOBAL_READY] = function () {
	          if (previousOnReady) previousOnReady();
	          resolve(window[SDK_GLOBAL]);
	        };
	        (0, _loadScript2['default'])(SDK_URL, function (err) {
	          if (err) reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          playsinline = _props2.playsinline,
	          controls = _props2.controls,
	          youtubeConfig = _props2.youtubeConfig,
	          _onError = _props2.onError;
	
	      var id = url && url.match(MATCH_URL)[1];
	      if (this.isReady) {
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url)
	        });
	        return;
	      }
	      if (this.loadingSDK) {
	        this.loadOnReady = url;
	        return;
	      }
	      this.loadingSDK = true;
	      this.getSDK().then(function (YT) {
	        _this2.player = new YT.Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _extends({}, DEFAULT_PLAYER_VARS, {
	            controls: controls ? 1 : 0,
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin,
	            playsinline: playsinline
	          }, youtubeConfig.playerVars),
	          events: {
	            onReady: function onReady() {
	              _this2.loadingSDK = false;
	              _this2.onReady();
	            },
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _onError(event.data);
	            }
	          }
	        });
	      }, _onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady || !this.player.playVideo) return;
	      this.player.playVideo();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady || !this.player.pauseVideo) return;
	      this.player.pauseVideo();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady || !this.player.stopVideo) return;
	      this.player.stopVideo();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player.seekTo) return;
	      this.player.seekTo(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady || !this.player.setVolume) return;
	      this.player.setVolume(fraction * 100);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      if (!this.isReady || !this.player.setPlaybackRate) return;
	      this.player.setPlaybackRate(rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady || !this.player.getDuration) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.getDuration()) return null;
	      return this.player.getCurrentTime() / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || !this.player.getVideoLoadedFraction) return null;
	      return this.player.getVideoLoadedFraction();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return YouTube;
	}(_Base3['default']);
	
	YouTube.displayName = 'YouTube';
	exports['default'] = YouTube;
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseStartTime = parseStartTime;
	var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/;
	
	// Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	function parseStartTime(url) {
	  var match = url.match(MATCH_START_QUERY);
	  if (match) {
	    var stamp = match[1];
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseStartStamp(stamp);
	    }
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp, 10);
	    }
	  }
	  return 0;
	}
	
	function parseStartStamp(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	  while (array !== null) {
	    var _array = array,
	        _array2 = _slicedToArray(_array, 3),
	        count = _array2[1],
	        period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	  return seconds;
	}

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(83);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(85);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(86);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(88);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(8);
	
	var _InternalPropTypes = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(8);
	
	var _InternalPropTypes = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager2 = __webpack_require__(92);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(16);
	
	var _RouterContext = __webpack_require__(52);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(8);
	
	var _RouterUtils = __webpack_require__(89);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	
	var propTypes = {
	  history: object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: func,
	  createElement: func,
	  onError: func,
	  onUpdate: func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: object
	};
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(49);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	var enterHooks = new PendingHooks();
	var changeHooks = new PendingHooks();
	
	function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	  var isSync = hook.length < asyncArity;
	
	  var transitionHook = function transitionHook() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (isSync) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	
	  pendingHooks.add(transitionHook);
	
	  return transitionHook;
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location) {
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  enterHooks.clear();
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (enterHooks.has(hooks[index])) {
	        next.apply(undefined, arguments);
	        enterHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  changeHooks.clear();
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (changeHooks.has(hooks[index])) {
	        next.apply(undefined, arguments);
	        changeHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](state, nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(52);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(126);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(91);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(12);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(49);
	
	var _PromiseUtils = __webpack_require__(87);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(12);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(127);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(91);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(12);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(20);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(90);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(92);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(8);
	
	var _RouterUtils = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(49);
	
	var _PromiseUtils = __webpack_require__(87);
	
	var _PatternUtils = __webpack_require__(12);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(274);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(50);
	
	var _PropTypes = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 254 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9c13bc2165573ed15d39487a7d5cdc4e.aac";

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "81e9097b295a05b5017cb5651ce9e12a.mp4";

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e640d0eb5529007076cb7b46e10d1d60.png";

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bac2956c016043e425b5569d36edc1c8.png";

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c1aced983ab1e275432d61dd0d362dad.png";

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "edbe2403a7c4f49befd335fb04ad6da7.png";

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eb558635d6181e635e1fea81f6e4f555.png";

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "756f98a6511b5e3c6c15bfc11a268661.png";

/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 264 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 265 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyppVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDhCMEY3N0EwQTc4MTFFN0I4NzNGQkU3RDBCNzA5QkQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDhCMEY3NzkwQTc4MTFFN0I4NzNGQkU3RDBCNzA5QkQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjM1RERGQTgzRDVEMTExRTZBQTY5RDRERDAwM0U3QjhEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjM1RERGQTg0RDVEMTExRTZBQTY5RDRERDAwM0U3QjhEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+bYjOFAAAAT9JREFUeNqkk8FKhFAUho8zMJD6BiLIuJsJeokW0xO41zZGe9G14C5aFBbkA/gAQYvoHYKh2hi28A1UQhDn/IOCyEwjzYFPzr33/3+Qcy81TUMDFswN88n8tny0e4uhvr+YMXdM3ewvnD0wJ51P2KYQzZhn5jxNU/J9n7Iso6IocEaSJJGqquR5Hmmahq035oKpuoB75iqOY4qiiMqypF0liiJZlkWGYXSeawQsuXlPkmRq2/Zecz8kDEPSdb3m5dmEP5fMNAiCg2YUNNDCAy8CVljhn8dWT7tCwBxdnuejA3ra+YT+UYIgdG2FgG90siyPDsBY2/pBwAs6RVFGB+BOtPWKgIipXdfdjuhQQeM4DlqM8QkBa+aR50qmaf4ZgjNooIUH3qOv8tGPiXY85yVzy3wxFZMz63bvdKjfCDAAbtJDNYYGOwcAAAAASUVORK5CYII="

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1ee32a7ad622bc27ad4d24d47d12b52b.png";

/***/ },
/* 267 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyppVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozNURERkE4M0Q1RDExMUU2QUE2OUQ0REQwMDNFN0I4RCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDozNURERkE4NEQ1RDExMUU2QUE2OUQ0REQwMDNFN0I4RCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjM1RERGQTgxRDVEMTExRTZBQTY5RDRERDAwM0U3QjhEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjM1RERGQTgyRDVEMTExRTZBQTY5RDRERDAwM0U3QjhEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+bbI34AAAAUZJREFUeNqkk81Kw0AUhW+apqWK4N9eHcFFK/gIuhCM79GVuHSvPoDiQsGCPoY/CxHEJxCKitBI91IE/5PG8Zw4gyVYG+yBD+7MnHtIMjeitZYUZbANbsC74drsldP+zkUB7IJYdxfP9kHJ9jlJikgBHIHFNpYnDx9y8RhJ8y3mmUyUXFkY8cQfK0reSbbOwTIIbcAeWGlFn7IZvEhgGtNSCFpXgzLq5WzPKgMqKK4iLe7a3VPXZqsphGzNDInnCI1zjKoC9xiP3auZuoeHXvawlwE+V5d456zq8PoMUKwar+3MAcGPV+XkH3Idx5YhAwJW0wP5zAG8VqMmA05ZzQ97mQM4E0ZnDDgEsT9eTK6olybhWcJAsQccMKAOarjXZEjUHyE824DH+/4ENfb2Pcp9/0zyy+9cATvgFoTgGdTN3mza/yXAAGsIPpo0/V+BAAAAAElFTkSuQmCC"

/***/ },
/* 268 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 269 */
/***/ function(module, exports) {

	// get successful control from form and assemble into object
	// http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2
	
	// types which indicate a submit action and are not successful controls
	// these will be ignored
	var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;
	
	// node names which could be successful controls
	var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;
	
	// Matches bracket notation.
	var brackets = /(\[[^\[\]]*\])/g;
	
	// serializes form fields
	// @param form MUST be an HTMLForm element
	// @param options is an optional argument to configure the serialization. Default output
	// with no options specified is a url encoded string
	//    - hash: [true | false] Configure the output type. If true, the output will
	//    be a js object.
	//    - serializer: [function] Optional serializer function to override the default one.
	//    The function takes 3 arguments (result, key, value) and should return new result
	//    hash and url encoded str serializers are provided with this module
	//    - disabled: [true | false]. If true serialize disabled fields.
	//    - empty: [true | false]. If true serialize empty fields
	function serialize(form, options) {
	    if (typeof options != 'object') {
	        options = { hash: !!options };
	    }
	    else if (options.hash === undefined) {
	        options.hash = true;
	    }
	
	    var result = (options.hash) ? {} : '';
	    var serializer = options.serializer || ((options.hash) ? hash_serializer : str_serialize);
	
	    var elements = form && form.elements ? form.elements : [];
	
	    //Object store each radio and set if it's empty or not
	    var radio_store = Object.create(null);
	
	    for (var i=0 ; i<elements.length ; ++i) {
	        var element = elements[i];
	
	        // ingore disabled fields
	        if ((!options.disabled && element.disabled) || !element.name) {
	            continue;
	        }
	        // ignore anyhting that is not considered a success field
	        if (!k_r_success_contrls.test(element.nodeName) ||
	            k_r_submitter.test(element.type)) {
	            continue;
	        }
	
	        var key = element.name;
	        var val = element.value;
	
	        // we can't just use element.value for checkboxes cause some browsers lie to us
	        // they say "on" for value when the box isn't checked
	        if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
	            val = undefined;
	        }
	
	        // If we want empty elements
	        if (options.empty) {
	            // for checkbox
	            if (element.type === 'checkbox' && !element.checked) {
	                val = '';
	            }
	
	            // for radio
	            if (element.type === 'radio') {
	                if (!radio_store[element.name] && !element.checked) {
	                    radio_store[element.name] = false;
	                }
	                else if (element.checked) {
	                    radio_store[element.name] = true;
	                }
	            }
	
	            // if options empty is true, continue only if its radio
	            if (val == undefined && element.type == 'radio') {
	                continue;
	            }
	        }
	        else {
	            // value-less fields are ignored unless options.empty is true
	            if (!val) {
	                continue;
	            }
	        }
	
	        // multi select boxes
	        if (element.type === 'select-multiple') {
	            val = [];
	
	            var selectOptions = element.options;
	            var isSelectedOptions = false;
	            for (var j=0 ; j<selectOptions.length ; ++j) {
	                var option = selectOptions[j];
	                var allowedEmpty = options.empty && !option.value;
	                var hasValue = (option.value || allowedEmpty);
	                if (option.selected && hasValue) {
	                    isSelectedOptions = true;
	
	                    // If using a hash serializer be sure to add the
	                    // correct notation for an array in the multi-select
	                    // context. Here the name attribute on the select element
	                    // might be missing the trailing bracket pair. Both names
	                    // "foo" and "foo[]" should be arrays.
	                    if (options.hash && key.slice(key.length - 2) !== '[]') {
	                        result = serializer(result, key + '[]', option.value);
	                    }
	                    else {
	                        result = serializer(result, key, option.value);
	                    }
	                }
	            }
	
	            // Serialize if no selected options and options.empty is true
	            if (!isSelectedOptions && options.empty) {
	                result = serializer(result, key, '');
	            }
	
	            continue;
	        }
	
	        result = serializer(result, key, val);
	    }
	
	    // Check for all empty radio buttons and serialize them with key=""
	    if (options.empty) {
	        for (var key in radio_store) {
	            if (!radio_store[key]) {
	                result = serializer(result, key, '');
	            }
	        }
	    }
	
	    return result;
	}
	
	function parse_keys(string) {
	    var keys = [];
	    var prefix = /^([^\[\]]*)/;
	    var children = new RegExp(brackets);
	    var match = prefix.exec(string);
	
	    if (match[1]) {
	        keys.push(match[1]);
	    }
	
	    while ((match = children.exec(string)) !== null) {
	        keys.push(match[1]);
	    }
	
	    return keys;
	}
	
	function hash_assign(result, keys, value) {
	    if (keys.length === 0) {
	        result = value;
	        return result;
	    }
	
	    var key = keys.shift();
	    var between = key.match(/^\[(.+?)\]$/);
	
	    if (key === '[]') {
	        result = result || [];
	
	        if (Array.isArray(result)) {
	            result.push(hash_assign(null, keys, value));
	        }
	        else {
	            // This might be the result of bad name attributes like "[][foo]",
	            // in this case the original `result` object will already be
	            // assigned to an object literal. Rather than coerce the object to
	            // an array, or cause an exception the attribute "_values" is
	            // assigned as an array.
	            result._values = result._values || [];
	            result._values.push(hash_assign(null, keys, value));
	        }
	
	        return result;
	    }
	
	    // Key is an attribute name and can be assigned directly.
	    if (!between) {
	        result[key] = hash_assign(result[key], keys, value);
	    }
	    else {
	        var string = between[1];
	        // +var converts the variable into a number
	        // better than parseInt because it doesn't truncate away trailing
	        // letters and actually fails if whole thing is not a number
	        var index = +string;
	
	        // If the characters between the brackets is not a number it is an
	        // attribute name and can be assigned directly.
	        if (isNaN(index)) {
	            result = result || {};
	            result[string] = hash_assign(result[string], keys, value);
	        }
	        else {
	            result = result || [];
	            result[index] = hash_assign(result[index], keys, value);
	        }
	    }
	
	    return result;
	}
	
	// Object/hash encoding serializer.
	function hash_serializer(result, key, value) {
	    var matches = key.match(brackets);
	
	    // Has brackets? Use the recursive assignment function to walk the keys,
	    // construct any missing objects in the result tree and make the assignment
	    // at the end of the chain.
	    if (matches) {
	        var keys = parse_keys(key);
	        hash_assign(result, keys, value);
	    }
	    else {
	        // Non bracket notation can make assignments directly.
	        var existing = result[key];
	
	        // If the value has been assigned already (for instance when a radio and
	        // a checkbox have the same name attribute) convert the previous value
	        // into an array before pushing into it.
	        //
	        // NOTE: If this requirement were removed all hash creation and
	        // assignment could go through `hash_assign`.
	        if (existing) {
	            if (!Array.isArray(existing)) {
	                result[key] = [ existing ];
	            }
	
	            result[key].push(value);
	        }
	        else {
	            result[key] = value;
	        }
	    }
	
	    return result;
	}
	
	// urlform encoding serializer
	function str_serialize(result, key, value) {
	    // encode newlines as \r\n cause the html spec says so
	    value = value.replace(/(\r)?\n/g, '\r\n');
	    value = encodeURIComponent(value);
	
	    // spaces should be '+' rather than '%20'.
	    value = value.replace(/%20/g, '+');
	    return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
	}
	
	module.exports = serialize;


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(199);

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(203);

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(206);

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(207);

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(218);

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(3);

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(4);

/***/ },
/* 277 */
/***/ function(module, exports) {

	module.exports = cesiumDll_da1e370eda307bab9f7b;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// app.js